export default {
    scan: {
        title: 'Zajem dokumenta',
        hint: 'Poslikaj stran z dvema vrsticama znakov na dnu — podatki se prenesejo na recepcijo.',
        sending: 'Pošiljam sliko …',
        taken: 'Poslikano: {count}',
        read_count: 'Prebrano: {count}',
        checks: 'Potrjeno {passed} od {total} kontrolnih števk.',
        again: 'Prebrano \u2014 poslikaj še enkrat',
        again_hint: 'Zapis je prebran, a ni popolnoma zanesljiv. Še en posnetek iste strani in strežnik bo iz obeh sestavil pravega.',
        take_another: 'Poslikaj še enkrat',
        live_hint: 'Kartico drži v okvirju, dokler ne piše, da je prebrano. En pritisk zajame tri sličice.',
        take_photo: 'Poslikaj dokument',
        take_photo_hint: 'Odpre se kamera. Zapis na dnu naj bo cel v sliki in oster.',
        reading: 'Berem …',
        done: 'Prebrano',
        done_hint: 'Podatki so na zaslonu recepcije. To okno lahko zapreš.',
        failed: 'Zapisa ni bilo mogoče prebrati',
        failed_hint: 'Najpogosteje je kriv prst čez zapis, odsev ali prevelika razdalja. Poskusi znova.',
        expired: 'Povezava ne velja več',
        expired_hint: 'Koda velja deset minut. Na recepciji naj pripravijo novo.',
        privacy: 'Slika se uporabi za branje dokumenta. Hrani se samo, če je hotel tako nastavil, in se nato samodejno izbriše.',
    },
    attention: {
        title: 'Posebnosti za to bivanje',
        hint: 'Kar mora sobarica vedeti, preden vstopi: posteljica, ura čiščenja, posebna čistila. Pokaže se na njenem telefonu nad sobo.',
        guest_title: 'Stalne posebnosti gosta',
        guest_hint: 'Velja za tega gosta ob vsakem bivanju — alergija, vzglavnik, ki ga vedno prosi. Za enkratne želje uporabi rezervacijo.',
        add: 'Dodaj',
        value: 'Podatek',
        note: 'Opomba',
        vip: 'VIP',
        cot: 'Otroška posteljica',
        extra_bed: 'Dodatna postelja',
        pet: 'Hišni ljubljenček',
        allergy: 'Alergija',
        products: 'Posebna čistila',
        extra_towels: 'Dodatne brisače',
        extra_pillows: 'Dodatni vzglavniki',
        clean_at: 'Čiščenje ob',
        do_not_enter_before: 'Ne vstopaj pred',
        language: 'Jezik gosta',
        late_checkout: 'Pozna odjava',
        extension_request: 'Prošnja za podaljšanje',
        early_checkin: 'Zgodnja prijava',
        preferred_room: 'Želena soba',
        // Namig ob izbiri sobe. Prosto/zasedeno velja za datume, ki so v obrazcu.
        wants_room: 'Gost želi sobo {room} ({state})',
        wants_room_free: 'prosta',
        wants_room_taken: 'zasedena za te datume',
        wants_room_unknown: 'razpoložljivosti še ne poznamo',
        wants_room_assign: 'Dodeli to sobo',
        wants_room_here: 'Soba {room} · ta soba',
        wants_room_elsewhere: 'Soba {room} · gost je v {actual}',
    },
    checklist: {
        tab: 'Kontrolni seznami',
        title: 'Kontrolni seznami čiščenja',
        hint: 'Kaj mora biti opravljeno, preden je soba končana. Seznami se seštejejo: hotelski standard, potem tip sobe, potem vrsta dela.',
        add: 'Nov seznam',
        edit: 'Uredi seznam',
        empty: 'Hotel še nima nobenega kontrolnega seznama. Brez njih se soba zaključi kot doslej.',
        name: 'Ime seznama',
        name_hint: 'Vidi ga samo vodstvo — sobarica vidi korake vseh seznamov skupaj, ker sobo počisti enkrat.',
        room_type: 'Tip sobe',
        room_type_hint: 'Prazno pomeni vse sobe v hotelu.',
        kind: 'Vrsta dela',
        kind_hint: 'Prazno pomeni vsako vrsto dela.',
        whole_house: 'Ves hotel',
        every_kind: 'Vsako delo',
        kind_departure: 'Po odhodu',
        kind_stayover: 'Med bivanjem',
        kind_arrival: 'Pred prihodom',
        kind_dirty: 'Soba za urediti',
        steps: '{count} korakov',
        steps_label: 'Koraki',
        steps_hint: 'V vrstnem redu, kot sobarica hodi po sobi. Zvezdica pomeni obvezen korak — brez odgovora nanj sobe ni mogoče zaključiti.',
        add_step: 'Dodaj korak',
        required: 'Obvezen',
        required_hint: 'Obvezen korak: sobe ni mogoče zaključiti, dokler nanj ni odgovorjeno.',
        retire: 'Umakni',
        restore: 'Vrni v uporabo',
        retired: 'Umaknjen',
    },
    area: {
        tab: 'Čiščenje',
        title: 'Skupni prostori',
        hint: 'Hodniki, wellness, dvigala, stopnišča — delo, ki ni soba. Po urniku se samodejno vpiše v dnevni delovni list.',
        add: 'Nov prostor',
        edit: 'Uredi prostor',
        empty: 'Hotel še nima vpisanih skupnih prostorov.',
        name: 'Ime prostora',
        floor: 'Nadstropje',
        floor_hint: 'Da se prostor uvrsti k sobam istega nadstropja in se krog hodi v enem prehodu.',
        floor_n: '{floor}. nadstropje',
        minutes: 'Norma (min)',
        minutes_hint: 'Koliko časa je predvideno. Prazno pomeni brez norme.',
        every: 'Kako pogosto',
        every_day: 'Vsak dan',
        every_week: 'Tedensko',
        every_month: 'Mesečno',
        every_month_on: 'Mesečno, {day}. v mesecu',
        weekdays: 'Dnevi',
        day_of_month: 'Dan v mesecu',
        day_of_month_hint: 'Od 1 do 28. Višja števila bi petkrat na leto tiho preskočila mesec.',
        steps: 'Koraki',
        steps_hint: 'Lasten seznam tega prostora — sobni kontrolni seznami zanj ne veljajo.',
        weekday_0: 'Ned',
        weekday_1: 'Pon',
        weekday_2: 'Tor',
        weekday_3: 'Sre',
        weekday_4: 'Čet',
        weekday_5: 'Pet',
        weekday_6: 'Sob',
    },
    dining: {
        title: 'Obroki in vstopi',
        hint: 'Kdo sme jesti, kdo je prišel in koliko oseb. Nastavi se v Nastavitve (zobnik) → Operativne nastavitve → Obroki in vstopi.',
        no_property: 'Najprej izberi objekt.',
        not_set_up: 'Obroki še niso nastavljeni',
        not_set_up_hint: 'V Nastavitve (zobnik) → Operativne nastavitve → Obroki in vstopi dodaj jedilnico in obrok z urnikom.',
        header: '{meal} · {restaurant} · {from}–{to}',
        expected: 'Pričakovani',
        persons_rooms: 'oseb · {rooms} sob',
        served: 'Postreženi',
        not_arrived: 'Še niso prišli',
        until: 'do {time}',
        extra_meals: 'Dodatni obroki',
        extra_split: '{amount} · {folio} na folio, {cash} blagajna',
        decisions: 'Odobritve / zavrnitve',
        decisions_hint: 'ročne odločitve z razlogi',
        device_offline: '{name} · brez povezave {minutes} min',
        list: 'Operativni seznam',
        empty: 'Za ta obrok danes ni pričakovanih gostov.',
        occupancy: '{adults} odr. + {children} otr.',
        plus_extra: '+{count} dokup',
        open_reservation: 'Odpri rezervacijo',
        arrivals: 'Prihod po 15 minutah',
        arrivals_hint: 'Kdaj so gostje dejansko prišli.',
        arrivals_empty: 'Danes še ni vstopov.',
        arrivals_bar: '{time} · {persons} oseb',
        forecast: 'Napoved obrokov',
        forecast_hint: 'Šteje OSEBE iz rezervacij in penzionov, ne sob.',
        forecast_empty: 'Za naslednje dni ni rezervacij s penzionom.',
        filter_all: 'Vsi · {count}',
        filter_expected: 'Še pričakovani · {count}',
        filter_partial: 'Delno · {count}',
        filter_served: 'Postreženi · {count}',
        filter_extra: 'Dodatni obrok · {count}',
        state_expected: 'pričakovan',
        state_partial: 'delno',
        state_served: 'postreženo',
        state_extra: 'dodatni obrok',
        kind_breakfast: 'Zajtrk',
        kind_lunch: 'Kosilo',
        kind_dinner: 'Večerja',
        restaurants: 'Jedilnice',
        restaurants_hint: 'Kje hotel streže. Obrok pripada jedilnici, tablica stoji pred njenimi vrati.',
        restaurants_empty: 'Ni še nobene jedilnice.',
        restaurant: 'Jedilnica',
        restaurant_add: 'Dodaj jedilnico',
        restaurant_edit: 'Uredi jedilnico',
        restaurant_name: 'Ime',
        greeting: 'Pozdrav na tablici',
        greeting_hint: 'Vrstica pod logotipom hotela. Če je prazna, tablica pokaže ime jedilnice.',
        greeting_house_hint: 'Velja za vse jedilnice, razen kjer ima jedilnica svojega.',
        greeting_sl: 'Dobro jutro!',
        greeting_en: 'Good morning!',
        greeting_en_label: 'Pozdrav (angleško)',
        no_greeting: 'brez pozdrava',
        closed: 'zaprto',
        close: 'Zapri jedilnico',
        reopen: 'Odpri jedilnico',
        close_refused: 'Jedilnice ni mogoče zapreti, dokler ima obroke. Najprej ukini obroke.',
        meals: 'Obroki',
        meals_hint: 'Kaj se streže, kdaj, in koliko stane dodatni obrok za tistega, ki ga nima v penzionu.',
        meals_empty: 'Ni še nobenega obroka.',
        meals_no_room: 'Najprej dodaj jedilnico.',
        meal_needs_room: 'Najprej dodaj jedilnico — obrok se streže v njej.',
        go_to_rooms: 'Na jedilnice',
        device_needs_room: 'Najprej dodaj jedilnico — tablica se veže nanjo.',
        device_needs_open_room: 'Vse jedilnice so zaprte — tablica se veže na odprto.',
        meal_add: 'Dodaj obrok',
        meal_edit: 'Uredi obrok',
        meal_name: 'Ime obroka',
        meal_name_sl: 'Zajtrk',
        meal_name_en_label: 'Ime obroka (angleško)',
        kind: 'Vrsta obroka',
        kind_fixed: 'Vrste obroka ni mogoče spremeniti — določa, kdo je bil upravičen. Za drugo vrsto naredi nov obrok.',
        from: 'Od',
        to: 'Do',
        tolerance: 'Toleranca (min)',
        tolerance_hint: 'Koliko pred in po uradnem času tablica še ne javi izjeme.',
        tolerance_short: '±{minutes} min',
        boards: 'Penzioni, ki vključujejo ta obrok',
        boards_hint: 'Privzeto po hotelskem pravilu. Če ga spremeniš, se ta zaslon in graf rezervacij lahko razideta.',
        boards_none: 'noben penzion',
        extra_price: 'Cena dodatnega obroka (€)',
        extra_price_hint: 'Bruto, na osebo. Nič pomeni, da hotel tega obroka ne prodaja posebej.',
        extra_tax_rate: 'Stopnja DDV',
        no_extra_price: 'ni v prodaji',
        retired: 'ukinjen',
        retire: 'Ukini obrok',
        restore: 'Vrni obrok',
        access: 'Vstop in dodatni obroki',
        access_hint: 'Kaj sme tablica pri vratih ponuditi, in kaj je skrito za PIN-om.',
        allow_folio: 'Dodatni obrok na sobo',
        allow_folio_hint: 'Postavka gre na folio gosta prek običajne poti.',
        allow_cash: 'Napoti na blagajno',
        allow_cash_hint: 'Gosta se napoti na blagajno. Znesek ostane na seznamu recepcije, dokler ga ne zapre fiskaliziran ra\u010dun \u2014 vrata jedilnice ne izdajo dokumenta.',
        attention_title: 'Zahteva obravnavo',
        entries: 'Vpisi',
        entries_empty: 'Za to sobo pri tem obroku ni vpisov.',
        entry_persons: '{count} oseb',
        entry_storno: 'Popravi',
        entry_storno_prompt: 'Kaj je bilo pri tem vpisu narobe?',
        entry_stornoed: 'Popravljeno.',
        entry_cancelled: 'popravljeno',
        entry_is_storno: 'popravek',
        attention_hint: 'Kar vrata sama niso mogla rešiti. Gotovina ostane tu, dokler je ne zapre fiskaliziran račun.',
        attention_served: 'postreženih {persons}, penzion krije {entitled}',
        attention_invoice: 'Oznaka računa',
        attention_settle: 'Zapri z računom',
        attention_resolve: 'Razreši',
        attention_resolve_prompt: 'Kaj je bilo storjeno?',
        attention_settled: 'Razrešeno.',
        offline: 'offline',
        attention_kind: { overrun: 'Presežena pravica', offline_conflict: 'Offline neskladje', unconfirmed_cash: 'Gotovina še ni prijavljena' },
        allow_free: 'Brezplačna odobritev',
        allow_free_hint: 'Obrok, ki ga hotel podari. Zahteva pravico dining:override in obvezen razlog.',
        pin_required: 'Prehranske podrobnosti za PIN-om',
        pin_required_hint: 'Opozorilo je vedno vidno; skrije se le, kaj točno je narobe.',
        pin_missing: 'PIN še ni nastavljen',
        pin_missing_hint: 'Dokler PIN-a ni, zaščite ni mogoče vklopiti — sicer bi hotel mislil, da so podatki skriti.',
        pin: 'PIN (4 števke)',
        pin_help: 'Hotelski PIN, ne oseben. Tablica pri vratih nima prijave zaposlenega.',
        pin_set: 'PIN je nastavljen.',
        pin_not_set: 'PIN ni nastavljen.',
        pin_set_action: 'Nastavi PIN',
        pin_change: 'Zamenjaj PIN',
        pin_clear: 'Odstrani PIN',
        pin_clear_refused: 'PIN-a ni mogoče odstraniti, dokler je zaščita vklopljena.',
        pin_dialog: 'PIN za prehranske podrobnosti',
        pin_dialog_hint: 'PIN se shrani samo kot povzetek in ga ni mogoče prebrati nazaj.',
        devices: 'Tablice',
        devices_hint: 'Naprave pri vratih. Registrira se s kodo, prekliče z enim pritiskom.',
        devices_empty: 'Ni še nobene tablice.',
        device_add: 'Dodaj tablico',
        device_rename: 'Uredi tablico',
    },
    // Kar je pri registriranih napravah enako, naj se reče na enem mestu: isti seznam
    // riše tablice pri vratih in telefone sobaric, zato so ti nizi nevtralni.
    staff_device: {
        name:         'Ime naprave',
        add_hint:     'Koda velja pet minut in samo enkrat.',
        code_hint:    'Skeniraj kodo z aplikacijo na napravi.',
        code_make:    'Pokaži kodo',
        code_expires: 'Koda velja do {at}.',
        seen:         'nazadnje {at}',
        active:       'aktivna',
        revoked:      'preklicana',
        revoke:       'Prekliči',
        restore:      'Vrni v uporabo',
        remove:            'Odstrani',
        show_removed:      'Prikaži odstranjene',
        remove_confirm:    'Odstrani napravo „{name}“?',
        remove_explain:    'Če se naprava ne pojavi v nobenem zapisu, bo izbrisana. Če se, bo skrita s seznama — vpisi, ki jo imenujejo, ostanejo nedotaknjeni.',
        removed_deleted:   'Naprava je izbrisana.',
        removed_archived:  'Naprava je skrita s seznama. Vpisi, ki jo imenujejo, so ostali.',
    },
    lost: {
        title: 'Najdeni predmeti',
        hint: 'Kar gost pusti v sobi. Sobarica najdbo zapiše na svojem portalu; tu se zgodi vse ostalo — klic gostu, predaja, pošiljanje.',
        search: 'Išči po opisu, številki ali gostu',
        empty: 'Nič najdenega.',
        photo: 'Fotografija',
        guest: 'Gost tisto noč: {name}',
        stored_in: 'hramba: {place}',
        handed_to: 'predano: {name}',
        handle: 'Obravnavaj',
        what_happened: 'Kaj se je zgodilo',
        handed_over_to: 'Komu je predano',
        handed_over_to_placeholder: 'Ime osebe ali kurirja',
        storage: 'Kje je shranjeno',
        note: 'Opomba',
        note_hint_contact: 'Kako je bil gost obveščen — telefon, e-pošta, sporočilo.',
        note_hint_handover: 'Kako je bilo predano — osebno, po pošti, številka pošiljke.',
        needs_name: 'Vpiši, komu je predano. Brez imena zapis ne pomeni nič.',
        status_all: 'Vse',
        status_reported: 'Prijavil gost',
        status_stored: 'V hrambi',
        status_contacted: 'Gost obveščen',
        status_returned: 'Vrnjeno',
        status_shipped: 'Poslano',
        status_disposed: 'Uničeno',
        origin_guest: 'Prijavil gost prek Mila',
    },
    materials: {
        tab: 'Materialno poslovanje',
        module_title: 'Imprion Materials — Materialno poslovanje in nabava',
        module_description: 'Modul pokriva zaloge in nabavo hotelske operative: artikle s črtnimi kodami in pakiranji, skladišča in vozičke, gibanja s FIFO/FEFO vrednotenjem, prevzemnice in izdajnice, inventuro, dobavitelje in njihove račune z desetletnim arhivom, ter maloprodajno blagajno. Knjiga količin ostane v jedru — minibar na folio in premik perila delujeta tudi brez modula.',
    },
    /**
     * Dobaviteljev katalog in pogodbe (docs/MATERIALNO-KATALOG.md, WP-M3a).
     *
     * Svoj imenski prostor in ne del `materials`, iz istega razloga kot
     * `materials_accounting`: `materials` opisuje modul kot izdelek, to pa je NABAVNA
     * stran — kaj kateri dobavitelj zaračuna, po kateri šifri in do kdaj cena velja.
     */
    materials_catalogue: {
        title: 'Katalog in pogodbe',
        no_property: 'Najprej izberi objekt.',
        lead_title: 'Kaj kateri dobavitelj zaračuna, in do kdaj',
        lead: 'Katalog je vrstica na PAR dobavitelj + artikel: njegova šifra, njegovo pakiranje, najmanjše naročilo, dobavni rok in cena z veljavnostjo. Isti artikel pri dveh dobaviteljih sta dve vrstici z dvema cenama. Pogodba je dogovor za obdobje; ob aktivaciji zapiše svoje cene v katalog z lastno veljavnostjo.',

        catalogue: 'Katalog',
        catalogue_hint: 'Cene po dobaviteljih. Cena, ki ji je potekla veljavnost, je označena — na naročilnico gre samo s potrditvijo in razlogom (koda 106).',
        contracts: 'Pogodbe',
        contracts_hint: 'Dogovorjene cene za obdobje. Osnutek se še ureja; aktivacija zapiše cene v katalog in pogodbe ne spreminja več.',

        empty: 'Kataloga še ni.',
        contracts_empty: 'Pogodb še ni.',
        add_entry: 'Nova vrstica kataloga',
        edit_entry: 'Uredi vrstico kataloga',
        add_contract: 'Nova pogodba',
        edit_contract: 'Uredi pogodbo',
        view_contract: 'Pogodba',
        saved: 'Shranjeno.',

        filter_all: 'Vse',
        filter_supplier: 'Dobavitelj',
        filter_supplier_help: 'Prazno pomeni vse dobavitelje.',
        filter_item: 'Artikel',
        filter_status: 'Stanje',
        filter_status_help: 'Stanje je izračunano na današnji dan: pogodba, ki ji je potekla veljavnost, se bere kot pretečena, tudi če je shranjena kot aktivna.',

        supplier: 'Dobavitelj',
        supplier_hint: 'Kdo prodaja. Skupaj z artiklom je to KLJUČ vrstice — ista dvojica ima natanko eno ceno, zato se pri urejanju ne da spremeniti.',
        item: 'Artikel',
        item_hint: 'Kaj kupujemo, po hišnem imenu. Dobaviteljevo ime izdelka se vpiše v svoje polje spodaj.',
        sku: 'Šifra dobavitelja',
        sku_hint: 'Njegova šifra, ne naša. To je tisto, kar gre na naročilnico in se vrne na dobavnici; hišni SKU njihovo skladišče ne pozna.',
        supplier_item_name: 'Njegovo ime izdelka',
        supplier_item_name_hint: 'Kakor je izdelek imenovan pri dobavitelju. Stoji ob našem imenu in ga ne nadomesti — skladiščnik preverja dobavo po njihovem besedilu.',
        price: 'Cena na enoto',
        price_hint: 'Neto cena ENE enote artikla, ne enega pakiranja. Cena na paket bi pomenila deljenje s številom, ki je lahko nič, primerjava dveh dobaviteljev z različno velikimi zaboji pa je bistvo te vrstice.',
        currency: 'Valuta',
        pack_unit: 'Pakiranje',
        pack_unit_hint: 'Njegova beseda za zaboj — „karton“, „paleta“. Prosto besedilo: nihče naj ne izbira s seznama, ki ga je napisal nekdo drug.',
        quantity_per_pack: 'Kosov v pakiranju',
        quantity_per_pack_hint: 'Koliko enot ARTIKLA je v enem pakiranju. Nič pomeni, da prodaja po kosu; predlog naročila zaokroži količino navzgor na cela pakiranja.',
        moq: 'Najmanjše naročilo',
        moq_hint: 'Najmanjša količina, ki jo dobavitelj sprejme, v enotah artikla. Nič pomeni, da ni povedal. Predlog najprej dvigne količino na to mejo in šele nato zaokroži na pakiranja — obratno bi dalo naročilo, ki ga dobavitelj zavrne.',
        lead_days: 'Dobavni rok (dni)',
        lead_days_hint: 'Koliko dni mine med naročilom in tovornjakom. Informativno; napoved potreb (WP-M6) bo iz tega računala točko naročanja.',
        price_from: 'Cena velja od',
        price_from_hint: 'Prazno pomeni „od nekdaj“. Cena, ki se še ni začela, ni pretečena — to je datum v koledarju in ne telefonski klic.',
        price_to: 'Cena velja do',
        price_to_hint: 'Vključno s tem dnem. Prazno pomeni, da konca nihče ni določil. Po tem dnevu strežnik zavrne naročilnico s to ceno (koda 106), dokler kdo pretečene cene izrecno ne sprejme z razlogom.',
        per_pack: '{quantity} / {unit}',
        pack: 'pakiranje',
        active_hint: 'Neaktivna vrstica se ne ponudi nikjer — niti kot pretečena. Uporabi jo, ko dobavitelja tega artikla ne prodaja več.',
        pair_is_the_key: 'Dobavitelja in artikla ni mogoče spremeniti',
        pair_is_the_key_hint: 'Dvojica dobavitelj + artikel JE ta vrstica. Sprememba katerega koli od njiju je druga vrstica, zato se naredi z novo vrstico in ne s popravkom te.',
        window_backwards: 'Cena ne more veljati do dneva pred začetkom veljavnosti.',

        expired: 'Cena je pretekla',
        not_started: 'Cena še ne velja',
        validity_open: 'brez omejitve veljavnosti',
        validity_from: 'velja od {from}',
        validity_to: 'velja do {to}',
        validity_range: 'velja {from} – {to}',

        source_manual: 'Ročno vpisano',
        source_contract: 'Iz pogodbe',
        source_invoice: 'Z zadnjega računa',

        contract_number: 'Številka pogodbe',
        contract_currency_hint: 'Valuta velja za VSE postavke pogodbe. Ena na dogovor in ne ena na vrstico: pogodba je podpisana v valuti, vrstice v dveh pa bi dale vsoto, ki je ni mogoče sešteti.',
        contract_number_hint: 'Dobaviteljeva oznaka dogovora ali hišna, če je papir nima. Ni enolična: dva objekta iste verige podpišeta isti dogovor.',
        contract_supplier_hint: 'S kom je dogovor. Ob aktivaciji dobi vsak artikel pogodbe svojo vrstico v katalogu pri tem dobavitelju.',
        valid_from: 'Velja od',
        valid_from_hint: 'Ta datum se ob aktivaciji prepiše na vsako ceno v katalogu.',
        valid_to: 'Velja do',
        valid_to_hint: 'Vključno s tem dnem. Ko mine, se pogodba bere kot pretečena, cene pa OSTANEJO v katalogu s pretečeno veljavnostjo — tako jih zavrnitev lahko poimensko navede, namesto da bi izginile brez pojasnila.',
        lines: 'Postavke',
        lines_empty: 'Pogodba brez postavk ne določa nobene cene.',
        lines_required: 'Pogodba mora imeti vsaj eno postavko z izbranim artiklom.',
        line_twice: 'Isti artikel je na dveh postavkah; katera cena bi veljala, ne bi bilo določeno.',
        add_line: 'Dodaj postavko',
        lines_n: '{count} postavk',
        read_only: 'Aktivirane pogodbe ni več mogoče urejati',
        read_only_hint: 'Cene te pogodbe so že zapisane v katalogu. Popravek bi pomenil vrstice, ki trdijo pogoje, ki jih papir nima več — zato se pogodba prekliče in napiše nova.',

        activate: 'Aktiviraj',
        activated: 'Pogodba je aktivirana; v katalog je zapisanih {count} cen.',
        cancel_contract: 'Prekliči pogodbo',
        cancelled: 'Pogodba je preklicana.',
        confirm_activate: 'Aktiviram pogodbo {number}? Njene cene se zapišejo v katalog z veljavnostjo pogodbe, pogodbe pa potem ni več mogoče urejati.',
        confirm_cancel: 'Prekličem pogodbo {number}? Cene, ki jih je zapisala v katalog, OSTANEJO — po potrebi jih izklopi v katalogu.',

        status_draft: 'Osnutek',
        status_active: 'Aktivna',
        status_expired: 'Pretečena',
        status_cancelled: 'Preklicana',

        offers: 'Ponudbe za izbrani artikel',
        offers_empty: 'Za ta artikel ni ponudb.',
        chain_offer: 'veriga',
        supplier_missing: 'dobavitelj manjka pri tem objektu',
        not_offered: 'ni ponujeno',

        errors: {
            price_expired: 'Vrstica {line}: cena za „{item}“ pri dobavitelju {supplier} je veljala do {to}.',
            price_expired_more: 'Vrstica {line}: cena za „{item}“ pri dobavitelju {supplier} je veljala do {to}, in še {more} drugih vrstic ima pretečeno ceno.',
            price_expired_plain: 'Naročilnica nosi ceno, ki ji je potekla veljavnost.',
        },
    },
    /**
     * Knjigovodstvo materialnega poslovanja (docs/MATERIALNO-KNJIGOVODSTVO.md, WP-M2b).
     *
     * Svoj imenski prostor in ne del `materials`, ker je to druga polovica modula:
     * `materials` opisuje modul kot izdelek, to pa je šifrant kontov, stroškovnih mest
     * in predaja obdobja knjigovodstvu. Izrazje je usklajeno z `docs/OSEBJE-RACUNOVODSTVO.md`
     * — „stroškovno mesto“ je ista beseda kot pri plačah in pomeni isto stvar.
     */
    materials_accounting: {
        title: 'Knjigovodstvo',
        no_property: 'Najprej izberi objekt.',
        lead_title: 'Konti, stroškovna mesta in predaja knjigovodstvu',
        lead: 'Konti so na KATEGORIJI artikla, s prevozom na posamezen artikel. Stroškovna mesta so svoj šifrant, z možno privzeto preslikavo iz oddelka. Izvoz preda knjižene prejete račune obdobja v Minimax — vsak račun natanko enkrat.',

        cost_centres: 'Stroškovna mesta',
        cost_centres_hint: 'Šifrant, po katerem se razbije strošek nabave. Svoj šifrant in ne oddelki: računovodstvo ima mesta, ki jih kadrovska struktura ne pozna (npr. „banket“).',
        cost_centres_empty: 'Ni stroškovnih mest.',
        add_cost_centre: 'Novo stroškovno mesto',
        edit_cost_centre: 'Uredi stroškovno mesto',
        cost_centre: 'Stroškovno mesto',
        cost_centre_code_hint: 'Šifra iz knjigovodstva. Shrani se brez presledkov in z velikimi črkami; v hiši mora biti enolična. Vrstica računa se sklicuje nanjo, zato je preimenovanje šifre nova šifra in ne popravek stare.',
        department: 'Oddelek',
        department_hint: 'Privzeta preslikava: nabava tega oddelka pade na to mesto, dokler vrstica ne pove drugače. Kaže samo v eno smer — brisanje oddelka ne pokvari knjigovodskih podatkov.',
        no_department: 'Brez oddelka',
        from_department: 'privzeto za: {name}',
        payroll_centre_differs: 'Oddelek že ima svoje stroškovno mesto',
        payroll_centre_differs_hint: 'Za plače je pri tem oddelku vpisano „{code}“ (docs/OSEBJE-RACUNOVODSTVO.md). Dve različni šifri za isto mesto pomenita plače na enem in nabavo na drugem — uskladi ju.',

        accounts: 'Kontni načrt',
        accounts_hint: 'Konti, na katere se knjiži nabava. Kontni načrt je knjigovodkinjin: uvozi se iz Minimaxa (Nastavitve (zobnik) → Objekt in sobe → Objekti → odpri objekt → zavihek Materialno poslovanje → Knjigovodski program → „Uvozi kontni načrt iz Minimaxa“) in poteka samo v eno smer — nazaj ne gre nič. Vrstica, ki je pri knjigovodji ni, se označi in ne izbriše.',
        accounts_empty: 'Ni kontov.',
        add_account: 'Nov konto',
        edit_account: 'Uredi konto',
        code: 'Šifra',
        account_code_hint: 'Šifra konta, kot je v knjigovodstvu. Vodilna ničla se ohrani — „0400“ ni „400“.',
        kind: 'Vrsta',
        kind_hint: 'Vrsta pove, za kaj konto je. Po njej preslikava kategorij ponudi pravi konto in ne celega načrta; strežnik zavrne konto napačne vrste v napačnem stolpcu.',
        kind_inventory: 'Zaloga',
        kind_consumption: 'Poraba',
        kind_cogs: 'Strošek prodanega',
        kind_input_vat: 'Vstopni DDV',
        kind_payable: 'Obveznost do dobavitelja',
        active_hint: 'Neaktivne vrstice ostanejo berljive — izvoz zaprtega obdobja jih imenuje — samo na novi vrstici se ne ponudijo več.',
        too_long: 'Predolgo',

        categories: 'Kategorije in konti',
        categories_hint: 'Preslikava kategorija → konti. Kategorija je edina raven, ki jo hiša že vzdržuje, in dovolj groba, da je ne pozabi popraviti.',
        categories_empty: 'Ni kategorij.',
        category: 'Kategorija',
        item_count: '{count} artiklov',
        none: '—',
        mapping_rule: 'Kateri konto velja',
        mapping_rule_hint: 'Najprej šifra, vpisana na vrstici računa; sicer prevoz na artiklu; sicer ta preslikava kategorije. Kategorija brez konta ni napaka — izvoz jo označi in obdobja ne ustavi.',

        overrides: 'Prevozi na artiklih',
        overrides_hint: 'Peščica artiklov, pri katerih pravilo kategorije ne drži. Prazno polje pomeni „vzemi s kategorije“ — izprazniti vsa štiri pomeni prevoz odstraniti.',
        overrides_empty: 'Noben artikel ne prevozi kategorije.',
        add_override: 'Nov prevoz',
        override_title: 'Prevoz konta na artiklu',
        article: 'Artikel',
        article_hint: 'Artikel se izbere enkrat; pozneje se ureja prevoz, ne artikel.',
        from_category: 'S kategorije',
        category_would_give: 'Kategorija bi dala',
        category_unmapped: 'Kategorija te artikle ni preslikana.',
        override_empty_hint: 'Prazno pomeni „vzemi s kategorije“.',

        export: 'Izvoz v knjigovodstvo',
        export_hint: 'Knjiženi prejeti računi obdobja, predani v Minimax. Predogled ne pošlje ničesar; isto nespremenjeno obdobje da vedno isti odtis.',
        period_from: 'Od',
        period_to: 'Do',

        /* Poraba po stroškovnih mestih (docs/MATERIALNO-KNJIGOVODSTVO.md §4b). */
        consumption: 'Poraba po stroškovnih mestih',
        consumption_hint: 'Kaj so izdaje obdobja stale hišo, razdeljeno po stroškovnem mestu, oddelku ali razlogu. Vrednosti so iz FIFO posnetkov gibanj, zato zaključen mesec odgovarja enako tudi po spremembi cen.',
        consumption_empty: 'V tem obdobju ni bilo nobene izdaje.',
        group_by: 'Razdeli po',
        by_cost_centre: 'Stroškovnem mestu',
        by_department: 'Oddelku',
        by_reason: 'Razlogu',
        show: 'Prikaži',
        quantity: 'Količina',
        value: 'Vrednost',
        total: 'Skupaj',
        unattributed: 'Nerazporejeno',

        preview: 'Predogled',
        send: 'Pošlji v Minimax',
        send_confirm: 'V Minimax bo poslanih {count} računov za obdobje {from} – {to}. Dokumentov v tujem knjigovodstvu od tu ni mogoče preklicati. Nadaljujem?',
        sent: 'Poslano: {sent}, že tam: {skipped}.',
        sent_drafts: 'Poslano: {sent} (od tega osnutkov: {drafts}), že tam: {skipped}.',
        drafts_title: '{count} računov je pri knjigovodji kot osnutek',
        drafts_hint: 'Minimax prejeti račun potrdi šele, ko ima odhodek s kontom stroška; prek API-ja odhodka ni mogoče poslati. Knjigovodja na osnutku doda odhodek (konto je v opombi računa) in ga potrdi. Ponovni izvoz teh računov ne pošlje znova.',
        history_drafts: '{count} osnutkov',

        // Račun je pri knjigovodji, a brez analitike: stroškovnega mesta z dokumenta
        // Minimax ne pozna. Mesec se zato ne da razdeliti po oddelkih, dokler hiša SM
        // ne doda v Minimaxu in izvoza ne ponovi.
        unallocated_title: '{count} računov je poslanih brez analitike',
        unallocated_hint: 'Stroškovno mesto z dokumenta v Minimaxu ne obstaja, zato je račun poslan brez njega — strošek pristane na kontu in nikjer drugje. Dodaj stroškovno mesto v Minimaxu z isto šifro in ponovi izvoz.',
        unallocated_toast: 'Brez analitike: {count}.',
        history_unallocated: 'brez analitike: {count}',
        not_configured: 'Poverilnice niso vpisane',
        not_configured_hint: 'Nastavitve (zobnik) → Objekt in sobe → Objekti → odpri objekt → zavihek Materialno poslovanje → Knjigovodski program. Brez uporabniškega imena, gesla, ID-ja aplikacije, skrivnosti in organizacije se ne da poslati ničesar.',
        invoices: 'Računov',
        sendable: 'Za poslati',
        already_sent: 'Že tam',
        net: 'Neto',
        vat: 'DDV',
        gross: 'Bruto',
        hash: 'Odtis (SHA-256)',
        invoice: 'Račun',
        supplier: 'Dobavitelj',
        issued_on: 'Izdan',
        credit_note: 'Dobropis',
        attentions: 'Opozoril: {count}',
        history: 'Zgodovina izvozov',
        history_hint: 'Vsak izvoz nosi odtis, števce in to, koliko računov je bilo že v knjigovodstvu. Odtis je odgovor na vprašanje „je to isti mesec, ki sem ga poslal“.',
        history_empty: 'Še ni izvozov.',
        history_counts: '{invoices} računov · {lines} vrstic · {skipped} že tam',
        refused_toast: 'Minimax je zavrnil {count} računov.',
        refused_title: 'Zavrnjeni računi: {count}',
        refused_hint: 'Vsak od njih je ostal pri nas in ni v knjigovodstvu. Popravi, kar zavrnitev pove, in obdobje pošlji še enkrat — poslani računi se ne pošljejo dvakrat.',
        refused_show: 'Pokaži zavrnitve ({count})',
        refused_hide: 'Skrij zavrnitve',

        settings_title: 'Knjigovodski program (Minimax)',
        settings_hint: 'Račun hiše pri Minimaxu, prek katerega izvoz zapiše prejete račune. Poverilnice vpiše hiša; shranjene so zapečatene in se nikoli ne vrnejo na zaslon.',
        needs_title: 'Kaj je treba pripraviti',
        need_account: 'Račun pri Minimaxu, na katerega se knjižijo prejeti računi te hiše.',
        need_client: 'ID aplikacije in skrivnost — Minimax ju izda razvijalcu na zahtevek pri podpori.',
        need_app_password: 'Geslo za dostop zunanjih aplikacij: v Minimaxu „GESLA ZA DOSTOP ZUNANJIH APLIKACIJ“ › „NOVA APLIKACIJA“. Več zaporednih napačnih prijav aplikacijo zaklene.',
        need_organisation: 'ID organizacije — katera knjigovodska organizacija računa naj sprejme dokumente.',
        no_test_host: 'Testno okolje ni drug naslov',
        no_test_host_hint: 'Minimax ima en spletni naslov; kar loči vajo od pravih knjig, je ORGANIZACIJA. Preveri povezavo pokaže imena organizacij — preberi ime, preden pošlješ prvo obdobje.',
        organisations: 'Organizacije tega računa',
        verify: 'Preveri povezavo',
        verified: 'Povezava deluje.',
        check_accounts: 'Preveri konte',
        check_accounts_hint: 'Bere kontni načrt pri Minimaxu; v knjige ne zapiše ničesar.',
        check_accounts_summary: '{checked} kontov preverjenih, {missing} manjka, {notPostable} brez dovoljenja za knjiženje',
        check_accounts_empty: 'Nikjer ni vpisanega nobenega konta — ni kaj preveriti.',
        check_accounts_name: 'Ime (pri nas)',
        check_accounts_used_by: 'Kje se uporablja',
        check_accounts_state: 'Pri Minimaxu',
        check_accounts_present: 'v Minimaxu',
        check_accounts_missing: 'manjka',
        check_accounts_not_postable: 'knjiženje ni dovoljeno',
        check_accounts_ok: 'Vseh {count} kontov je v kontnem načrtu pri Minimaxu.',
        check_accounts_problems: 'Manjka {missing} kontov, {notPostable} jih ne dovoljuje knjiženja. Konto na osnutku izbere knjigovodja — če ga tam ni, ga ne bo mogel izbrati.',
        import_accounts: 'Uvozi kontni načrt iz Minimaxa',
        import_accounts_done: 'Uvoženih {created} novih, posodobljenih {updated}, {missing} kontov ni pri knjigovodji.',
        last_import: 'Zadnji uvoz {when}: {answer}',
        missing_at_minimax: 'ni pri knjigovodji',
        source_minimax: 'Minimax',
        source_house: 'ročno',
        base_url: 'Naslov API',
        base_url_hint: 'Privzeto https://moj.minimax.si/SI/API. Spremeni samo, če ti Minimax izrecno da drug naslov.',
        organisation_id: 'ID organizacije (Minimax: OrganisationId)',
        organisation_id_hint: 'Številka organizacije v Minimaxu. To je edina nastavitev, ki odloči, čigave knjige izvoz doseže.',
        username: 'Uporabniško ime zunanje aplikacije (Minimax: Uporabniško ime)',
        username_hint: 'Uporabnik API pri Minimaxu.',
        password: 'Geslo zunanje aplikacije (Minimax: Geslo)',
        password_hint: 'Geslo za dostop zunanjih aplikacij. Prazno polje pomeni „pusti shranjeno“; odstranitev je svoj gumb.',
        client_id: 'Client ID (Minimax API)',
        client_id_hint: 'Polovica para, ki ga izda Minimax. Skrit kot skrivnost, ker je par z eno odkrito polovico par z enim ugibom.',
        client_secret: 'Client secret (Minimax API)',
        client_secret_hint: 'Druga polovica para. Prazno polje pomeni „pusti shranjeno“.',
        secret_set: 'Shranjeno',
        clear: 'Odstrani',
        sealed: 'Zapečateno',
        sealed_hint: 'Vsa tri gesla so zapisana zapečatena s ključem namestitve in se ne vrnejo na zaslon. Zaslon izve samo, ali so vpisana.',
        status_incomplete: 'Račun še ni vpisan',
        status_incomplete_hint: 'Izpolni uporabniško ime, geslo aplikacije, ID aplikacije in skrivnost; ID organizacije izbereš po uspešni preverbi povezave.',
        status_no_organisation: 'Organizacija še ni izbrana',
        status_no_organisation_hint: 'Povezava deluje. Vpiši ID organizacije iz seznama spodaj in shrani.',
        status_untested: 'Povezava še ni preverjena',
        status_untested_hint: 'Pritisni „Preveri povezavo“ — bere samo seznam organizacij in v knjige ne zapiše ničesar.',
        status_working: 'Povezava deluje',
        status_checked: 'Zadnja preverba {when}: {answer}',

        tolerances_title: 'Tolerance ujembe',
        tolerances_hint: 'Koliko sme prevzem odstopati od naročilnice in računa, preden trismerna ujemba zavrne.',
        tolerances_rule: 'Znotraj tolerance se knjiži z zapisom razlike',
        tolerances_rule_hint: 'Razlika znotraj meje se knjiži in zapiše; razlika izven nje se zavrne in zavrnitev pove, katera vrstica, koliko in proti čemu (docs/MATERIALNO.md §10.7).',
        tolerance_amount: 'Znesek (%)',
        tolerance_amount_hint: 'Dovoljeno odstopanje skupnega zneska. Nič pomeni, da vsaka razlika zaokroževanja zavrne — kar je ujemba, ki nikoli ne uspe.',
        tolerance_quantity: 'Količina',
        tolerance_quantity_hint: 'Dovoljeno odstopanje količine, v enotah artikla.',
        tolerance_price: 'Cena (%)',
        tolerance_price_hint: 'Dovoljeno odstopanje cene na enoto.',
    },
    stock: {
        chain_item: 'Artikel verige: {code} — {name}',
        chain_item_hint: 'Ta artikel je v šifrantu verige. Naziv, enoto in davčno stopnjo določa veriga; spremenijo se v šifrantu verige in se od tam prenesejo sem. Vse ostalo — cena, minimum, dobavitelj, mesto — ostaja tvoje.',
        chain_locked: 'Določa veriga.',

        /* Izdaja: kam je blago šlo (docs/MATERIALNO-KNJIGOVODSTVO.md §4a). Razlog je bil
           prej vpisan v opombo kot besedilo, stroškovnega mesta pa ni bilo nikjer. */
        issue_reason: 'Razlog izdaje',
        issue_reason_department: 'Oddelek',
        issue_reason_consumption: 'Poraba',
        issue_department: 'Oddelek',
        no_department: 'Brez oddelka',
        cost_centre: 'Stroškovno mesto',
        cost_centre_help: 'Šifra iz šifranta stroškovnih mest. Ob izbiri oddelka se predlaga tisto, ki je nanj preslikano.',
        no_cost_centre: 'Brez stroškovnega mesta',
        same_as_document: 'Enako kot papir',

        document: 'Prevzemnica',
        lot_trace_title: 'Kje je serija',
        lot_trace_lead: 'Vpiši številko serije (lot) — pokaže, v katerih skladiščih je še in kam je že šla. Za odpoklic.',
        lot_trace_placeholder: 'Številka serije …',
        lot_trace_search: 'Poišči',
        lot_trace_empty: 'Serije „{lot}“ ni v nobenem prevzemu.',
        lot_trace_on_hand: 'Še na zalogi',
        lot_trace_gone: 'Že porabljeno',
        lot_trace_no_place: 'Brez skladišča',
        lot_trace_used: 'porabljeno {count}',
        lot_trace_takes: 'Kam je šlo',
        expires: 'Rok',
        gaps_title: 'Prodano brez kritja',
        gaps_lead: 'Zaloga, ki je odšla iz hotela, preden jo je katera koli plast plačala. Vsak zapis čaka, da ga ovrednoti naslednji prevzem istega artikla v isto skladišče.',
        gaps_empty: 'Ni zapisov.',
        gaps_open: 'Odprto',
        gaps_all: 'Vse',
        gaps_resolved: 'Ovrednoteno',
        gaps_from_sale: 'prodaja',
        gaps_from_entry: 'hitri vnos',
        net_content: 'Neto količina',
        net_content_hint: 'Kar je v eni enoti: 500 (g), 700 (ml), 1 (kos)',
        net_content_unit: 'Enota neto količine',
        comparative_price: 'Primerjalna cena',
        content_none: '—',
        content_gram: 'g (cena/kg)',
        content_millilitre: 'ml (cena/l)',
        content_piece: 'kos (cena/kos)',
        barcodes: 'Črtne kode',
        barcodes_empty: 'Artikel še nima kod.',
        barcode_add: 'Nova koda …',
        price_history: 'Zgodovina cene',
        price_now: 'zdaj',
        labels_print: 'Natisni cenovke',
        labels_none: 'Najprej izberi artikle.',
        needs_manage: 'Za urejanje artiklov, skladišč in dobaviteljev potrebuješ pravico Zaloga (šifranti).',
        needs_inventory: 'Inventuro knjiži nekdo s pravico Zaloga (inventura) — osnutek lahko shraniš in ga bo knjižil on.',
        invoice_title: 'Dobaviteljev račun',
        invoice_number: 'Številka računa',
        invoice_number_hint: 'Dobaviteljeva številka računa — po njej prepoznamo podvojen vnos',
        invoice_issued_on: 'Datum računa',
        invoice_delivered_on: 'Datum dobave',
        invoice_due_on: 'Rok plačila',
        invoice_due_on_hint: 'Neobvezno',
        invoice_bases: 'Davčne osnove po stopnjah',
        invoice_bases_empty: 'Vrstice še nimajo cen.',
        invoice_total: 'Skupaj',
        invoice_declared_net: 'Osnova z računa',
        invoice_declared_gross: 'Za plačilo z računa',
        invoice_difference: 'Znesek z računa se od vrstic razlikuje za {amount}. Razlika je lahko prevoz, embalaža ali popust — preveri, preden knjižiš.',
        invoice_attach: 'Pripni izvirnik',
        invoice_attached: 'Izvirnik je shranjen.',
        invoice_open: 'Odpri izvirnik',
        invoice_archived: 'Arhivirano',
        invoice_no_file: 'Izvirnika še ni.',
        invoice_save_first: 'Najprej shrani osnutek, nato pripni izvirnik.',
        archive_title: 'Arhiv prejetih računov',
        archive_lead: 'Prejeti računi se hranijo 10 let v obliki, v kateri so prispeli. Zgoščena vrednost dokazuje, da datoteka ni bila spremenjena. Seznam zajema izvirnike na prevzemnicah in na samostojnih računih.',
        archive_empty: 'V izbranem letu ni prejetih računov.',
        archive_source: 'Vir',
        archive_source_receipt: 'Prevzemnica',
        archive_source_invoice: 'Račun',
        archive_year: 'Leto',
        archive_missing: 'Brez izvirnika',
        archive_open: 'Odpri',
        setup_title: 'Zaloge in minibar',
        setup_hint: 'Kaj hotel hrani in kje. Sobarice na svojem portalu potem premikajo te stvari med temi mesti; minibar gre samodejno na račun sobe.',
        things: 'Artikli',
        places: 'Skladišča (mesta)',
        no_things: 'Ni artiklov.',
        no_places: 'Nič vpisanega.',
        add_item: 'Nov artikel',
        edit_item: 'Uredi artikel',
        add_place: 'Novo mesto',
        edit_place: 'Uredi mesto',
        name: 'Ime',
        kind: 'Vrsta',
        kind_hint: 'Perilo se pere in vrača, potrošni material se porabi, minibar se zaračuna gostu.',
        kind_linen: 'Perilo',
        kind_supply: 'Potrošni material',
        kind_minibar: 'Minibar',
        unit: 'Enota',
        minimum: 'Najmanjša zaloga',
        minimum_hint: 'Pod tem se pokaže opozorilo. Prazno pomeni, da tega nihče ne spremlja.',

        // Decimalne količine (docs/MATERIALNO.md §9g). Količina ostane celo število;
        // decimalke povedo le, koliko desetin enote je to.
        decimals:               'Decimalke',
        decimals_hint:          '0 = kosi · 1 = 0,1 · 2 = 0,01 · 3 = 0,001. Količine ostanejo cela števila; decimalke povedo, koliko desetin enote je ena.',
        decimals_rescale_hint:  'Sprememba prevrednoti VSE količine tega artikla — gibanja, plasti, vrstice papirjev in inventure. Zmanjšanje se zavrne, če bi katera koli količina izgubila decimalko.',
        decimals_0:             '0 — cele enote (kosi)',
        decimals_1:             '1 — 0,1',
        decimals_2:             '2 — 0,01',
        decimals_3:             '3 — 0,001',
        decimals_refused:       'Merila artikla ni bilo mogoče spremeniti.',

        errors: {
            decimals_would_round: 'Merila ni mogoče zmanjšati z {from} na {to} decimalk: v zbirki {where} je količina, ki bi izgubila decimalko. Popravite tisto količino ali izberite drobnejše merilo.',
            scale_changed: 'Artikel je bil medtem preskaliran — osveži obrazec in vpiši količino znova',
        },
        min_n: 'min. {count}',
        price: 'Cena',
        price_hint: 'Kar plača gost. Prepiše se na račun ob zapisu — poznejša sprememba cene ne spremeni starih računov.',
        tax_rate: 'DDV (%)',
        tax_rate_hint: 'Na primer 22 ali 9,5.',
        place_kind: 'Vrsta mesta',
        place_kind_hint: 'Perilo v pralnici ni zaloga, ki jo hotel danes lahko uporabi.',
        place_store: 'Skladišče',
        place_floor: 'Omara v nadstropju',
        place_trolley: 'Voziček',
        place_laundry: 'Pralnica',
        place_rooms: 'V sobah',
        mobility: 'Mobilnost',
        mobility_hint: 'Voziček se premika po hotelu, skladišče stoji. Vpliva na razvrščanje in poznejše štetje po mestih.',
        mobility_mobile: 'Mobilno',
        mobility_stationary: 'Stacionarno',
        place_default: 'Privzeto skladišče — ponujeno pri prevzemih in premikih',
        default_badge: 'privzeto',
        documents_title: 'Prevzemi in vrednost zaloge',
        documents_hint: 'Prevzem vknjiži dobavo in njeno nabavno ceno v zalogo. Stolpec vrednosti pokaže, koliko je polica vredna — najstarejše dobave se porabijo najprej (FIFO).',
        documents: 'Dokumenti',
        no_documents: 'Še ni dokumentov.',
        doc_receipt: 'Prevzem',
        doc_issue: 'Izdaja',
        doc_transfer: 'Prenos',
        doc_writeoff: 'Odpis',
        doc_inventory: 'Inventura',
        count_place: 'Mesto štetja',
        line_counted: 'Prešteto',
        book_n: 'knjižno {count}',
        status_draft: 'Osnutek',
        status_posted: 'Knjižen',
        post: 'Knjiži',
        posted: 'Knjiženo.',
        new_receipt: 'Nov prevzem',
        supplier: 'Dobavitelj',
        suppliers: 'Dobavitelji',
        no_suppliers: 'Še ni dobaviteljev.',
        suppliers_hint: 'Register dobaviteljev hotela. Davčna številka vodi obrazec — Preveri jo pogleda v evropski register DDV in izpolni ime ter naslov.',
        tax_lookup_help: 'Vpiši davčno in klikni Preveri — ostalo se izpolni samo.',
        address: 'Naslov',
        country: 'Država',
        web: 'Spletna stran',
        contacts: 'Kontakti',
        contacts_n: '{count} kontaktov',
        add_contact: 'Dodaj kontakt',
        contact_role: 'Vloga',
        contact_role_hint: 'npr. prodaja, dostava',
        rating_title: 'Ocena dobavitelja (ISO)',
        rating_quality: 'Kakovost',
        rating_delivery: 'Dobavni roki',
        rating_price: 'Cena',
        rating_cooperation: 'Odzivnost',
        rating_status: 'Status odobritve',
        rating_note: 'Utemeljitev',
        rating_status_approved: 'Odobren',
        rating_status_conditional: 'Pogojno odobren',
        rating_status_rejected: 'Neodobren',
        rating_evaluated: 'Zadnja ocena: {date}',
        add_supplier: 'Nov dobavitelj',
        edit_supplier: 'Uredi dobavitelja',
        tax_number: 'Davčna številka',
        reference: 'Št. dobavnice',
        reference_hint: 'Dobaviteljeva lastna številka, da se papir spet najde.',
        to_place: 'V mesto',
        lines: 'Postavke',
        line_item: 'Artikel',
        line_quantity: 'Količina',
        line_unit_cost: 'Cena/enoto',
        add_line: 'Dodaj postavko',
        save_draft: 'Shrani osnutek',
        save_and_post: 'Shrani in knjiži',
        value_title: 'Vrednost zaloge',
        no_value: 'Na polici še ni ničesar.',
        value_total: 'Skupaj',
        all_places: 'Vsa skladišča',
        export_excel: 'Excel',
        export_pdf: 'PDF',
        pieces: 'kos',
        new_document: 'Nov dokument',
        document_type: 'Vrsta dokumenta',
        document_type_hint: 'Prevzem vknjiži dobavo, izdaja in odpis knjižita zalogo ven, prenos jo premakne med mesti, inventura prešteje eno mesto in knjiži samo razlike. Naročilnica je pismo dobavitelju — zaloge ne premakne, dokler dobava ni prevzeta.',
        from_place: 'Iz mesta',
        consumption: 'Material',
        consumption_total: 'Porabljena vrednost',
        consumption_reason_hint: 'V obdobju',
        consumption_by_item: 'Po artiklih',
        consumption_by_place: 'Po mestih',
        consumption_by_room: 'Po sobah',
        no_consumption: 'V tem obdobju ni porabe.',
        no_consumption_rooms: 'V tem obdobju ni porabe, vezane na sobo.',
        reason_sold: 'Minibar prodano',
        reason_used: 'Porabljeno',
        reason_damaged: 'Poškodovano',
        reason_delivery: 'Prevzem',
        reason_transfer: 'Prenos',
        reason_soiled: 'V pralnico',
        reason_washed: 'Iz pralnice',
        reason_count: 'Inventurna razlika',
        card_balances: 'Stanje po skladiščih',
        card_ledger: 'Prejemi, izdaje in premiki',
        card_suppliers: 'Dobavitelji in cene',
        open_item_catalogue: 'Odpri katalog za ta artikel',
        open_catalogue: 'Katalog',
        card_empty: 'Ta artikel se še ni premaknil.',
        card_date: 'Datum',
        card_kind: 'Vrsta',
        card_route: 'Iz → v',
        card_value: 'Vrednost',
        page_hint: 'Stanje artiklov, skladišča, premiki in dokumenti na enem mestu.',
        // Branje, ki ni uspelo. Prazna tabela in „0 €“ pod njo sta trditvi o zalogi —
        // AppLoadError pove, da odgovora ni bilo.
        load_failed:        'Zalog ni bilo mogoče prebrati.',
        layers_load_failed: 'Serij tega artikla ni bilo mogoče prebrati.',
        tab_overview: 'Pregled',
        tab_warehouses: 'Skladišča',
        tab_movements: 'Premiki',
        kpi_items: '{count} aktivnih artiklov',
        kpi_critical: '{count} kritičnih',
        kpi_all_good: 'vse v redu',
        kpi_open_documents: 'Odprti dokumenti',
        kpi_drafts_hint: 'osnutki čakajo knjiženje',
        kpi_places_hint: '{count} mobilnih',
        attention_title: 'Zahteva pozornost',
        attention_open: '{count} odprtih',
        attention_empty: 'Nič ne čaka — zaloga je urejena.',
        attention_review: 'Preglej',
        warehouse_meta: '{count} artiklov · {value}',
        recent_documents: 'Zadnji dokumenti',
        all_documents: 'Vsi',
        quick_actions: 'Hitra dejanja',
        quick_receipt: 'Prejem blaga',
        quick_transfer: 'Premik med skladišči',
        quick_inventory: 'Inventura',
        all_items: 'Vsi artikli',
        all_reasons: 'Vse vrste',
        movements_empty: 'Ni premikov za izbrane filtre.',
        movements_load_failed: 'Premikov ni bilo mogoče prebrati.',

        // Dolgi seznami se berejo po straneh (docs/MATERIALNO.md §10). Vrstica pod
        // seznamom pove, kateri del celote je na zaslonu — brez nje je odrezan seznam
        // videti enako kot kratek.
        list_range: 'Prikazanih {from}–{to} od {total}',
        list_capped: 'zapisov je še več, kot jih strežnik prešteje — zoži filtre',
        list_previous: 'Nazaj',
        list_next: 'Naprej',
        list_load_more: 'Naloži več',
        status_ok: 'V redu',
        status_below: 'Pod minimumom',
        status_critical: 'Kritično',
        status_inactive: 'Neaktiven',
        col_quantity: 'Stanje',
        col_avg_cost: 'Nabavna cena',
        unknown_item: 'Neznan artikel',
        unknown_place: 'Neznano mesto',
        unknown_room: 'Neznana soba',
        ai_receipt: 'AI prevzem',
        ai_drop_here: 'Spusti dobavnico sem',
        ai_drop_hint: 'Klikni ali povleci dobavnico (slika ali PDF) kamorkoli na kartico.',
        tax_lookup: 'Preveri',
        tax_lookup_failed: 'Register DDV trenutno ne odgovarja — poskusi znova.',
        tax_lookup_invalid: 'Ta številka ni v registru zavezancev za DDV.',
        parse_failed: 'Dobavnice ni bilo mogoče prebrati.',
        parse_concerns: 'Bralnik je opazil',
        parse_new_supplier: '{name} še ni v registru dobaviteljev — shranjevanje prevzema ga bo dodalo.',
        parse_unmatched: 'Na papirju: {name}',
        below_minimum: 'Pod minimumom',
        held_of_min: '{held} od min. {minimum}',
        order_n: 'naroči {count}',
        doc_order: 'Naročilnica',
        status_ordered: 'Naročeno',
        issue_order: 'Izdaj',
        to_receipt: 'V prevzem',
        email_order: 'Pošlji po e-pošti',
        compose_order: 'Sestavi naročilnico',
        line_tax: 'DDV %',
        from_order_note: 'Po naročilnici {number}',
        order_mail_subject: 'Naročilo {number}',
        order_mail_body: 'Pozdravljeni,\n\nprosimo za dobavo:\n\n{lines}\n\nHvala in lep pozdrav.',
        last_supplier_hint: 'Zadnji dobavitelj: {name} · {price} €',
        doc_rfq: 'Povpraševanje',
        status_sent: 'Poslano',
        rfq_to_order: 'V naročilnico',
        from_rfq_note: 'Po povpraševanju {number}',
        rfq_mail_subject: 'Povpraševanje {number}',
        rfq_mail_body: 'Pozdravljeni,\n\nprosimo za ponudbo za:\n\n{lines}\n\nHvala in lep pozdrav.',
        send_to_suppliers: 'Pošlji dobaviteljem',
        line_needs_supplier: 'Vsaka postavka potrebuje dobavitelja.',
        sent_to_suppliers: 'Poslano dobaviteljem: {list}',
        drafts_created: 'Osnutki pripravljeni: {list}',
        col_item_count: 'Št. artiklov',
        tab_consumption: 'Poraba',
        section_basic: 'Osnovno',
        section_prices: 'Cene in DDV',
        section_stock: 'Zaloga',
        section_retail: 'Maloprodaja',
        section_tracing: 'Sledljivost',
        sku: 'Šifra',
        sku_hint: 'Interna šifra, edinstvena v objektu. Prazno = predlagamo jo sami.',
        sku_auto: 'ART-0001 (samodejno)',
        ean: 'Črtna koda (EAN)',
        ean_hint: '8, 12, 13 ali 14 števk.',
        ean_invalid: 'Koda mora imeti 8, 12, 13 ali 14 števk.',
        category: 'Kategorija',
        brand: 'Znamka',
        purchase_price: 'Nabavna cena',
        purchase_price_hint: 'Samodejno se posodobi ob vsakem knjiženem prevzemu; lahko jo popraviš ročno. Vrednost zaloge še naprej določa FIFO.',
        col_last_cost: 'Zadnja nabavna',
        pack_size: 'Pakiranje',
        pack_unit: 'Enota pakiranja',
        pack_hint: 'Npr. 6 × 0,25 l. Informativno — zaloga se šteje v osnovni enoti.',
        size: 'Velikost',
        color: 'Barva',
        photo: 'Fotografija',
        photo_after_save: 'Fotografijo lahko dodaš po prvem shranjevanju.',
        primary_place: 'Primarna lokacija',
        primary_place_hint: 'Kje artikel običajno stoji; predlaga se pri prevzemu.',
        default_supplier: 'Privzeti dobavitelj',
        default_supplier_hint: 'Naročilnica ga uporabi pred zgodovino zadnje dobave.',
        unit_mode: 'Način prodaje',
        unit_mode_hint: 'Pri teži in volumnu se šteje v CELIH osnovnih enotah — gramih oz. mililitrih (1,5 kg = 1500).',
        unit_mode_piece: 'Na kos',
        unit_mode_weight: 'Na težo (g)',
        unit_mode_volume: 'Na volumen (ml)',
        status: 'Stanje',
        status_hint: 'Nedosegljiv artikel ostane viden, a ga blagajna ne proda. Ukinjen je skrit povsod razen v zgodovini.',
        status_active: 'Aktiven',
        status_unavailable: 'Nedosegljiv',
        status_discontinued: 'Ukinjen',
        track_lot: 'Sledi lotom in rokom',
        track_lot_hint: 'Prevzem takega artikla mora navesti lot in rok uporabe.',
        storage_temp_min:  'Najnižja temperatura hrambe (°C)',
        storage_temp_max:  'Najvišja temperatura hrambe (°C)',
        storage_temp_hint: 'Neobvezno in neodvisno. Meritev ob prevzemu izven tega okna vrstico postavi v karanteno; prazno polje pomeni, da termometer o artiklu ne odloča.',
        lot: 'Lot',
        no_lot: 'Brez lota',
        expires_at: 'Rok uporabe',
        open_layers: 'Odprte plasti',
        expires_in_n_days: 'Poteče čez {count} dni',
        expired_n_days: 'Potekel pred {count} dnevi',
        vat_existing: '{rate} (obstoječe)',
        all_types: 'Vsi',
        sort_by_date: 'Po datumu',
        sort_by_type: 'Po vrsti',
        create_item_named: "Ustvari '{name}'",
        expected_at: 'Predvideni prevzem',
        expected_at_hint: 'Dan, ki ga obljubi dobavitelj. Brez njega naročila ni mogoče terjati.',
        ordered_title: 'Naročeno',
        ordered_hint: 'Kaj je še na poti. Prispelo se sešteva po vseh prevzemih na naročilo, tudi če pride v dveh dobavah.',
        no_ordered: 'Nič ni v naročilu.',
        late_n_days: 'Zamuda {count} dni',
        due_on: 'Rok {date}',
        no_due_date: 'Brez roka',
        outstanding: 'Še ni prispelo',
        order_progress: 'Prispelo {received} od {ordered}',
        receive_order: 'Prevzemi',
        receipt_for_order: 'Prevzem po naročilu {number}',
        against_order: 'Po naročilu {number}',
        variances: 'Odstopanja',
        no_variances: 'Brez odstopanj — dobava se ujema z naročilom.',
        variance_short: 'Manjkalo',
        variance_over: 'Preveč',
        variance_missing: 'Ni prispelo',
        variance_extra: 'Ni bilo naročeno',
        variance_price: 'Druga cena',
        variance_qty: 'naročeno {ordered}, prispelo {received}',
        variance_cost: 'cena {ordered} → {received}',
        delivered_on_time: 'Dostavljeno na obljubljeni dan',
        delivered_late: 'Dostavljeno {count} dni prepozno',
        delivered_early: 'Dostavljeno {count} dni prej',
        delivered_unpromised: 'Naročilo brez obljubljenega roka',
        pos_title: 'Bar in kuhinja (POS)',
        pos_hint: 'Bere se v živo iz Imprion POS, ki ostaja edina knjiga za hrano in pijačo. Ta zaslon samo gleda — prevzemi in inventure za bar se delajo v POS-u.',
        pos_empty: 'Nič ne ustreza.',
        pos_no_category: 'Brez kategorije',
    },
    guest_link: {
        button: 'Portal za gosta',
        title: 'Povezava za gosta',
        hint: 'Gost prek povezave vidi svoje bivanje, navodila za prihod in stanje računa. Povezava ostane ista, dokler je ne prekličete.',
        issue: 'Izdaj povezavo',
        copy: 'Kopiraj povezavo',
        copied: 'Povezava je kopirana.',
        revoke: 'Prekliči povezavo',
        revoked: 'Povezava je preklicana.',
        // Odkar povezava ne poteče več (docs/POTEK_GOSTA.md §9b), datum ni več konec
        // povezave, ampak konec njenega PRVEGA življenja. Receptorka mora to prebrati
        // tukaj: sicer bo gostu povedala, da povezava po tem datumu ne dela, in izdala
        // novo — s čimer bo staro ubila.
        expires: 'Velja v celoti do {date}; potem povezava ostane odprta kot spomin na bivanje (brez osebnih podatkov).',

        // Pošiljanje po WhatsAppu (docs/OBVESCANJE.md §10.9). Pošlje se ŽIVA povezava;
        // nova se izda samo, če je ni.
        whatsapp: 'Pošlji po WhatsAppu',
        whatsapp_sent: 'Pozdrav s povezavo je poslan na {number}.',
        whatsapp_failed: 'Pozdrava ni bilo mogoče poslati.',
        whatsapp_not_ready: 'Pošiljanje po WhatsAppu ni pripravljeno: v Nastavitve (zobnik) → Integracije in komunikacija → Obveščanje vklopi WhatsApp prek Twilia in vpiši predlogo pozdrava gostu.',
        add_phone: 'Dodaj telefonsko številko plačnika',
        add_phone_placeholder: '+386 40 123 456',
        phone_saved: 'Telefonska številka je shranjena na kartici gosta.',
        whatsapp_no_phone: 'Plačnik nima telefonske številke — vpiši jo na kartici gosta.',

        // Ista povezava po e-pošti in po SMS. Pošlje se ŽIVA povezava, tako kot pri
        // WhatsAppu; pismo je v gostovem jeziku, SMS pa je dolg natanko toliko, kolikor
        // ostane ob povezavi (docs/OBVESCANJE.md §10.9).
        email: 'Pošlji po e-pošti',
        email_sent: 'Povezava je poslana na {address}.',
        email_failed: 'Pisma ni bilo mogoče poslati.',
        email_no_address: 'Plačnik nima e-naslova — vpiši ga na kartici gosta.',
        add_email: 'Dodaj e-naslov plačnika',
        add_email_placeholder: 'ime.priimek@primer.si',
        email_saved: 'E-naslov je shranjen na kartici gosta.',

        sms: 'Pošlji po SMS',
        sms_sent: 'Povezava je poslana na {number}.',
        sms_failed: 'Sporočila SMS ni bilo mogoče poslati.',
        sms_not_ready: 'SMS ni nastavljen: Nastavitve (zobnik) → Integracije in komunikacija → Obveščanje.',
        sms_no_phone: 'Plačnik nima telefonske številke — vpiši jo na kartici gosta.',
    },
    general: {
        previous: 'Prejšnja',
        next: 'Naslednja',
        hint: 'Namig',
        clear: 'Počisti',
        refresh: 'Osveži',
        // Ponovno branje po napaki — AppLoadError.vue. Ločeno od „Osveži“: to je gumb
        // na mestu, kjer podatkov NI, in ne na seznamu, ki je bil prebran.
        try_again: 'Poskusi znova',
        activate: 'Vklopi',
        deactivate: 'Izklopi',
        deleted: 'Izbrisano',
        saved: 'Shranjeno',
        add:     'Dodaj',
        edit:    'Uredi',
        delete:  'Izbriši',
        cancel:  'Prekliči',
        save:    'Shrani',
        close:   'Zapri',
        search:  'Iskanje',
        confirm: 'Potrdi',
        select_confirm: 'Potrdi',
        selected_count: 'izbranih: {count}',
        yes:     'Da',
        no:      'Ne',
        back:    'Nazaj',
        actions: 'Dejanja',
        show_password: 'Pokaži geslo',
        hide_password: 'Skrij geslo',
        pick_date: 'Izberi datum',
        no_data: 'Ni podatkov',
        loading: 'Nalaganje …',
        active:  'Aktiven',
        inactive: 'Neaktiven',
        from:    'Od',
        to:      'Do',
        all:     'Vse',
        today:   'Danes',
        name:    'Naziv',
        code:    'Koda',
        description: 'Opis',
        confirm_delete: 'Res želiš izbrisati ta zapis?',
        notes:   'Opombe',
        status:  'Status',
        email:   'E-pošta',
        phone:   'Telefon',
    },
    business_register: {
        nav: 'Poslovni register',
        no_property: 'Najprej izberi objekt.',
        title: 'AJPES — Poslovni register Slovenije',
        hint: 'Kdo sme zakonito zastopati podjetje: direktor, prokurist, likvidator. To je edini vir tega podatka — seznam davčnih zavezancev (FURS) oseb sploh ne vsebuje.',
        needs_title: 'Kaj mora hotel urediti pri AJPES',
        need_account: 'Uporabniški račun na www.ajpes.si. To je ISTI račun kot za eTurizem — uporabniško ime in geslo portala.',
        need_order: 'Naročilnico „Naročilo za uporabo podatkov PRS — SFTP ali restPrsInfo“, podpisano in poslano na prs@ajpes.si. V njej je obvezen namen uporabe podatkov.',
        need_schema: 'Kupljen paket enot. Zastopnike vrne samo ŠIRŠI nabor (PRS_SN_E ali PRS_SN_P); ožji in minimalni ne. Vsako vprašanje se plača po enoti.',
        need_certificate: 'Kvalificirano digitalno potrdilo, vpisano v profil na AJPES. AJPES brez njega ne vrne osebnih podatkov — torej imen zastopnikov.',
        status_unset: 'Ni nastavljeno',
        status_unset_hint: 'Dokler ni uporabniškega imena in gesla, hiša tega registra ne more vprašati ničesar. Vse drugo deluje naprej.',
        status_working: 'Deluje',
        status_failing: 'Ne deluje',
        status_never_checked: 'Povezava še ni bila preverjena.',
        status_last: 'Zadnja preveritev {date}: {message}',
        username: 'Uporabniško ime AJPES',
        username_hint: 'Isto kot za prijavo na www.ajpes.si.',
        password: 'Geslo AJPES',
        password_hint: 'Vpiši geslo. Shrani se šifrirano in se nikoli ne vrne na zaslon.',
        password_stored: 'Geslo je shranjeno. Pusti prazno, da ostane nespremenjeno.',
        password_set: '••••••••  (shranjeno)',
        clear_password: 'Odstrani geslo',
        password_cleared: 'Geslo je odstranjeno.',
        schema: 'Šifra storitve',
        schema_hint: 'Paket, ki ga je hiša naročila pri AJPES. Odloča, kako širok je odgovor in koliko stane posamezno vprašanje.',
        schema_set_wider: 'širši nabor',
        schema_set_narrow: 'ožji nabor',
        schema_set_minimal: 'minimalni nabor',
        schema_kind_unit: 'enota',
        schema_kind_query: 'poizvedba',
        too_long: 'Vrednost je predolga.',
        schema_too_narrow: 'Ta paket ne vrača zastopnikov',
        schema_too_narrow_hint: 'Ožji in minimalni nabor odgovorita na vse o podjetju razen na osebe. To ni napaka in ni podatek, da podjetje nima direktorja — vprašanje o osebah preprosto ni bilo kupljeno.',
        environment: 'Okolje',
        environment_hint: 'Testno okolje AJPES odgovarja le za tri podjetja ene majhne občine in ima svoje uporabniško ime, ki ga AJPES pošlje po elektronski pošti.',
        test: 'Testno okolje AJPES',
        verify: 'Preveri povezavo',
        verified: 'Račun AJPES deluje: {account}',
        verified_found: 'Register je odgovoril: {name}',
        verified_not_found: 'Račun deluje, register pa ni odgovoril na poskusno vprašanje: {reason}',
        no_certificate: 'Na računu ni vpisanega digitalnega potrdila. AJPES brez njega ne vrne imen zastopnikov.',
        units_left: 'ostane {count} enot',
        verify_failed: 'Povezave ni bilo mogoče preveriti',
        sealed: 'Geslo je šifrirano',
        sealed_hint: 'Shrani se s ključem namestitve in se nikoli ne vrne na zaslon ne v odgovor API-ja.',
        saved: 'Nastavitve so shranjene.',
        tax_list_title: 'Seznam davčnih zavezancev (FURS) je nekaj drugega',
        tax_list_hint: 'Iskanje podjetja po imenu, davčni številki in naslovu teče iz javnega seznama FURS, ki se prenese vsako noč. Je brezplačno, ne potrebuje računa in ne vsebuje oseb. Tu nastavljaš samo register zastopnikov.',
        panel_title: 'Zastopniki (AJPES)',
        panel_hint: 'Kdo sme podpisati za to podjetje. Vprašanje gre v državni register ob pritisku na gumb; odgovor se nikamor ne shrani.',
        panel_bizi: 'Poglej na bizi.si',
        panel_ask: 'Preveri v AJPES',
        panel_idle: 'Še ni bilo vprašano. Vsako vprašanje se plača po enoti iz paketa hiše.',
        panel_failed: 'Registra ni bilo mogoče vprašati',
        panel_nobody: 'Register ne navaja nobenega zastopnika',
        panel_since: 'vpisan {date}',
        panel_source: 'Vir: {source} · vprašano {at}. Ni shranjeno pri podjetju.',
        fact_registration: 'Matična številka',
        fact_activity: 'Glavna dejavnost',
        fact_seat: 'Sedež',
        fact_entered: 'Datum vpisa',
    },
    crm: {
        tab_overview: 'Pregled',
        tab_timeline: 'Časovnica',
        tab_stays: 'Bivanja',
        tab_preferences: 'Preference',
        tab_internal: 'Interno',
        // Sporočilo, ki ga je gost napisal Milu in ga potrdil — edini vpis na tej
        // časovnici, ki ne prihaja od hiše, ampak od gosta.
        event_guest_message: 'Sporočilo gosta (Milo)',
        tag_new: 'Nov gost',
        tag_repeat: 'Ponovni gost',
        tag_inactive: 'Neaktiven',
        tag_problem: 'Problematičen',
        tag_add: 'Dodaj oznako',
        tag_remove: 'Klik odstrani oznako',
        tag_placeholder: 'Nova oznaka …',
        marketing_yes: 'Marketinško soglasje',
        marketing_no: 'Brez marketinškega soglasja',

        // Marketinško soglasje (docs/MARKETING.md §13). Štiri stanja in ne kljukica:
        // „nismo vprašali“ in „vprašali smo in je rekel ne“ nista ista stvar.
        consent_title:  'Soglasje za marketing',
        consent_record: 'Zabeleži soglasje',
        consent_note:   'Opomba',
        consent_note_hint: 'kaj je gost dejansko rekel',
        consent_hint:   'Pisma kampanj gredo samo gostom z veljavnim soglasjem in naslovom, ki ni na seznamu zavrnjenih.',
        consent_source_desk: 'Zabeleži se kot soglasje, sprejeto na recepciji. Kljukice, ki jo gost obkljuka sam, recepcija ne more vpisati namesto njega.',

        consent_granted:   'Dovoljeno',
        consent_refused:   'Zavrnjeno',
        consent_withdrawn: 'Preklicano',
        consent_none:      'Ni vprašano',

        consent_source_check_in:         'ob spletni prijavi',
        consent_source_portal:           'v gostovem portalu',
        consent_source_import:           'iz uvoza',
        consent_source_unsubscribe_link: 'prek povezave v pismu',
        new_reservation: 'Nova rezervacija',
        add_task: 'Dodaj opravilo',
        contact: 'Kontakt',
        stat_next: 'Naslednji prihod',
        stat_last: 'Zadnje bivanje',
        stat_stays: 'Bivanj',
        stat_nights: 'Nočitev',
        stat_spend: 'Poraba',
        stat_average: 'Povpr. bivanje',
        stat_open: 'Neporavnano',
        stat_tasks: 'Odprta opravila',
        timeline_empty: 'Še ni dogodkov — nastanejo z rezervacijami, prijavami in računi.',
        stays_empty: 'Še ni bivanj.',
        preferences_standing: 'Stalne preference',
        preferences_sensitive: 'Občutljive informacije',
        preferences_sensitive_hint: 'Alergije in podobno: samo za pripravo sobe in strežbo, nikoli za marketing.',
        note_placeholder: 'Interna opomba o gostu …',
        note_add: 'Dodaj',
        tasks: 'Opravila',
        crm: 'CRM pregled',
        crm_group: 'CRM',
        crm_overview: 'CRM pregled',
        crm_manager: 'CRM vodstvo',
        tasks_for_guest: 'Opravila za gosta',
        tasks_open: 'Odprta',
        tasks_all: 'Vsa',
        tasks_empty: 'Ni opravil.',
        task_assigned: 'Odgovoren',
        task_unassigned: 'Brez odgovornega',
        task_overdue: 'Zapadlo',
        tasks_mine: 'Moja opravila',
        task_title: 'Naslov',
        task_note: 'Opomba',
        task_due: 'Rok',
        task_done: 'Opravljeno',
        task_saved: 'Opravilo je shranjeno.',
        segments: 'Segmenti',
        segments_hint: 'Vsi pogoji morajo veljati hkrati. Člani se izračunajo sproti — segment ni nikoli zastarel seznam.',
        back_to_manager: 'Nazaj na vodstveni pregled',
        segments_saved: 'Shranjeni segmenti',
        segments_none: 'Še ni shranjenih segmentov.',
        segment_add_condition: 'Dodaj pogoj',
        segment_preview: 'Prikaži člane',
        segment_name: 'Ime segmenta …',
        segment_saved: 'Segment je shranjen.',
        segment_members: 'Člani ({count})',
        segment_empty: 'Noben gost ne ustreza pogojem.',
        field_marketing_consent: 'Marketinško soglasje',
        field_email_consent: 'Soglasje za e-pošto',
        field_min_stays: 'Število bivanj',
        field_last_stay_days_ago: 'Zadnje bivanje',
        field_stayed_within_days: 'Bival v zadnjih',
        field_total_spend_min: 'Skupna poraba',
        field_country: 'Državljanstvo',
        field_no_future_reservation: 'Brez prihodnje rezervacije',
        field_open_balance: 'Neporavnan znesek',
        field_tag: 'Oznaka',
        op_is: 'je',
        op_at_least: 'vsaj',
        op_more_than_days: 'pred več kot (dni)',
        op_within_days: 'v zadnjih (dneh)',
        op_at_least_eur: 'vsaj (€)',
        op_equals: 'je enako',
        opportunities: 'Priložnosti',
        contacts: 'Kontaktne osebe',
        contact_name: 'Ime in priimek',
        contact_role: 'Vloga',
        contact_add: 'Dodaj kontakt',
        contracts: 'Pogodbe',
        contract_name: 'Ime pogodbe …',
        contract_terms: 'Dogovorjene ugodnosti …',
        contract_add: 'Dodaj pogodbo',
        credit_limit: 'Kreditni limit',
        payment_terms: 'plačilni rok {days} dni',
        receivables_badge: 'Odprte terjatve: {amount}',
        linked_guests: 'Povezani gostje',
        stat_reservations: 'Rezervacij',
        stat_revenue: 'Promet',
        stat_receivables: 'Terjatve',
        stat_deals: 'Odprte priložnosti',
        stage_inquiry: 'Povpraševanje',
        stage_qualified: 'Kvalificirano',
        stage_offer: 'Ponudba',
        stage_negotiation: 'Pogajanja',
        stage_won: 'Dobljeno',
        stage_lost: 'Izgubljeno',
        stage_back: 'Korak nazaj',
        stage_forward: 'Korak naprej',
        type_contract: 'Poslovna pogodba',
        type_group: 'Skupinska rezervacija',
        type_event: 'Dogodek',
        type_agency: 'Agencija',
        type_private: 'Zasebni obisk',
        deal_title: 'Naslov priložnosti …',
        deal_value: 'Vrednost (€)',
        deal_guests: 'Št. oseb',
        deal_rooms: 'Št. sob',
        deal_room_types: 'Tipi sob …',
        deal_note: 'Podrobnosti povpraševanja: dodatne dejavnosti, najem dvorane, najem koles …',
        deal_guests_n: '{count} oseb',
        deal_rooms_n: '{count} sob',
        deal_title_label: 'Naziv',
        deal_type_label: 'Tip',
        deal_value_auto: 'Prazno = samodejno iz vrstic.',
        deal_value_auto_short: 'samodejno',
        deal_lines: 'Vrstice povpraševanja',
        deal_note_label: 'Podrobnosti',
        line_room_type: 'Tip sobe',
        line_nights: 'Nočitve',
        line_nights_short: 'noč.',
        line_guests_short: 'os.',
        line_date: 'Datum',
        line_facility: 'Zmogljivost',
        line_quantity: 'Količina',
        line_note: 'Opomba',
        line_note_hint: 'npr. registrska številka',
        line_add_room: 'Dodaj sobo',
        deal_add: 'Dodaj priložnost',
        desk_today: 'Za recepcijo — danes',
        today_notable: 'VIP in ponovni gostje danes',
        today_incomplete: 'Prihodi brez dokumenta',
        numbers: 'Številke',
        open_tasks: 'Odprta opravila',
        guests_with_balance: 'Gostje z neporavnanim',
        management: 'Za vodstvo',
        guests_total: 'Vseh gostov',
        guests_new: 'Novi (1 bivanje)',
        guests_repeat: 'Ponovni',
        revenue_total: 'Promet gostov',
        revenue_repeat: 'Promet ponovnih',
        top_companies: 'Najuspešnejša podjetja',
        win_back: 'Vredni ponovnega nagovora',
        win_back_hint: 'Bivali, brez prihodnje rezervacije, tiho več kot 10 mesecev.',
        birthdays: 'Prihajajoči rojstni dnevi',
        birthdays_hint: 'Samo gostje z marketinškim soglasjem.',
    },
    crmm: {
        compare: 'Primerjaj z lani',
        compare_on: 'Primerjava z lani',
        tab_overview: 'Pregled',
        tab_sales: 'Prodaja',
        tab_guests: 'Gostje',
        tab_corporate: 'Podjetja',
        period_year: 'Letos',
        period_90: 'Zadnjih 90 dni',
        period_month: 'Ta mesec',
        title_overview: 'CRM pregled vodstva',
        sub_overview: 'Od odnosa z gostom do prodajnega rezultata',
        title_sales: 'Prodaja in priložnosti',
        sub_sales: 'Vrednost, verjetnost, hitrost in naslednji koraki',
        title_guests: 'Gostje in zvestoba',
        sub_guests: 'Retencija, vrednost gosta in aktivacijski segmenti',
        title_corporate: 'Poslovni partnerji',
        sub_corporate: 'Prihodek, pogodbe, terjatve in tveganja',
        guest_revenue: 'Prihodek gostov',
        repeat_share: 'Delež ponovnih gostov',
        weighted_pipeline: 'Utežen prodajni lijak',
        company_receivables: 'Terjatve podjetij',
        open_deals_n: '{n} odprtih priložnosti',
        overdue_n: '{amount} zapadlih',
        revenue_split: 'Prihodek novih in ponovnih gostov',
        new: 'Novi',
        repeat: 'Ponovni',
        needs_attention: 'Zahteva pozornost',
        open_pipeline: 'Odprt pipeline',
        win_rate: 'Uspešnost (win rate)',
        avg_cycle: 'Povprečen cikel',
        won_lost: 'dobljeno {won} · izgubljeno {lost}',
        days: '{n} dni',
        funnel: 'Prodajni lijak',
        probability: 'verjetnost',
        open_deals: 'Odprte priložnosti',
        no_company: 'brez podjetja',
        active_guests: 'Aktivni gostje',
        repeat_guests: 'Ponovni gostje',
        avg_guest_value: 'Povprečna vrednost gosta',
        reachable: 'Marketinško dosegljivi',
        top_segments: 'Segmenti z največjim potencialom',
        retention: 'Retencija po prvem bivanju',
        retention_note: 'Retencija uporablja kohorto prvega odhoda, ne vseh gostov v zbirki.',
        corporate_revenue: 'Prihodek podjetij',
        active_partners: 'Aktivni partnerji',
        with_contract: '{n} s pogodbo',
        company_adr: 'ADR podjetij',
        overdue_receivables: 'Zapadle terjatve',
        key_partners: 'Ključni partnerji',
        revenue: 'Prihodek',
        nights: 'Nočitve',
        receivables: 'Terjatve',
        contracts_risks: 'Pogodbe in tveganja',
        points: 'odst. točke',
        vs_last_year: 'glede na lani',
    },
    /**
     * „Kaj me čaka“ — operativni pregled materialnega poslovanja
     * (docs/MATERIALNO.md §10.11).
     *
     * Vrstice pridejo s strežnika že urejene in že izračunane; tu so samo besede.
     * `kind_*` je, KAJ vrstica je, `fig_*` in `total_*` sta številki ob njej.
     */
    materialsOverview: {
        title: 'Materialno — pregled',
        lead: 'Kaj čaka prav tebe: vsaka vrstica ima znesek ali količino, odgovorno osebo, koliko časa že čaka in gumb na zaslon, ki jo zapre. Razvrščeno po nujnosti, ne po času vpisa.',
        read_at: 'Prebrano ob {time}',
        no_panels: 'Tvoj račun nima nobene pravice v materialnem poslovanju, zato tu ni plošče. To ni isto kot „nič te ne čaka“ — za dostop vprašaj skrbnika.',
        panel_empty: 'Nič ne čaka. Ta plošča je prazna, ker res ni ničesar odprtega.',
        next_step: 'Odpri',
        due: 'Rok',
        age_hours: '{count} h',
        age_days: '{count} dni',
        more_n: 'in še {count} × {kind}',

        panel_storekeeper: 'Skladiščnik',
        panel_buyer: 'Nabavnik',
        panel_head_of_department: 'Vodja oddelka',
        panel_accounting: 'Računovodstvo',
        panel_director: 'Direktor',

        badge_late: 'zamuja {count} dni',
        badge_escalated: 'eskalirano',
        badge_over_budget: 'čez načrt',
        badge_no_budget: 'ni načrta',
        badge_credit_note: 'dobropis',

        kind_delivery_today: 'Dobava danes',
        kind_receipt_draft: 'Nedokončan prevzem',
        kind_quarantine: 'Karantena',
        kind_return_pending: 'Vračilo v osnutku',
        kind_count_task: 'Moja inventura',
        kind_expiring_lot: 'Poteka',
        kind_to_order: 'Za naročilo',
        kind_supplier_late: 'Dobavitelj zamuja',
        kind_rfq_open: 'Odprto povpraševanje',
        kind_requisition_to_order: 'Odobreno, ni naročeno',
        kind_approval_pending: 'Čaka mojo odobritev',
        kind_budget_remaining: 'Ostanek načrta',
        kind_invoice_unposted: 'Neknjižen račun',
        kind_credit_note_expected: 'Pričakovan dobropis',
        kind_export_refusal: 'Zavrnjen izvoz',
        kind_export_drafts: 'Osnutki pri knjigovodji',
        kind_accounts_check: 'Konti se ne ujemajo',
        kind_accounts_check_never: 'Konti še niso preverjeni',
        kind_stock_value: 'Vrednost zaloge',
        kind_money_tied_up: 'Vezan denar',
        kind_write_off: 'Odpis',
        kind_budget_deviation: 'Odstopanje od načrta',
        kind_top_supplier: 'Največji dobavitelj',

        fig_lines: 'postavk',
        fig_ordered: 'naročeno',
        fig_received: 'prejeto',
        fig_lines_counted: 'prešteto',
        fig_lines_expected: 'vseh vrstic',
        fig_days_left: 'dni do poteka',
        fig_on_hand: 'na zalogi',
        fig_on_order: 'na poti',
        fig_minimum: 'minimum',
        fig_suppliers: 'dobaviteljev',
        fig_remaining_cents: 'ostanek načrta',
        fig_planned_cents: 'načrtovano',
        fig_actual_cents: 'porabljeno',
        fig_consumption_cents: 'izdano ta mesec',
        fig_tolerance_breaches: 'izven tolerance',
        fig_invoices: 'računov',
        fig_skipped: 'preskočenih',
        fig_days_cover: 'dni pokritja',
        fig_pct_used: 'porabljeno',

        total_incoming_value_cents: 'Vrednost dobav',
        total_quarantine_open: 'Odprtih neskladij',
        total_to_order_value_cents: 'Za naročilo',
        total_late_value_cents: 'V zamudi',
        total_approved_value_cents: 'Odobreno, ni naročeno',
        total_pending_cents: 'Čaka odobritev',
        total_pending_count: 'Papirjev',
        total_unposted_cents: 'Neknjiženo',
        total_unposted_count: 'Računov',
        total_credit_notes_expected_cents: 'Pričakovani dobropisi',
        total_export_refusals: 'Zavrnitev',
        total_export_drafts: 'Osnutkov',
        total_stock_value_cents: 'Vrednost zaloge',
        total_write_off_cents: 'Odpisano ta mesec',
    },
    materialsOrder: {
        title: 'Naročilnice',
        lead: 'Naročilnica ima svoje življenje: osnutek → odobreno → poslano → potrjeno → delno dobavljeno → zaprto ali preklicano. Kaj je prispelo, se sešteje iz prevzemov in se ne vpisuje.',
        detail_lead: 'Kaj je naročeno, kaj je prišlo in kaj se je z naročilnico dogajalo.',
        heading: 'Naročilnica {number}',
        empty: 'Ni naročilnic.',
        not_found: 'Naročilnice ni.',
        filter_status: 'Stanje',
        filter_status_help: 'Odprto je vse od „poslano“ do „delno dobavljeno“ — takrat hiša nekaj čaka.',
        filter_all: 'Vsa',
        lines: 'Postavke',
        lines_n: '{count} postavk',
        outstanding_lines_n: 'še {count} artiklov ni prispelo',
        expected_at: 'Rok dobave',
        article: 'Artikel',
        ordered: 'Naročeno',
        received: 'Prevzeto',
        outstanding: 'Odprto',
        unit_cost: 'Cena na enoto',
        from_rfq: 'Iz povpraševanja',
        timeline: 'Potek',
        step_created: 'Napisana',
        step_approved: 'Odobrena',
        step_sent: 'Poslana dobavitelju',
        step_confirmed: 'Dobavitelj potrdil',
        step_closed: 'Zaprta',
        sent_by_hand: 'brez e-naslova (po telefonu)',
        status_draft: 'Osnutek',
        status_approved: 'Odobreno',
        status_sent: 'Poslano',
        status_confirmed: 'Potrjeno',
        status_partially_delivered: 'Delno dobavljeno',
        status_closed: 'Zaprto',
        status_cancelled: 'Preklicano',
        action_approve: 'Odobri',
        action_send: 'Pošlji dobavitelju',
        action_confirm: 'Vnesi potrditev',
        action_close: 'Zapri',
        action_cancel: 'Prekliči',
        done_approve: 'Naročilnica je odobrena.',
        done_send: 'Naročilnica je poslana dobavitelju.',
        done_confirm: 'Potrditev dobavitelja je zabeležena.',
        done_close: 'Naročilnica je zaprta.',
        done_cancel: 'Naročilnica je preklicana.',
        sent_without_mail: 'Naročilnica je označena kot poslana — dobavitelj nima e-naslova, zato pismo ni odšlo.',
        confirmation_number: 'Številka potrditve',
        confirmation_number_help: 'Dobaviteljeva lastna oznaka naročila. Neobvezna — manjši dobavitelj potrdi po telefonu.',
        promised_on: 'Obljubljeni datum',
        promised_on_help: 'Dan, ki ga je obljubil dobavitelj. Stoji ob našem roku dobave in ga ne prepiše.',
        reason: 'Razlog',
        reason_help: 'Obvezen. Zaprta ali preklicana naročilnica je denar, ki ga hiša ni porabila, in blago, ki ga oddelek še čaka — čez tri tedne kdo vpraša, kdo je to ustavil.',
    },
    materialsRfq: {
        title: 'Povpraševanja',
        lead: 'En seznam artiklov, poslan več dobaviteljem, in ena primerjalna tabela iz njihovih odgovorov. Izbira napiše naročilnico s ponujenimi cenami.',
        detail_lead: 'Kdo je bil vprašan, kaj so odgovorili in kaj smo izbrali.',
        heading: 'Povpraševanje {number}',
        add: 'Novo povpraševanje',
        empty: 'Ni povpraševanj.',
        not_found: 'Povpraševanja ni.',
        created: 'Povpraševanje je ustvarjeno.',
        filter_status: 'Stanje',
        filter_status_help: 'Osnutek je še v pisanju, poslano čaka ponudbe, zaprto pomeni, da je vsaka vrstica naročena.',
        filter_all: 'Vsa',
        status_draft: 'Osnutek',
        status_sent: 'Poslano',
        status_closed: 'Zaprto',
        suppliers: 'Dobavitelji',
        suppliers_help: 'Vsi dobijo ISTO pismo. Trije, ki odgovarjajo na tri različne sezname, dajo tri cene, ki jih ni mogoče primerjati.',
        suppliers_n: '{count} dobaviteljev',
        due_on: 'Rok za odgovor',
        due_on_help: 'Dan, do katerega hiša pričakuje ponudbo. Neobvezen.',
        note: 'Opomba',
        lines: 'Artikli',
        lines_n: '{count} artiklov',
        add_line: 'Dodaj vrstico',
        no_lines: 'Vpiši vsaj en artikel.',
        article: 'Artikel',
        quantity: 'Količina',
        action_send: 'Pošlji dobaviteljem',
        action_quote: 'Vnesi ponudbo',
        action_choose: 'Ustvari naročilnice',
        sent: 'Povpraševanje je poslano ({count} pisem).',
        sent_with_skipped: 'Poslano ({count} pisem). Brez e-naslova: {names} — te je treba poklicati.',
        send_sent: 'Poslano ({count} dobaviteljem)',
        send_failed: 'Ni poslano ({count} dobaviteljem)',
        send_no_address: 'brez e-naslova',
        comparison: 'Primerjava ponudb',
        comparison_help: 'Po artiklih: cena vsakega dobavitelja, najcenejša označena, skupaj po dobavitelju in manjkajoče vrstice. „Zadnja cena“ je zadnja nabavna cena artikla.',
        no_comparison: 'Primerjave še ni.',
        reference_price: 'Zadnja cena',
        no_answer: 'ni odgovoril',
        missing: 'ni ponudil',
        missing_n: 'manjka {count} vrstic',
        not_comparable: 'druga valuta',
        lead_days_n: '{count} dni',
        moq_n: 'min. {count}',
        total: 'Skupaj',
        chosen: 'Izbrano',
        choose_line: 'Izberi to vrstico',
        choose_supplier: 'Dobavitelj',
        choose_supplier_help: 'En pritisk je ena naročilnica pri enem dobavitelju. Seznam se sme razdeliti — drugi del izberi z drugim pritiskom.',
        pick_cheapest: 'Označi najcenejšega',
        chosen_done: 'Nastala je naročilnica {numbers}.',
        quote_title: 'Ponudba dobavitelja',
        quote_supplier: 'Dobavitelj',
        quote_supplier_help: 'Druga ponudba istega dobavitelja zamenja prvo — popravek cene je eno povpraševanje v dveh pismih.',
        quote_received_on: 'Prejeto',
        quote_received_on_help: 'Dan, ko je ponudba prišla. Prazno pomeni danes.',
        quote_note: 'Opomba',
        quote_price: 'Cena na enoto',
        quote_packaging: 'Pakiranje',
        quote_lead_days: 'Dobavni rok (dni)',
        quote_moq: 'Najmanjše naročilo',
        quote_no_lines: 'Vpiši vsaj eno ceno.',
        quote_saved: 'Ponudba je vnesena.',
    },
    /**
     * Zahtevki, odobritve in pravila odobritev (docs/MATERIALNO-ZAHTEVKI.md, WP-M4).
     */
    materialsRequisition: {
        title: 'Zahtevki',
        lead: 'Oddelek napiše, kaj potrebuje; kdor sme porabiti denar, to odobri; šele nato nastane naročilnica. Ocena je kataloška cena v trenutku, ko je bil zahtevek napisan.',
        detail_lead: 'Kaj je bilo zahtevano, na čigavi mizi je zahtevek in kaj je iz njega nastalo.',
        heading: 'Zahtevek {number}',
        add: 'Nov zahtevek',
        edit: 'Uredi zahtevek',
        empty: 'Ni zahtevkov.',
        not_found: 'Zahtevka ni.',
        filter_all: 'Vsi',
        filter_mine: 'Samo moji',
        filter_mine_help: 'Pokaže samo zahtevke, ki si jih napisal sam. Odobritelj privzeto vidi vse.',
        status_draft: 'Osnutek',
        status_submitted: 'Oddan',
        status_approved: 'Odobren',
        status_rejected: 'Zavrnjen',
        status_ordered: 'Naročen',
        status_cancelled: 'Preklican',
        department: 'Oddelek',
        department_help: 'Kdo bo blago porabil. Obvezen — po njem se ve, koga vprašati, ko zahtevek obstane.',
        cost_centre: 'Stroškovno mesto',
        cost_centre_help: 'Šifrant knjigovodstva. Neobvezno — brez njega se strošek razporedi po pravilih kategorije.',
        no_cost_centre: 'Brez stroškovnega mesta',
        needed_on: 'Potrebujem do',
        needed_on_help: 'Dan, ko mora biti blago v hiši. Neobvezen; iz njega se ne izračuna nič, je pa prvo, kar odobritelj pogleda.',
        note: 'Opomba',
        note_help: 'Zakaj je to potrebno. Ena poved prihrani telefonski klic.',
        lines: 'Postavke',
        lines_n: '{count} postavk',
        add_line: 'Dodaj vrstico',
        no_lines: 'Vpiši vsaj en artikel.',
        article: 'Artikel',
        quantity: 'Količina',
        unit: 'Enota',
        unit_help: 'Prevzeta iz artikla. Popravi jo, če oddelek šteje drugače kot skladišče.',
        line_note: 'Opomba vrstice',
        estimated_unit: 'Ocena na enoto',
        estimated: 'Ocena',
        estimated_total: 'Ocenjena vrednost',
        waiting_on: 'čaka: {role} (nivo {level})',
        approvals: 'Odobritve',
        no_approvals: 'Zahtevek še ni oddan, zato ga nihče ne čaka.',
        level_n: 'Nivo {level}',
        due_at: 'Rok',
        escalated_at: 'Predano namestniku {at}',
        decision_pending: 'Čaka',
        decision_approved: 'Odobreno',
        decision_rejected: 'Zavrnjeno',
        decision_lead: 'Zahtevek {number}',
        decision_note: 'Opomba',
        decision_note_help: 'Neobvezna. Kar zapišeš, ostane na zahtevku in ga vidi tisti, ki ga je napisal.',
        reason: 'Razlog',
        reason_help: 'Obvezen. „Zavrnjeno“ brez razloga pomeni, da bo isti zahtevek v ponedeljek napisan znova.',
        orders: 'Naročilnice',
        order_one: 'Naročilnica',
        action_submit: 'Oddaj',
        action_edit: 'Uredi',
        action_cancel: 'Prekliči',
        action_approve: 'Odobri',
        action_reject: 'Zavrni',
        action_order: 'Ustvari naročilnice',
        done_submit: 'Zahtevek je oddan.',
        done_cancel: 'Zahtevek je preklican.',
        done_approve: 'Zahtevek je odobren.',
        done_reject: 'Zahtevek je zavrnjen.',
        done_order: 'Nastalo je {count} naročilnic.',
        submit_failed: 'Osnutek je shranjen, oddaja pa ni uspela.',
        budget_exceeded: 'Zahtevek presega proračun',
        errors: {
            not_approved: 'Zahtevek {number} še ni odobren — na vrsti je {role} (nivo {level}, rok {due}).',
            required: 'Za naročilo te vrednosti je potreben zahtevek.',
        },
    },
    materialsForecast: {
        title: 'Napoved potreb',
        no_property: 'Najprej izberi objekt.',
        lead_title: 'Koliko bo hiša porabila in kdaj ji zmanjka',
        lead: 'Napoved je sestavljena iz podatkov, ki jih ta PMS že ima: prihodov, nočitev, čiščenj, zajtrkov in zajamčenih števil na dogodkih. Vsaka številka pove, iz česa je. Predlog naročila je predlog — zahtevek napiše človek.',

        tab_forecast: 'Napoved',
        tab_profiles: 'Profili porabe',

        window_title: 'Napoved po artiklih',
        window_lead: 'Zgoraj dnevi hiše, spodaj kaj ti dnevi pojedo. Odpri vrstico, da vidiš dnevno porabo in razlago.',
        window: 'Obdobje',
        days: '{count} dni',
        peak: '(vrh {value})',
        drivers_title: 'Dnevi hiše',
        events_title: 'Dogodki v obdobju',
        guaranteed: 'zajamčeno {count}',
        daily_demand: 'Dnevna poraba',

        no_profiles: 'Napoved potrebuje profile porabe — dodaj jih na zavihku Profili.',
        to_profiles: 'Odpri profile',

        article: 'Artikel',
        on_hand: 'Na zalogi',
        on_order: 'Naročeno',
        demand: 'Poraba v obdobju',
        cover_days: 'Pokritost (dni)',
        stockout_on: 'Zmanjka',
        suggestion: 'Predlog',
        tick_all: 'Označi vse',
        explain: 'Razlaga',
        no_explain: 'Strežnik za ta artikel ni poslal razlage.',
        lead_safety: 'Dobavni rok {lead} dni · varnostna zaloga {safety} dni · minimum {min}',
        lead_safety_short: 'rok {lead} d · varnost {safety} d',

        create_requisition: 'Ustvari zahtevek',
        requisition_title: 'Nov zahtevek iz napovedi',
        requisition_lead: 'Količine so predlog strežnika iz iste napovedi. Zahtevek gre po običajni odobritveni poti.',
        requisition_items: 'Artikli ({count})',
        needed_on: 'Potrebujem do',
        needed_on_help: 'Privzeto prvi dan obdobja plus najdaljši dobavni rok med izbranimi artikli.',
        department: 'Oddelek',
        department_help: 'Kdo blago potrebuje. Odloča, kdo zahtevek odobri.',
        cost_centre: 'Stroškovno mesto',
        cost_centre_help: 'Proti kateremu proračunu se strošek meri. Brez njega proračun o zahtevku ne pove ničesar.',
        no_cost_centre: 'Brez stroškovnega mesta',
        nothing_ticked: 'Označi vsaj en artikel.',
        requisition_created: 'Zahtevek {number} je ustvarjen.',

        profiles_title: 'Profili porabe',
        profiles_lead: 'Ena poved o enem artiklu: kaj ga porablja in koliko ga gre na eno tako enoto. Brez profilov ni napovedi.',
        profiles_empty: 'Ni še nobenega profila.',
        add_profile: 'Nov profil',
        edit_profile: 'Uredi profil',
        confirm_delete: 'Res želiš izbrisati profil za „{name}“?',
        per_unit: '{quantity} / {unit}',

        article_help: 'Artikel iz šifranta zalog. En artikel ima lahko več profilov.',
        driver: 'Vir porabe',
        driver_help: 'Hišno dejstvo, ki mu je poraba sorazmerna.',
        quantity_per_unit: 'Količina na enoto',
        quantity_per_unit_help: 'Koliko artikla gre na eno enoto vira — npr. 2 milnici na čiščenje. Decimalke so dovoljene.',
        quantity_positive: 'Količina mora biti večja od nič.',
        lead_days: 'Dobavni rok (dni)',
        lead_days_help: 'Koliko dni mine od naročila do prevzema pri tem viru porabe.',
        safety_days: 'Varnostna zaloga (dni)',
        safety_days_help: 'Koliko dni zaloge naj ostane na dan dobave.',
        active_help: 'Izklopljen profil ostane zapisan, v napovedi pa ne šteje.',
        note: 'Opomba',

        driver_arrival: 'Prihod',
        driver_room_night: 'Nočitev sobe',
        driver_guest_night: 'Nočitev osebe',
        driver_cleaning: 'Čiščenje',
        driver_breakfast_cover: 'Zajtrk',
        driver_event_cover: 'Oseba na dogodku',
        driver_minibar_history: 'Minibar (zgodovina)',
        driver_consumption_history: 'Poraba (zgodovina)',
        driver_fixed_daily: 'Enako vsak dan',

        driver_arrival_hint: 'Prihodi iz rezervacij.',
        driver_room_night_hint: 'Zasedene sobe po nočeh iz rezervacij.',
        driver_guest_night_hint: 'Osebe po nočeh iz rezervacij.',
        driver_cleaning_hint: 'Čiščenja iz načrta sobaric.',
        driver_breakfast_cover_hint: 'Zajtrki iz Dininga.',
        driver_event_cover_hint: 'Osebe iz zajamčenih števil potrjenih različic dogodkov.',
        driver_minibar_history_hint: 'Povprečje minibar porabe zadnjih 28 dni, skalirano z zasedenostjo.',
        driver_consumption_history_hint: 'Povprečje izdaj artikla zadnjih 28 dni, skalirano z zasedenostjo.',
        driver_fixed_daily_hint: 'Enaka količina vsak dan, ne glede na zasedenost.',

        driver_unit_arrival: 'prihod',
        driver_unit_room_night: 'nočitev',
        driver_unit_guest_night: 'nočitev osebe',
        driver_unit_cleaning: 'čiščenje',
        driver_unit_breakfast_cover: 'zajtrk',
        driver_unit_event_cover: 'oseba',
        driver_unit_minibar_history: 'dan',
        driver_unit_consumption_history: 'dan',
        driver_unit_fixed_daily: 'dan',
    },
    materialsKPI: {
        title: 'Kazalniki materialnega poslovanja',
        no_property: 'Najprej izberi objekt.',
        lead_title: 'Šest kazalnikov, po katerih se vodi skladišče',
        lead: 'Vsi zneski so iz FIFO posnetkov gibanj, zato zaključeno obdobje odgovarja enako tudi pozneje. Kjer kazalnik nima odgovora — prazna hiša nima stroška na sobo-noč, polica brez porabe nima pokritosti — je narisan pomišljaj in ne nič.',

        period: 'Obdobje',
        period_hint: 'Oba datuma sta vključena. Privzeto zadnji polni mesec: mesec v teku odgovori strošek, ki velja za enajst dni.',
        from: 'Od',
        to: 'Do',
        show: 'Prikaži',
        export_csv: 'Izvozi CSV',
        table_empty: 'V tem obdobju ni vrstic.',
        no_category: 'Brez kategorije',
        days_count: '{count} dni',
        never_issued: 'Nikoli izdano',

        card_cost_per_room_night: 'Strošek na zasedeno sobo-noč',
        card_cost_per_room_night_terms: '{consumption} porabe na {nights} zasedenih sobo-noči',
        card_no_room_nights: 'V obdobju ni bilo prodane nobene sobo-noči, zato kazalnik nima odgovora.',
        card_cover: 'Dnevi pokritosti zaloge',
        card_cover_terms: '{value} zaloge pri {daily} dnevne porabe',
        card_no_consumption: 'V zadnjih 30 dneh ni bilo porabe, zato pokritosti ni mogoče izračunati.',
        card_dead_stock: 'Neaktivna zaloga',
        card_dead_stock_terms: '{count} artiklov brez izdaje 90 dni · {expiring} serij poteče v 30 dneh ({value})',
        card_write_offs: 'Odpisi in manjki',
        card_write_offs_terms: '{count} gibanj · {share} porabe obdobja',
        card_supplier_delays: 'Zamujeni prevzemi',
        card_supplier_delays_terms: 'povprečno {average} dni zamude · {overdue} odprtih naročil po roku',
        card_price_variance: 'Razlika dogovorjena–dejanska cena',
        card_price_variance_terms: '{lines} vrstic odstopa od {priced} vrstic z dogovorjeno ceno',

        by_category: 'Strošek po kategorijah',
        by_category_hint: 'Prvih osem kategorij po vrednosti porabe, z deležem celotne porabe obdobja.',
        category: 'Kategorija',
        consumption: 'Poraba',
        per_room_night: 'Na sobo-noč',
        share: 'Delež',

        by_place: 'Pokritost po prostorih in kategorijah',
        by_place_hint: 'Vrednost zaloge proti povprečni dnevni porabi zadnjih 30 dni. Pod 3 dni je opozorilo, nad 60 dni je denar, ki stoji.',
        scope: 'Vrsta',
        scope_place: 'Prostor',
        scope_category: 'Kategorija',
        name: 'Ime',
        stock_value: 'Vrednost zaloge',
        daily: 'Dnevna poraba',
        cover: 'Pokritost',

        dead_stock: 'Neaktivna zaloga in roki',
        dead_stock_hint: 'Artikli, ki so na polici in 90 dni niso šli iz hiše, po vrednosti navzdol. Rok je najbližji rok med živimi serijami.',
        item: 'Artikel',
        quantity: 'Količina',
        value: 'Vrednost',
        last_issued: 'Zadnja izdaja',
        expires: 'Poteče',
        movements: 'Gibanj',

        write_offs: 'Odpisi in manjki',
        write_offs_hint: 'Odpisi, polomljeno in inventurni manjki obdobja po FIFO vrednosti. Inventurni presežki niso všteti — mesec, ki bi jih odštel, bi manjke prikazal manjše, kot so.',

        supplier_delays: 'Dobavne zamude',
        supplier_delays_hint: 'Presojeni so samo prevzemi, katerih naročilo je nosilo obljubljeni dan. Odprta naročila po roku so merjena na danes.',
        supplier: 'Dobavitelj',
        judged: 'Presojenih',
        late: 'Zamudnih',
        average_late: 'Povprečna zamuda',
        worst_late: 'Največ',
        open_overdue: 'Odprtih po roku',

        price_variance: 'Razlika dogovorjena–dejanska cena',
        price_variance_hint: 'Za vsako vrstico prevzema obdobja: cena iz veljavne pogodbe ali kataloga na tisti dan proti knjiženi nabavni ceni. Predznak je ohranjen — negativno je vrstica, kjer je hiša plačala manj od dogovorjenega.',
        document: 'Prevzem',
        agreed: 'Dogovorjena',
        booked: 'Knjižena',
        variance: 'Razlika',
        source: 'Vir cene',
        source_contract: 'Pogodba',
        source_catalogue: 'Katalog',
    },

    materialsClose: {
        title: 'Mesečni zaključek materialnega',
        no_property: 'Najprej izberi objekt.',
        lead_title: 'Kontrolni seznam meseca in gumb, ki ga zapre',
        lead: 'Seznam se izračuna ob vsakem branju in se nikoli ne shrani. Shrani se ODLOČITEV — s seznamom, kakršen je bil ob pritisku. Zaključen mesec zavrne vsako knjiženje, katerega poslovni datum pade vanj; ponovno odpiranje zahteva razlog in se zapiše v revizijsko sled.',

        month: 'Mesec',
        month_hint: 'Privzeto zadnji mesec: mesec, ki ga kdo zapira, je tisti, ki se je iztekel.',
        show: 'Osveži',

        stock_value: 'Vrednost zaloge',
        stock_value_hint: 'Vrednost polic iz FIFO plasti ob tem branju, razbita po prostorih. Ob zaključku se ta številka shrani v posnetek.',
        place: 'Prostor',
        value: 'Vrednost',

        checklist: 'Kontrolni seznam',
        checklist_hint: 'Vsaka vrstica pove stanje, število in znesek ter vodi na zaslon, kjer se uredi. Zaporo naredijo samo vrstice s stanjem „zapira“.',
        item: 'Postavka',
        status: 'Stanje',
        count: 'Število',
        amount: 'Znesek',
        detail: 'Podrobnosti',

        status_ok: 'Urejeno',
        status_warning: 'Opozorilo',
        status_blocking: 'Zapira',

        item_draft_documents: 'Osnutki papirjev, datirani v ta mesec',
        item_uninvoiced_receipts: 'Prevzemi brez računa dobavitelja',
        item_open_invoices: 'Prejeti računi, ki niso knjiženi',
        item_expected_credit_notes: 'Pričakovani dobropisi',
        item_ap_export: 'Predaja knjigovodstvu',
        item_count_sessions: 'Inventure, preštete in neknjižene',
        item_budget_deviation: 'Prekoračitve proračuna',

        state_open: 'Odprt',
        state_blocked: 'Zapore',
        state_closed: 'Zaključen',
        state_reopened: 'Ponovno odprt',
        state: 'Stanje',

        blocked_title: 'Meseca ni mogoče zaključiti',
        note: 'Opomba',
        close_month: 'Zaključi mesec',
        close_confirm: 'Zaključim mesec {month} pri vrednosti zaloge {value}? Po zaključku noben papir s poslovnim datumom v tem mesecu ne bo več knjižljiv.',
        closed_toast: 'Mesec {month} je zaključen.',
        closed_title: 'Mesec {month} je zaključen',
        closed_lead: 'Knjiženje s poslovnim datumom v tem mesecu je zavrnjeno. Če je treba vanj še kaj knjižiti, mesec ponovno odpri v zgodovini spodaj — z razlogom.',

        history: 'Zgodovina zaključkov',
        history_hint: 'Vrstica se ob ponovnem odprtju ohrani in ožigosa, ne izbriše: vprašanje čez leto ni, ali je mesec odprt, ampak kdo ga je odprl in zakaj.',
        history_empty: 'Ta objekt še ni zaključil nobenega meseca.',
        closed_at: 'Zaključeno',
        reopen: 'Ponovno odpri',
        reopen_confirm: 'Ponovno odprem mesec {month}? Knjigovodstvo ima številke tega meseca že pri sebi.',
        reopen_reason: 'Razlog za ponovno odprtje meseca:',
        reopen_needs_reason: 'Brez razloga meseca ni mogoče ponovno odpreti.',
        reopened_toast: 'Mesec {month} je ponovno odprt.',
    },

    materialsBudget: {
        title: 'Proračuni',
        no_property: 'Najprej izberi objekt.',
        lead_title: 'Kaj je hiša nameravala porabiti in kaj je',
        lead: 'Načrt je ena številka za eno stroškovno mesto, eno kategorijo in en mesec. Poleg njega stojita knjiženo in obljubljeno — odobren zahtevek in odprta naročilnica sta porabljena denar, ki račun še čaka.',

        overview_title: 'Pregled leta',
        overview_lead: 'Vrstica je stroškovno mesto in kategorija, stolpec je mesec. Načrt se ureja v načinu urejanja in shrani v enem pritisku.',
        year: 'Leto',
        category: 'Kategorija',
        all_categories: 'Vse kategorije',
        cost_centre: 'Stroškovno mesto',
        cost_centre_help: 'Iz šifranta stroškovnih mest v Knjigovodstvu.',
        category_help: 'Iz kategorij artiklov, po katerih so preslikani konti.',
        year_total: 'Skupaj leto',
        legend: 'V celici: načrt, delež porabe, knjiženo + obljubljeno, ostanek. Prekoračen proračun je rdeč.',

        planned: 'Načrt',
        actual: 'Knjiženo',
        committed: 'Obljubljeno',
        remaining: 'Ostanek',

        empty: 'Za to leto ni še nobenega načrta.',
        empty_hint: 'Vklopi urejanje in dodaj vrstico, ali kopiraj načrt iz drugega meseca.',

        edit_plan: 'Uredi načrt',
        save_plan: 'Shrani načrt',
        saved: 'Shranjenih vrstic: {count}.',
        add_row: 'Dodaj vrstico',
        add_row_lead: 'Vrstica se doda samo na zaslon. Zapiše se, ko shraniš načrt.',

        copy: 'Kopiraj iz meseca',
        copy_title: 'Kopiraj proračun',
        copy_lead: 'Vzame vse vrstice izvornega meseca in jih zapiše v ciljnega, pomnožene s faktorjem.',
        copy_from: 'Iz meseca',
        copy_from_help: 'Mesec, katerega načrt se prepiše.',
        copy_to: 'V mesec',
        copy_to_help: 'Mesec, ki načrt dobi. Obstoječe vrstice se prepišejo.',
        copy_same_month: 'Izvorni in ciljni mesec sta ista.',
        copied: 'Proračun je prekopiran.',
        factor: 'Faktor (%)',
        factor_help: '100 % je „enako kot prej“. 105 % je pet odstotkov več.',
        factor_hint: '{percent} %',
    },
    materialsApprovals: {
        title: 'Moje odobritve',
        lead: 'Zahtevki, ki čakajo prav tebe. Zamujeni so na vrhu — takrat je namestnik že spuščen zraven.',
        empty: 'Nič ne čaka nate.',
        overdue: 'Zamuja',
    },
    materialsApprovalRules: {
        title: 'Pravila odobritev',
        lead: 'Od katerega zneska naprej je potreben podpis, čigav je in do kdaj.',
        how_title: 'Kako se pravila berejo',
        how: 'Zahtevek, ki ne ustreza nobenemu pravilu, je odobren že ob oddaji. Če jih ustreza več, odloča najvišji nivo — ta pove, koliko podpisov je potrebnih.',
        add: 'Novo pravilo',
        empty: 'Ni pravil. Vsak zahtevek je odobren takoj ob oddaji.',
        threshold: 'Prag (€)',
        threshold_help: 'Vrednost, OD katere pravilo velja. Nič pomeni vsak zahtevek.',
        category: 'Kategorija',
        category_help: 'Kategorija artikla. Prazno pomeni vse kategorije.',
        any_category: 'Vse kategorije',
        cost_centre: 'Stroškovno mesto',
        cost_centre_help: 'Prazno pomeni vsa stroškovna mesta.',
        any_cost_centre: 'Vsa stroškovna mesta',
        level: 'Nivo',
        level_help: 'Nivo 1 je prvi podpis, nivo 2 drugi. Višji nivo pomeni več podpisov, ne drugačnega vrstnega reda.',
        level_n: 'Nivo {level}',
        approver: 'Odobritelj',
        approver_help: 'Vloga, ne oseba: kdor jo ima, sme odobriti. Odsotnost enega tako ne ustavi hiše.',
        deputy: 'Namestnik',
        deputy_help: 'Vloga, ki jo strežnik spusti zraven, ko rok poteče. Neobvezna — brez nje zahtevek preprosto čaka naprej.',
        no_deputy: 'Brez namestnika',
        due_hours: 'Rok (ur)',
        due_hours_help: 'Koliko ur ima odobritelj, preden se zahtevek preda namestniku.',
        confirm_delete: 'Res želiš izbrisati pravilo „{name}“?',
    },
    /**
     * Prevzem s tolerancami, karantena in odločitve o njej
     * (docs/MATERIALNO-PREVZEM.md, WP-M3c).
     */
    receiving: {
        title: 'Prevzem — karantena',
        lead: 'Vrstice prevzema, ki niso ustrezale naročilu, kakovosti ali temperaturi. Blago je knjiženo in stoji v karanteni, dokler nekdo ne odloči.',
        empty: 'Ni vrstic v karanteni.',

        filter_status: 'Stanje',
        filter_status_help: 'Odprte so tiste, o katerih še ni nihče odločil. Privzeto pokažemo prav te.',
        filter_all: 'Vse',

        line_n: 'vrstica {line}',
        figures: 'Naročeno {ordered} · prejeto {received} · meja {limit}',
        substituted_for: 'Namesto: {item}',
        measured_temperature: 'Izmerjeno: {value} °C',

        kind_quantity: 'Količina',
        kind_price: 'Cena',
        kind_quality: 'Kakovost',
        kind_temperature: 'Temperatura',
        kind_substitution: 'Nadomestek',

        status_open: 'Odprto',
        status_accepted: 'Sprejeto',
        status_returned: 'Vrnjeno',
        status_written_off: 'Odpisano',

        accept: 'Sprejmi',
        return: 'Vrni dobavitelju',
        write_off: 'Odpiši',
        open_return: 'Odpri vračilo',

        accepted: 'Blago je prestavljeno na polico.',
        returned: 'Vračilni dokument je knjižen.',
        written_off: 'Blago je odpisano.',

        confirm_accept: 'Sprejem iz karantene',
        confirm_accept_lead: '{item} — {quantity} {unit} bo prestavljeno iz karantene v skladišče prevzema.',
        confirm_return: 'Vračilo dobavitelju',
        confirm_return_lead: '{item} — {quantity} {unit} bo šlo z vračilnim dokumentom nazaj dobavitelju.',
        confirm_write_off: 'Odpis iz karantene',
        confirm_write_off_lead: '{item} — {quantity} {unit} bo odpisano; blago zapusti zalogo brez vračila.',

        return_reason: 'Razlog vračila',
        return_reason_help: 'Po tem razlogu je razvrščeno poročilo o vračilih pri dobavitelju.',
        expects_credit_note: 'Pričakujem dobropis',
        decision_note: 'Opomba',
        decision_note_help: 'Kar bo nekdo čez tri mesece prebral ob tej vrstici. Opomba se zapiše tudi v revizijsko sled.',

        reason_damaged: 'Poškodovano',
        reason_expired: 'Pretečen rok',
        reason_quality: 'Kakovost',
        reason_wrong_item: 'Napačen artikel',
        reason_over_delivery: 'Preveč dobavljeno',
        reason_temperature: 'Temperatura',
        reason_other: 'Drugo',

        line_extras: 'Kakovost, temperatura, nadomestek',
        line_ordered: 'Naročeno: {quantity} {unit}',
        line_quantity_off: 'količina izven meje ({limit})',
        line_price_off: 'cena izven meje ({limit})',

        quality: 'Kakovost',
        quality_help: 'Prazno pomeni, da nihče ni pogledal. „Ni ustrezno“ vrstico postavi v karanteno.',
        quality_unsaid: 'Ni podatka',
        quality_ok: 'Ustrezno',
        quality_not_ok: 'Ni ustrezno',

        temperature: 'Temperatura (°C)',
        temperature_help: 'Kar je pokazal termometer ob prevzemu. Prazno pomeni, da nihče ni meril — in to ni zavrnitev.',
        storage_min: 'Artikel: najmanj {min} °C',
        storage_max: 'Artikel: največ {max} °C',
        storage_range: 'Artikel: {min} do {max} °C',

        substitute: 'Nadomestek',
        substitute_help: 'Dobavitelj je poslal drug artikel. Vrstica knjiži TISTO, kar je prišlo, zapis pa pove, kaj je bilo naročeno.',
        substituted: 'Nadomestek',
        no_substitute: 'Brez nadomestka',

        banner_title: 'V karanteni: {count} vrstic',
        banner_lead: 'Prevzem {number} je knjižen, del blaga pa stoji v karanteni, dokler nekdo ne odloči.',
        banner_open: 'Odpri karanteno',

        errors: {
            out_of_tolerance: 'Vrstica {line} ({item}): naročeno {ordered}, prejeto {received}, meja je {limit}.',
            out_of_tolerance_more: 'Vrstica {line} ({item}): naročeno {ordered}, prejeto {received}, meja je {limit}. Takih vrstic je še {more}.',
            out_of_tolerance_plain: 'Prevzem je izven toleranc hiše. Knjiži brez stroge preverbe, da gre sporna vrstica v karanteno.',
        },
    },

    /** Vračila dobavitelju (docs/MATERIALNO-PREVZEM.md §6). */
    stockReturn: {
        title: 'Vračila dobavitelju',
        title_one: 'Vračilo',
        lead: 'Dokumenti z lastno številčno vrsto (VR) in obratnim gibanjem iz skladišča.',
        empty: 'Ni vračil.',
        back: 'Na vračila',
        not_found: 'Vračila ni mogoče najti.',

        filter_status: 'Stanje',
        filter_status_help: 'Osnutek še ni premaknil blaga; knjiženo je odšlo iz skladišča.',
        filter_all: 'Vsa',

        status_draft: 'Osnutek',
        status_posted: 'Knjiženo',
        status_cancelled: 'Preklicano',

        against_receipt: 'Na prevzem {number}',
        lines_n: '{count} vrstic',
        awaiting_credit_note: 'Čaka dobropis',
        awaiting_credit_note_help: 'Hiša pričakuje dobropis dobavitelja. Ko ga knjižiš med prejete račune, se sklicuje na to vračilo.',

        supplier: 'Dobavitelj',
        receipt: 'Prevzem',
        status: 'Stanje',
        total: 'Vrednost',

        line_item: 'Artikel',
        line_quantity: 'Količina',
        line_unit_cost: 'Nabavna cena',
        line_lot: 'Serija',
        line_reason: 'Razlog',

        post: 'Knjiži',
        cancel: 'Prekliči',
        posted_toast: 'Vračilo je knjiženo, blago je odšlo iz skladišča.',
        cancelled_toast: 'Osnutek vračila je preklican.',
    },

    materialsInvoice: {
        title: 'Prejeti računi',
        lead: 'Dobaviteljev račun je svoj dokument: en račun lahko pokriva več prevzemov, dobropis pa je svoja vrsta. Trismerna ujemba ga primerja z naročilnico in s prevzemom, knjiženje pa prenese njegove cene na police.',
        detail_lead: 'Kaj piše na papirju, kaj je prišlo in kaj je bilo naročeno.',
        empty: 'Ni prejetih dokumentov.',
        not_found: 'Dokumenta ni.',
        no_number: 'Brez številke',
        number: 'Številka dokumenta',
        supplier: 'Dobavitelj',
        status: 'Stanje',
        issued_on: 'Datum računa',
        due_on: 'Rok plačila',
        stated_gross: 'Navedeni bruto',
        derived_gross: 'Izpeljani bruto',
        exchange_rate: 'Tečaj',
        credit_note_of: 'Dobropis k',
        open_source: 'Odpri izvorni račun',
        receipts_n: '{count} prevzemov',
        heading_invoice: 'Prejeti račun {number}',
        heading_credit_note: 'Dobropis {number}',
        filter_status: 'Stanje',
        filter_status_help: 'Osnutek je natipkan papir, ujeto je preverjen, knjiženo pomeni, da je denar na policah.',
        filter_supplier: 'Dobavitelj',
        filter_all: 'Vse',
        status_draft: 'Osnutek',
        status_matched: 'Ujeto',
        status_posted: 'Knjiženo',
        status_cancelled: 'Preklicano',
        intercompany: 'Medpodjetniški',
        match_title: 'Trismerna ujemba',
        match_lead: 'Naročeno ↔ prevzeto ↔ zaračunano, po artiklih. Barva pove, ali je razlika znotraj toleranc hiše.',
        match_exact: 'Se ujema',
        match_within_tolerance: 'Znotraj tolerance',
        match_unmatched: 'Ne ujema se',
        article: 'Artikel',
        ordered: 'Naročeno',
        received: 'Prevzeto',
        invoiced: 'Zaračunano',
        variance: 'Razlika',
        verdict: 'Ocena',
        tolerance_quantity: 'količina',
        tolerance_price: 'cena',
        tolerance_amount: 'znesek',
        fault_quantity: 'Količina: prišlo {expected}, zaračunano {actual} (razlika {variance}, meja {limit}).',
        fault_price: 'Cena: dogovorjeno {expected}, zaračunano {actual} (razlika {variance}, meja {limit}).',
        fault_amount: 'Znesek: prevzem {expected}, račun {actual} (razlika {variance}, meja {limit}).',
        action_match: 'Ujemi',
        action_post: 'Knjiži',
        action_credit_note: 'Dobropis',
        action_cancel: 'Prekliči dokument',
        matched: 'Ujemba potrjena.',
        posted: 'Dokument je knjižen.',
        credited: 'Dobropis je izdan.',
        original_title: 'Izvirnik',
        original_lead: 'Dobaviteljev papir, kakor je prispel. Hrani se 10 let v izvirni obliki; zgoščena vrednost dokazuje, da datoteka ni bila spremenjena.',
        original_drop: 'Povleci datoteko sem ali jo izberi.',
        original_choose: 'Naloži izvirnik',
        original_none: 'PDF, slika ali e-SLOG XML. Naložiti ga je mogoče tudi po knjiženju — papir pogosto pride za blagom.',
        original_file: 'Datoteka',
        original_unnamed: 'Brez imena',
        original_size: 'Velikost',
        original_archived_at: 'Arhivirano',
        original_sha256: 'Zgoščena vrednost (SHA-256)',
        original_open: 'Odpri izvirnik',
        original_kept: 'Izvirnik je shranjen in arhiviran.',
        original_failed: 'Račun je vnesen, izvirnika pa ni bilo mogoče shraniti. Naloži ga na zaslonu računa.',
        credit_note_title: 'Nov dobropis',
        credit_note_rule: 'Izvorni račun se ne spremeni. Dobropis je nov dokument z negativnimi vrsticami, strošek prodanega pa pade na DAN DOBROPISA.',
        credit_number_help: 'Številka z dobaviteljevega dobropisa. Sme biti ista kot na računu — dobropis ima svoje kazalo.',
        credit_issued_help: 'Ta dan nosi strošek prodanega. Obdobje prevzema je lahko davčno zaklenjeno, zato vknjižba nazaj ni izvedljiva.',
        credit_lines: 'Vrstice',
        credit_quantity: 'Vrnjeno',
        credit_quantity_help: 'Največ {max} — toliko jih je bilo zaračunanih.',
        credit_no_lines: 'Vpiši vsaj eno količino.',
        credit_quantity_over: '{item}: največ {max} — toliko jih je bilo zaračunanih.',
        delivered_on: 'Datum dobave',
        currency: 'Valuta',
        exchange_rate_on: 'Datum tečaja',
        exchange_rate_source: 'Vir tečaja',
        create_title: 'Nov prejeti račun',
        create_lead: 'Vnesi dobaviteljev papir. Označi prevzeme, ki jih pokriva, in popravi, kar na računu piše drugače.',
        create_action: 'Nov prejeti račun',
        created: 'Račun je vnesen.',
        create_supplier_help: 'Ko izbereš dobavitelja, se spodaj ponudijo njegovi knjiženi prevzemi, ki jih še ne pokriva noben račun.',
        create_number_help: 'Številka z dobaviteljevega računa. Sme biti prazna — papir brez številke ne gre v kazalo podvojitev.',
        create_issued_help: 'Datum, ki ga nosi račun. Iz njega se predlaga rok plačila.',
        create_delivered_help: 'Kdaj je blago prišlo. Ob označitvi prevzemov se predlaga zadnji med njimi.',
        create_due_help: 'Predlagano je 30 dni od datuma računa. Dobavitelj nima zapisanih plačilnih pogojev, zato je to predlog in ne pravilo.',
        create_currency_help: 'Prazno pomeni hišno valuto ({currency}). Tri črke, npr. CHF.',
        create_rate_help: 'Koliko {currency} kupi ena enota računove valute. Tečaj 0 ne pretvori ničesar — ujemba bi primerjala dve valuti in razliko imenovala odstopanje.',
        create_rate_on_help: 'Dan, na katerega je tečaj veljal.',
        create_rate_source_help: 'Od kod je tečaj — npr. ECB ali Banka Slovenije.',
        create_receipts: 'Prevzemi, ki jih račun pokriva',
        create_receipts_help: 'En račun lahko pokriva več dobav. Ponujeni so samo knjiženi prevzemi tega dobavitelja, ki jih še ne pokriva noben račun — osnutek nima blaga na policah, proti kateremu bi se račun ujel.',
        create_receipts_pick_supplier: 'Najprej izberi dobavitelja.',
        create_receipts_empty: 'Ta dobavitelj nima nepokritih knjiženih prevzemov.',
        create_receipt_lines_n: '{count} vrstic',
        create_lines: 'Vrstice računa',
        create_no_lines: 'Račun mora imeti vsaj eno vrstico.',
        create_line_no_item: 'Vsaka vrstica mora imenovati artikel.',
        create_line_no_quantity: '{item}: količina ne sme biti 0.',
        create_line_vat: '{item}: stopnja DDV mora biti med 0 in 100.',
        create_quantity: 'Količina',
        create_unit_price: 'Cena/enoto',
        create_vat: 'DDV %',
        create_add_line: 'Dodaj vrstico',
        create_vat_bases: 'Rekapitulacija DDV',
        create_vat_bases_help: 'Kot piše na papirju, po stopnjah. Predlog iz vrstic je le izhodišče — dobaviteljeva aritmetika je tista, ki jo revizor drži ob papirju.',
        create_base_net: 'Osnova',
        create_base_tax: 'DDV',
        create_bases_from_lines: 'Izračunaj iz vrstic',
        create_stated_net: 'Navedeni neto',
        create_stated_net_help: 'Neto, kot piše na papirju. Hrani se ob izpeljanem in ne namesto njega.',
        create_stated_gross_help: 'Bruto, kot piše na papirju. Če se ne ujema z vrsticami, se to tu vidi; strežnik zavrne šele ob knjiženju (koda 105), ne ob vnosu.',
        create_difference: 'Razlika do vrstic',
        create_unbalanced: 'Navedeni bruto se ne ujema z vrsticami. Osnutek se vseeno shrani — preveri vrstice ali dodaj vrstico za prevoz oziroma popust, sicer knjiženje ne bo šlo skozi.',
        create_currency_length: 'Valuta ima tri črke.',
        read_xml: 'Preberi iz e-računa (XML)',
        read_xml_action: 'Naloži datoteko',
        read_xml_help: 'e-SLOG ali UBL XML se prebere kot dobaviteljeva lastna aritmetika; sliko ali PDF prebere model. Nič se ne zapiše — vsa polja spodaj ostanejo tvoja.',
        read_reviewed: 'Vsa prebrana polja so predlog; preveri jih ob papirju.',
        read_source_eslog: 'Prebrano iz e-SLOG XML',
        read_source_ubl: 'Prebrano iz UBL XML',
        read_source_ai: 'Prebral model s slike',
        read_duplicate: 'Ta številka računa je pri tem dobavitelju že knjižena na dokumentu {document}. Nadaljevanje bi isto blago plačalo dvakrat.',
        read_failed: 'Dokumenta ni bilo mogoče prebrati.',
        read_done: 'Dokument je prebran. Preveri polja ob papirju.',
        errors: {
            out_of_tolerance: 'Vrstica {line} ({item}): {kind} odstopa za {variance}, meja je {limit}.',
            out_of_tolerance_more: 'Vrstica {line} ({item}): {kind} odstopa za {variance}, meja je {limit}. Takih vrstic je še {more}.',
            out_of_tolerance_plain: 'Račun se ne ujema s prevzemom znotraj toleranc hiše.',
            already_matched: 'Ta dokument je že ujet.',
            not_balanced: 'Na papirju piše {stated}, vrstice pa dajo {derived}. Preveri vrstice ali dodaj vrstico za prevoz oziroma popust.',
        },
    },
    retail: {
        uncovered_title: 'Zaloga ne pokrije prodaje',
        uncovered_hint: 'Prodajo lahko dovoli vodja s pravico upravljanja maloprodaje. Razlog se trajno shrani k računu, artikel pa počaka v seznamu, dokler ga ne ovrednoti naslednji prevzem.',
        uncovered_reason: 'Razlog',
        uncovered_placeholder: 'npr. dobavnica še ni knjižena',
        uncovered_confirm: 'Dovoli in prodaj',
        done_room_title: 'Zaračunano na sobo',
        done_room_hint: 'Za to prodajo ni računa — gost jo poravna na hotelskem računu ob odjavi, kjer se tudi fiskalizira. Ni česa natisniti.',
        done_print_blocked: 'Brskalnik je blokiral novo okno — dovoli pojavna okna za to stran in natisni kopijo iz seznama računov.',
        done_print_failed: 'Računa {number} ni bilo mogoče naložiti za tisk. Prodaja je zaključena; poskusi znova ali natisni kopijo s seznama.',
        page_hint: 'Prodaja čez pult. Vsaka blagajna je vezana na svoje skladišče — kar proda, gre iz njega.',
        tills: 'Blagajne',
        till: 'Blagajna',
        select_till: 'Izberi blagajno',
        no_tills: 'Ni blagajn. Odpri prvo in ji določi skladišče.',
        load_failed: 'Blagajne ni bilo mogoče prebrati.',
        manage_tills: 'Upravljaj blagajne',
        needs_sell: 'Za blagajno nimaš pravice',
        needs_sell_hint: 'Prijava na blagajno, odprtje izmene in prodaja čez pult zahtevajo pravico Maloprodaja (prodaja). Prosi vodjo, naj ti jo dodeli.',
        needs_price_right: 'Ta artikel še nima cene. Vpiše jo lahko nekdo s pravico Zaloga (šifranti).',
        needs_manage_tills: 'Za postavljanje blagajn potrebuješ pravico Maloprodaja (upravljanje).',
        needs_manage_shifts: 'Za pregled izmen potrebuješ pravico Maloprodaja (upravljanje).',
        add_till: 'Nova blagajna',
        edit_till: 'Uredi blagajno',
        till_name: 'Ime blagajne',
        till_place: 'Skladišče',
        new_place: 'Dodaj skladišče',
        till_place_hint: 'Iz tega mesta blagajna trga zalogo. Dve blagajni smeta kazati na isto skladišče.',
        assortment: 'Kaj prodaja ta blagajna',
        assortment_hint: 'Označi kategorije, ki jih ta blagajna prodaja. Nič označenega pomeni vse.',
        assortment_all: 'Vse kategorije',
        assortment_all_hint: 'Nič označenega: blagajna pokaže vse, kar je na zalogi v njenem skladišču — tudi artikle brez kategorije.',
        assortment_no_categories: 'Noben artikel še nima kategorije, zato tu ni kaj označiti. Blagajna prodaja vse, kar je na zalogi v njenem skladišču.',
        assortment_uncategorised: '{count} artiklov brez kategorije ne bo vidnih',
        assortment_uncategorised_hint: 'Ko blagajna označi kategorije, prodaja samo te. Artikli, ki niso uvrščeni nikamor, na tej blagajni izpadejo — uvrsti jih v kategorijo ali pusti izbor prazen.',
        till_inactive: 'Blagajna je zaprta.',
        articles: 'Artikli',
        set_price: 'Nastavi ceno',
        less: 'Manj',
        more: 'Več',
        locked: 'Blagajna je zaklenjena',
        locked_hint: 'Izberi blagajno in vnesi svoj PIN.',
        locked_out: 'Blagajna se je zaklenila. Znova vnesi PIN.',
        enter_pin: 'Vnesi PIN',
        pin_wrong: 'Napačen PIN ali blagajna ni dodeljena. Preveri izbrano blagajno zgoraj.',
        category_all: 'Vse',
        category_none: 'Ostalo',
        pin_too_many: 'Preveč poskusov. Počakaj trenutek.',
        pin_unavailable: 'Blagajna trenutno ni dosegljiva ({reason}). PIN ostane vpisan — poskusi znova.',
        pin_backspace: 'Zbriši',
        sign_in: 'Prijava',
        lock_hint: 'Zakleni blagajno / zamenjaj prodajalca',
        no_price: 'Brez cene',
        no_price_hint: 'Artikel nima cene — nastavi jo na kartici artikla v Zalogi.',
        no_articles: 'Noben artikel nima cene. Cene se vpišejo pri artiklu v Zalogi.',
        search: 'Iskanje',
        in_stock: 'Na zalogi: {count}',
        basket: 'Košarica',
        basket_empty: 'Košarica je prazna. Klikni artikel.',
        remove: 'Odstrani',
        total: 'Za plačilo',
        payment: 'Plačilo',
        payment_room: 'Soba',
        room: 'Soba gosta',
        pick_room: 'Izberi sobo',
        find_room: 'Številka sobe ali ime gosta',
        no_room_found: 'Ni sobe ne gosta s tem imenom.',
        no_rooms_in_house: 'V hotelu ni prijavljenih gostov.',
        payment_cash: 'Gotovina',
        payment_card: 'Kartica',
        confirm: 'Potrdi prodajo',
        sold: 'Prodano · {number} · {total}',
        // Izmena
        shift_none:             'Izmena ni odprta',
        shift_none_hint:        'Blagajna ne more prodajati, dokler izmena ni odprta. Vpiši, kaj je v predalu.',
        shift_float:            'Začetni polog',
        shift_float_hint:       'Kar je v predalu pred prvo prodajo. Lahko je 0.',
        shift_open:             'Odpri izmeno',
        shift_drawer:           'Predal',
        shift_opened_by:        'Odprl {name}',
        shift_expected:         'Pričakovano',
        shift_pay_in:           'Vplačilo',
        shift_pay_out:          'Izplačilo',
        shift_pay_ins:          'Vplačila',
        shift_pay_outs:         'Izplačila',
        shift_cash_refunds:     'Gotovinska vračila',
        shift_card_refunds:     'Kartična vračila',
        shift_amount:           'Znesek',
        shift_reason:           'Razlog',
        shift_reason_hint:      'Obvezen. Pojavi se na zaključku izmene.',
        shift_movements:        'Vplačila in izplačila',
        shift_close:            'Zaključi izmeno',
        shift_close_title:      'Preštej predal',
        shift_counted:          'Prešteto',
        shift_counted_hint:     'Koliko je dejansko v predalu.',
        shift_short:            'Manjko',
        shift_over:             'Višek',
        shift_variance_reason:  'Razlog za razliko',
        shift_variance_hint:    'Obvezen. Zapiše se — nič se ne prilagodi, da bi se izšlo.',
        shift_close_confirm:    'Zaključi',
        shift_closed_title:     'Izmena zaključena',
        shift_print:            'Natisni zaključek',
        shift_unreferenced:     'Kartice brez reference: {count}',
        shift_unreferenced_print: 'Odobreno brez reference',
        shift_pending:          'Čaka terminal: {count}',
        shift_pending_hint:     'Te prodaje niso denar. Dokončaj ali prekliči jih.',
        shift_counts:           'Prodaje: {sales} · Vračila: {returns}',
        // Zaključni zaslon
        done_title:            'Prodaja zaključena',
        done_print:            'Natisni račun',
        done_next:             'Nova prodaja',
        done_copy:             'Kopija',
        done_copy_hint:        'Natisne kopijo z oznako KOPIJA in zaporedno številko, kot zahteva FURS.',
        done_copy_made:        'Kopija natisnjena.',
        done_copy_unavailable: 'Kopije tega računa ni mogoče izdati — izdan je bil, preden je sistem hranil izvirni zapis.',
        // Kartica — čakanje na terminal
        card_waiting:           'Čakam na terminal',
        card_waiting_hint:      'Račun se izda šele, ko terminal odobri plačilo. Do takrat prodaja ne drži ničesar.',
        card_auth_code:         'Avtorizacijska koda',
        card_auth_code_hint:    'S terminala. Obvezna.',
        card_transaction:       'ID transakcije',
        card_transaction_hint:  'Neobvezno — samo če je na listku.',
        card_no_reference:      'Terminal je odobril, kode ne morem prebrati',
        card_have_code:         'Imam avtorizacijsko kodo',
        card_no_reference_title: 'Odobreno brez reference',
        card_no_reference_hint: 'Uporabi le, če je terminal plačilo RES odobril. Zapis se pojavi na dnevni poravnavi in ga bo nekdo preveril.',
        card_reason:            'Razlog',
        card_reason_placeholder: 'npr. listek se ni natisnil',
        card_confirm:           'Potrdi plačilo',
        card_abandon:           'Prekliči prodajo',
        card_pending:           'Čaka terminal',
        card_abandoned:         'Preklicano',
        card_finish:            'Dokončaj',

        // Vračila
        return_action:     'Vrni',
        return_title:      'Vračilo · {number}',
        return_credits:    'Izda se dobropis k računu {number}.',
        return_sold:       'prodano {count}',
        return_already:    'že vrnjeno {count}',
        return_less:       'Manj',
        return_more:       'Več',
        return_nothing_left: 'S tega računa je vrnjeno že vse.',
        return_refund:     'Vrnitev denarja',
        return_reason:     'Razlog',
        return_reason_hint: 'Neobvezno. Zapiše se na dobropis.',
        return_total:      'Za vrnitev',
        return_confirm:    'Potrdi vračilo',
        return_room_sale:  'Prodaje na sobo tu ni mogoče vrniti — denar bi moral nazaj na račun bivanja.',
        return_needs_approval: 'Vračilo presega hotelsko mejo. Potrdi ga lahko vodja, prijavljen v portal.',
        returned:          'Vrnjeno · {number} · {total}',
        todays_returns:    'Današnja vračila',
        day_refunded:      'Vrnjeno danes',
        todays_sales: 'Današnje prodaje',
        no_sales: 'Danes še ni prodaj.',
        day_total: 'Skupaj danes',
        fiscal_now: 'Ob potrditvi se izda davčno potrjen račun.',
        fiscal_room: 'Gre na folio gosta; davčno se potrdi na hotelskem računu ob odjavi.',
        buyer_name: 'Kupec (neobvezno)',
        buyer_name_hint: 'Če kupec želi ime na računu.',
        fiscal_note: 'V1 izda interni dokument MP; davčna potrditev računa še ni vklopljena.',
    },
    /**
     * Verige objektov (WP-M5, docs/VERIGE-ZASLONI.md).
     *
     * Svoj imenski prostor in ne del `materials_catalogue`: katalog je NABAVNA stran
     * enega objekta, veriga pa vprašanje, kateri objekti kupujejo skupaj — in isti
     * besednjak uporabljata nastavitveni zaslon (Nastavitve (zobnik) → Integracije in
     * komunikacija → Verige) in nabavni (Nabava in zaloga → Veriga).
     */
    chainItem: {
        title: 'Šifrant',
        lead: 'Skupni šifrant artiklov verige. Vsaka hiša svoj artikel poveže na vrstico šifranta — od takrat naprej se ujemanje ne izračunava iz imena, ampak je zapisano.',
        add: 'Nov artikel verige',
        edit: 'Uredi artikel verige',
        empty: 'Šifranta verige še ni.',
        search: 'Išči po šifri ali nazivu',

        code: 'Šifra verige',
        code_hint: 'Šifra, ki jo veriga uporablja za ta artikel — npr. „KAVA-1KG“. Enolična v verigi; vedno z veliko.',
        name: 'Naziv',
        unit: 'Enota',
        unit_hint: 'Kaj je en kos — „kos“, „l“, „kg“. Prosto besedilo, tako kot pri hišnem artiklu.',
        decimals: 'Natančnost',
        decimals_hint: 'Na koliko decimalk veriga šteje ta artikel. Enako pomeni kot pri hišnem artiklu: količina ostane celo število v 10^n enote.',
        decimals_locked: 'Natančnosti ni več mogoče spremeniti — artikel je vezan na {count} hiš. Natančnost se spremeni s preračunom v vsaki hiši posebej.',
        decimals_n: 'decimalk: {count}',
        category: 'Kategorija',
        tax_rate: 'Davčna stopnja',
        tax_rate_hint: 'Stopnja, ki jo artikel nosi pri vseh članih verige. Ob shranjevanju se prepiše na vse povezane hišne artikle.',
        net_content: 'Neto vsebina',
        net_content_hint: 'Koliko je v enem kosu — 500 g, 700 ml. Cele enote najmanjše mere.',
        net_content_unit: 'Enota vsebine',
        barcodes: 'Črtne kode',
        barcodes_hint: 'Kode, po katerih veriga pozna artikel. Po njih posvojitev NAJPREJ išče ujemanje — koda na embalaži je edino ujemanje, ki ni ugibanje.',
        barcodes_n: 'kod: {count}',
        active_hint: 'Neaktivna vrstica ostane zapisana in povezana, le posvojitev je ne ponuja več.',

        houses: 'Hiše',
        houses_n: 'hiš: {count}',
        houses_empty: 'Veriga nima objektov.',
        not_adopted: 'Ni posvojeno',

        range: 'Prikazanih {from}–{to} od {total}',
        capped: 'Seznam je odrezan — zoži iskanje.',

        saved: 'Shranjeno.',
        saved_propagated: 'Shranjeno. Popravek je prenesen na {count} povezanih hišnih artiklov.',
        deleted: 'Izbrisano.',
        confirm_delete: 'Res izbrišem {code} — {name}? Če veriga tega artikla ne kupuje več, ga raje deaktiviraj: vrstica, povezave in zgodovina ostanejo.',

        filter_all: 'Vse vrstice',
        filter_active: 'Samo aktivne',
        filter_inactive: 'Samo neaktivne',

        adoption: 'Posvojitev',
        adoption_lead: 'Kateri artikli verige so že naši in kateri še ne. Vsako povezavo potrdi človek — samodejnega ujemanja po imenu namenoma ni.',
        unmatched: 'Še ni posvojeno',
        unmatched_empty: 'Vsi aktivni artikli verige so posvojeni.',
        linked: 'Že povezano',
        linked_empty: 'Ta hiša še ni posvojila nobenega artikla verige.',
        our_article: 'Naš artikel',
        no_link: '— ne poveži —',
        no_candidate: 'Ni predloga — artikel lahko ustvariš pri nas.',
        create_here: 'Ustvari pri nas',
        link_selected: 'Poveži izbrane',
        selected_n: 'izbranih: {count}',
        candidate_scale: '{name} (šteje na {decimals} decimalk — ni mogoče)',
        adopted_n: 'Povezano: {count}.',
        unlink: 'Odveži',
        unlinked: 'Odvezano.',
        confirm_unlink: 'Res odvežem naš artikel od {code} — {name}? Artikel ostane z vso zalogo in zgodovino, izgubi le identiteto verige.',

        match_barcode: 'Najdeno po črtni kodi.',
        match_sku: 'Najdeno po šifri.',
        match_name: 'Najdeno po imenu — preveri, preden potrdiš.',
    },
    chain: {
        nav: 'Verige',
        title: 'Veriga',
        settings_lead: 'Veriga je skupina objektov, ki kupujejo kot ena hiša: skupni katalog cen, skupne pogodbe in skupna povpraševanja. Objekt je lahko v natanko eni verigi.',
        no_permission: 'Za ta zaslon nimaš pravice.',
        no_permission_hint: 'Verige ureja račun s pravico „chains:manage“. Kdo je v verigi, piše na zaslonu Nabava in zaloga → Veriga → zavihek Veriga.',
        no_property: 'Najprej izberi objekt.',
        not_in_chain: 'Ta objekt ni v nobeni verigi',
        not_in_chain_hint: 'Verigo sestavi skrbnik v Nastavitve (zobnik) → Integracije in komunikacija → Verige. Dokler objekt ni v verigi, zanj ni skupnega kataloga, skupnih potreb ne prenosov.',
        lead: 'Skupne cene, skupne pogodbe in skupne potrebe vseh objektov verige. Člani so samo za branje — verigo se ureja v nastavitvah.',

        chains: 'Verige',
        chains_hint: 'Vsaka veriga ima svoje objekte in dve stikali: skupni katalog in skupna nabava.',
        empty: 'Verig še ni.',
        add: 'Nova veriga',
        edit: 'Uredi verigo',
        saved: 'Shranjeno.',
        members_n: 'objektov: {count}',
        houses_n: 'objektov: {count}',
        no_members: 'Brez objektov.',
        members_read_only: 'Objekti verige. Seznam se ureja v Nastavitve (zobnik) → Integracije in komunikacija → Verige.',
        this_property: 'ta objekt',

        name: 'Naziv',
        name_hint: 'Ime verige, kot ga uporablja hiša — npr. „Skupina Portorož“.',
        members: 'Člani',
        members_hint: 'Objekti, ki kupujejo skupaj.',
        members_help: 'Najmanj dva; objekt je lahko v natanko eni verigi.',
        two_members: 'Veriga potrebuje vsaj dva objekta.',
        central_catalogue: 'Skupni katalog',
        central_catalogue_hint: 'Cene in pogodbe verige veljajo za vse člane. Objektov lastni katalog ostane — ponudbe so označene, čigave so.',
        pooled_procurement: 'Skupna nabava',
        pooled_procurement_hint: 'Zahtevke več objektov je mogoče združiti v eno povpraševanje.',

        catalogue: 'Katalog verige',
        catalogue_hint: 'Cene, ki veljajo za vse objekte verige. Dobavitelj je določen z DAVČNO ŠTEVILKO in ne s šifrantom enega objekta — isti trgovec je pri vsakem članu svoja kartica.',
        catalogue_empty: 'Kataloga verige še ni.',
        add_entry: 'Nova vrstica kataloga',
        edit_entry: 'Uredi vrstico kataloga',
        tax_number: 'Davčna številka',
        tax_number_hint: 'Po njej vsak objekt verige najde istega dobavitelja. Če člana ta dobavitelj nima v šifrantu, ponudba to pove.',
        supplier_name: 'Dobavitelj',
        supplier_name_hint: 'Naziv, kot ga bere človek. Za povezavo šteje davčna številka.',
        item: 'Artikel',
        item_hint: 'Artikel tega objekta. Strežnik člane poveže po svojem ključu.',
        sku: 'Šifra dobavitelja',
        sku_hint: 'Šifra, ki gre na naročilnico — nikoli hišni SKU.',
        price: 'Cena',
        price_hint: 'Neto cena ENE enote artikla, ne pakiranja.',
        currency: 'Valuta',
        pack_unit: 'Enota pakiranja',
        pack_unit_hint: 'Dobaviteljeva beseda za škatlo — „karton“, „paleta“.',
        quantity_per_pack: 'Kos/pak.',
        quantity_per_pack_hint: 'Koliko enot artikla je v enem pakiranju. Nič pomeni, da se prodaja po kosu.',
        moq: 'Najmanjše naročilo',
        moq_hint: 'Najmanjša količina, ki jo dobavitelj sprejme.',
        lead_days: 'Dobavni rok (dni)',
        lead_days_hint: 'Koliko dni od naročila do dobave.',
        price_from: 'Cena od',
        price_to: 'Cena do',
        price_to_hint: 'Zadnji dan, ko cena še velja. Prazno pomeni, da konec ni določen.',
        active_hint: 'Neaktivna vrstica ostane zapisana, a se ne ponudi na naročilnici.',
        per_pack: '{quantity} / {unit}',
        pack: 'pakiranje',
        expired: 'Potekla',
        not_started: 'Še ne velja',
        validity_open: 'velja brez omejitve',
        validity_from: 'velja od {from}',
        validity_to: 'velja do {to}',
        validity_range: 'velja {from} – {to}',
        window_backwards: 'Cena se ne more končati pred začetkom.',

        contracts: 'Pogodbe verige',
        contracts_hint: 'Dogovorjene cene za obdobje, ki veljajo za vse objekte verige. Osnutek se še ureja; aktivacija zapiše cene v katalog verige.',
        contracts_empty: 'Pogodb verige še ni.',
        add_contract: 'Nova pogodba',
        edit_contract: 'Uredi pogodbo',
        view_contract: 'Pogodba',
        contract_number: 'Številka pogodbe',
        contract_number_hint: 'Kot je zapisana na papirju, ki sta ga podpisala.',
        contract_currency_hint: 'Ena valuta za celo pogodbo — postavke v dveh valutah so vsota, ki je ni mogoče sešteti.',
        valid_from: 'Velja od',
        valid_to: 'Velja do',
        valid_to_hint: 'Zadnji dan veljavnosti. Prazno pomeni, da konec ni dogovorjen.',
        lines: 'Postavke',
        add_line: 'Dodaj postavko',
        lines_empty: 'Pogodba še nima postavk.',
        lines_n: 'postavk: {count}',
        lines_required: 'Pogodba brez postavk ne zapiše nobene cene.',
        line_twice: 'Isti artikel je na pogodbi dvakrat.',
        read_only: 'Pogodbe ni več mogoče urejati',
        read_only_hint: 'Aktivirana ali preklicana pogodba se samo bere. Cene, ki jih je zapisala, ostanejo v katalogu verige.',
        activate: 'Aktiviraj',
        activated: 'Aktivirano. Zapisanih cen: {count}.',
        confirm_activate: 'Aktiviram pogodbo {number}? Cene se zapišejo v katalog VSEH objektov verige.',
        cancel_contract: 'Prekliči pogodbo',
        confirm_cancel: 'Prekličem pogodbo {number}? Cene, ki jih je zapisala, ostanejo v katalogu — s svojo veljavnostjo.',
        cancelled: 'Preklicano.',
        status_draft: 'Osnutek',
        status_active: 'Aktivna',
        status_expired: 'Pretečena',
        status_cancelled: 'Preklicana',

        demand: 'Skupne potrebe',
        demand_hint: 'Kaj potrebujejo objekti verige skupaj, sešteto po artiklu. Pod vsako vrstico piše, čigava je katera količina in iz katerega zahtevka.',
        demand_empty: 'Odprtih skupnih potreb ni.',
        pooling_off: 'Skupna nabava ni vklopljena',
        pooling_off_hint: 'Potrebe se vidijo, skupno povpraševanje pa lahko strežnik zavrne. Stikalo je v Nastavitve (zobnik) → Integracije in komunikacija → Verige.',
        rfq_suppliers: 'Dobavitelji objekta',
        rfq_suppliers_hint: 'Iz šifranta tega objekta.',
        rfq_chain_suppliers: 'Dobavitelji verige',
        rfq_chain_suppliers_hint: 'Iz kataloga verige, po davčni številki — tudi tisti, ki jih ta objekt nima v šifrantu.',
        rfq_due_on: 'Rok za odgovor',
        rfq_due_on_hint: 'Do kdaj naj dobavitelji odgovorijo.',
        create_pooled_rfq: 'Ustvari skupno povpraševanje',
        selected_n: 'izbranih vrstic: {count}',
        nothing_selected: 'Izberi vsaj eno vrstico.',
        pooled_rfq_created: 'Skupno povpraševanje je nastalo.',
    },
    /**
     * Prenosi med objekti verige (WP-M5, docs/VERIGE-ZASLONI.md).
     *
     * Svoj imenski prostor in ne del `stock`: premik znotraj hiše je računica enega
     * objekta, prenos pa dveh — zaloga pade pri pošiljatelju in zraste pri prejemniku,
     * vmes pa je klin, ko blago ni na nobeni polici.
     */
    materialsTransfer: {
        title: 'Prenosi',
        lead: 'Blago, ki gre z ene hiše na drugo znotraj verige. Osnutek se še ureja; s pošiljanjem zaloga odide, s prevzemom prispe.',
        detail_lead: 'Kaj je na prenosu, koliko je vredno in kaj se je z njim zgodilo.',
        heading: 'Prenos {number}',
        not_found: 'Prenosa ni mogoče najti.',
        add: 'Nov prenos',
        created: 'Osnutek prenosa je nastal.',
        empty: 'Prenosov ni.',

        outgoing: 'Odhodni',
        incoming: 'Prihodni',
        filter_all: 'Vsi',
        filter_status: 'Stanje',
        filter_status_help: 'Prazno pomeni vsa stanja.',

        lines: 'Postavke',
        lines_n: 'postavk: {count}',
        lines_empty: 'Prenos še nima postavk.',
        lines_required: 'Prenos brez postavk ne premakne ničesar.',
        add_line: 'Dodaj postavko',
        article: 'Artikel',
        quantity: 'Količina',
        lot: 'Serija',
        lot_hint: 'Serija ali lot, kjer jih hiša vodi. Prazno je običajno.',
        unit_cost: 'Cena/enoto',
        line_total: 'Skupaj',
        mapped_to: 'Artikel prejemnika',
        unmapped: 'ni preslikan',
        unmapped_n: 'nepreslikanih: {count}',

        to_property: 'Prejemnik',
        to_property_hint: 'Objekt iz iste verige. Prenos zunaj verige strežnik zavrne.',
        from_place: 'Iz skladišča',
        from_place_hint: 'S katere police blago odide.',
        to_place: 'V skladišče',
        to_place_hint: 'Kam blago prispe. Ni nujno tisto, v katerega hiša kupuje.',
        no_members: 'Veriga nima drugega objekta',
        no_members_hint: 'Prenos je mogoč le na drug objekt iste verige. Člane ureja skrbnik v Nastavitve (zobnik) → Integracije in komunikacija → Verige.',

        other_currency: 'Objekta imata različni valuti',
        other_currency_hint: 'Vklopi, kadar pošiljatelj vodi drugo valuto kot ta objekt. Kjer je znano iz registra objektov, se tečaj pokaže sam.',
        exchange_rate: 'Tečaj',
        exchange_rate_hint: 'Koliko enot valute tega objekta je ena enota pošiljateljeve.',

        unmapped_first: 'Nekatere postavke še niso preslikane',
        unmapped_first_hint: 'Postavk brez artikla prejemnika: {count}. Blago, ki ne pristane na noben artikel, prispe in se ne šteje nikamor.',
        mapping_lead: 'Kateri artikel tega objekta je katera postavka',
        mapping_lead_hint: 'Vsaka hiša ima svoj šifrant, zato pošiljateljev artikel na tej polici ne pomeni ničesar, dokler mu nekdo ne pove imena.',
        mapping_required: 'Izberi vsaj en artikel.',

        cancel_reason: 'Razlog',
        cancel_reason_hint: 'Zakaj prenosa ne bo. Razlog se zapiše na dokument — bereta ga obe hiši.',

        action_send: 'Pošlji',
        action_receive: 'Prejmi',
        action_mapping: 'Preslikaj artikle',
        action_cancel: 'Prekliči',
        done_send: 'Poslano.',
        done_receive: 'Prevzeto.',
        done_mapping: 'Preslikano.',
        done_cancel: 'Preklicano.',

        timeline: 'Potek',
        timeline_empty: 'Zaenkrat se ni zgodilo nič.',
        sent: 'Poslano',
        received: 'Prevzeto',
        cancelled: 'Preklicano',
        sent_at: 'poslano',
        received_at: 'prevzeto',
        by: 'kdo: {who}',

        status_draft: 'Osnutek',
        status_sent: 'Poslano',
        status_received: 'Prevzeto',
        status_cancelled: 'Preklicano',

        intercompany_invoice: 'Medpodjetniški račun',
        intercompany_draft: 'osnutek',
        intercompany_issued: 'izdan',
        intercompany_missing: 'manjka',
        intercompany_cancelled: 'preklican',

        errors: {
            outside_chain: 'Prenos je mogoč le med objekti iste verige.',
        },
    },
    stay_request: {
        title: 'Prošnje gostov',
        answered_title: 'Odgovorjene v zadnjih 7 dneh',
        no_guest: 'Gost',
        rooms: 'soba {rooms}',
        departure: 'odhod {date}',
        kind_late_checkout: 'Pozni odhod',
        kind_extension: 'Podaljšanje za {count} noč | Podaljšanje za {count} noči',
        source_assistant: 'Milo',
        source_portal: 'Portal za goste',
        no_quote: 'Cene za podaljšanje ni bilo mogoče izračunati.',
        quote_room: 'Soba {room} → do {date}',
        not_available: 'ni prosta',
        check_price: 'preveri ceno',
        hour: 'Do katere ure',
        no_hour: 'Brez ure',
        answer_placeholder: 'Odgovor gostu (neobvezno)',
        confirm: 'Potrdi',
        confirm_extension: 'Potrdi podaljšanje',
        decline: 'Zavrni',
        confirm_extension_question: 'Podaljšam bivanje do {date} za skupaj +{amount}?',
        confirmed: 'Prošnja potrjena',
        declined: 'Prošnja zavrnjena',
        decide_failed: 'Odgovora na prošnjo ni bilo mogoče shraniti.',
        status_pending: 'čaka',
        status_confirmed: 'potrjeno',
        status_declined: 'zavrnjeno',
    },
    today: {
        title: 'Danes',
        lead: 'Kaj se danes dogaja v hiši in kaj čaka tebe.',

        greeting_morning: 'Dobro jutro',
        greeting_day: 'Dober dan',
        greeting_evening: 'Dober večer',
        greeting_morning_named: 'Dobro jutro, {name}',
        greeting_day_named: 'Dober dan, {name}',
        greeting_evening_named: 'Dober večer, {name}',

        no_sections: 'Tvojemu računu ni dodeljen noben zaslon, o katerem bi ta stran lahko kaj povedala. Pravice ureja skrbnik hiše.',
        open_settings: 'Odpri nastavitve',
        open_reception: 'Odpri Recepcijo',
        open_housekeeping: 'Odpri Gospodinjstvo',
        open_maintenance: 'Odpri Vzdrževanje',
        open_events: 'Odpri Dogodke',
        open_dining: 'Odpri Obroke',
        open_materials: 'Odpri Materialno',
        open_staff: 'Odpri Zaposlene',
        open_crm: 'Odpri CRM',
        open_registrations: 'Odpri Poročanje AJPES',
        section_quiet: 'Nič ne čaka.',
        section_failed: 'Podatkov trenutno ni mogoče prebrati.',
        all_clear: 'Vse urejeno',
        attention_title: 'Danes potrebuje pozornost',
        attention_waiting: 'Čaka 1 zadeva | Čaka zadev: {count}',
        no_room: 'brez sobe',

        section_reception: 'Recepcija',
        section_registrations: 'Poročanje AJPES',
        section_housekeeping: 'Gospodinjstvo',
        section_maintenance: 'Vzdrževanje',
        section_events: 'Dogodki',
        section_dining: 'Obroki',
        section_materials: 'Materialno',
        section_staff: 'Zaposleni',
        section_crm: 'CRM',

        count_arrivals: 'Prihodi',
        count_arrivals_unassigned: 'Brez sobe',
        count_departures: 'Odhodi',
        count_in_house: 'V hiši',
        count_occupancy_pct: 'Zasedenost',
        count_unconfirmed: 'Nepotrjene',
        count_reminders_due: 'Opomniki',
        count_unregistered: 'Neprijavljeni',
        count_departures_due: 'Odjave',
        count_failed: 'Zavrnjene',
        count_pending: 'V vrsti',
        count_dirty: 'Za pospraviti',
        count_priority: 'Prednostne',
        count_clean: 'Čiste',
        count_inspected: 'Pregledane',
        count_lost_items_open: 'Najdeni predmeti',
        count_open: 'Odprte',
        count_urgent: 'Nujne',
        count_today: 'Danes',
        count_next_7_days: 'V 7 dneh',
        count_covers_today: 'Obroki danes',
        count_approvals_pending: 'Za odobritev',
        count_receiving_today: 'Dobave danes',
        count_orders_open: 'Odprta naročila',
        count_below_minimum: 'Pod minimumom',
        count_invoices_unmatched: 'Neusklajeni računi',
        count_on_shift_today: 'Na delu',
        count_absent_today: 'Odsotni',
        count_pending_requests: 'Čaka odločitev',
        count_tasks_due: 'Zapadle naloge',
        count_opportunities_open: 'Odprte priložnosti',

        sub_arrivals_unassigned: 'prihod brez dodeljene sobe',
        sub_priority: 'prihod danes, soba ni pripravljena',
        sub_unregistered: 'gost je v hiši in ni prijavljen',
        sub_departures_due: 'odjava še ni sporočena',

        status_draft: 'osnutek',
        status_confirmed: 'potrjeno',
        status_checked_in: 'prijavljen',
        status_checked_out: 'odjavljen',
        status_cancelled: 'preklicano',
        status_no_show: 'ni prišel',
        status_clean: 'čista',
        status_dirty: 'umazana',
        status_inspected: 'pregledana',
        status_occupied: 'zasedena',
        status_out_of_order: 'izven uporabe',
        status_out_of_service: 'izven prodaje',
        status_blocking: 'blokira sobo',
        status_normal: 'običajna',
        status_cosmetic: 'kozmetična',
        status_inquiry: 'povpraševanje',
        status_option: 'opcija',
        status_in_progress: 'v teku',
        status_completed: 'zaključeno',
        status_lost: 'izgubljeno',
        status_sent: 'poslano',
        status_absence_request: 'dopust',
        status_time_correction: 'popravek ure',
        status_shift_change: 'sprememba turnusa',
    },
    nav: {
        today: 'Danes',
        events: 'Dogodki',
        collapse_menu: 'Skrči meni',
        expand_menu: 'Razširi meni',
        marketing: 'Marketing',
        groups: 'Skupine',
        offers: 'Ponudbe',
        stock: 'Zaloga',
        retail: 'Blagajna',
        suppliers: 'Dobavitelji',
        materials_accounting: 'Knjigovodstvo',
        materials_forecast: 'Napoved potreb',
        materials_budgets: 'Proračuni',
        materials_kpi: 'Kazalniki',
        materials_period_close: 'Mesečni zaključek',
        sales_group: 'Komerciala',
        materials_catalogue: 'Katalog in pogodbe',
        materials_invoices: 'Prejeti računi',
        materials_orders: 'Naročilnice',
        materials_rfqs: 'Povpraševanja',
        materials_requisitions: 'Zahtevki',
        materials_approvals: 'Moje odobritve',
        materials_approval_rules: 'Pravila odobritev',
        materials_receiving: 'Prevzem',
        materials_returns: 'Vračila',
        materials_mobile: 'Mobilno',
        materials_counts: 'Inventure',
        materials_chain: 'Veriga',
        materials_transfers: 'Prenosi zaloge',
        materials_overview: 'Pregled',
        materials_group: 'Materialno poslovanje',
        // Podnaslovi v zavihku Materialno poslovanje — vrstni red dela: kaj je na
        // polici, kaj hiša kupuje, kaj prispe, za kaj je zaračunano in veriga okrog tega.
        materials_group_stock:      'Zaloga',
        materials_group_purchasing: 'Nabava',
        materials_group_receiving:  'Prevzem',
        materials_group_accounting: 'Računi in knjigovodstvo',
        materials_group_chain:      'Veriga',
        // Ni več `assistant`: Milo ni menijski vnos, ampak krogla v vrstici
        // (AssistantOrb.vue). Ime zaslona je `assistant.title`.
        crm_group: 'CRM',
        crm_overview: 'Pregled',
        crm_manager: 'Vodstvo',
        segments: 'Segmenti',
        opportunities: 'Priložnosti',
        tasks: 'Opravila',
        lost_items: 'Najdeni predmeti',
        users:        'Uporabniki',
        roles:        'Vloge',
        appearance:   'Videz',
        companies: 'Podjetja',
        chessboard:   'Razpored sob',
        availability: 'Razpoložljivost',
        reservations: 'Rezervacije',
        guests:       'Gostje',
        properties:   'Objekti',
        rooms:        'Sobe',
        rate_plans:   'Ceniki',
        channels:     'Kanali',
        invoices:     'Računi',
        facilities:   'Zmogljivosti',
        dining:       'Obroki in vstopi',
        housekeeping: 'Čiščenje sob',
        housekeeping_overview: 'Čiščenje — pregled',
        maintenance:  'Vzdrževanje',
        reports:      'Poročila',
        finance: 'Finance',
        settings:     'Nastavitve',
        staff_group:  'Zaposleni',
        staff_personal:   'Osebno',
        staff_management: 'Vodenje',
        staff_hr:         'Kadri',
        me:           'Jaz',
        staff_today:  'Danes',
        vacations:    'Dopusti',
        rota:         'Urnik',
        my_rota:      'Moj urnik',
        my_time:      'Moja ura',
        time_record:  'Evidenca časa',
        time_corrections: 'Popravki',
        absences:     'Odsotnosti',
        employments:  'Kadrovske kartice',
        coverage:     'Pokritost',
        staff_catalogue: 'Oddelki in delovna mesta',
        staff_org_chart: 'Organigram',
        staff_settings:  'Evidenca delovnega časa',
        logout:       'Odjava',
        menu:         'Meni',
        theme:        'Videz',
        theme_light:  'Svetlo',
        theme_dark:   'Temno',
        theme_system: 'Sistemsko',
        language:     'Jezik',
        language_sl:  'Slovenščina',
        language_en:  'Angleščina',
        reminders:    'Opomniki',
        // Zaslon poročanja v eTurizem. Stal je kot zavihek v Financah; od 14. 9. 2026
        // je svoja stran pod Recepcijo, ker ima prijava gosta 12-urni rok.
        registrations: 'Poročanje AJPES',
        // „Prevozi“ alone stood beside „Prenosi“ and the two were read as the same
        // word by everybody who did not already know which was which. Both say what
        // they move now.
        transfers:    'Prevozi gostov',
        // Sedem skupin novega menija. Ključi so angleški kot povsod drugje; besedilo
        // je hotelirjevo.
        group_reception:   'Recepcija',
        group_sales:       'Prodaja in gostje',
        group_events:      'Dogodki in gostinstvo',
        group_house:       'Operativa',
        group_procurement: 'Nabava in zaloga',
        group_finance:     'Finance',
        // Knjigovodstvo materiala stoji zdaj pod Financami, pri bralcu, ki ga odpira.
        materials_group_bookkeeping: 'Knjigovodstvo materiala',
        // Sedem skupin za zobnikom.
        settings_property:   'Objekt in sobe',
        settings_people:     'Uporabniki, vloge in varnost',
        settings_finance:    'Finance in skladnost',
        settings_guest:      'Izkušnja gosta, Milo in zasloni',
        settings_operations: 'Operativne nastavitve',
        settings_links:      'Integracije in komunikacija',
        settings_browser:    'Ta brskalnik',
        back_to_app:      'Nazaj v aplikacijo',
        // Iskalnik zaslonov (Ctrl+K).
        search:             'Poišči zaslon …',
        search_placeholder: 'Kam? Poišči zaslon …',
        search_hint:        'Vsak zaslon, ki ga smeš odpreti — natipkaj nekaj črk njegovega imena.',
        search_empty:       'Ni zaslona s tem imenom.',
        // Priljubljene.
        favourites:           'Priljubljene',
        favourites_reset:     'ponastavi',
        favourites_reset_hint: 'Vrni privzete priljubljene',
        favourites_max:       'Največ {count} priljubljenih',
        favourites_reorder_hint: 'Priljubljene lahko povlečeš na drugo mesto ali jih premakneš s puščicama na vrstici.',
        favourite_add:        'Dodaj med priljubljene',
        favourite_remove:     'Odstrani iz priljubljenih',
        favourite_move_up:    'Premakni gor',
        favourite_move_down:  'Premakni dol',
        // Preklop med novim in klasičnim menijem.
        menu_style:      'Meni',
        menu_new:        'Novi meni (skupine, iskanje, priljubljene)',
        menu_classic:    'Klasični meni',
        menu_style_hint: 'Klasični meni ostane na voljo za prehodno obdobje, da se ni treba navaditi čez noč.',
    },
    table: {
        rows_per_page: 'Vrstic na stran',
        showing:       'Prikazano {from}–{to} od {total}',
        filter:        'Filter',
        clear_filters: 'Počisti filtre',
        row_actions:   'Dejanja',
    },
    // Vstopni portal predstavitvenega strežnika (views/demo, Logic/Demo.go).
    demo_entry: {
        group_haccp: 'HACCP',
        group_rez: 'Rezervacije',
        role_haccp_upravljalec: 'Upravljalec portala',
        shows_haccp_upravljalec: 'Operaterska konzola · izberite »Administrator«',
        role_haccp_lastnik: 'Lastnik',
        shows_haccp_lastnik: 'Vodstveni portal · izberite Marjeto Kovač',
        role_haccp_vodja: 'Vodja',
        shows_haccp_vodja: 'Vodstveni portal · izberite Andreja Zupana',
        role_haccp_zaposleni: 'Zaposleni',
        shows_haccp_zaposleni: 'Aplikacija za izmeno · izberite Špelo Novak',
        role_rez_upravljalec: 'Upravljalec portala',
        shows_rez_upravljalec: 'Partnerji, nastavitve portala',
        role_rez_lastnik: 'Lastnik',
        shows_rez_lastnik: 'Svoje storitve, termini, cene',
        role_rez_zaposleni: 'Zaposleni',
        shows_rez_zaposleni: 'Današnji termini in rezervacije',
        role_rez_stranka: 'Stranka',
        shows_rez_stranka: 'Rezervacija termina',
        group_mac: 'iPhone, ura in iPad — na Macu',
        mac_title: 'Telefon in ura sobarice, iPad na vratih jedilnice',
        mac_shows: 'Prave aplikacije za iPhone, Apple Watch in iPad tečejo v Applovem simulatorju na Macu z Xcode. Datoteka jih zgradi, odpre in poveže s predstavitvenim strežnikom.',
        mac_step_download: 'Prenesite datoteko in v mapi Prenosi dvokliknite »Imprion-simulatorji.command« (v mapi Imprion simulatorji).',
        mac_step_allow: 'Samo prvič: če jo macOS zavrne, odprite Sistemske nastavitve → Zasebnost in varnost in pritisnite »Vseeno odpri«.',
        mac_step_wait: 'Prvič gradnja traja nekaj minut, nato se odprejo iPhone, ura in iPad, že povezani. Naslednjič je to stvar pol minute.',
        mac_download: 'Prenesi za Mac',
        subtitle:          'Predstavitev',
        warning:           'Demo okolje — samo za predstavitev',
        title:             'Kdo ste danes?',
        lead:              'En klik in ste prijavljeni v vlogi — brez tipkanja uporabnikov in gesel med predstavitvijo.',
        loading:           'Nalagam …',
        unavailable:       'Ta strežnik ni predstavitveni',
        unavailable_hint:  'Prijava z enim klikom deluje samo na strežniku za predstavitve.',
        enter:             'Vstopi',
        signing_in:        'Prijavljam …',
        sign_in_failed:    'Te vloge na tem strežniku ni.',
        back:              'Nazaj na izbiro vlog',
        group_desk:        'Uprava in recepcija',
        group_floor:       'Gospodinjstvo in osebje',
        group_guest:       'Gost, soba in veriga',
        role_direktor:        'Direktor',
        shows_direktor:       'Vse: poročila, nastavitve, uporabniki',
        role_vodja_recepcije: 'Vodja recepcije',
        shows_vodja_recepcije:'Danes, prošnje gostov, šahovnica',
        role_receptor:        'Receptor',
        shows_receptor:       'Prihodi in odhodi, folio, PIN za naročila',
        role_marketing:       'Marketing',
        shows_marketing:      'Kampanje, ponudbe, objave',
        role_zajtrk:          'Zajtrkovalnica',
        shows_zajtrk:         'Obroki in vstopi na vratih jedilnice',
        role_vodja_ciscenja:  'Vodja čiščenja',
        shows_vodja_ciscenja: 'Razpored sob, ekipe, pregledi',
        role_sobarica:        'Sobarica',
        shows_sobarica:       'Moje sobe za danes, na telefonu',
        role_vzdrzevalec:     'Vzdrževalec',
        shows_vzdrzevalec:    'Okvare in delovni nalogi',
        role_zaposleni:       'Zaposleni',
        shows_zaposleni:      'Urnik, dopust, evidenca časa',
        role_gost:            'Gost',
        shows_gost:           'Telefon gosta v sobi 404',
        role_tv:              'Sobni TV',
        shows_tv:             'Televizija v sobi 404',
        role_veriga:          'Uprava verige',
        shows_veriga:         'Več hotelov na enem mestu',
        role_book:            'Spletna rezervacija',
        shows_book:           'Rezervacijski sistem hotela',
    },
    // Vrata, skozi katera konzola uprave odpre to recepcijo (docs/UPRAVA.md §9).
    handoff: {
        opening: 'Odpiram hišo …',
        failed:  'Povezava je potekla ali ni veljavna. Odpri hišo znova iz konzole uprave.',
    },
    login: {
        title:    'Prijava',
        username: 'Uporabniško ime',
        password: 'Geslo',
        submit:   'Prijava',
        failed:   'Napačno uporabniško ime ali geslo',
    },
    // Dogodki — dve odločitvi hiše (docs/DOGODKI.md §6, odločitvi 5 in 6).
    property_events: {
        title: 'Dogodki',
        hint: 'Kdaj je zajamčeno število dokončno in po čem se obračuna, če jih pride manj.',
        cutoff_days: 'Rok za zajamčeno število (dni prej)',
        cutoff_days_hint: 'Prazno oziroma 0 pomeni izdelkov privzetek — tri dni. Po roku se število premakne le z novo različico.',
        charge_below: 'Če jih pride manj',
        charge_below_hint: 'Kar hiša naredi, kadar je dejansko število nižje od zajamčenega.',
        charge_below_default: 'Kot je v navadi (po zajamčenem)',
        charge_below_on: 'Obračunaj po zajamčenem številu',
        charge_below_off: 'Obračunaj po dejanskem številu',
    },
    property: {
        details_tab:  'Podatki objekta',
        details_hint: 'Vse nastavitve tega objekta. Gumb Uredi jih odklene kar tukaj.',
        section_basic:      'Osnovno',
        section_time_money: 'Čas in denar',
        section_sales:      'Prodaja in blagajna',
        child_until_age_none:            'Brez pravila',
        retail_return_approval_default:  'Privzeto (50 €)',
        document_scan: 'Fotografije dokumentov',
        document_scan_hint: 'Kaj se zgodi s sliko, ki jo recepcija naredi pri branju gostovega dokumenta.',
        document_scan_keep: 'Hrani fotografije',
        document_scan_keep_hint: 'Privzeto se slika po branju zavrže. Vklopi le, če jih potrebuješ ob sporih.',
        document_scan_days: 'Hrani (dni)',
        document_scan_days_hint: 'Šteje se od zajema. Po tem se slika samodejno izbriše (največ 90 dni).',
        document_scan_ai: 'Beri dokument tudi z modelom (AI)',
        document_scan_ai_hint: 'Poleg bralnika na strežniku sliko prebere še jezikovni model. Bere tudi slabe fotografije, dokumente brez strojnega zapisa in naslov s sprednje strani. Vsako branje preverijo kontrolne števke dokumenta.',
        document_scan_ai_notice: 'Slika dokumenta bo poslana zunanjemu obdelovalcu (Anthropic). To hotel navede v svoji politiki zasebnosti in uredi pogodbo o obdelavi podatkov. Slika se pri obdelovalcu ne hrani; ime gosta in rezervacija se ne pošljeta.',
        vat_rates: 'Stopnje DDV',
        vat_rates_hint: 'Šifrant stopenj, med katerimi se izbira pri postavkah. Vpiši odstotke (22, 9,5, 5, 0).',
        vat_rate_add: 'Dodaj stopnjo',
        vat_rates_default: 'Brez vnosa velja običajni slovenski nabor: 22 %, 9,5 %, 5 % in 0 %.',
        accommodation_tax_rate: 'DDV za nastanitev (%)',
        accommodation_tax_rate_help: 'Stopnja, po kateri se obračuna nočitev — v Sloveniji 9,5 %. Vsaka knjižena nočitev jo nosi s sabo.',
        street: 'Ulica',
        properties:       'Objekti',
        property:         'Objekt',
        add:              'Dodaj objekt',
        edit:             'Uredi objekt',
        timezone:         'Časovni pas',
        night_audit_hour: 'Ura nočnega zaključka',
        check_out_hour:      'Ura odjave',
        check_out_hour_hint: 'Do kdaj naj bi bil gost iz sobe. Ni pravilo, ki bi koga zavrnilo: po tej uri se soba, ki je nihče ni sprostil, šteje za prosto, da lahko jutro teče naprej - hiša pa to pove z vrstico v „zahteva obravnavo“.',
        retail_card_confirmation:      'Potrditev plačila s kartico',
        retail_card_confirmation_hint: 'Račun se izda šele po odobritvi terminala. Vklopi, če hotel sprejema kartice.',
        site_published:      'Objavljena spletna stran',
        site_published_hint: 'Ali je lastna spletna stran hiše javno dostopna. Ločeno od rezervacijskega motorja — hiša brez njega dobi stran brez gumba za rezervacijo.',
        retail_return_approval:      'Meja za vračila brez odobritve',
        retail_return_approval_hint: 'Nad tem zneskom vračilo potrdi vodja. Prazno ali 0 pomeni privzetih 50 €.',
        currency:         'Valuta',
        address:          'Naslov',
        city:             'Kraj',
        postal_code:      'Poštna številka',
        country:          'Država',
        default_language: 'Privzeti jezik',
        child_until_age: 'Otrok do starosti',
        cancellation_charge: 'Odpovedni strošek',
        cancellation_charge_hint: 'Kako se knjiži odpovedni strošek. Če pustiš, kot je, se knjiži natanko tako kot doslej - vprašanje DDV pa ostane odprto za računovodstvo.',
        child_until_age_hint: 'Kdor je na dan prihoda mlajši od tega, je na rezervaciji otrok. Nič: brez pravila, vsi so odrasli.',
        in_use:           'Objekta ni mogoče izbrisati, ker ima vpisane sobe',
    },
    room_type: {
        sleeps: 'sprejme {count}',
        occupancy_exceeded: 'Ta tip sobe sprejme največ {count} oseb. Izberi večjo ali zmanjšaj število gostov.',
        room_types:        'Tipi sob',
        room_type:         'Tip sobe',
        add:               'Dodaj tip sobe',
        edit:              'Uredi tip sobe',
        standard_occupancy: 'Standardna zasedenost',
        max_occupancy:     'Največja zasedenost',
        beds:              'Ležišča',
        extra_beds:        'Dodatna ležišča',
        code_taken: 'To kodo že uporablja drug tip sobe.',
        code_taken_error: 'Kode {code} ne moremo uporabiti \u2014 ima jo že drug tip sobe. Izberi drugo.',
        display_order_taken: 'Zasedeno: {taken}',
        display_order:     'Vrstni red',
        reorder:           'Spremeni vrstni red',
        move_up:           'Premakni navzgor',
        move_down:         'Premakni navzdol',
        no_rooms:          'Ta tip sobe še nima vpisanih sob. Dodaj jih pri objektu.',
        in_use:            'Tipa sobe ni mogoče izbrisati, ker ima vpisane sobe',
        group_category:        'Kategorija skupine',
        group_category_hint:   'Kateri centralni kategoriji sob uprave verige pripada ta tip sobe. Po njej uprava potisne cenike v to hišo.',
        group_category_none:   'Brez kategorije',
        group_category_failed: 'Kategorije skupine ni bilo mogoče shraniti. Tip sobe je shranjen.',
    },
    room: {
        rooms:      'Sobe',
        room:       'Soba',
        add:        'Dodaj sobo',
        edit:       'Uredi sobo',
        number:     'Številka',
        floor:      'Nadstropje',
        floor_number: '{floor}. nadstropje',
        ground_floor: 'Pritličje',
        block:      'Zapora sobe',
        block_reason: 'Razlog zapore',
        occupied_cannot_delete: 'Zasedene sobe ni mogoče izbrisati',
        named:      'Soba {room}',
    },
    // Napisi povedo, kaj je s sobo treba narediti oziroma kaj soba JE za prodajo — ne,
    // kako je videti. Notranje oznake (dirty/clean/inspected) so nespremenjene.
    // Utemeljitev: docs/HOUSEKEEPING.md §3.2.
    room_status: {
        clean:          'Počiščena',
        dirty:          'Za urediti',
        inspected:      'Pripravljena',
        occupied:       'Zasedena',
        out_of_order:   'Izven uporabe',
        out_of_service: 'Izven prodaje',
    },
    room_screen: {
        back: 'Razpored',
        simulated: 'Simulirana oprema',
        arriving_at: 'prihod ob {hour}',
        nobody_tonight: 'Nocoj je prosta',
        unavailable: 'Te sobe ni mogoče prikazati',
        unavailable_hint: 'Pripada drugemu objektu, je bila odstranjena, ali pa ta račun nima vpogleda v dogajanje v sobah.',
        no_system: 'Ta hotel nima sistema sobne avtomatizacije',
        no_system_hint: 'Iz te sobe se ne bere nič in tudi povedati ji ni mogoče ničesar. Vse ostalo v sobi deluje kot doslej.',
        no_sensors: 'V tej sobi ni vgrajeno nič, kar bi javljalo.',
        prepare: 'Pripravi za prihod',
        prepare_title: 'Kaj bo narejeno',
        prepare_hvac: 'Ogrevanje na udobje, ciljna temperatura {value}°',
        prepare_until_arrival: 'velja do prihoda gosta ob {hour}',
        prepare_until_half_hour: 'velja pol ure — ta gost ni povedal ure prihoda',
        prepare_not_housekeeping: 'stanje čiščenja se NE spremeni — ogreta soba ni pospravljena soba',
        prepare_not_keys: 'gostov ključ NI del tega — aktivira se ob prijavi',
        prepare_confirm: 'Potrdi',
        live: 'Živo stanje',
        temperature: 'Temperatura',
        target: 'cilj {value}°',
        window: 'Okno',
        window_open: 'odprto · {minutes} min',
        window_closed: 'zaprto',
        presence: 'Prisotnost',
        presence_in: 'zasedena · že {minutes} min',
        presence_out: 'prazna · že {minutes} min',
        signs: 'Znaki',
        make_up: 'POSPRAVI SOBO',
        humidity: 'Vlaga',
        energy: 'Poraba danes',
        control: 'Upravljanje',
        no_control: 'Ta soba ne sprejema ukazov.',
        driver_no_control: 'Ta sistem sobne avtomatizacije sobe bere, pisati vanje pa ne dovoli.',
        halted: 'Klima je ustavljena',
        halted_hint: 'Ustavil jo je sistem sobne avtomatizacije sam, ker je okno odprto. To je pravilo tistega sistema in ne naše; ko se okno zapre, se spet zažene.',
        mode: 'Režim',
        mode_comfort: 'Udobje',
        mode_eco: 'Eko',
        mode_off: 'Izklop',
        setpoint: 'Ciljna temperatura',
        holds_for: 'Velja',
        duration_30m: '30 minut',
        duration_until_arrival: 'do prihoda gosta',
        duration_until_automation: 'do naslednje avtomatizacije',
        duration_permanent: 'trajno',
        command_sending: 'pošiljam …',
        command_confirmed: 'naprava potrdila · {time}',
        command_confirmed_short: 'naprava je potrdila',
        preparation_warming: 'ogreva {from}° → {to}° · prihod ob {hour}',
        preparation_warming_plain: 'ogreva {from}° → {to}°',
        preparation_ready: 'pripravljena {value}°',
        preparation_failed: 'priprave ni uspelo izvesti',
        preparation_assumed: 'privzeta ura hiše',
        command_unconfirmed: 'ni potrjeno — ukaz je bil poslan in odgovora ni bilo',
        command_expired: 'ročni poseg je potekel',
        command_failed: 'Ukaza ni bilo mogoče poslati.',
        retry: 'Poskusi znova',
        automations: 'Avtomatizacije hotela',
        preheat: 'ogrej sobo {hours} h pred napovedanim prihodom',
        eco_on_checkout: 'ob odjavi preklopi na eko',
        automations_hint: 'Stikalo hotela se ureja na njegovem nastavitvenem zaslonu. Ta soba lahko pove le, ali odločitev hotela velja zanjo.',
        automation_on: 'velja za to sobo',
        automation_off: 'za to sobo ne velja',
        automation_house_on: '(hotel ima vklopljeno)',
        automation_house_off: '(hotel ima izklopljeno)',
        automation_inherit: 'Po hotelu',
        automation_force_on: 'Vedno',
        automation_force_off: 'Nikoli',
        automation_failed: 'Nastavitve ni bilo mogoče shraniti.',
        reservation: 'Rezervacija in ključi',
        keys: 'Ključi',
        keys_hint: 'Gumbi za kartice pridejo z integracijo ključavnic. Do takrat se ključ izda ob prijavi, kot doslej.',
        timeline: 'Kaj se je dogajalo',
        timeline_empty: 'Za to sobo še ni zabeleženo nič.',
        lane_all: 'Vse',
        lane_guest: 'Gost',
        lane_housekeeping: 'Čiščenje',
        lane_hvac: 'Klima',
        lane_access: 'Dostop',
        lane_alarm: 'Alarmi',
    },
    room_event: {
        window_opened: 'Okno odprto',
        window_closed: 'Okno zaprto po {minutes} min',
        presence_arrived: 'V sobi je nekdo',
        presence_left: 'Soba je prazna',
        hvac_mode_changed: 'Režim {from} → {to}',
        setpoint_changed: 'Cilj {from}° → {to}°',
        hvac_halted: 'Klima ustavljena — okno je odprto',
        hvac_resumed: 'Klima znova zagnana',
        command_sent: 'Poslan ukaz: {to}',
        command_confirmed: 'Naprava je potrdila',
        command_unconfirmed: 'Odgovora ni bilo — ni znano, ali je soba ukaz izvedla',
        command_expired: 'Ročni poseg je potekel',
        proposal_confirmed: 'Milov predlog potrjen: {from} → {to}',
        setting_changed: 'Nastavitev {from} → {to}',
        sensor_silent: 'Soba je nehala javljati',
        sensor_returned: 'Soba spet javlja',
        attention_raised: 'Temperatura {from}° → {to}°',
        stay_state_sent: 'Soba javljena kot {to}',
        simulator_scenario: 'Predstavitev: {to}',
        hk_generated: 'Uvrščena na jutranji seznam',
        hk_assigned: 'Dodeljena',
        hk_reassigned: 'Predana drugi',
        hk_started: 'Čiščenje začeto',
        hk_deferred: 'Preloženo',
        hk_resumed: 'Nadaljevano',
        hk_finished: 'Čiščenje končano',
        hk_finished_again: 'Ponovno počiščeno',
        hk_inspection_failed: 'Vrnjeno v popravo',
        hk_rework_started: 'Popravljanje začeto',
        hk_inspected: 'Sprejeto',
        hk_skipped: 'Izpuščeno',
        // Ime je desno na vrstici, ura pa levo, zato stavek ne imenuje nobenega od
        // njiju: vrstica se prebere kot „09:41 · Prednost postavil/a · Ana“.
        hk_prioritised: 'Prednost postavljena',
        hk_prioritised_by_guest: 'Gost je prosil za čiščenje — soba postavljena naprej',
        hk_deprioritised: 'Prednost umaknjena',
        scenario_window_open: 'odprto okno',
        scenario_window_close: 'zaprto okno',
        scenario_hvac_fault: 'pokvarjena klima',
        scenario_hvac_repair: 'popravljena klima',
        scenario_sensor_silent: 'utišani senzorji',
        scenario_sensor_return: 'senzorji spet javljajo',
        scenario_all_normal: 'vse nazaj v normalno',
        stay_vacant: 'ni prodana',
        stay_sold: 'prodana',
        stay_checked_in: 'gost prijavljen',
        stay_checked_out: 'gost odjavljen',
        note_preheat: 'predpriprava pred prihodom',
        note_eco_on_checkout: 'eko ob odjavi gosta',
        note_simulator: 'simulirana oprema',
        unknown: 'Zabeleženo: {event}',
    },
    // Demo pult: režija predstavitve sobne telemetrije. Zaslon obstaja samo v hotelu,
    // ki teče na simulatorju — hotel s pravo opremo ga sploh nima.
    room_control: {
        open: 'Nastavi sobo {room}',
        title: 'Soba {room}',
        cooler: 'Znižaj za 0,5 °C',
        warmer: 'Zvišaj za 0,5 °C',
        holds_until_arrival: 'velja do prihoda gosta',
        no_reading: 'Ta soba se še ni oglasila, zato ji ni mogoče nič sporočiti.',
        room_cannot: 'Ta soba ni opremljena za krmiljenje ogrevanja. Meritve se berejo, ukazov ne sprejema.',
        driver_cannot: 'Sistem sobne avtomatizacije te hiše meritve daje, ukazov pa ne sprejema.',
        no_permission: 'Za spreminjanje temperature potrebuješ pravico „Krmiljenje udobja“.',
        open_room: 'Odpri stran sobe',
    },
    grms: {
        nav: 'Integracija GRMS',
        no_property: 'Najprej izberi objekt.',

        connection: 'Povezava',
        connection_hint: 'Kateri sistem bere sobe te hiše in kje stoji njegova oprema. Izpolni se enkrat, ob namestitvi.',
        connection_note: 'Sporočilo vmesnika',

        automation: 'Samodejna priprava sob',
        automation_hint: 'Kaj naj oprema naredi sama: sobo pred prihodom gosta ogreje, po odhodu pa spusti na eko. Meje in trajanja opozoril niso tu — to so mnenja hiše o topli sobi in se urejajo posebej.',
        automation_no_permission: 'Za urejanje avtomatizacij potrebuješ pravico „Avtomatizacija telemetrije“.',
        automation_saved: 'Avtomatizacije so shranjene.',

        preheat: 'Pripravi sobo pred prihodom',
        preheat_hint: 'Sobo, v katero gost danes prihaja, hiša sama preklopi na udobje in ciljno temperaturo. Ukaz gre enkrat na bivanje, sobe brez krmiljenja se ne dotakne, sobo, ki je že na udobju, pa pusti pri miru.',
        preheat_hours: 'Koliko ur pred prihodom',
        preheat_hours_hint: '3 ure zadostujejo hladni sobi z navadnim radiatorjem. 0 pomeni izklopljeno.',
        preheat_arrival_time: 'Privzeta ura prihoda',
        preheat_arrival_time_hint: 'Za goste, ki ure niso povedali — teh je večina. Ta ura je odločitev hiše in ne ugibanje: vrstica in časovnica povesta, da ura ni gostova.',
        preheat_zero_hint: 'Nič ur pomeni izklopljeno. Ob shranjevanju se stikalo ugasne.',

        eco_on_checkout: 'Po odhodu preklopi na eko',
        eco_on_checkout_hint: 'Ko je soba sproščena, hiša ogrevanje spusti na varčno raven. Soba, ki jo kdo drži z ročnim posegom, se ne dotakne, dokler poseg ne poteče.',

        comfort_target: 'Ciljna temperatura udobja (°C)',
        comfort_target_hint: 'To hiša zahteva, kadar sama pove cilj — pri pripravi na prihod. Kaj „udobje“ pomeni sicer, ve sistem sobne avtomatizacije.',
        eco_target: 'Temperatura eko (°C)',
        eco_target_hint: 'Varčna raven med bivanji.',

        driver: 'Sistem sobne avtomatizacije',
        driver_hint: 'Izbira velja za to hišo. Demo hotel in hotel s pravo opremo lahko tečeta drug ob drugem.',
        driver_none: 'Brez sobne avtomatizacije',
        driver_simulator: 'Simulator (predstavitve)',
        driver_knx: 'KNX (vmesnik v omari)',
        driver_modbus: 'Hotelski agent — Smarteh Modbus',
        driver_interel: 'Interel (oblak)',
        driver_nomadix: 'Nomadix (oblak)',

        not_built: '{driver} v tej izdaji še ni na voljo',
        not_built_hint: 'Izbiro lahko shraniš, a sobe se do izdaje gonilnika ne bodo brale. Prazen stolpec na šahovnici je posledica tega in ne okvare.',

        base_url: 'Naslov storitve',
        username: 'Uporabniško ime',
        secret: 'Geslo ali žeton',
        secret_hint: 'Shrani se šifrirano in se nikoli ne vrne na zaslon.',
        secret_stored: 'Geslo je shranjeno. Prazno polje ga pusti pri miru.',
        secret_set: 'shranjeno',

        note_not_configured: 'Naslov vmesnika še ni vpisan.',
        note_no_free_channel: 'Vmesnik nima prostega kanala. Najpogosteje ga drži odprta seja ETS pri inštalaterju - zapri jo in povezava se vzpostavi sama.',
        note_secure_required: 'Vmesnik zahteva KNX IP Secure, ki v tej izdaji ni podprt.',
        note_unreachable: 'Vmesnika ni mogoče doseči. Preveri naslov, kabel in omrežje do omare.',
        agent_connected: 'Vmesnik je dosegljiv',
        agent_offline: 'Vmesnik ni dosegljiv',
        last_seen: 'Zadnji stik {at}',
        never_seen: 'Stika še ni bilo.',

        interface_address: 'Naslov vmesnika KNXnet/IP',
        interface_address_hint: 'IP naslov vmesnika v omari. Vrata 3671 se dodajo sama.',
        knx_mode: 'Način',
        knx_mode_hint: 'Tunnelling deluje z najcenejšim vmesnikom in ne zahteva ničesar od hotelskega omrežja. Routing pride s prvo instalacijo, ki ga potrebuje.',
        knx_tunnelling: 'Tunnelling (privzeto)',
        physical_address: 'Naš fizični naslov na vodilu',
        physical_address_hint: 'Naslov, ki si ga izposodimo na vodilu. Privzeto 15.15.250, ki je v skoraj vsaki instalaciji prost.',

        secure_unsupported: 'KNX Secure v tej izdaji ni podprt',
        secure_unsupported_hint: 'Vmesnik, ki zahteva KNX IP Secure, bo povezavo zavrnil z jasnim sporočilom in ne s tiho okvaro. Večina hotelskih instalacij ga nima.',

        simulator_title: 'Ta hiša bo videla izmišljene vrednosti',
        simulator_hint: 'Simulator je namenjen predstavitvam. Nobena naprava v nobeni sobi se ne premakne, vsaka številka na zaslonu pa je izmišljena.',

        capabilities: 'Zmožnosti',
        capabilities_hint: 'Kaj hiša dejansko dobi, izpeljano iz potrjene preslikave. Ni nastavitev: soba, ki spet meri, to pove sama, ko pošlje vrednost.',
        capabilities_none: 'Dokler ni potrjena nobena soba, hiša nima nobene zmožnosti.',
        capability_temperature: 'Temperatura',
        capability_humidity: 'Vlaga',
        capability_window_contact: 'Okno',
        capability_occupancy: 'Prisotnost',
        capability_energy_meter: 'Poraba',
        capability_hvac_control: 'Krmiljenje ogrevanja',
        capability_door_access: 'Vrata',
        capability_control_mode: 'Ukaz: režim',
        capability_control_setpoint: 'Ukaz: ciljna temperatura',

        rooms_mapped: 'Potrjenih sob: {mapped} od {total}.',

        ets: 'Uvoz iz ETS',
        ets_hint: 'Naslovov ni treba prepisovati. Inštalater izvozi skupinske naslove iz ETS, tu jih preberemo in predlagamo, katera soba je katera.',
        ets_file: 'Datoteka (.knxproj ali CSV)',
        ets_import: 'Preberi',
        ets_failed: 'Datoteke ni bilo mogoče prebrati',
        ets_read: '{file}: prebranih {count} naslovov, prepoznanih sob {rooms}, preskočenih naslovov {skipped}.',
        ets_confirm: 'Potrdi izbrane sobe ({count})',
        ets_discard: 'Zavrzi predlog',

        unassigned: 'Neuvrščeno ({count})',
        unassigned_hint: 'Naslovi, ki jih ni bilo mogoče pripisati sobi. Ostanejo tu — najpogosteje gre za način poimenovanja, ki ga še ne poznamo.',

        mapping: 'Preslikava sob',
        mapping_hint: 'Potrjene sobe. Soba brez potrjene preslikave nima telemetrije — ne pol telemetrije.',
        mapping_none: 'Nobena soba še ni potrjena.',
        mapping_remove: 'Odstrani sobo',
        mapping_saved: 'Potrjenih sob: {count}.',
        mapping_removed: 'Soba je odstranjena iz preslikave.',

        direction_read: 'beri',
        direction_write: 'piši',
        direction_both: 'oboje',

        point_temperature: 'Temperatura',
        point_setpoint: 'Ciljna temperatura',
        point_hvac_mode: 'Režim',
        point_humidity: 'Vlaga',
        point_window: 'Okno',
        point_presence: 'Prisotnost',
        point_dnd: 'Ne moti',
        point_mur: 'Pospravi sobo',
        point_energy: 'Poraba',
        point_stay_state: 'Stanje bivanja',

        read_now: 'Beri zdaj',
        read_failed: 'Branja ni bilo mogoče izvesti.',
        read_nothing: 'brez odgovora',

        state_accepted: 'Sprejeto',
        state_executed: 'Izvedeno',
        state_failed: 'Neuspelo',
        commands: 'Dnevnik ukazov',
        commands_hint: 'Zadnjih petdeset ukazov na vodilo. »Sprejeto« pomeni, da je vodilo telegram vzelo; »izvedeno« šele, da je naprava javila novo vrednost.',
        commands_none: 'Zaenkrat ni bilo nobenega ukaza.',
        command_at: 'Čas',
        command_room: 'Soba',
        command_kind: 'Kaj',
        command_address: 'Naslov',
        command_value: 'Vrednost',
        command_state: 'Stanje',

        saved: 'Povezava je shranjena.',
    },
    demo: {
        nav: 'Demo pult',
        no_property: 'Najprej izberi objekt.',
        unavailable: 'Ta objekt ima pravo sobno opremo',
        unavailable_hint: 'Demo pult obstaja samo tam, kjer sobe javlja simulator. V hotelu s pravo opremo ni ničesar, kar bi se dalo režirati — in prav je tako.',
        honest_title: 'Vse na tem zaslonu je simulacija',
        honest_hint: 'Gumbi premikajo izmišljene vrednosti v simulatorju sobne avtomatizacije. Nobena naprava v nobeni sobi se ne premakne. Vsak pritisk se zapiše v časovnico sobe kot demo dejanje, z imenom tistega, ki ga je sprožil.',

        scene: 'Celoten prizor',
        scene_hint: 'Postavi zgodbo, ki se pove sama: gost prihaja čez dve uri v sobo z odprtim oknom, hotel ima vklopljeno predpripravo, v prazni sobi je pokvarjeno ogrevanje, tretja soba pa je utihnila. Vrstica »zahteva obravnavo« se pojavi sama, brez pritiska.',
        scene_stage: 'Postavi celoten prizor',
        scene_clear: 'Pospravi',
        scene_none: 'Prizor ni postavljen. Sobe spodaj lahko režiraš tudi posamično.',
        scene_up: 'Prizor stoji: prihod v sobo {arrival} ob {hour} (odprto okno), okvara ogrevanja v sobi {fault}, utihnjeni senzorji v sobi {silent}.',
        scene_booking: 'Rezervacija {number}',
        scene_by: 'postavil {name}',
        scene_clear_hint: '»Pospravi« pobriše vse režirano, vrne hotelske nastavitve, kot so bile, in odpove to rezervacijo — nič drugega.',
        scene_staged: 'Prizor je postavljen.',
        scene_cleared: 'Prizor je pospravljen.',
        scene_failed: 'Prizora ni bilo mogoče postaviti.',
        scene_clear_failed: 'Prizora ni bilo mogoče pospraviti.',

        rooms: 'Sobe',
        rooms_hint: 'Vsaka soba pove, kaj počne zdaj, in ima ob sebi stikala za režijo. Ponoven pritisk isto stvar pospravi.',
        rooms_empty: 'Ta objekt še nima sob s simulirano opremo.',
        no_match: 'Nobena soba se ne ujema z iskanjem.',
        search: 'Številka sobe',
        floor: '{floor}. nadstropje',
        reading_age: 'meritev {age}',

        control_window: 'Okno',
        control_window_hint: 'Pusti okno odprto in ga drži odprtega. Simulirano zračenje se zapre samo — to se ne.',
        control_hvac: 'Okvara',
        control_hvac_hint: 'Ogrevanje se zatakne in soba se greje čez cilj. Ukazi so sprejeti in nikoli izvedeni — to je stanje »ni potrjeno«.',
        control_sensor: 'Utihni',
        control_sensor_hint: 'Soba neha javljati. Vrednosti ostanejo, kjer so, in se starajo — zaslon jih posivi in iz njih ne sproži nobenega pravila.',
        control_dnd: 'NE MOTI',
        control_dnd_hint: 'Znak na vratih, dokler ga kdo ne umakne.',
        control_mur: 'POSPRAVI SOBO',
        control_mur_hint: 'Gost prosi za čiščenje. Na krogu se pojavi vrstica „zahteva obravnavo“ — razen če je hkrati vklopljen znak „ne moti“, ki jo prekrije.',
        control_prepare: 'Prihod',
        control_prepare_hint: 'Sobo pusti hladno (12°) na eku — takšno, kot jo hiša najde pred prihodom gosta. Ko jo priprava ali receptor ogreje, se to na zaslonu vidi v nekaj minutah in ne v uri. Izklop sobo vrne v običajno ogreto.',

        stage_failed: 'Scenarija ni bilo mogoče sprožiti.',
    },
    telemetry: {
        age_seconds: 'pred {count} s',
        age_minutes: 'pred {count} min',
        age_hours: 'pred {hours} h {minutes} min',
        chip_window: 'okno {minutes} min',
        chip_temperature: '{value}°',
        chip_halted: 'klima ustavljena',
        chip_dnd: 'NE MOTI',
        chip_mur: 'POSPRAVI SOBO',
        chip_silent: 'ni podatka · {age}',
        chip_preparing: 'ogreva {from}° → {to}° · prihod {hour}',
        chip_preparing_plain: 'ogreva {from}° → {to}°',
        chip_prepared: 'pripravljena {value}°',
        chip_preparation_failed: 'priprava ni uspela',
        chip_preparation_failed_note: 'priprava ni uspela — {note}',
    },
    board_attention: {
        kind_arrival_room_not_ready: 'Soba ni pripravljena za prihod',
        kind_unpaid_departure: 'Odhod z odprtim saldom',
        kind_blocked_room_occupied: 'Zaprta soba z rezerviranimi nočitvami',
        kind_window_open_before_arrival: 'Odprto okno pred prihodom',
        kind_window_open_vacant: 'Pozabljeno odprto okno',
        kind_temperature_out_of_bounds: 'Soba izven temperaturnih mej',
        kind_temperature_unreached: 'Soba do prihoda ne bo ogreta',
        kind_room_preparation_failed: 'Priprava sobe ni uspela',
        kind_telemetry_room_silent: 'Soba je nehala javljati',
        kind_telemetry_unreachable: 'Sistem sobne avtomatizacije se ne odziva',
        kind_room_not_released: 'Soba ni bila sproščena',
        kind_guest_message: 'Sporočilo gosta (Milo)',
        kind_unknown: 'Zahteva obravnavo',
        title: 'Zahteva obravnavo · {count}',
        critical_count: '{count} kritičnih',
        show_all: 'Prikaži vse ({count})',
        open_list: 'Razreši',
        show_fewer: 'Prikaži manj',
        // Odjava, in ne »odpri rezervacijo«: gumb dela natanko tisto, kar bi
        // receptor naredil, če bi gost stal pred njim — pelje na standardno odjavo,
        // čeprav je bivanje že poteklo.
        check_out: 'Odjavi',
        check_out_hint: 'Odpre odjavo rezervacije za sobo {room}',
        settle: 'Razrešeno',
        settle_title: 'Označi kot obravnavano',
        settle_resolution: 'Kaj ste storili?',
        settle_help: 'Zapis ostane v evidenci. Stanja sobe, računa ali rezervacije to ne spremeni — pove le, da je nekdo pogledal in kaj je naredil.',
        settled: 'Vrstica je označena kot obravnavana.',
        settle_failed: 'Vrstice ni bilo mogoče označiti.',
        // »stanje: {state}« in ne »soba je {state}«: napisi stanj so od v1.333.0 naloge
        // („Za urediti"), ne pridevniki, in „soba je Za urediti" ni stavek.
        arrival_room_not_ready: 'Soba {room} — prihod ob {hour}, stanje: {state}',
        unpaid_departure: 'Soba {room}, {guest} — odhod z odprtim saldom {amount}',
        blocked_room_occupied: 'Soba {room} je {state}, a ima rezervirane nočitve',
        window_open_before_arrival: 'Soba {room} — okno odprto {minutes} min, gost prihaja danes',
        window_open_vacant: 'Soba {room} — okno odprto {minutes} min, nihče ne prihaja',
        temperature_out_of_bounds: 'Soba {room} — {value}°, cilj {target}°, prazna že {minutes} min',
        temperature_unreached: 'Soba {room} — {value}°, cilj {target}° — do {hour} ne bo dosegla',
        room_preparation_failed: 'Soba {room} — priprave na prihod ob {hour} oprema ni izvedla; {value}°, cilj {target}°',
        telemetry_room_silent: 'Soba {room} se ni oglasila že {minutes} min',
        telemetry_unreachable: 'Sistem sobne avtomatizacije se ne odziva — utihnilo je {count} sob',
        room_not_released: 'Soba {room} — gost je odjavljen, sobe do {hour} ni sprostil; šteje se za prosto',
        guest_message: 'Soba {room}, {guest} prek Mila: „{text}“',
        unknown_kind: 'Soba {room} — zahteva obravnavo',
        unknown_state: 'neznano stanje',
        room_unknown: 'brez sobe',
        guest_unknown: 'gost neznan',
    },
    // „Označi za čiščenje“ — soba, o kateri koledar ne pove nič, gre na današnji krog
    // takoj (docs/HOUSEKEEPING.md §17).
    mark: {
        title: 'Označi za čiščenje',
        room_named: 'Soba {room}',
        reason: 'Razlog',
        note: 'Opomba',
        note_placeholder: 'Npr. gost je razlil vino, ogled sobe ob 11h …',
        submit: 'Označi za čiščenje',
        marked_message: 'Soba {room} je na današnjem krogu čiščenja.',
        reason_guest_request: 'Gost prosi za čiščenje',
        reason_complaint: 'Pritožba na sobo',
        reason_soiled: 'Umazano po čiščenju',
        reason_after_use: 'Po ogledu ali delu v sobi',
        reason_other: 'Drugo',
        already_open_title: 'Ta soba je danes že na krogu',
        nobody: 'nedodeljeno',
        due_by: 'do {hour}',
        status_pending: 'čaka',
        status_awaiting_release: 'čaka na sprostitev sobe',
        status_in_progress: 'v delu',
        status_done: 'počiščeno',
        status_inspected: 'sprejeto',
        status_skipped: 'preskočeno',
        status_deferred: 'preloženo',
        status_rework_required: 'vrnjeno v čiščenje',
        refused_out_of_service: 'Soba je izven uporabe. Najprej jo vrni v uporabo, potem jo je mogoče uvrstiti na krog čiščenja.',
        failed: 'Sobe ni bilo mogoče označiti za čiščenje.',
    },
    housekeeping: {
        require_inspection: 'Zahtevaj pregled sob',
        require_inspection_hint: 'Vklopljeno: soba po čiščenju ostane »Počiščena« in čaka, da jo nadzornica sprejme (»Pripravljena«). Izklopljeno: končano čiščenje samodejno sprejme sobo — brez ločenega pregleda.',
        allow_self_inspection: 'Dovoli, da sobo potrdi tisti, ki jo je počistil',
        allow_self_inspection_hint: 'Izklopljeno (privzeto): sobo mora potrditi nekdo drug, kot jo je počistil — v tem je vrednost pregleda. Vklopi v hotelu, kjer je v izmeni ena sama sobarica; sicer bo potrditev cel dan zavrnjena.',
        supervisor_skips_inspection: 'Delo nadzornice ne potrebuje sprejema',
        supervisor_skips_inspection_hint: 'Izklopljeno (privzeto): tudi soba, ki jo je počistila nadzornica, čaka na sprejem. Vklopljeno: soba, ki jo je začela oseba s pravico »Potrdi pregled sobe«, je ob zaključku takoj pripravljena — nadzornica odgovarja vodstvu in ne presoji sodelavke. Velja samo za njene sobe; za vse ostale pregled ostane.',
        // Isti izrazi kot v portalu za sobarice — en izdelek ne sme istega dela
        // poimenovati dvakrat drugače.
        kind_departure: 'Odhod',
        kind_stayover:  'Ostaja',
        kind_arrival:   'Prihod',
        kind_dirty: 'Za urediti',
        cleaning_now:   'V čiščenju',
        cleaning_legend: 'Soba se čisti — ob njej je ura, do katere naj bi bila gotova.',
        cleaning_by:    'Čisti {name}',
        ready_by:       'Predvidoma do {time}',

        kind_departure_help: 'Gost je odšel — soba se v celoti preobleče in počisti.',
        kind_stayover_help:  'Gost ostaja — dnevno čiščenje okrog njegovih stvari.',
        kind_arrival_help:   'Soba je prazna in danes pride gost — priprava in pregled.',

        norms:                'Normativi čiščenja',
        norms_hint:           'Koliko minut naj bi delo trajalo. Prazno polje pomeni, da normativ ni določen — takrat na nobenem zaslonu ni cilja.',
        norms_written_hint:   'Normativ se zapiše na nalogo, ko se izdela dnevni list čiščenja. Sprememba velja od naslednjega lista naprej in ne spremeni tega, po čem je bilo merjeno delo prejšnjih dni.',
        norms_override:       'Normativi čiščenja za ta tip sobe',
        norms_override_hint:  'Prazno polje pomeni „kot objekt“. Vpiši vrednost samo tam, kjer ta tip sobe odstopa od hotela.',

        norm_as_property: 'Kot objekt: {minutes} min',
        norm_not_set:     'Ni določeno',
        minutes_short:    'min',

        // Ekipe: dve ali tri sobarice na isti sobi (docs/HOUSEKEEPING.md §15).
        team_factor:       'Faktor ekipe',
        team_factor_default: '{percent} (privzeto)',
        team_factor_hint:  'Koliko odstotkov normativa porabi ekipa za sobo. Dve osebi sta hitrejši od ene, nista pa dvakrat hitrejši — podajata si stvari in čakata na kopalnico. Prazno pomeni hišni privzetek: 60 % za dva, 45 % za tri ali več.',
        team_factor_pair:  'Dve osebi (%)',
        team_factor_group: 'Tri ali več (%)',

        recommended_team_size:            'Priporočena velikost ekipe',
        recommended_team_size_none:       'Ni določeno',
        recommended_team_size_inherit:    'Kot tip sobe',
        recommended_team_size_n:          '{count} osebi',
        recommended_team_size_room_hint:  'Koliko sobaric je smiselno poslati v to sobo. Prazno pomeni „kot tip sobe“. Je priporočilo in ne pravilo — nič ne prepove ene same osebe.',
        recommended_team_size_type_hint:  'Koliko sobaric je smiselno poslati v sobo tega tipa — apartma z dvema kopalnicama, suita čez dve nadstropji. Posamezna soba lahko to prepiše.',
        recommended_team_size_area_hint:  'Koliko sobaric je smiselno poslati v ta prostor — wellness, banketna dvorana. Prostor nima tipa, iz katerega bi podedoval, zato velja to, kar piše tu.',

        no_property: 'Najprej izberi objekt.',

        // Telefoni in ure. Naprava za sobarice pripada OSEBI — prav zato aplikacija
        // sploh nima prijave.
        devices:      'Naprave',
        devices_hint: 'Telefoni in ure, ki jih nosijo sobarice. Registrira se s kodo, prekliče z enim pritiskom.',
        devices_empty: 'Ni še nobene naprave.',
        device_add:    'Dodaj napravo',
        device_rename: 'Uredi napravo',
        device_person: 'Pripada osebi',
        device_needs_person: 'Ni še nobene sobarice — naprava se veže na osebo.',
        device_needs_permission: 'Nimaš pravice brati sobaric tega objekta.',
    },

    // „Čiščenje — pregled“ — jutro na oddelku, kot ga bereta recepcija in vodstvo
    // (docs/HOUSEKEEPING.md „Pregled za recepcijo in vodstvo“). Izrazi so isti kot v
    // portalu za sobarice: en izdelek istega dela ne sme poimenovati dvakrat drugače.
    hk_overview: {
        title: 'Čiščenje — pregled',
        hint:  'Kako danes teče čiščenje: kdo kaj ima, kdaj kdo konča in katere sobe še niso pripravljene. Samo za branje.',
        read_only: 'Razpored se ureja v aplikaciji za sobarice — tam nadzornica dodeljuje sobe, sprejema pregled in določa vrstni red.',
        no_property: 'Najprej izberi objekt.',

        date:      'Dan',
        date_hint: 'Poslovni dan hiše, ne koledarski. Prazno pomeni dan, ki ga hotel trenutno dela.',

        load_failed:      'Dneva čiščenja ni bilo mogoče prebrati.',
        load_failed_hint: 'Poskusi znova. Če se ponavlja, gre najverjetneje za pravico „Branje čiščenja“ ali za modul Operativa.',
        empty:            'Za ta dan ni nobene naloge čiščenja.',

        read_now: 'Prebrano pravkar',
        read_ago: 'Prebrano pred {value}',

        rooms_heading:  'Sobe',
        tasks_heading:  'Naloge',
        people_heading: 'Ljudje',

        being_cleaned:      'V čiščenju',
        rooms_blocked:      'Ni v prodaji',
        rooms_not_visible:  'Brez pravice „Branje objekta“',

        tasks_open:      'Odprte',
        tasks_open_hint: 'Vse, kar še ni končano.',
        tasks_in_progress: 'V teku',
        tasks_done:        'Končane',
        tasks_awaiting_inspection:      'Čakajo pregled',
        tasks_awaiting_inspection_hint: 'Počiščeno, nadzornica še ni potrdila.',

        people_empty:      'Za danes ni razporejene nobene sobarice.',
        people_teams_note: 'Sobe ekipe štejejo pri vsakem njenem članu — vrstica pove, kaj ima posameznik pred sabo, in se ne sešteva.',
        person_progress:   '{done} končanih · {left} še',
        on_absence:        'Odsotna',

        round_title:   'Kdaj kdo konča',
        round_summary: 'Hiša je predvidoma urejena ob {time}; krogov: {count}.',
        lanes_title:   'Po sobaricah',
        lanes_hint:    'Sobe v vrstnem redu, v katerem jih bo posamezna sobarica dejansko obhodila. Vrstni red določi nadzornica in se tu ne spreminja.',

        unassigned_title: 'Nedodeljene sobe',
        unassigned_hint:  'Delo, ki ga še nima nihče. Dokler soba ni dodeljena, zanjo ni predvidene ure.',

        inspection_title: 'Čakajo pregled',
        inspection_hint:  'Počiščene sobe, ki jih nadzornica še ni sprejela. Najdlje čakajoča je prva.',
        waiting_for:      'čaka {value}',

        blocked_title: 'Sobe, ki niso v prodaji',
        blocked_hint:  'Izven uporabe ali izven prodaje — z razlogom zapore, kjer je zapisan.',

        finishes:   'konča ob {time}',
        rooms_left: '{count} sob',
        no_shift:   'Urnik ni znan',
        norm:       'normativ {value}',
        due_by:     'pripravljena do {time}',
        priority:   'Prednostno',
        after_shift: 'Po koncu izmene',
        dnd:        'Znak „ne moti“',

        legend_working:     'Se čisti',
        legend_late:        'Ne bo pravočasno',
        legend_after_shift: 'Po koncu izmene',
        legend_now:         'Zdaj',

        room_is:        'soba: {state}',
        room_unknown:   'Neznana soba',
        team:           'Ekipa',
        somebody_else:  'Nekdo drug',

        status_awaiting_release: 'Čaka sprostitev',
        status_pending:          'Čaka',
        status_in_progress:      'V teku',
        status_done:             'Končano',
        status_inspected:        'Pregledano',
        status_skipped:          'Preskočeno',
        status_deferred:         'Preloženo',
        status_rework:           'Vrnjeno v popravek',

        kind_dirty_done: 'Urejena',
        kind_area:       'Skupni prostor',

        minutes: '{value} min',
        hours:   '{value} h',
    },
    reservation: {
        contract_company:      'Podjetje s pogodbeno ceno',
        contract_company_none: 'Brez pogodbene cene',
        contract_line:         'Pogodba: {name} ({source}) · ponudb: {count}',
        contract_none:         'To podjetje v tej hiši za te datume nima pogodbene cene',
        contract_source_group: 'skupina',
        contract_source_house: 'hiša',
        moved_from:             'Premaknjena iz „{house}“ (rezervacija {number})',
        moved_to:               'Premaknjena v „{house}“ (rezervacija {number})',
        package: 'Sestavine paketa',
        package_included: 'vključeno',
        package_worth: 'interna vrednost {amount}',
        package_planned: 'načrtovano',
        package_posted: 'na kartici',
        package_created: 'rezervirano',
        package_failed: 'ni uspelo',
        package_kind_room_service: 'Postrežba v sobo',
        package_kind_dining: 'Obrok',
        package_kind_facility: 'Zmogljivost',
        package_kind_parking: 'Parkiranje',
        package_kind_service: 'Storitev',
        package_kind_product: 'Izdelek',
        package_when_arrival: 'ob prihodu',
        package_when_each_night: 'vsako noč',
        package_when_departure: 'ob odhodu',
        rooms: 'Sobe',
        confirm_hint: 'Potrdi rezervacijo — iz osnutka postane potrjena in soba je obljubljena.',
        cancel_hint: 'Odpovej rezervacijo — sobe se sprostijo in gredo nazaj v prodajo.',
        open_hint: 'Odpri rezervacijo — gostje, sobe, folio in račun.',
        spending: 'Poraba',
        search_placeholder: 'Številka ali ime gosta',
        spending_hint: 'Kaj je ta rezervacija porabila poleg sobe — bar iz blagajne, velnes, izposoja, turistična taksa.',
        spending_empty: 'Poleg sobe še ni ničesar.',
        spending_total: 'Skupaj poraba',
        spending_paid: 'Plačano',
        spending_due: 'Za plačilo',
        spending_no_folio: 'Ta rezervacija še nima folia — dodaj ga z „Nov folio“.',
        spending_group_folio: 'Soba in turistična taksa se knjižita na folio skupine {group}, ki se odpre ob prvem knjiženju. Folio te rezervacije je samo za dodatno porabo — odpri ga z „Nov folio“.',
        spending_open_folio: 'Odpri folio',
        spending_bar_label: 'Razmerje porabe po virih',
        spending_items: 'postavk: {count}',
        spending_receipts: 'računov: {count}',
        spending_person_nights: 'nočitev: {count}',
        spending_per_night: '{amount} / noč',
        spending_more: '+ {count}',
        spending_tax_note: 'Pobrana za občino · ni prihodek hiše',
        spending_tax_excluded: 'turistična taksa ni všteta',
        spending_tax_excluded_hint: 'Taksa se pobere za občino, zato ne pove ničesar o tem, kje je hiša zaslužila. V razmerju je ni, v skupni porabi in v znesku za plačilo pa je.',
        spending_refund: 'Vračilo',
        spending_refund_tooltip: 'Vrni plačilo s tega folia — pri preplačilu je ponujena razlika',
        spending_refund_none: 'Na tem foliu ni plačila za vračilo',
        spending_refund_closed: 'Folio je zaprt — vračilo ni več mogoče',
        spending_refund_pick: 'Katero plačilo naj se vrne?',
        spending_refund_pick_hint: 'Na tem foliu je več plačil. Izberi tisto, ki se vrača — znesek je tisti, ki ga je še mogoče vrniti.',
        facility_pending: 'Rezervirano iz ponudbe hotela, še ni na foliu',
        stay: 'Bivanje',
        nights_count: '{count} noči',
        expected_arrival: 'Napovedan prihod',
        expected_arrival_help: 'Ura, ki jo je gost napovedal. Sobo s to uro čiščenje postavi pred ostale.',
        reservations:   'Rezervacije',
        reservation:    'Rezervacija',
        add:            'Nova rezervacija',
        edit:           'Uredi rezervacijo',
        number:         'Številka',
        arrival:        'Prihod',
        departure:      'Odhod',
        nights:         'Noči',
        nights_hint: 'Vpišeš lahko noči — odhod se preračuna iz prihoda.',
        adults:         'Odrasli',
        children:       'Otroci',
        source:         'Vir',
        campaign:       'Kampanja',
        payer:          'Plačnik',
        extras:            'Parkirno mesto in ostalo',
        extras_hint:       'Kar gost vzame za ves čas bivanja. Zaračuna se na folio sobe.',
        extras_per_day:    '{price} na dan',
        extras_per_hour:   '{price} na uro',
        extras_unclear:    '{price} · pri storitvi izberi sredstva, sicer se prodaja po dnevih',
        extras_no_hours:   'Za ta dan ni prostih terminov.',
        extras_per_days:   '{price} za {days} dni',
        extras_days:       '{days} dni ·',
        extras_free:       'Prostih ta dan: {count}',
        extras_none_free:  'Ta dan ni prostega',
        extras_plate_nth:  'Tablica {number}',
        extras_plate:      'Registrska tablica',
        extras_full_days:  'Ni prostega za: {days} — ti dnevi niso vključeni.',
        extras_failed:     'Za „{name}“ ni prostega mesta — rezervacija sobe je narejena, dodatek pa ne.',
        extras_failed_count: 'Za „{name}“ ni prostih {count} — rezervacija sobe je narejena, dodatek pa ne.',
        extras_quantity:   'Koliko',
        mail_wishes:       'Gost je v e-pošti prosil še za',
        total:          'Skupaj',
        special_requests: 'Posebne želje',
        internal_notes: 'Interne opombe',
        confirm:        'Potrdi',
        confirm_on_hint: 'Rezervacija nastane kot potrjena — soba je zasedena in gost je pričakovan.',
        confirm_off_hint: 'Rezervacija nastane kot osnutek — soba je vseeno zadržana, dokler je ne potrdite ali izbrišete.',
        cancel:         'Odpovej',
        no_show:        'Ni prišel',
        check_in:       'Prijava',
        check_in_needs_confirmation: 'Rezervacija je še osnutek. Najprej jo potrdi (gumb „Potrdi“), potem lahko prijaviš goste.',
        check_in_not_possible: 'Prijava ni mogoča: rezervacija je v stanju „{status}“.',
        check_out:      'Odjava',
        // Odjava in sprostitev sobe sta dva dogodka (docs/HOUSEKEEPING.md §16).
        release_room:     'Soba sproščena',
        released_at:      'Soba sproščena: {value}',
        released:         'Soba {room} je sproščena.',
        released_already: 'Soba {room} je bila že sproščena.',
        release_failed:   'Sobe ni bilo mogoče sprostiti.',
        change_room:    'Zamenjaj sobo ali termin',
        confirm_cancel: 'Res želiš odpovedati to rezervacijo? Sobe se sprostijo za prodajo.',
        confirm_no_show: 'Označi kot „ni prišel“? Sobe se sprostijo za prodajo.',
        room_taken:     'Soba je za izbrani termin že zasedena. Rezervacija ni bila spremenjena.',
        arrivals:       'Prihodi',
        departures:     'Odhodi',
        in_house:       'V hotelu',
        checked_in_count:      'Prijavljenih {done} od {total}',
        checked_in_count_page: 'Prijavljenih {done} od {total} na tej strani',
        restricted: 'Omejitve cenika ne dovolijo tega bivanja.',
        override_restrictions: 'Rezerviraj kljub omejitvam',
        override_restrictions_hint: 'Izjema ostane zapisana pri rezervaciji.',
        override_reason: 'Razlog za izjemo',
        override_reason_hint: 'Napiši ga za tistega, ki bo čez mesec dni vprašal, zakaj je bil zaprt vikend prodan.',
        override_forbidden: 'Za izjemo je potrebna pravica — prosi vodjo recepcije.',
    },
    reservation_status: {
        draft:       'Osnutek',
        confirmed:   'Potrjena',
        checked_in:  'Prijavljena',
        checked_out: 'Odjavljena',
        cancelled:   'Odpovedana',
        no_show:     'Ni prišel',
    },
    /**
     * Skupina, ki raste (docs/SKUPINE.md §9). Doslej se je dala samo zmanjšati —
     * podjetje, ki v torek pokliče, da pride še štiri ljudi, je pomenilo odpoved
     * skupine in novo rezervacijo.
     */
    growth: {
        increase:       'Povečaj',
        increase_title: 'Povečaj blok',
        rooms_to_add:   'Dodatnih sob',
        add_block:      'Dodaj tip sobe',
        add_block_title: 'Dodaj tip sobe',
        will_hold:      'Sobe se zadržijo takoj — skupina že drži svoje sobe.',
        // Brez štetega samostalnika: „za 1 sob“ je narobe, „za 1 sobo“ pa bi
        // zahtevalo sklanjanje po številu. Predznak pove isto in je pravilen za
        // vsako število.
        grown:          'Blok povečan: +{rooms}.',
        grown_held:     'Blok povečan: +{rooms} · zadržanih: {held}.',
    },
    ladder: {
        remove: 'Odstrani stopnjo',
        title: 'Odpovedna lestvica',
        days: 'dni prej',
        add: 'Stopnica',
        reduce: 'Zmanjšaj',
        reduce_title: 'Zmanjšanje bloka',
        rooms_to_release: 'Sprosti sob:',
        quote_fee: 'Po lestvici: {pct} % ob {days} dneh pred prihodom → odpovedni strošek {fee} € na skupinski folio.',
        quote_free: 'Ob {days} dneh pred prihodom je zmanjšanje brez stroškov.',
        waive: 'Brez odpovednih stroškov (izjema)',
        charge_title: 'Odpovedni strošek',
        tax_unset: 'DDV: čaka računovodstvo (knjiži kot doslej)',
        tax_outside: 'DDV: ni predmet DDV',
        tax_zero: 'DDV: obdavčeno po 0 %',
        tax_taxed: 'DDV: obdavčeno po',
        reduction_label: 'Naziv za zmanjšanje',
        cancellation_label: 'Naziv za odpoved',
        revenue_group: 'Vrsta prihodka',
        reduced: 'Sobe so sproščene in zabeležene.',
        reduced_fee: 'Sobe sproščene; odpovedni strošek {fee} € knjižen na skupinski folio.',
        fee: 'strošek',
        waived: 'strošek opuščen',
    },
    offers: {
        title: 'Ponudbe',
        hint: 'Vse izdane grafične ponudbe hotela — za rezervacije in skupine. Klik na vrstico odpre ponudbo, kot jo vidi naročnik.',
        empty: 'Še ni izdanih ponudb. Izdaš jih z gumbom »Ponudba« na rezervaciji ali skupini.',
        col_number: 'Številka',
        col_for: 'Za koga',
        col_rooms: 'Sobe',
        col_nights: 'Noči',
        col_unit: 'Cena/noč',
        col_total: 'Skupaj',
        col_vat: 'DDV',
        col_valid: 'Velja do',
        source_reservation: 'Rezervacija',
        source_group: 'Skupina',
        status_issued: 'Izdelana',
        status_opened: 'Odprta',
        status_confirmed: 'Potrjena',
        status_expired: 'Potekla',
        status_all: 'Vsi statusi',
        source_all: 'Vsi viri',
        period_this_month: 'Ta mesec',
        period_last_30_days: 'Zadnjih 30 dni',
        period_this_quarter: 'To četrtletje',
        period_this_year: 'Letos',
        period_all: 'Vsa obdobja',
        search: 'Iskanje po številki ali naročniku',
        empty_filtered: 'Nobena ponudba ne ustreza izbranim filtrom.',
        expires_soon: 'Poteče kmalu',
        kpi_open: 'V obtoku',
        kpi_confirmed: 'Potrjene',
        kpi_expiring: 'Potečejo v 7 dneh',
        kpi_conversion: 'Konverzija',
        kpi_amount: 'Skupaj {amount}',
        kpi_expiring_hint: 'Izdane in odprte ponudbe',
        kpi_conversion_hint: '{won} od {decided}',
        // Cevovod: stopnje, stolpci in dejanja vrstice.
        stage_all:      'Vse stopnje',
        stage_offer:    'Ponudba',
        stage_proforma: 'Predračun',
        stage_prepaid:  'Predplačilo',
        stage_invoice:  'Račun',
        col_proforma:   'Predračun',
        col_prepaid:    'Predplačilo',
        col_invoice:    'Račun',
        open_folio:      'Odpri folio',
        issue_proforma: 'Izdaj predračun',
        record_receipt: 'Prejeto plačilo',
        cancel_proforma: 'Prekliči predračun',
        documents:      'Dokumenti',
        open_subject:   'Odpri skupino ali rezervacijo',
    },
    proforma: {
        group_needs_company_title: 'Skupina nima naročnika',
        group_needs_company_hint:  'Predračun skupine se piše proti foliu naročnika. Odpri skupino in pri Naročnik izberi podjetje, nato izdaj predračun.',
        group_needs_routing_title: 'Skupina nima pravil knjiženja',
        group_needs_routing_hint:  'Na skupini najprej nastavi Skupina plača (nočitve, taksa …), da folio skupine ve, kaj sprejme.',
        group_open:                'Odpri skupino',
        language:      'Jezik predračuna',
        language_hint: 'Predračun se natisne v tem jeziku, ne glede na jezik vmesnika bralca. Isti jezik podeduje račun za predplačilo, ki se izda ob prejemu plačila.',
        title: 'Predračun',

        status_issued:      'Izdan',
        status_partly_paid: 'Delno plačan',
        status_paid:        'Plačan',
        status_expired:     'Potekel',
        status_superseded:  'Nadomeščen',
        status_cancelled:   'Preklican',

        issue_title:      'Izdaja predračuna',
        issue_hint_title: 'Predračun ni davčni dokument',
        issue_hint:       'Z njim hiša zaprosi za plačilo, preden je karkoli opravila. DDV se obračuna šele ob prejemu plačila — takrat se izda račun za predplačilo. Vrednost posla izračuna strežnik iz blokov skupine oziroma sob rezervacije.',
        supersedes_title: 'Nadomesti predračun {number}',
        supersedes_hint:  'Prejšnji predračun dobi status »Nadomeščen«. Mogoče je le, dokler nanj ni prispelo nobeno plačilo.',

        ask_title:       'Koliko naj predračun zahteva',
        ask:             'Način',
        ask_hint:        'Delež celotne vrednosti posla ali natančen znesek.',
        ask_percent:     'Delež (%)',
        ask_amount:      'Znesek (€)',
        mode_percent:    'Delež',
        mode_amount:     'Znesek',
        valid_days:      'Velja (dni)',
        valid_days_hint: '0 pomeni brez roka.',
        note:            'Opomba na predračunu',
        issue:           'Izdaj predračun',
        issued:          'Predračun {number} je izdan.',
        issue_failed:    'Predračuna ni bilo mogoče izdati.',

        receipt_title:          'Prejeto plačilo na predračun',
        requested:              'Zahtevano',
        received:               'Prejeto',
        remaining:              'Preostanek',
        receipt_amount:         'Prejeti znesek (€)',
        receipt_method:         'Način plačila',
        receipt_reference:      'Bančni sklic',
        receipt_reference_hint: 'Sklic z izpiska. Številka predračuna se na plačilo zapiše samodejno.',
        receipt_note:           'Opomba',
        receipt_mail:           'Pošlji račun za predplačilo po e-pošti',
        receipt_mail_hint:      'Kupcu na naslov s predračuna.',
        receipt_will_happen:    'Zabeležilo se bo plačilo na folio in izdal račun za predplačilo.',
        received_done:          'Plačilo je zabeleženo, izdan je račun za predplačilo {number}.',
        receipt_failed:         'Plačila ni bilo mogoče zabeležiti.',
        lower_to_remaining:     'Znižaj na preostanek',
        not_payable:            'Na ta predračun ni mogoče zabeležiti plačila — je preklican, nadomeščen, potekel ali v celoti plačan. Izdaj nov predračun ali odpri račun za predplačilo, ki že obstaja.',
        amount_exceeded:        'Znesek presega to, kar predračun še zahteva. Preostanek je {remaining}.',

        documents_title:        'Dokumenti posla',
        document_proforma:      'Predračun {number} (PDF)',
        document_advances:      'Računi za predplačilo',
        document_advance:       'Račun za predplačilo {number} (PDF)',
        document_invoice:       'Račun {number}',
        cancel_title:           'Preklic predračuna',
        cancel_reason:          'Razlog preklica',
        cancel_credits_advance: 'Proti temu predračunu je bilo prejeto plačilo. Preklic papirja denarja NE vrne in računa za predplačilo ne stornira - vračilo se uredi posebej na foliu plačnika („Storniraj del“ pri predplačilih).',
        cancel_done:            'Predračun {number} je preklican.',
        cancel_failed:          'Predračuna ni bilo mogoče preklicati.',
        pdf_failed:             'Dokumenta ni bilo mogoče prenesti.',
    },
    goffer: {
        button_reservation: 'Ponudba',
        button: 'Ponudba za naročnika',
        copied: 'Povezava do grafične ponudbe je v odložišču in prikazana spodaj — AI uvod je pripravljen, stran pa natisljiva v PDF.',
        minted: 'Grafična ponudba je pripravljena — povezava je prikazana spodaj.',
        link_label: 'Grafična ponudba',
        copy_failed: 'Kopiranje v odložišče ni uspelo — označi in kopiraj povezavo ročno.',
        confirmed_badge: 'Naročnik potrdil {date}',
        hold_failed:     'Sob ni bilo mogoče držati: {reason}',
        download_pdf: 'Prenesi PDF',
        send_mail: 'Pošlji po e-pošti',
        mail_sent: 'Ponudba je poslana po e-pošti.',
        mail_failed: 'Ponudbe ni bilo mogoče poslati.',
    },
    gmail: {
        // Eno okno za oba gumba na kartici skupine: „Pošlji po e-pošti“ pri ponudbi in
        // pri rooming listi. Vprašanje je isto — komu gre pismo —, razlikuje se samo,
        // kaj naslovnik dobi, zato sta naslov in opis edini vrstici, ki sta dvojni.
        offer_title:   'Pošlji ponudbo po e-pošti',
        offer_hint:    'Naslovniki dobijo ponudbo v PDF — isto, kot jo pokaže zaslon skupine, pripravljeno ob pošiljanju.',
        rooming_title: 'Pošlji rooming listo po e-pošti',
        rooming_hint:  'Naslovniki dobijo povezavo, prek katere vpišejo goste. Pošlje se živa povezava; nova se ustvari le, če je skupina še nima.',

        recipients:  'Naslovniki',
        placeholder: 'Vpiši e-naslov in pritisni Enter …',
        help:        'Enter, vejica ali klik izven polja doda naslov. Največ {count} naslovnikov.',
        invalid:       '{email} ni veljaven e-naslov.',
        invalid_short: 'Neveljaven e-naslov.',
        limit:         'Največ {count} naslovnikov.',
        duplicate:   '{email} je že na seznamu.',
        none:        'Dodaj vsaj enega naslovnika.',
        send:        'Pošlji',
        sent:        'Poslano na {emails}.',
        failed:      'Pisma ni bilo mogoče poslati.',
    },

    gfinance: {
        proforma: 'Predračun',
        proforma_failed: 'Predračuna ni bilo mogoče pripraviti — skupina še nima vrednosti (blok brez cene ali brez držanih sob).',
        title: 'Denar skupine',
        balance: 'Saldo skupinskega folia',
        no_folio: 'Skupinski folio se odpre ob prvem pobiranju.',
        collect: 'Poberi po pravilih',
        collected: 'Prenesenih {count} postavk ({amount} €) na skupinski folio.',
        skipped: '{count} postavk preskočenih — poglej folije bivanj.',
        routing: 'Skupina plača',
        unrouted: '{count} postavk za {amount} € je še na folijih gostov',
        sources: { room: 'nočitve', tourist_tax: 'takso', pos: 'POS', service: 'storitve', facility: 'zmogljivosti', manual: 'ročne' },
    },
    gpayer: {
        title: 'Plačnik skupine',
        payer: 'Plačnik',
        hint: 'Podjetje, ki naroča in plača. Nanj se odpre skupinski folio, brez njega ni predračuna in ne računa.',
        none: 'Brez plačnika',
        missing: 'Plačnik ni določen — brez njega ni folia skupine in predračuna.',
        unnamed: 'Določen (imena ni bilo mogoče prebrati)',
        set: 'Določi plačnika',
        change: 'Spremeni',
        saved: 'Plačnik skupine je shranjen.',
        failed: 'Plačnika ni bilo mogoče shraniti.',
    },
    gcancel: {
        title: 'Odpoved celotne skupine',
        held: 'Še držano',
        picked_up: 'Prevzeto (svoje rezervacije)',
        contract_value: 'Pogodbena vrednost',
        keep: 'Odpovedni stroški ({pct} %, {days} dni pred prihodom)',
        already_charged: 'Že na skupinskem foliu',
        prepaid: 'Plačano vnaprej',
        refund: 'Za vračilo',
        due: 'Še za plačilo',
        confirm: 'Odpovej skupino',
        whole_group: 'Cela skupina',
        members_warning: 'Že prevzetih {rooms} sob bo odpovedanih skupaj s skupino — njihovi gostje izgubijo rezervacijo.',
        blocked_title: 'Skupine še ni mogoče odpovedati',
        blocked_hint: 'Te rezervacije imajo gosta v hotelu ali so že odjavljene: {numbers}. Najprej uredi njih — nič tukaj ne bo vrglo gosta iz sobe.',
        done: 'Skupina je odpovedana, sobe sproščene.',
        done_fee: 'Skupina je odpovedana ({rooms} rezervacij) in knjižen je odpovedni strošek {fee} €.',
    },
    // Dogovorjeni termin skupine (docs/SKUPINE.md §12 in §13). Dve dejanji za enim
    // oknom: enaka dolžina je ZAMIK in ne prevrednoti ničesar, drugačna dolžina kupi
    // ali vrne noči po dogovorjeni ceni bloka.
    gdates: {
        button: 'Spremeni termin',
        title: 'Spremeni termin skupine',
        hint: 'Vsaka držana soba in vsako že prevzeto bivanje dobi ali vrne noči, ki jih povesta nova datuma. Preden potrdiš, spodaj piše, kaj bo s katero sobo in koliko je dogovor potem vreden.',
        mode_dates: 'Sprememba termina — dolžina se spremeni',
        mode_dates_hint: 'Dodane noči se obračunajo po dogovorjeni ceni bloka, odvzete se po isti ceni odštejejo. Cenika novega dne se ne bere.',
        mode_shift: 'Zamik skupine — enako število noči',
        mode_shift_hint: 'Iste noči, drugi dnevi. Cena se ne spremeni in na folio se ne knjiži nič.',
        reason: 'Razlog',
        reason_help: 'S tvojimi besedami — „pridejo dan prej“, „seminar so podaljšali za noč“. Obvezen: dogovorjeno število sob se ne spremeni, zato razlog edini pove, zakaj je teden drugačen.',
        planning: 'Preverjam sobe …',
        value_delta: 'Vrednost dogovora',
        rooms_summary: 'Preverjenih sob: {rooms} · zavrnjenih: {blocked}',
        release_note: 'Rok za sprostitev opcije gre s prihodom: {date}',
        nights_added: 'noči več: {count}',
        nights_removed: 'noči manj: {count}',
        nights_both: 'noči več: {added}, noči manj: {removed}',
        nights_none: 'brez spremembe števila noči',
        what_held: 'držana soba',
        what_stay: 'rezervacija {number}',
        ok: 'V redu',
        ok_unchanged: 'V redu — brez spremembe',
        ok_added: 'V redu — noči več: {count}, {amount} €',
        ok_removed: 'V redu — noči manj: {count}, {amount} €',
        ok_both: 'V redu — noči več: {added}, noči manj: {removed}, {amount} €',
        blocked_title: 'Termina še ni mogoče spremeniti ({blocked} od {rooms} sob)',
        blocked_hint: 'Skupina se premakne cela ali nič. Sprosti ali prestavi sobe, ki so na poti, in poskusi znova — noči za gostom, ki je že prijavljen ali odjavljen, se ne premaknejo.',
        confirm: 'Potrdi',
        needs_change: 'Vpiši nov termin — vsaj eden od datumov mora biti drugačen.',
        needs_nights: 'Odhod mora biti za prihodom — skupina brez ene same noči ni termin.',
        needs_reason: 'Vpiši razlog.',
        needs_plan: 'Načrta ni bilo mogoče prebrati.',
        needs_free_rooms: 'Nekatere sobe novega termina ne morejo vzeti.',
        done: 'Termin skupine je spremenjen: držanih sob {held}, rezervacij {picked_up}. Dogovor je zdaj za {amount} € drugačen.',
        done_shift: 'Skupina je zamaknjena: držanih sob {held}, rezervacij {picked_up}. Cena ostaja enaka.',
    },
    rooming: {
        // „Sobe in blok“ — rooming seznam proti pogodbi (docs/SKUPINE.md §16).
        plan_title: 'Sobe in blok',
        plan_total: 'Zdaj {now} · po spremembi {then}',
        plan_unknown_type: 'Neznan tip sobe',
        plan_counts: 'potrebno {needed} · v bloku prostih {held}',
        plan_short_house: 'manjka {count} · hiša ima prostih {available}',
        plan_per_night: '€/noč',
        plan_add: 'Dodaj {count} sob po {amount}/noč',
        plan_add_capped: 'Hiša ima prostih le {count} — več jih ta termin ni.',
        plan_none_available: 'Hiša tega tipa ta termin nima prostega.',
        plan_only_available: 'Na voljo je le {count} sob — dodaj manj ali izberi drug tip sobe.',
        // Druge sobe, ki jih hiša ima, kadar tega tipa zmanjka (docs/SKUPINE.md §16).
        plan_alt_title: 'Namesto tega:',
        plan_alt: '{count} × {name} · {amount}/noč ({delta}) · prostih {available}',
        plan_alt_unpriced: '{count} × {name} · cena po ceniku · prostih {available}',
        plan_alt_rest: 'še {count} sob brez tipa, ki bi bil prost',
        plan_alt_applied: 'Sob tipa {name}: {count}. Preveri ceno in dodaj sobe v blok.',
        plan_spare: '{count} sob ostane neuporabljenih',
        plan_release: 'Sprosti',
        plan_matches: 'se ujema',
        plan_grown: 'Blok je večji za {count} sob.',
        plan_released: 'Sproščenih sob: {count}.',
        plan_reason_grow: 'rooming seznam potrebuje več sob',
        plan_reason_shrink: 'rooming seznam potrebuje manj sob',
        plan_fee_title: 'Sprostitev {count} sob stane {amount}',
        plan_fee_hint: 'Rok za sprostitev ({date}) je mimo, zato velja odpovedna lestvica pogodbe. Znesek se knjiži na folio skupine.',
        plan_fee_hint_ladder: 'Odpovedna lestvica pogodbe zadrži del vrednosti. Znesek se knjiži na folio skupine.',
        plan_fee_title_free: 'Sprostitev {count} sob po roku — potrdi',
        plan_fee_confirm: 'Potrdi in sprosti',
        proforma_reissued: 'Izdan je nov predračun {number}; prejšnji je razveljavljen.',
        failed_room_taken: 'Soba iz bloka ni več na voljo — medtem je bila prodana. Gosta prevzemi v drugo sobo ali preveri razpoložljivost.',
        failed_no_hold: 'Blok nima več prostih sob za prevzem. V seznamu je več vrstic, kot je skupina rezervirala sob — dodaj sobe v blok ali združi goste.',
        failed_guest: 'Gosta ni bilo mogoče zapisati v knjigo gostov. Preveri ime in priimek.',
        failed_guests: 'Vrstica nima gostov ali jih ima preveč (največ 10 na sobo).',
        failed_operation: 'Ta vrstica je bila poslana brez lastne oznake, zato bi ponovna potrditev lahko rezervirala dvakrat. Osveži zaslon in znova preberi seznam.',
        failed_repeat: 'Ta soba se že rezervira pod istim pritiskom gumba. Počakaj trenutek in osveži skupino — morda že ima svojo rezervacijo.',
        failed_stay: 'Izbrana soba ni soba te skupine ali pa je njena rezervacija odpovedana oziroma zaključena. Osveži skupino in izberi drugo sobo.',
        no_register: 'Brez podatkov za prijavo — dokument bo treba vtipkati ob prijavi.',
        occupancy: 'Zasedenost',
        occupancy_auto: 'Izračunano iz rojstnih datumov — po potrebi popravi.',
        link_button: 'Povezava za naročnika',
        link_copied: 'Povezava za vnos gostov je kopirana — pošlji jo naročniku.',
        load_pending: 'Preveri vnose naročnika',
        no_pending: 'Naročnik še ni vpisal nobenega gosta.',
        button: 'Rooming lista',
        title: 'Uvoz rooming liste',
        placeholder: 'Prilepi seznam gostov — Excel/CSV vrstice ali besedilo e-pošte …',
        drop_hint: 'Ali povleci .csv/.txt datoteko sem.',
        parse: 'Razčleni',
        parse_failed: 'Seznama ni bilo mogoče razčleniti.',
        concerns: 'Preveri pred potrditvijo',
        room: 'Soba',
        existing: 'obstoječ gost',

        // NE „nov gost“. Oznaka govori o KNJIGI GOSTOV in ne o skupini: pri skupini,
        // ki ima vse sobe že prevzete, je novoprispeli član iste skupine — recepcija
        // je „nov gost“ brala kot „tujec“ in ga zato odpirala kot novo rezervacijo.
        new: 'še ni v knjigi gostov',
        new_title: 'Te osebe hiša še nima v knjigi gostov. Ob potrditvi se ji ustvari profil.',
        pick_candidate: 'Izberi obstoječega …',
        as_new: '→ ustvari novega gosta',
        confirm_note: 'Nič še ni rezervirano. Vrstica z novo sobo postane rezervacija po dogovorjeni ceni z bloka, vrstica z obstoječo sobo pa goste samo doda nanjo; novi gostje se ustvarijo ob potrditvi.',

        // KAM gredo ljudje ene vrstice: v sobo, ki jo skupina že ima, ali v novo z
        // bloka. Novo sobo ponudimo le, dokler blok še kaj drži.
        where:        'Kam',
        new_room:     'Nova soba',
        free_places:  '{count} prosto',
        full:         'polno',
        no_holds:     'Skupina nima več sob v opciji — goste razporedi v sobe, ki jih že ima.',
        placed_count: 'razporejenih: {count}',

        commit: 'Ustvari {count} rezervacij',
        commit_place: 'Razporedi {count} gostov',
        commit_mixed: 'Ustvari {rooms} rezervacij, razporedi {guests} gostov',
        close: 'Zapri',

        // Vrstica ROOMING LISTA na razprti kartici skupine. Števec je vpisan s
        // {številkami} in ne s slovnično množino, kar je pravilo vsake štete
        // oznake v tem portalu (libs/staffVacation.ts, formatDays): slovenščina ima
        // štiri oblike in zapis, ki nosi vse štiri, nekdo prej ali slej prevede v dve.
        row_title:     'Rooming lista',
        filled_of:     'vpisanih {filled} od {total} sob · {guests} gostov',
        open:          'Odpri listo',
        no_link:       'Povezava za naročnika še ni izdana.',
        pending_badge: 'nepregledanih: {count}',
        send_mail:     'Pošlji po e-pošti',

        // Urejevalnik razporeda (docs/SKUPINE.md §17). Dve podokni: udeleženci levo,
        // sobe desno, oseba se povleče iz enega v drugo.
        people_title:     'Udeleženci',
        people_search:    'Išči po imenu ali podjetju …',
        unassigned:       'Brez sobe',
        unassigned_empty: 'Vsi so razporejeni. Osebo lahko povlečeš sem in jo vzameš iz sobe.',
        room_empty:       'Prazna',
        no_stay_fits: 'Nobena soba skupine nima {count} prostih mest — povleci osebo v sobo s prostim mestom.',
        stay_has_places: 'V sobi že {booked}/{capacity} — prostih {free}. Povleci sem osebo.',
        room_empty_hint:  'Soba je prazna — povleci vanjo osebo ali jo zapri.',
        room_remove:      'Zapri sobo (osebe gredo med nerazporejene)',
        capacity:         '{guests}/{capacity} oseb',
        new_room_zone:    'Nova soba — povleci osebo sem ali klikni',
        move:             'Premakni',
        move_to:          'Premakni v …',
        move_new:         '→ v novo sobo',
        move_none:        '→ brez sobe',
        occupancy_split:  '{adults} odraslih, {children} otrok',

        // „Razporedi samodejno“. Pravila so na strežniku
        // (DataStructures.ArrangeRooming); tu je samo, kar recepcija prebere.
        arrange:                'Razporedi samodejno',
        arrange_result:         'Kako je razporejeno',
        arrange_done:           'Razporejeno v {count} sob. Nič še ni rezervirano.',
        arrange_failed:         'Samodejne razporeditve ni bilo mogoče izvesti.',
        arrange_hint_title:     'Kako razporeja',
        arrange_hint_wish:      'Želja iz opombe velja: „sam“, „enoposteljna“ pomeni svojo sobo, „skupaj z Ano“ pa skupno sobo.',
        arrange_hint_vip:       'VIP dobi svojo sobo, razen če opomba pravi drugače.',
        arrange_hint_company:   'Nato isto podjetje, znotraj njega isti spol. Moškega in ženske nikoli ne da skupaj — to stori le izrecna želja.',
        arrange_hint_capacity:  'Nobena soba ni bolj polna, kot tip sobe dopušča.',
        arrange_hint_block:     'Najprej porabi tipe sob, ki jih blok še drži, da manko v „Sobe in blok“ upade.',
        arrange_hint_nothing:   'Nič se ne rezervira — predlog lahko popraviš z vlečenjem.',
    },
    // Dogodki (docs/DOGODKI.md §3.3). Hišno izrazje: „dvorana“ in ne „prostor“,
    // „glavarina“ za trojico števil, „različica“ za zamrznjeni dogovor, „prevzem“ za
    // to, da je oddelek list vzel. „BEO“ ostane BEO — stroka reče tako.
    event: {
        errors: {
            venue_taken: 'Dvorana {venue} je ob {at} zasedena: {by}. Nič ni bilo shranjeno — izberi drug termin ali drugo dvorano.',
            venue_not_open_range: 'Dvorana {venue} ob {at} nima termina: njen koledar ima ta dan termine samo od {from} do {to}, del pa (skupaj s pripravo in pospravljanjem) sega čez. Nič ni bilo shranjeno. Odpiralni čas dvorane podaljšaš v Nastavitve → Zmogljivosti; koledar se ob shranjevanju objavi sam.',
            venue_not_open_day: 'Dvorana {venue} za dan {at} nima nobenega termina: ta dan v tednu je v odpiralnem času zaprt ali pa koledar tako daleč še ni objavljen. Nič ni bilo shranjeno. Odpiralni čas nastaviš v Nastavitve → Zmogljivosti; manjkajoč koledar popravi »Objavi koledar«.',
            venue_closed: 'Dvorana {venue} je ob {at} zaprta (zapora v Zmogljivostih). Nič ni bilo shranjeno — izberi drug termin ali drugo dvorano.',
            venue_taken_unnamed: 'Dvorana {venue} je ob {at} zasedena z rezervacijo brez imena. Nič ni bilo shranjeno — poglej jo v Zmogljivostih ali izberi drug termin.',
            setup_overlap: 'Dvorana {venue} je prosta, a se priprava in pospravljanje ({preparation} + {teardown} min) prekrivata z {by} ({held}). Zamakni del ali skrajšaj pripravo na prostoru.',
            guarantee_locked: 'Zajamčeno število za {part} ({guaranteed} → {requested}) se po potrditvi spremeni samo z novo različico. Uporabi „Nova različica“.',
            guarantee_past_cutoff: 'Rok za zajamčeno število dela {part} je potekel ({cutoff}); {guaranteed} → {requested} ni več mogoče znižati. Dvig gre skozi novo različico.',
            version_superseded: 'Različica {seen}, ki jo gledaš, ni več veljavna — velja različica {standing}. Osveži dogodek in poskusi znova.',
            lines_unbalanced: 'Postavke se ne ujemajo s paketom (razlika {difference} €) pri: {parts}. Uredi postavke, preden potrdiš različico.',
            not_settled: 'Dogodka ni mogoče zaključiti: folio ima odprt saldo {balance} € in {unposted} neknjiženih postavk.',
        },
        title: 'Dogodki',
        hint: 'Seminarji, konference, poroke in banketi: od povpraševanja do zaključka.',
        add: 'Nov dogodek',
        edit: 'Uredi dogodek',
        open: 'Odpri',
        not_found: 'Tega dogodka ni.',
        empty: 'Ni dogodkov v izbranem obsegu.',
        column_empty: 'Prazno',
        count: 'prikazanih {shown} od {total}',
        hidden: 'skritih: {count}',
        search_placeholder: 'Številka, naziv, naročnik, odgovorni …',

        number: 'Številka',
        name: 'Naziv',
        public_name: 'Javni naziv',
        public_name_help: 'Kar sme na steno v avli. Prazno pomeni „ne objavi“, ne „uporabi interno ime“.',
        kind: 'Vrsta',
        source: 'Vir',
        source_unknown: 'Ni navedeno',
        client: 'Naročnik',
        no_client: 'Brez naročnika',
        any_client: 'Vsi naročniki',
        option_title: 'Opcija',
        option_hint: 'Opcija drži dvorano, zato ima rok. Brez roka je dvorana zadržana za vedno.',
        option_until: 'Opcija velja do',
        option_confirm: 'Postavi opcijo',
        owner: 'Odgovorni',
        no_owner: 'Brez odgovornega',
        any_owner: 'Vsi odgovorni',
        dates: 'Termin',
        start: 'Začetek',
        end: 'Konec',
        dates_required: 'Izberi začetek in konec.',
        budget: 'Vrednost',
        minimum_spend: 'Najmanjša poraba',
        notes: 'Opombe',
        publish: 'Objavi na zaslonih',
        publish_help: 'Objavi se javni naziv, dvorana in ura — nikoli naročnik, cena ali število.',
        guarantee_cutoff: 'Rok za zajamčeno število',
        guarantee_cutoff_help: 'Po tem roku se zajamčeno število premakne le z novo različico.',
        filter_from: 'Od',
        filter_to: 'Do',

        status: 'Stanje',
        status_inquiry: 'Povpraševanje',
        status_option: 'Opcija',
        status_confirmed: 'Potrjeno',
        status_in_progress: 'V izvedbi',
        status_completed: 'Zaključeno',
        status_lost: 'Izgubljeno',
        status_cancelled: 'Odpovedano',
        status_changed: 'Stanje je zdaj „{status}“.',
        status_failed: 'Stanja ni bilo mogoče spremeniti.',
        confirm: 'Potrdi',
        move_to: 'Premakni v „{status}“',

        scope_live: 'Žive stopnje',
        scope_all: 'Vse',
        scope_lost: 'Izgubljene',
        scope_cancelled: 'Odpovedane',
        scope_completed: 'Zaključene',
        view_table: 'Tabela',
        view_pipeline: 'Lijak',

        kind_conference: 'Konferenca',
        kind_seminar: 'Seminar',
        kind_meeting: 'Sestanek',
        kind_wedding: 'Poroka',
        kind_banquet: 'Banket',
        kind_party: 'Zabava',
        kind_other: 'Drugo',

        source_mail: 'E-pošta',
        source_phone: 'Telefon',
        source_web: 'Splet',
        source_crm: 'CRM',
        source_desk: 'Recepcija',
        source_walk_in: 'Osebno',

        lost_title: 'Izgubljeno',
        lost_hint: 'Povpraševanje, ki ni obrodilo. Razlog je obvezen in je iz šifranta — lijak, ki ima proste razloge, je lijak, ki se ga ne da sešteti.',
        lost_reason: 'Razlog',
        lost_note: 'Opomba',
        lost_note_help: 'Neobvezno. Kar bi si človek zapisal ob klicu.',
        lost_confirm: 'Označi kot izgubljeno',
        lost_done: 'Dogodek je označen kot izgubljen.',
        lost_failed: 'Dogodka ni bilo mogoče označiti kot izgubljenega.',
        lost_price: 'Cena',
        lost_availability: 'Ni bilo prostora',
        lost_dates: 'Termin',
        lost_competitor: 'Konkurenca',
        lost_capacity: 'Kapaciteta',
        lost_no_reply: 'Brez odgovora',
        lost_called_off: 'Odpovedali so sami',
        lost_other: 'Drugo',

        headcount: 'Glavarina',
        headcount_hint: 'Načrtovano je delovna številka, zajamčeno je pogodbena, dejansko je tisto, kar je prišlo.',
        headcount_triple: 'nač. {planned} · zajam. {guaranteed} · dej. {actual}',
        headcount_short: '{count} oseb',
        headcount_inherited: 'Brez lastnih števil del podeduje glavarino dogodka.',
        headcount_inherited_short: 'podedovano z dogodka',
        headcount_guarantee_locked: 'Rok za zajamčeno število je potekel — premakne ga le nova različica.',
        headcount_actual_locked: 'Dejansko število se vpiše, ko je dogodek v izvedbi.',
        planned: 'Načrtovano oseb',
        planned_help: 'Delovna številka. Prosto se premika, dokler ni podpisa.',
        guaranteed: 'Zajamčeno oseb',
        guaranteed_help: 'Številka, po kateri hiša zaračuna.',
        actual: 'Dejansko oseb',

        tab_programme: 'Program',
        tab_catering: 'Postavke in meni',
        tab_rooms: 'Sobe in udeleženci',
        tab_staff: 'Osebje',
        tab_offer: 'Ponudba',
        tab_versions: 'Različice',
        tab_beo: 'BEO',
        tab_money: 'Finančni dogovor',

        programme_hint: 'Vsak del rezervira prostor za svoje okno. Priprava in pospravljanje sta znotraj rezerviranega okna, na tiskanem programu pa ju ni.',
        programme_empty: 'Program je še prazen.',
        part_add: 'Dodaj del',
        part_edit: 'Uredi del',
        part_title: 'Naziv dela',
        part_kind: 'Vrsta dela',
        part_order: 'Zaporedje',
        part_order_help: 'Za dva dela ob isti uri.',
        part_date: 'Datum',
        part_from: 'Od',
        part_to: 'Do',
        part_date_required: 'Izberi datum dela.',
        part_outside_event: 'Del mora biti na dan dogodka: {from} – {to}. Za drug dan najprej popravi datume dogodka.',
        part_venues: 'Dvorane',
        part_venues_help: 'Prijem je vse ali nič: dvorana, ki je ni mogoče dobiti, zavrne cel shranjek.',
        part_no_venue: 'Brez dvorane',
        part_no_venue_yet: 'Prostor še ni rezerviran',
        part_layout: 'Postavitev',
        part_department: 'Oddelek',
        part_responsible: 'Odgovorni',
        part_claimed: 'rezervirano {from}–{to}',
        part_turnaround: 'Priprava in pospravljanje',
        part_turnaround_manual: 'Določi ročno',
        part_turnaround_preparation: 'Priprava (min)',
        part_turnaround_teardown: 'Pospravljanje (min)',
        part_turnaround_automatic: 'samodejno: priprava {preparation} min · pospravljanje {teardown} min',
        part_turnaround_automatic_none: 'samodejno: izbrana dvorana ne navaja priprave ali pospravljanja',
        part_turnaround_automatic_no_venue: 'samodejno: izberi dvorano, da se pokažeta njena časa',
        part_turnaround_hint: 'Velja za prvi oziroma zadnji del v dvorani; med deli istega dogodka se ne šteje.',
        part_turnaround_manual_hint: 'Ročna vrednost velja tudi, če je pred tem delom že drug del istega dogodka.',
        part_turnaround_line: 'priprava {preparation} min · pospravljanje {teardown} min',
        part_turnaround_manual_badge: 'ročno',
        part_turnaround_auto_badge: 'samodejno',
        part_shared_badge: 'deljena dvorana',
        part_shared_own: 'Dvorana {venue}: del se prekriva z delom „{part}“ istega dogodka ({from}–{to}) — oba sta v dvorani hkrati.',
        part_shared_own_turnaround: 'Dvorana {venue}: priprava oziroma pospravljanje se prekriva z delom „{part}“ istega dogodka ({from}–{to}).',
        part_shared_sentence: 'Dvorana {venue} je ob tem času tudi v dogodku {event} ({from}–{to}) — uporabljena hkrati.',
        part_shared_turnaround: 'Dvorana {venue} je ob tem času tudi v dogodku {event} ({from}–{to}) — priprava oziroma pospravljanje se prekrivata.',
        part_lines: 'postavk: {count}',
        part_release: 'Odstrani',
        part_release_confirm: 'Odstranim del „{part}“ in sprostim dvorano?',
        part_released: 'Del je odstranjen, dvorana je sproščena.',
        part_failed: 'Dela ni bilo mogoče shraniti.',
        part_untitled: 'Neimenovan del',

        part_kind_arrival: 'Prihod',
        part_kind_registration: 'Registracija',
        part_kind_session: 'Sekcija',
        part_kind_break: 'Odmor',
        part_kind_lunch: 'Kosilo',
        part_kind_dinner: 'Večerja',
        part_kind_reception: 'Sprejem',
        part_kind_ceremony: 'Obred',
        part_kind_party: 'Zabava',
        part_kind_setup: 'Priprava',
        part_kind_teardown: 'Pospravljanje',
        part_kind_other: 'Drugo',

        layout_none: 'Brez postavitve',
        layout_theatre: 'Kino',
        layout_school: 'Šolska',
        layout_u_shape: 'U-oblika',
        layout_banquet: 'Banketna',
        layout_cocktail: 'Koktajl',
        layout_boardroom: 'Sejna',
        layout_custom: 'Po meri',

        catering_title: 'Postavke in meni — {part}',
        catering_hint: 'Kar je v teh dveh karticah po shranjevanju, JE dogovor za ta del: meni in vse ostalo, kar se zanj obračuna. Prazna kartica pomeni, da tega ni.',
        catering_hint_short: 'Meni in ostale postavke po delih programa.',
        catering_edit: 'Uredi postavke in meni',
        card_menu: 'Meni',
        card_menu_hint: 'Hrana in pijača tega dela, z dietami.',
        card_menu_add: 'Dodaj jed ali pijačo',
        card_menu_empty: 'Meni je prazen.',
        card_other: 'Ostale postavke',
        card_other_hint: 'Najem dvorane, oprema, osebje, zunanji izvajalci in drugo.',
        card_other_empty: 'Ni drugih postavk.',
        card_subtotal: 'Skupaj: {amount}',
        hire_offer: 'Dvorana {venue} ima v ceniku {price}.',
        hire_add: 'Dodaj najem dvorane',
        hire_title: 'Najem — {venue}',
        catering_add_line: 'Dodaj postavko',
        catering_empty: 'Ni postavk.',
        catering_none: 'Ta del nima ne menija ne drugih postavk.',
        catering_saved: 'Postavke in meni so shranjeni.',
        catering_failed: 'Menija ni bilo mogoče shraniti.',
        diets: 'Diete',
        per_head: 'na osebo',

        line_title: 'Postavka',
        line_kind: 'Vrsta',
        line_per: 'Enota',
        line_quantity: 'Količina',
        line_unit: 'Cena/enoto',
        line_discount: 'Popust (%)',
        line_tax: 'DDV',
        line_price_mode: 'Način',
        line_covered_by: 'Vključeno v',
        line_posting: 'Knjiženje',
        line_untitled: 'Neimenovana postavka',

        line_kind_venue: 'Dvorana',
        line_kind_food: 'Hrana',
        line_kind_drink: 'Pijača',
        line_kind_equipment: 'Oprema',
        line_kind_staff: 'Osebje',
        line_kind_external: 'Zunanji',
        line_kind_other: 'Drugo',

        per_per_event: 'na dogodek',
        per_per_person: 'na osebo',
        per_per_hour: 'na uro',
        per_per_item: 'na kos',

        price_mode_included: 'Vključeno',
        price_mode_surcharge: 'Doplačilo',
        price_mode_free: 'Brezplačno',

        posting_on_confirmation: 'Ob potrditvi',
        posting_on_completion: 'Po izvedbi',
        posting_none: 'Se ne knjiži',

        covered_by_none: 'Samostojno',
        covered_by_package: 'Paket',
        covered_by_board: 'Pansion',
        covered_by_rate_plan: 'Cenik',

        diet_vegetarian: 'Vegetarijansko',
        diet_vegan: 'Vegansko',
        diet_gluten_free: 'Brez glutena',
        diet_lactose_free: 'Brez laktoze',
        diet_halal: 'Halal',
        diet_kosher: 'Košer',
        diet_child: 'Otroški obrok',
        diet_other: 'Drugo',

        balance_ok: 'Postavke se izidejo: {total}.',
        balance_off: 'Postavke se ne izidejo',
        balance_off_hint: 'Razlika je {difference}, spornih postavk: {count}. Dokler se ne izide, različice ni mogoče zamrzniti.',

        kitchen_preview: 'Kuhinjski list',
        kitchen_empty: 'Ni podatkov za list.',
        kitchen_confirmed: 'Iz potrjene različice {version}.',
        kitchen_draft: 'Delovno stanje — ni pogodba.',
        kitchen_covers: '{count} oseb',
        kitchen_estimate: 'ocena',
        kitchen_on_actuals: 'po dejanski porabi',
        kitchen_use_contract: 'Potrjena različica',
        kitchen_use_draft: 'Delovno stanje',
        section_kitchen: 'Kuhinja',
        section_service: 'Strežba',
        section_department: 'Oddelek',

        rooms: 'Sobe',
        rooms_none: 'Ta dogodek nima sob. Blok sob je skupina — dogodek se nanjo sklicuje.',
        rooms_linked: 'Sobe tega dogodka vodi skupina.',
        rooms_open: 'Odpri skupino',
        rooms_create: 'Dodaj sobe',
        rooms_new_name: 'Naziv skupine',
        rooms_link: 'Poveži z obstoječo skupino',
        rooms_link_do: 'Poveži',
        rooms_pick: 'Izberi skupino',
        rooms_type: 'Tip sobe',
        rooms_count: 'Sob',
        rooms_price: 'Cena/noč',
        rooms_add_block: 'Dodaj tip sobe',
        rooms_arrival: 'Prihod',
        rooms_departure: 'Odhod',
        rooms_nights_help: 'Noči, za katere hiša drži sobe; privzeto dan dogodka in jutro po njem.',
        rooming_import: 'V rooming seznam skupine',
        rooming_copy: 'Kopiraj bivajoče za rooming',
        rooming_copied: '{count} oseb je na odložišču — odpri skupino, Rooming seznam, Prilepi.',
        rooming_copy_failed: 'Kopiranje ni uspelo; označi seznam ročno.',
        rooms_release: 'Rok sprostitve',
        rooms_release_help: 'Do kdaj hiša drži sobe. Prazno pomeni brez roka.',
        rooms_unlink: 'Odveži skupino',
        rooms_saved: 'Shranjeno.',
        rooms_failed: 'Povezave ni bilo mogoče shraniti.',

        participants: 'Udeleženci',
        participants_empty: 'Ni udeležencev.',
        participants_counts: 'skupaj {total} · prespi {staying} · zunanjih {external}',
        diet_none: 'Brez diete',
        participant_add: 'Dodaj udeleženca',
        participant_add_failed: 'Udeleženca ni bilo mogoče dodati.',
        participant_first_name: 'Ime',
        participant_last_name: 'Priimek',
        participant_name: 'Ime',
        participant_company: 'Podjetje',
        participant_role: 'Vloga',
        participant_diet: 'Dieta',
        participant_staying: 'Prespi',
        participant_has_bed: 'ima posteljo',
        participant_wants_bed: 'čaka posteljo',
        participant_delete_failed: 'Udeleženca ni bilo mogoče odstraniti.',

        role_delegate: 'Udeleženec',
        role_speaker: 'Predavatelj',
        role_vip: 'VIP',
        role_staff: 'Osebje',
        role_supplier: 'Dobavitelj',

        import_title: 'Uvozi udeležence',
        import_hint: 'Prilepi seznam. Model ga prebere in pokaže, kaj je razumel — nič se ne zapiše, dokler ne potrdiš.',
        import_placeholder: 'Ime, priimek, podjetje, e-pošta, prespi, dieta …',
        import_parse: 'Preberi',
        import_parse_failed: 'Seznama ni bilo mogoče prebrati.',
        import_row: 'Vrstica',
        import_match: 'Ujemanje',
        import_match_new: 'nov',
        import_match_existing: 'v registru',
        import_match_ambiguous: 'nejasno ({count})',
        import_counts: 'skupaj {total} · prespi {staying} · zunanjih {external}',
        import_linked: 'povezanih: {count}',
        import_concerns: 'Kaj je bilo nejasno',
        import_replace: 'Zamenjaj obstoječi seznam',
        import_replace_help: 'Organizator je poslal popravljen seznam. Stari se izprazni.',
        import_back: 'Nazaj',
        import_confirm: 'Uvozi',
        import_done: 'Dodanih {added}, odstranjenih {removed}.',
        import_failed: 'Uvoz ni uspel.',

        needs_title: 'Kadrovska potreba — {part}',
        needs_edit: 'Uredi potrebe',
        needs_add: 'Dodaj potrebo',
        needs_none: 'Ta del nima kadrovskih potreb.',
        needs_people: 'Ljudi',
        needs_position: 'Delovno mesto',
        needs_saved: 'Kadrovske potrebe so shranjene.',
        needs_failed: 'Kadrovskih potreb ni bilo mogoče shraniti.',
        any_position: 'Katero koli mesto',
        no_department: 'Brez oddelka',
        all_departments: 'Vsi oddelki',

        staffing: 'Pokritost po urniku',
        staffing_day: 'Dan',
        staffing_need: 'Potreba',
        staffing_scheduled: 'Razporejeno',
        staffing_draft: 'osnutek',
        staffing_shortfall: 'Manjka',
        staffing_empty: 'Ni podatkov o pokritosti.',
        staffing_no_rota: 'Urnik za te dni še ni objavljen.',

        offer_hint: 'Ponudbena povezava se ustvari samo, kadar je še ni: drugi pritisk vrne isto povezavo, ker bi nova razveljavila tisto, ki jo je prodaja že poslala.',
        offer_needs_version: 'Ponudba je zamrznjena različica, ne osnutek. Najprej zamrzni različico — kar je zdaj v programu in postrežbi, postane dogovor — nato ustvari povezavo.',
        offer_none: 'Ponudbena povezava še ni ustvarjena.',
        offer_issue: 'Ustvari povezavo',
        offer_issued: 'Izdano',
        offer_issued_done: 'Povezava je pripravljena.',
        offer_expires: 'Poteče',
        offer_viewed: 'Ogledano',
        offer_not_viewed: 'Še ni ogledano',
        offer_copy: 'Kopiraj',
        offer_copied: 'Povezava je kopirana.',
        offer_copy_failed: 'Povezave ni bilo mogoče kopirati.',
        offer_open: 'Odpri',
        offer_pdf: 'PDF ponudbe',
        offer_revoke: 'Razveljavi povezavo',
        offer_revoked: 'Povezava je razveljavljena.',
        offer_failed: 'Dejanja ni bilo mogoče izvesti.',
        offer_client: 'Potrditev naročnika',
        offer_client_confirmed: 'Naročnik je potrdil različico {version} ({at}).',
        offer_client_waiting: 'Naročnik še ni potrdil.',

        version: 'Različica',
        diff_field: {
            title: 'Naziv',
            kind: 'Vrsta',
            per: 'Enota',
            quantity: 'Količina',
            unit_amount: 'Cena/enoto',
            discount: 'Popust',
            tax_rate: 'DDV',
            price_mode: 'Način',
            covered_by: 'Vključeno v',
            posting: 'Knjiženje',
            diets: 'Diete',
            start_at: 'Začetek',
            end_at: 'Konec',
            facility_id: 'Dvorane',
            layout: 'Postavitev',
            department_id: 'Oddelek',
            responsible_user_id: 'Odgovorni',
            notes: 'Opombe',
        },
        versions_hint: 'Zamrznjena različica je posnetek dogovora. Razlika se izračuna ob branju in se nikoli ne shrani.',
        versions_empty: 'Ni še nobene zamrznjene različice.',
        version_when: 'Zamrznjeno',
        version_reason: 'Razlog',
        version_total: 'Skupaj',
        version_acknowledged: 'Prevzeli',
        version_nobody: 'nihče še',
        version_standing: 'velja',
        version_standing_short: 'različica {version}',
        version_compare: 'Primerjaj',
        diff_from: 'Od različice',
        diff_to: 'Do',
        diff_working: 'Delovno stanje',
        diff_none: 'Ni razlike.',
        diff_added: 'dodano',
        diff_removed: 'odstranjeno',
        diff_changed: 'spremenjeno',
        diff_headcount: 'Glavarina: načrtovano {planned}, zajamčeno {guaranteed}, dejansko {actual}',
        acknowledge: 'Prevzemi',
        acknowledge_title: 'Prevzem različice {version}',
        acknowledged: 'Prevzem je zabeležen.',
        acknowledge_failed: 'Prevzema ni bilo mogoče zabeležiti.',

        change_title: 'Nova različica',
        change_hint: 'Velja različica {version}. Sprememba potrjenega dogodka je nova različica, ne popravek.',
        change_hint_first: 'Prva različica: kar je zdaj v programu, postane dogovor.',
        change_reason: 'Razlog',
        change_reason_help: 'Kaj se je spremenilo in zakaj. Pride na pismo oddelkom.',
        change_needs_reason: 'Razlog je obvezen.',
        change_confirm: 'Zamrzni različico',
        change_done: 'Različica {version} je zamrznjena.',
        change_failed: 'Različice ni bilo mogoče zamrzniti.',
        impact: 'Kaj to pomeni',
        impact_loading: 'Računam razliko …',
        impact_value: 'Razlika v vrednosti',
        impact_headcount: 'Glavarina',
        impact_headcount_same: 'nespremenjena',
        impact_parts: 'Deli programa',
        impact_parts_count: 'spremenjenih: {count}',
        impact_acknowledgements: 'Ti prevzemi se razveljavijo:',
        impact_capacity: 'Preveri številke',
        impact_capacity_guarantee: 'Zajamčeno število ({guaranteed}) je večje od načrtovanega ({planned}).',

        beo_view: 'Pogled',
        beo_view_all: 'Vse',
        beo_view_kitchen: 'Kuhinja',
        beo_view_service: 'Strežba',
        beo_view_technical: 'Tehnika',
        beo_version: 'Različica',
        beo_contract: 'Potrjena (pogodba)',
        beo_working: 'Delovno stanje',
        beo_since: 'Razlika od',
        beo_since_help: 'Ob spremembi se pošlje razlika, ne nov list.',
        beo_since_none: 'Brez razlike',
        beo_confirmed: 'Potrjena različica {version}',
        beo_draft: 'Delovno stanje — ni pogodba.',
        beo_generated: 'izrisano {at}',
        beo_change: 'Kaj se je spremenilo med različicama {from} in {to}',
        beo_setup: 'rezervirano {from}–{to}',
        beo_sections: 'Prevzemi po oddelkih',
        beo_taken: 'prevzel {who} ({at})',
        beo_not_taken: 'še ni prevzeto',
        beo_pdf_failed: 'Lista ni bilo mogoče natisniti.',
        beo_pdf: 'Natisni',
        beo_empty: 'Ni podatkov za BEO.',
        basis_actual: 'po dejanskem številu',
        basis_guaranteed: 'po zajamčenem številu',
        basis_planned: 'po načrtovanem številu',

        tasks: 'Naloge',
        tasks_empty: 'Ni nalog.',
        tasks_generate: 'Osveži iz programa',
        tasks_generated: 'Novih {created}, osveženih {refreshed}, umaknjenih {withdrawn}.',
        tasks_generate_failed: 'Nalog ni bilo mogoče osvežiti.',
        task_open: 'Odprta',
        task_done: 'Opravljeno',
        task_cancelled: 'Umaknjena',
        task_stale: 'iz starejše različice',
        task_failed: 'Naloge ni bilo mogoče spremeniti.',

        folio: 'Kartica dogodka',
        folio_is_group: 'kartica skupine',
        folio_none: 'Kartica še ni odprta.',
        folio_create: 'Odpri kartico',
        folio_created: 'Kartica je odprta.',
        folio_failed: 'Kartice ni bilo mogoče odpreti.',
        folio_open: 'Odpri kartico',
        folio_charges: 'Bremenitve',
        folio_payments: 'Plačila',
        folio_balance: 'Saldo',
        folio_unbilled: 'Še neknjiženo',
        post_charges: 'Knjiži postavke',
        post_pending: 'neknjiženih: {count}',
        post_done: 'Knjiženih {posted}, nespremenjenih {unchanged}, skupaj {amount}.',
        post_failed: 'Postavk ni bilo mogoče knjižiti.',

        proformas: 'Predračuni',
        proformas_state: 'izdanih {count} · zahtevano {requested} · plačano {prepaid}',
        proforma_again_confirm: 'Dogodek že ima odprt predračun {number}, ki še čaka na plačilo. Izdam še enega?',
        proforma_pdf: 'PDF',
        proforma_row_dates: 'izdan {issued} · velja do {valid}',
        proformas_last: 'zadnji: {number}',
        proforma_share: 'Delež (%)',
        proforma_share_help: 'Prazno oziroma 100 % pomeni celo vrednost.',
        proforma_valid: 'Velja (dni)',
        proforma_issue: 'Izdaj predračun',
        proforma_done: 'Predračun {number} je izdan.',
        proforma_failed: 'Predračuna ni bilo mogoče izdati.',

        ladder: 'Odpovedna lestvica',
        ladder_hint: 'Koliko hiša obdrži, če se dogodek odpove toliko dni prej. Ureja se od najdaljšega roka navzdol.',
        ladder_days: 'Dni prej',
        ladder_keep: 'Obdrži (%)',
        ladder_add: 'Dodaj stopnjo',
        ladder_saved: 'Lestvica je shranjena.',
        ladder_failed: 'Lestvice ni bilo mogoče shraniti.',

        ending: 'Konec dogodka',
        cancel_open: 'Odpovej dogodek',
        cancel_title: 'Odpoved dogodka',
        cancel_contract: 'Vrednost pogodbe',
        cancel_tier: 'Stopnja ({days} dni prej, {percent} %)',
        cancel_prepaid: 'Že plačano',
        cancel_refund: 'Za vračilo',
        cancel_due: 'Za doplačilo',
        cancel_venues: 'Sprosti se dvoran: {count}.',
        cancel_reason: 'Razlog odpovedi',
        cancel_waive: 'Odpusti odpovedni strošek',
        cancel_waive_help: 'Hiša se odpove svojemu deležu. Zapiše se, da je bil odpuščen.',
        cancel_confirm: 'Odpovej',
        cancel_done: 'Dogodek je odpovedan.',
        cancel_failed: 'Dogodka ni bilo mogoče odpovedati.',
        cancel_quote_failed: 'Lestvice ni bilo mogoče prebrati.',
        close: 'Zaključi dogodek',
        close_done: 'Dogodek je zaključen. Saldo: {balance}.',
        close_failed: 'Dogodka ni bilo mogoče zaključiti.',

        calendar: 'Koledar dvoran',
        calendar_empty: 'V tem obdobju ni dogodkov.',
        calendar_venue: 'Dvorana',
        calendar_claimed: 'Prijeto okno (priprava in pospravljanje)',
        calendar_shared: 'Dvorana v souporabi z drugim dogodkom',
        all_venues: 'Vse dvorane',
        today: 'Danes',
        range_previous: 'Prejšnje obdobje',
        range_next: 'Naslednje obdobje',
        view_day: 'Dan',
        view_week: 'Teden',
        view_month: 'Mesec',

        warn_unclaimed: 'Nekateri deli programa so brez rezerviranega prostora (npr. „{part}“) — skupaj {count}.',
        warn_shared_own: 'Dvorana {venue}: del „{part}“ se prekriva z delom „{other}“ ({from}–{to}) istega dogodka.',
        warn_shared_venue: 'Dvorana {venue} je pri delu „{part}“ v souporabi z dogodkom {event} ({from}–{to}).',
        warn_no_version: 'Dogodek je potrjen, a ni zamrznjene različice — oddelki delajo po osnutku.',
        warn_guarantee_due: 'Zajamčeno število ni določeno · rok čez {days} dni.',
        warn_guarantee_passed: 'Rok za zajamčeno število je potekel ({date}) in število še ni določeno.',
        warn_unbalanced: 'Postavke se ne izidejo: razlika {difference} €, spornih {count}. Različice ni mogoče zamrzniti.',
        warn_stale: 'Navodila so zastarela — dogodek se je spremenil po različici {version}. Finance, predračun in listi oddelkov še kažejo različico {version}: zamrzni novo različico, nato v Finančnem dogovoru knjiži postavke.',
        warn_not_acknowledged: 'Različice {version} še niso prevzeli: {departments}.',
        warn_rooms_changed: 'Sobna skupina se je spremenila po potrditvi — preveri ponudbo in različico.',
        warn_no_payer: 'Plačnik ni določen — brez njega ni folia in predračuna.',
        warn_unposted: 'Neknjiženih postavk po pogodbi: {count}.',
        warn_folio_open: 'Kartica dogodka še ni poravnana.',
    },
    group: {
        // Seznam, s katerim recepcija dela, je ŽIVI. Odpovedana in zaključena skupina
        // sta končani; seznam, ki se odpre na vseh petih stanjih, dobi rep opravljenega
        // posla, ki naslednji prihod potisne s zaslona.
        scope_live:      'Žive skupine',
        scope_all:       'Vse',
        scope_cancelled: 'Odpovedane',
        scope_completed: 'Zaključene',
        search_placeholder: 'Številka, naziv, podjetje, kontakt, termin, sobe, stanje',
        search_matches:     'najdenih: {shown} od {total}',
        hidden:          'skritih: {count}',
        sort_by:         'Razvrsti po: {column}',
        actions_menu:    'Dejanja',
        group: 'Skupina',
        pickup: 'Prevzemi sobo',
        pickup_title: 'Prevzem sobe iz bloka',
        pickup_room_note: 'Iz bloka se vzame naslednja držana soba tega tipa — ni nujno tista, ki si jo pritisnil na razporedu. Katera je, se vidi na razporedu takoj po prevzemu.',
        pickup_payer_group: 'Plača skupina — {payer}',
        pickup_payer_guest: 'Plača gost',
        pickup_guests_hint: 'Po ena vrstica na ležišče. Izbira se med gosti te skupine; koga novega dodaš kar iz izbirnika.',
        pickup_check_in_now: 'Rezervacija {number} je nastala. Gosta prijavim zdaj?',
        pickup_payer_none: 'Ta skupina nima svojega plačnika — ni naročnika-podjetja in stik skupine ni gost hiše. Sobo zato plača gost, ki ga izbereš spodaj.',
        pickup_needs_room_type: 'Blok sob ni znan, zato prevzem ni mogoč. Odpri skupino in prevzemi sobo z njene strani.',
        pickup_needs_payer_group: 'Skupina nima plačnika, na katerega bi bilo mogoče knjižiti sobo. Izberi gosta.',
        pickup_needs_payer_guest: 'Izberi gosta, ki plača sobo.',
        pickup_needs_people: 'V sobi mora biti vsaj ena oseba.',
        pickup_hint: 'Iz bloka se vzame ena držana soba in nastane potrjena rezervacija po dogovorjeni ceni z bloka. Sobe se tržnica nikoli ne dotakne — nočitve se atomsko preoznačijo na novo rezervacijo.',
        picked_up: 'Rezervacija {number} je ustvarjena iz bloka.',
        title: 'Skupinske rezervacije',
        hint: 'Skupina drži blok sob: ob prehodu v Možnost sistem zasede konkretne sobe po tipih — razpored, prodaja in kanali vidijo resnico takoj.',
        add: 'Nova skupina',
        create: 'Ustvari',
        created: 'Skupina je ustvarjena kot povpraševanje.',
        number: 'Številka',
        name: 'Naziv',
        period: 'Termin',
        rooms: 'Sobe',
        rooms_short: 'sob',
        night: 'noč',
        status: 'Status',
        release: 'Sprostitev',
        release_help: 'Do tega dne velja opcija; potem se neprevzete sobe same vrnejo v prodajo.',
        released: 'Sproščeno',
        held: 'drži {count}',
        holding: 'drži {count} sob',
        not_holding: 'še ne drži sob',
        contact: 'Kontakt',
        notes: 'Opombe',
        blocks: 'Blok sob',
        add_block: 'Dodaj tip',
        price_from_plan: 'Cenik',
        no_plan: 'Ročno / brez cenika',
        manual_price: 'ročno',
        available_short: 'na voljo: {count}',
        block_total: 'Skupaj blok',
        grand_total: 'Skupaj',
        block_shortage: '{type}: na voljo je le {available} sob (potrebnih {requested}), najmanj jih je prostih {night}.',
        empty: 'Še ni skupin. Ustvari prvo s gumbom Nova skupina.',
        // Enoti ob vnosnih poljih v vrstici bloka. Brez njiju sta „%“ in „€ / noč“
        // dve številki, ki nihče ne ve, na kaj se nanašata.
        discount_unit: '% popust',
        price_unit:    '€ / noč / sobo',
        not_found: 'Te skupine ni — morda je bila izbrisana ali pa povezava kaže na drug hotel.',
        statuses: { inquiry: 'Povpraševanje', option: 'Opcija', confirmed: 'Potrjena', completed: 'Zaključena', cancelled: 'Odpovedana' },
        actions: { option: 'V opcijo', confirmed: 'Potrdi', completed: 'Zaključi', cancelled: 'Odpovej' },
        done: {
            option: 'Sobe so zasedene — opcija drži blok.',
            confirmed: 'Skupina je potrjena.',
            completed: 'Skupina je zaključena; neprevzete sobe so sproščene.',
            cancelled: 'Skupina je odpovedana; sobe so sproščene.',
        },
    },
    // Pravila urnika hiše (docs/OSEBJE.md §7, §16). Privzetki so zakonsko izhodišče
    // (ZDR-1); nič v obrazcu jih ne vpiše — nič pomeni „kar pravi zakon“.
    staff_today: {
        title: 'Danes',
        hint:  'Šest stvari o današnjem dnevu, ki zahtevajo odločitev ali klic. Nič se tu ne odloči — vsaka vrstica vodi na zaslon, kjer se zapre. Osveži se sama vsaki dve minuti, dokler je zavihek odprt.',

        date_hint:    'Koledarski dan v času hiše. Privzeto današnji.',
        generated_at: 'Osveženo ob {time}',

        not_visible:      'Tega ne vidiš',
        not_visible_hint: 'Za ta razdelek je potrebna pravica {permission}. Prazno in „nimaš pravice“ nista isto, zato tu ne piše nič.',

        empty:     'Nič.',
        truncated: 'Prikazanih {shown} od {total}.',

        unnamed_department: 'Neimenovan oddelek',
        unnamed_person:     'Neimenovana oseba',
        channel_unknown:    'neznana pot',

        section_coverage_gaps:      'Nepokrito',
        section_coverage_gaps_hint: 'Oddelki, ki jih objavljeni urnik danes ne pokrije. Osnutki so posebej — te zapre gumb Objavi in ne iskanje človeka.',

        section_missing_stamps:      'Manjkajoči žigi',
        section_missing_stamps_hint: 'Urnik je namera, ura je dejstvo. Vrstica je vprašanje, ki ga je vredno postaviti, in nikoli obtožba.',

        section_waiting_approval:      'Čaka odločitev',
        section_waiting_approval_hint: 'Odsotnosti, popravki evidence in spremembe turnusa, ki jih ni nihče potrdil. Najstarejše zgoraj.',

        section_documents_expiring:      'Dokumenti potečejo',
        section_documents_expiring_hint: 'Papirji na kadrovskih karticah, ki potečejo v 30 dneh ali so že potekli.',

        section_failed_notifications:      'Neuspela obvestila',
        section_failed_notifications_hint: 'Kar je hiša v zadnjih 7 dneh poskusila sporočiti osebju in ni prišlo skozi. Napačna številka ali blokirana pot se ne popravi s čakanjem.',

        section_in_house:      'V hiši',
        section_in_house_hint: 'Kdo je zdaj žigosan v hiši in kdo je danes odsoten.',

        row_coverage_gap:        'manjka {minutes}, tudi z osnutki',
        row_coverage_draft:      'manjka {minutes}; osnutki bi to pokrili — objavi',
        row_no_arrival:          'turnus teče {minutes} brez prihoda',
        row_still_in:            'turnus se je končal pred {minutes}, žig je še odprt',
        row_open_stamp:          'prihod izpred {days} dni ni bil nikoli zaključen',
        row_absence_request:     '{kind} — čaka {days} dni',
        row_time_correction:     'popravek evidence — čaka {days} dni',
        row_shift_change:        'sprememba turnusa ni potrjena — {days} dni',
        row_document_expiring:   'poteče čez {days} dni',
        row_document_expired:    'potekel pred {days} dnevi',
        row_delivery_failed:     'sporočilo ni prišlo skozi ({channel})',
        row_clocked_in:          'v hiši {minutes}',
        row_on_absence:          'odsoten — {kind}',
    },

    staff_rules: {
        title: 'Pravila urnika',
        hint:  'Kaj hiša dovoli pri razporejanju. Prazno polje pomeni zakonsko izhodišče, ki je zapisano kot namig. Nič od tega ne prepove turnusa — razporejanje samo opozori in v sledi se zabeleži, da je vodja vseeno shranila. Edino, kar je zavrnjeno, je prekrivanje dveh turnusov iste osebe.',

        daily_rest:      'Dnevni počitek med turnusoma (min)',
        daily_rest_hint: 'ZDR-1: 11 ur. Prazno = 11 ur.',

        weekly_rest:      'Tedenski počitek v sedmih dneh (min)',
        weekly_rest_hint: 'ZDR-1: 24 ur nepretrgano. Prazno = 24 ur.',

        max_consecutive_days:      'Največ zaporednih delovnih dni',
        max_consecutive_days_hint: 'Prazno = 6.',

        max_daily_minutes:      'Največ ur na dan (min)',
        max_daily_minutes_hint: 'ZDR-1: 10 ur z nadurami. Prazno = 10 ur.',

        max_weekly_overtime:      'Dovoljeno nad tedensko obveznostjo (min)',
        max_weekly_overtime_hint: 'Meri se proti obveznosti s kadrovske kartice te osebe, ne proti 40 uram hiše. ZDR-1: 8 ur na teden. Prazno = 8 ur.',

        late_stamp:      'Zamuda, po kateri žig velja za manjkajočega (min)',
        late_stamp_hint: 'Toliko po začetku turnusa brez prihoda se človek pojavi na zaslonu Danes. Prag odloča samo, ali gre kdo pogledat — ure se štejejo tako ali tako. Prazno = 15 min.',

        days_value: '{days} dni',
    },

    // Obračun plač — kako zaključen mesec zapusti hišo (docs/EVIDENCA-CASA.md § „Payroll
    // Connect“). Nič tu ne pove, koliko je ura vredna: to je odgovor računovodstva.
    staff_payroll: {
        title: 'Obračun plač',
        hint:  'Kam gre zaključen mesec in v kakšni obliki. Nastavitve ne spremenijo nobene številke — povedo, kateri program ga prevzame, pod katero šifro podjetja in kako je zapisana ura. Kaj je ura vredna, ostaja odgovor računovodstva.',

        provider:      'Program za obračun plač',
        provider_hint: 'Samo zapis, kateri program prevzame datoteko. Vsi dobijo iste vrstice iz istega posnetka.',

        provider_generic:  'Splošno (navadna datoteka)',
        provider_vasco:    'Vasco',
        provider_saop:     'SAOP',
        provider_pantheon: 'Pantheon',
        provider_minimax:  'Minimax',

        company_code:      'Šifra podjetja',
        company_code_hint: 'Šifra te hiše v programu za obračun plač. Piše se v prvi stolpec vsake vrstice.',

        export_format:      'Privzeta oblika izvoza',
        export_format_hint: 'XLSX je zapisan kot želja, ne kot ponudba: te datoteke ta storitev ne zna izdelati in izvoz jo zavrne z besedilom. Odločitev o preglednični knjižnici je odločitev o odobrenih odvisnostih.',

        format_csv:  'CSV',
        format_xlsx: 'XLSX (ni na voljo)',

        hours_as:      'Zapis ur',
        hours_as_hint: 'Samo zapis, nikoli zaokroževanje: 455 minut je 7,58 ure ali 7:35, oboje se da pretvoriti nazaj v minute. Mesečni list, ki ga oseba podpiše, je vedno v h:mm.',

        hours_decimal: 'Decimalno (7,58)',
        hours_hhmm:    'Ure in minute (7:35)',

        decimal_comma:      'Slovenski zapis števil',
        decimal_comma_hint: 'Decimalna vejica in podpičje med stolpci — tako datoteko odpre Excel na slovenskem Windowsu. Eno stikalo in ne dve: datoteka z vejico v decimalkah in vejico med stolpci nima stolpcev.',

        absence_codes:      'Šifre odsotnosti',
        absence_codes_hint: 'Vaše plačne šifre za naše vrste odsotnosti. Namenoma prazno: katera naša vrsta pade pod katero šifro, je vprašanje za računovodstvo (docs/OSEBJE-RACUNOVODSTVO.md, vprašanje 1) in ga ne ugibamo. Prazno pomeni, da izvoz nosi naše ime vrste — datoteka je še vedno popolna.',
        absence_code_placeholder: 'npr. D01',
        absence_codes_count: 'Izpolnjenih šifer: {count}',
        absence_codes_empty: 'Ni izpolnjenih šifer',

        export:       'Izvoz za plače',
        export_draft: 'Izvoz za plače (osnutek)',

        export_csv:                'CSV — vrstica na osebo',
        export_csv_detail:         'CSV — z razdelkom po dnevih',
        export_xlsx_unavailable:   'XLSX — ni na voljo',

        sheet:         'List za zaposlenega (PDF)',
        my_sheet:       'Moj mesečni list (PDF)',
        my_sheet_draft: 'Moj mesečni list (osnutek)',
    },

    ai_settings: {
        events_enable: 'Beri lokalne dogodke',
        title: 'Milo – AI pomočnik',
        hint: 'Kaj sme Milo brati o okolici hotela.',
        events_url: 'Vir lokalnih dogodkov (URL)',
        events_url_help: 'Stran s koledarjem dogodkov v kraju — npr. koledar turistične skupnosti. Prazno pomeni, da Milo o dogodkih ne odgovarja.',
        events_sources: 'Viri prireditev',
        events_sources_hint: 'Koledarji in viri, ki jih Milo prebere in razčleni v seznam po dnevih. Kraj je lahko en sam vir redko — dodaj jih toliko, kolikor jih kraj ima.',
        events_sources_empty: 'Ni virov. Dokler jih ni, Milo prebere zgornji naslov, če je vpisan.',
        events_source_add: 'Dodaj vir',
        events_source_label: 'Ime',
        events_source_label_placeholder: 'Turizem Ljubljana',
        events_source_kind: 'Vrsta',
        events_source_url: 'Naslov',
        events_kind_ics: 'Koledar ICS',
        events_kind_feed: 'Vir RSS / Atom',
        events_kind_visitljubljana: 'Visit Ljubljana (samo Ljubljana)',
    },
    tv_channels: {
        url_insecure: 'Naslov je http:// — zaslon teče prek https in brskalnik takega toka ne naloži (blokirana mešana vsebina). Uporabi naslov https://, sicer bo slika črna.',
        epg_url: 'TV spored (XMLTV vir)',
        epg_url_help: 'Eden ali več naslovov XMLTV, vsak v svoji vrstici — od IPTV ponudnika ali javnih virov; spored je njihova unija (tudi .gz). Prazno = brez sporeda; zasloni takrat kažejo samo imena kanalov.',
        epg_id: 'ID v sporedu (XMLTV)',
        epg_id_help: 'ID kanala iz XMLTV vira (npr. slo1.tv). Prazno = kanal brez sporeda.',
        title: 'TV kanali (IPTV)',
        hint: 'Kanali, ki jih smejo gostje gledati v sobi — naslovi tokov iz hotelske IPTV pogodbe. Produkt ne prinaša nobenih kanalov.',
        add: 'Dodaj kanal',
        edit: 'Uredi kanal',
        empty: 'Še ni vnesenih kanalov.',
        empty_hint: 'Vnesi ime in naslov toka (HLS/IPTV) iz pogodbe s ponudnikom. Kanali se predvajajo samo na sobnih zaslonih — panel v avli jih nikoli ne vidi.',
        name: 'Ime',
        note: 'Opis',
        category: 'Kategorija',
        category_help: 'Skupina na zaslonu — »Nacionalni«, »Šport«, »Otroški«. Kanali z isto kategorijo so na sobnem zaslonu pod skupnim naslovom. Prazno pomeni skupino »Ostalo«.',
        url: 'Naslov toka',
        url_help: 'http(s) naslov — na Samsungu se HLS predvaja neposredno; v namiznem brskalniku HLS ne igra (to je omejitev brskalnika, ne zaslona).',
        order: 'Vrstni red',
        active: 'Aktiven',
        confirm_delete: 'Izbrišem kanal »{name}«?',
    },
    music: {
        url_insecure: 'Naslov je http:// — zaslon teče prek https in brskalnik takega toka ne naloži (blokirana mešana vsebina). Uporabi naslov https://, sicer bo radio tiho.',
        tab: 'Glasba in TV',
        title: 'Glasbene postaje',
        hint: 'Kaj smejo gostje poslušati v sobi in kaj avla predvaja sama. Produkt ne prinaša nobenih postaj — kaj hotel sme zakonito predvajati, ve samo hotel.',
        add: 'Dodaj postajo',
        edit: 'Uredi postajo',
        empty: 'Še ni vnesenih postaj.',
        empty_hint: 'Vnesi ime in naslov toka ali datoteke. Postaja za goste se predvaja v sobah; postaja hotela v skupnih prostorih — zanjo veljata SAZAS in IPF.',
        name: 'Ime',
        note: 'Opis (ena vrstica pod imenom)',
        url: 'Naslov',
        url_help: 'http(s) naslov toka ali zvočne datoteke. Ali stran za njim obstaja, se preveri šele na televizorju.',
        source: 'Vrsta',
        source_stream: 'Tok v živo',
        source_file: 'Posnetek (datoteka)',
        audience: 'Za koga',
        audience_help: 'Gostje: predvajanje v sobi, brez SAZAS/IPF. Hotel: javni prostori, hotelska licenca.',
        audience_guest: 'Gostje (sobe)',
        audience_house: 'Hotel (javni prostori)',
        ambience: 'Ambient avle',
        ambience_help: 'Panel brez sobe to postajo zažene sam. Ena na hotel — vklop tu jo izklopi drugje.',
        ambience_badge: 'ambient',
        active: 'Aktivna',
        confirm_delete: 'Izbrišem postajo »{name}«? Zasloni je ne bodo več ponujali.',
    },
    display: {
        item_signup: 'Točka s prijavo',
        item_signup_help: 'Gostje se prijavijo z OK na televizorju ali z gumbom na telefonu; spodaj se nabira seznam prijavljenih.',
        signup_sheet: '{count} prijavljenih',
        signup_none: 'Še brez prijav — štejejo se po objavi programa.',
        nav: 'TV zasloni v sobah',
        program_tab: 'Program dneva',
        waiting_tab: 'Čakajo na potrditev',
        devices_tab: 'Zasloni',
        waiting_count: 'Na potrditev čaka: {count}',
        waiting_banner_hint: 'Nekdo stoji pred televizorjem, ki kaže kodo, in čaka, da ga spustiš noter.',
        waiting_open: 'Poglej čakajoče',
        program_title: 'Program dneva',
        program_hint: 'Kar bo pisalo na zaslonih. Na televizorje ne gre nič, dokler ne pritisneš Objavi.',
        program_empty: 'Za ta dan še ni nobene točke.',
        publish: 'Objavi na zaslone',
        published_now: 'Objavljeno — na zaslonih je {count} točk.',
        published_at: 'objavljeno {at}',
        published_stale: 'objavljeno {at} · neobjavljene spremembe',
        never_published: 'še ni objavljeno',
        today: 'Danes',
        tomorrow: 'Jutri',
        add_item: 'Dodaj točko programa',
        edit_item: 'Uredi točko',
        confirm_item: 'Potrdi',
        proposed_by_ai: 'AI predlog — čaka potrditev',
        from: 'Od',
        to: 'Do',
        to_hint: 'lahko prazno',
        item_title: 'Naslov',
        item_note: 'Opomba',
        standing_info: 'Stalne informacije na zaslonu',
        standing_info_hint: 'npr. Zajtrk do 10.30 · odjava do 10.00 · recepcija: tipka 0',
        offer_note: 'Ponudba tedna ob strani zaslona se bere iz marketinga samodejno — aktivna ponudba, ki se izteče prva.',
        no_property: 'Najprej izberi objekt.',
        waiting_title: 'Zasloni, ki čakajo na potrditev',
        waiting_hint: 'Zaslon se javi sam in pokaže kodo. Poišči kodo, ki jo vidiš na televizorju, in jo potrdi.',
        waiting_empty: 'Trenutno noben zaslon ne čaka.',
        waiting_empty_hint: 'Tako je prav. Televizor, ki ga priklopiš, se javi sam in se pojavi tukaj s kodo, ki jo pokaže na zaslonu — dodajati ga ni treba nikjer.',
        waiting_since: 'javlja se od {at}',
        unknown_model: 'neznana naprava',
        approve: 'Potrdi',
        approve_hint: 'Potrjuješ zaslon s kodo {code}. Preveri, da je to res koda na televizorju pred tabo.',
        approved: 'Zaslon je potrjen. Televizor se preklopi sam.',
        dismiss: 'Zavrni',
        name: 'Ime zaslona',
        place: 'Kje stoji',
        place_room: 'Soba',
        place_venue: 'Dvorana',
        place_venue_named: 'Dvorana · {venue}',
        place_public: 'Javni prostor',
        venue: 'Dvorana',
        venue_hint: 'Zaslon pred vrati dvorane pokaže, kaj je v njej — nikoli naročnika, cene ali števila gostov.',
        venue_search: 'Iskanje dvorane …',
        room: 'Soba',
        room_search: 'Išči sobo …',
        devices: 'Registrirani zasloni',
        devices_hint: 'Zasloni, ki so že povezani. Prekliče se z enim pritiskom — televizor nato spet pokaže kodo.',
        // Naslov aplikacije za zaslone: edini korak, ki ga hotelir naredi na televizorju
        // samem. Naslov pride s strežnika (display_portal_url), tu ga nikoli ne pišemo.
        open_app:        'Odpri aplikacijo za zaslone',
        open_app_hint:   'Odpri na televizorju ali v brskalniku; zaslon pokaže kodo, ki jo potrdiš v zavihku Čakajo na potrditev.',
        copy_app_url:    'Kopiraj naslov',
        tizen_launcher:  'Samsung (Tizen) URL launcher: {url}',
        copy_tizen_url:  'Kopiraj naslov za Samsung',
        url_copied:      'Naslov je kopiran.',
        url_copy_failed: 'Kopiranje ni uspelo — naslov označi in kopiraj ročno.',
        devices_empty: 'Ni še nobenega zaslona.',
        devices_empty_hint: 'Zaslona se od tu ne doda — televizor na steni ne more skenirati kode. Priklopi ga, pokazal bo kodo in se javil med čakajoče.',
        live: 'v živo',
        quiet: 'brez povezave {minutes} min',
        lost: 'izgubljen — {hours} h brez povezave',
        b2b_capable: 'Samsung TV',
        // Koda, ki jo je zaslon pokazal ob povezavi in ostane na napravi
        // (docs/DISPLAY.md §2). Oznaka, ne geslo — zato tudi ni skrita.
        pairing_code_hint:        'Koda, ki jo je ta zaslon pokazal ob povezavi. Klikni za kopiranje.',
        pairing_code_copied:      'Koda je kopirana.',
        pairing_code_copy_failed: 'Kopiranje ni uspelo — kodo označi in kopiraj ročno.',
        device_rename: 'Uredi zaslon',
        // Kako je zaslon obrnjen (docs/DISPLAY.md §10.10). Nastavlja se zato, ker
        // televizor na obrnjenem nosilcu tega ne ve — zavrtelo se je držalo, ne
        // firmware, in okno še naprej javlja 1920×1080.
        orientation: 'Obrnjenost zaslona',
        orientation_hint: 'Samodejno: po oknu; Pokončno: slika se obrne za televizor, obrnjen za 90°.',
        orientation_auto: 'Samodejno (po oknu)',
        orientation_landscape: 'Ležeče',
        orientation_portrait: 'Pokončno (zasukano v desno)',
        orientation_portrait_flipped: 'Pokončno (zasukano v levo)',
        needs_rooms: 'Hotel še nima sob — zaslon se veže na sobo ali na splošni način.',
    },
    publishing: {
        nav: 'Objave',
        no_property: 'Najprej izberi objekt.',
        meta_title: 'Facebook in Instagram',
        meta_hint: 'Potrjena besedila objaviš neposredno na stran hotela. Objavi lahko le, kdor ima pravico Marketing (objava).',
        meta_needs_title: 'Kaj mora hotel pridobiti',
        meta_need_page: 'Facebook STRAN hotela (ne osebni profil) in njen številčni ID — Nastavitve strani → O strani.',
        meta_need_app: 'Aplikacijo na developers.facebook.com s pravicami pages_manage_posts in pages_read_engagement; za Instagram še instagram_basic in instagram_content_publish.',
        meta_need_token: 'Žeton strani (Page access token). Priporočeno: sistemski uporabnik v Meta Business Suite — ta žeton ne poteče. Kratkoživi žeton iz Graph Explorerja poteče v nekaj urah.',
        meta_need_ig: 'Za Instagram: POSLOVNI ali ustvarjalski račun, POVEZAN s to stranjo. ID dobiš z GET /{page-id}?fields=instagram_business_account.',
        page_id: 'ID Facebook strani',
        page_id_hint: 'Samo številke.',
        instagram_id: 'ID Instagram računa',
        instagram_id_hint: 'Neobvezno. Brez njega hotel objavlja samo na stran.',
        page_token: 'Žeton strani',
        page_token_hint: 'Vpiši žeton. Shrani se šifriran in se nikoli ne vrne na zaslon.',
        token_stored: 'Žeton je shranjen. Pusti prazno, da ostane nespremenjen.',
        token_set: '••••••••  (shranjen)',
        clear_token: 'Odstrani žeton',
        token_cleared: 'Žeton je odstranjen.',
        verify: 'Preveri povezavo',
        verified: 'Povezano s stranjo »{name}«.',
        verify_failed: 'Povezave ni bilo mogoče preveriti',
        sealed: 'Žetoni so šifrirani',
        sealed_hint: 'Shranijo se s ključem te namestitve in se ne vrnejo na zaslon. Namestitev brez ključa žetona ne more shraniti.',
        saved: 'Nastavitve objav so shranjene.',
        google_title: 'Google Business Profile',
        google_hint: 'Polja za objave na Google — vnesi jih, ko jih hotel pridobi.',
        google_not_yet: 'Objavljanje na Google v tej izdaji še ne deluje',
        google_not_yet_hint: 'Polja so tu, da si hotel med postopkom zapiše, kar dobi. Nič se še ne pošilja.',
        google_needs_title: 'Kaj mora hotel pridobiti',
        google_need_verified: 'POTRJENO lokacijo na Google Business Profile (razglednica, telefon ali video) — postopek hotela, traja tedne.',
        google_need_api: 'Odobren dostop do Business Profile API prek Googlovega obrazca za zahtevo dostopa (pregled, ne ključ, ki bi ga kdo generiral).',
        google_need_oauth: 'OAuth 2.0 odjemalca v Google Cloud projektu z obsegom business.manage in osvežitveni žeton računa, ki upravlja lokacijo.',
        google_need_ids: 'ID računa (accounts/…) in ID lokacije (locations/…).',
        google_account: 'ID računa',
        google_account_hint: 'npr. accounts/123456789',
        google_location: 'ID lokacije',
        google_location_hint: 'npr. locations/987654321',
        google_token: 'Osvežitveni žeton (OAuth)',
        google_token_hint: 'Neuporabljen do vzpostavitve povezave. Shrani se šifriran.',
        publish: 'Objavi',
        publish_facebook: 'Objavi na Facebook',
        publish_instagram: 'Objavi na Instagram',
        published: 'Objavljeno na {platform}.',
        published_no_photo: 'Objavljeno na {platform} — brez fotografije (ponudba je nima).',
        publish_failed: 'Objava ni uspela',
        not_configured: 'Objave niso nastavljene — glej Nastavitve (zobnik) → Izkušnja gosta, Milo in zasloni → Objave.',
        only_approved: 'Objaviš lahko samo potrjeno besedilo.',
        published_list: 'Objavljeno',
        open_post: 'Odpri objavo',
    },
    /*
     * Nastavitve → Milo za goste (načrt §11a).
     *
     * Kartica odloča o eni stvari: ali hišin pomočnik odgovarja GOSTU, in kaj sme zanj
     * pripraviti. Privzeto je izklopljen — nova funkcija se ne sme prižgati sama.
     */
    settings_guest_portal: {
        nav: 'Gostov portal',
        title: 'Videz gostovega portala',
        hint: 'Kako hiša izgleda gostu: ime, geslo, barvi, tema in monogram. Isti zapis berejo gostov portal, javna stran hiše in sobni zasloni.',
        no_property: 'Najprej izberite objekt.',
        needs_permission: 'Za ogled videza gostovega portala potrebujete pravico Objekt (branje).',
        display_name: 'Ime na portalu',
        display_name_hint: 'Kar gost prebere v pozdravu. Prazno pomeni ime objekta.',
        tagline: 'Geslo pod imenom',
        tagline_hint: 'Drobna vrstica pod imenom — NI kraj. Naslov hiše pride iz objekta in ga gost vidi na strani „Prihod“.',
        tagline_placeholder: 'HOTEL & SPA',
        address_notice: 'Naslov te hiše',
        primary: 'Glavna barva',
        primary_hint: 'Pozdravno polje, povezave, glava. Prazno pomeni privzeto barvo portala.',
        accent: 'Poudarek',
        accent_hint: 'Znak hiše in glavni gumbi. Prazno pomeni privzeti poudarek portala.',
        colour_clear: 'Počisti barvo',
        theme: 'Tema',
        theme_hint: 'Sistem pomeni, da odloči gostova naprava.',
        theme_system: 'sistem',
        theme_light: 'svetla',
        theme_dark: 'temna',
        radius: 'Zaobljenost',
        radius_hint: 'Zaobljeni ali ostri robovi kartic.',
        radius_rounded: 'zaobljeno',
        radius_square: 'ostro',
        typeface: 'Pisava',
        typeface_hint: 'Zaenkrat jo upoštevajo samo sobni zasloni; portal in javna stran rišeta v pisavi izdelka.',
        typeface_system: 'privzeta (sistemska)',
        typeface_trirong: 'Trirong + Montserrat',
        monogram: 'Monogram',
        monogram_hint: 'Ena ali dve črki v znaku, dokler hiša nima logotipa.',
        logo: 'Logotip',
        logo_hint: 'Logotip se naloži med fotografijami objekta; tu se ga samo vidi.',
        logo_set: 'Portal riše ta logotip; monogram se uporabi le, če ga ni.',
        logo_none: 'Hiša nima naloženega logotipa — portal riše monogram.',
        address: 'Javni naslov portala',
        address_hint: 'Osnova vsake povezave, ki jo gost dobi.',
        address_none: 'Ta namestitev nima gostovega portala.',
        copy: 'Kopiraj',
        copied: 'Naslov je kopiran.',
        used_where: 'Kje se vidi',
        used_guest: 'Gostov portal (povezava iz rezervacije)',
        used_site: 'Javna stran hiše',
        used_display: 'Sobni zasloni',
        preview: 'Predogled',
        preview_note: 'Približek pozdravnega polja v gostovem portalu.',
        preview_note_system: 'Približek pozdravnega polja. Pri temi „sistem“ odloči gostova naprava; tu je prikazana vaša.',
        preview_no_name: 'HIŠA',
        preview_eyebrow: 'VAŠE BIVANJE',
        preview_greeting: 'Dobrodošli v {name}',
        preview_subtitle: 'Vse o bivanju na enem mestu.',
        preview_card_title: 'Spletna prijava',
        preview_card_text: 'Podatki gostov, dokument in plačilo — pred prihodom.',
        preview_card_button: 'Dokončaj prijavo',
        summary_theme: 'tema {theme}',
        saved: 'Videz gostovega portala je shranjen.',
    },
    milo_settings: {
        nav: 'Milo za goste',
        title: 'Milo za goste',
        hint: 'Pomočnik v gostovem portalu: odgovarja iz podatkov hiše in pripravi predloge, ki jih gost potrdi. Ne sprejema plačil in ne izdaja računov.',
        no_property: 'Najprej izberite objekt.',
        enabled: 'Milo za goste',
        enabled_hint: 'Gost ga vidi kot gumb v svojem portalu. Odgovarja o svoji rezervaciji, hiši in okolici; o drugih gostih, osebju ali financah hiše ne pove ničesar.',
        actions: 'Kaj sme pripraviti',
        action_late_checkout: 'Prošnja za pozni odhod',
        action_late_checkout_hint: 'Prošnja in ne obljuba — odloči recepcija.',
        action_services: 'Rezervacija storitev',
        action_services_hint: 'Samo iz kataloga hiše in po ceni iz kataloga; zahteva modul Skupine in dogodki.',
        action_room_requests: 'Prošnje za sobo',
        action_room_requests_hint: 'Počistite sobo, ne moti do ure. Gre po gospodinjski poti — tipke ob postelji Milo ne pritisne.',
        action_messages: 'Sporočilo recepciji',
        action_messages_hint: 'Gost napiše sporočilo ali prosi za človeka; vrstica se pojavi na seznamu opozoril in na kartoteki gosta.',
        action_room_service: 'Naročilo iz jedilnika v sobo',
        action_room_service_hint: 'Gost naroči s hišnega jedilnika po ceni blagajne; edino dejanje, ki je s potrditvijo takoj opravljeno — kuhinja začne, znesek gre na račun sobe. Zunaj strežnih ur Milo zavrne in pove ure.',
        action_lost_items: 'Prijava izgubljenega predmeta',
        action_lost_items_hint: 'Gost prijavi, kaj je pozabil; zapis se odpre med najdenimi predmeti v stanju „Prijavil gost“ z gostom kot kontaktom. Nič ni najdeno — nekdo mora iti pogledat.',
        action_transfers: 'Prošnja za prevoz',
        action_transfers_hint: 'Gost zaprosi za avto; zahteva se zapiše med Prevoze in se NE pošlje ponudniku. Uro in ceno potrdi recepcija, portal cenika prevozov nima.',
        daily_turn_limit: 'Dnevna meja vprašanj',
        daily_turn_limit_hint: 'Na rezervacijo, na hišni dan. 0 pomeni privzeto (30).',
        max_turns: 'Dolžina konteksta',
        max_turns_hint: 'Koliko preteklih sporočil dobi model. 0 pomeni privzeto (20).',
        retention_days: 'Hramba po odhodu (dni)',
        retention_days_hint: 'Po tem se pogovor izbriše; rezervacije, postavke in vrstice na kartoteki ostanejo. 0 pomeni privzeto (30).',
        see_usage: 'Poglej porabo',
        see_attentions: 'Kam pridejo sporočila',
        saved: 'Nastavitve Mila so shranjene.',
        summary_on: 'Vklopljen za goste',
        summary_off: 'Za goste izklopljen',
        summary_limit: 'meja {count} vprašanj/dan',
        summary_retention: 'hramba {days}',
        summary_days_one: '{count} dan',
        summary_days_two: '{count} dneva',
        summary_days_few: '{count} dni',
        summary_days_other: '{count} dni',
    },
    order_pin: {
        nav: 'PIN za naročila',
        title: 'PIN za naročila',
        hint: 'Štirimestna koda, ki jo gost vpiše, preden naroči postrežbo v sobo ali rezervira storitev.',
        no_property: 'Najprej izberite objekt.',
        how_title: 'Kako deluje',
        how_issued: 'PIN se izda ob prijavi in velja za bivanje.',
        how_reception: 'Recepcija ga vedno vidi — v oknu za prijavo in na rezervaciji.',
        how_asked: 'Gost ga vpiše pred vsakim naročilom ali rezervacijo tam, kjer je spodaj vklopljeno.',
        how_wrong: 'Po treh napačnih poskusih mora gost počakati: najprej 30 sekund, nato vsakič dvakrat dlje, največ 15 minut.',
        doors: 'Kje se PIN zahteva',
        portal: 'Na gostovem telefonu (portal)',
        portal_hint: 'Gostov portal zahteva PIN pred naročilom ali rezervacijo.',
        display: 'Na sobni televiziji',
        display_hint: 'Zaslon v sobi zahteva PIN pred naročilom ali rezervacijo.',
        email: 'Pošlji PIN po e-pošti ob prijavi',
        email_hint: 'Plačnik rezervacije dobi PIN po e-pošti, ko je soba prijavljena.',
        email_needs_door: 'Na voljo, ko je PIN vklopljen vsaj na telefonu ali televiziji.',
        saved: 'Nastavitve PIN-a za naročila so shranjene.',
        reservation_label: 'PIN za naročila',
        send_mail: 'Pošlji po e-pošti',
        mail_sent: 'Poslano na {to}',
        mail_failed: 'PIN-a ni bilo mogoče poslati.',
        check_in_title: 'Povejte gostu PIN za naročila',
        check_in_mailed: 'Poslan na {to}',
    },
    city_pulse: {
        nav: 'Mesto v živo',
        title: 'Mesto v živo',
        hint: 'Ali je v mestu gužva — Milo na recepciji in Milo v gostovem portalu odgovarjata iz istega branja. Štirje viri, vsak neobvezen; kar ni bilo prebrano, Milo pove na glas.',
        no_property: 'Najprej izberite objekt.',
        enabled: 'Mesto v živo',
        enabled_hint: 'Dokler je izklopljeno, Milo na vprašanje o gužvi pošteno odgovori, da hiša tega ne ponuja.',
        parts: 'Kaj sme prebrati',
        part_events: 'Dogodki danes',
        part_events_hint: 'Iz virov prireditev, ki jih hiša že ima — isto branje kot orodje „prireditve v mestu“. Nič ne stane.',
        part_traffic: 'Promet pred hotelom',
        part_traffic_hint: 'Trenutna hitrost proti običajni na cesti pri hotelu in dogodki v krogu ~5 km. Bere se prek TomToma s ključem hiše; vsako vprašanje porabi dve zahtevi iz dnevne kvote.',
        part_parking: 'Parkirišča',
        part_parking_hint: 'Zasedenost javnih parkirišč, kjer jo upravljavec objavlja. Za večino krajev v Sloveniji vira ni in to Milo pove.',
        part_weather: 'Vreme zdaj',
        part_weather_hint: 'Ena ura iz iste napovedi, kot jo rišejo sobni zasloni. Tu je zato, ker je gužva zunaj odvisna od vremena — ne namesto napovedi.',
        events_not_ready: 'Branje dogodkov je izklopljeno',
        events_not_ready_hint: 'Ta del bo vklopljen in tih. Dogodke vklopite in vire nastavite pri objektu, v razdelku „Milo — AI pomočnik“.',
        parking_town_uncovered: 'Za kraj {town} ni vira o parkiriščih',
        parking_towns: 'Zasedenost znamo prebrati za: {towns}. Milo bo pošteno povedal, da tega za vaš kraj ne more preveriti.',
        key_section: 'Ključ za promet',
        needs_title: 'Kaj potrebujete',
        need_account: 'Brezplačen razvijalski račun na developer.tomtom.com.',
        need_key: 'Nov API ključ s pravico do Traffic API (brezplačno do 2.500 zahtev na dan).',
        need_paste: 'Ključ prilepite spodaj, shranite in pritisnite „Preveri povezavo“.',
        tomtom_key: 'TomTom API ključ',
        key_hint: 'Shrani se zaklenjen in se nikoli ne prikaže nazaj.',
        key_stored: 'Ključ je shranjen. Prazno polje pomeni „pusti pri miru“.',
        key_set: 'shranjen',
        clear_key: 'Odstrani',
        key_cleared: 'Ključ je odstranjen.',
        verify: 'Preveri povezavo',
        check_ok: 'Povezava deluje',
        check_failed: 'Povezava ne deluje',
        saved: 'Nastavitve „Mesto v živo“ so shranjene.',
        summary_on: 'Vklopljeno za {town} · bere: {parts}',
        summary_off: 'Izklopljeno',
        summary_no_parts: 'Vklopljeno, a noben vir ni izbran — Milo nima česa prebrati.',
    },
    audit: {
        kinds: {
            chat_conversation: 'pogovor', chat_operation: 'predlog', guest_chat_operation: 'predlog gosta', guest_chat_thread: 'pogovor gosta', staff_time_correction: 'popravek ur', staff_shift_change: 'sprememba turnusa', staff_absence: 'odsotnost', rota: 'razpored', settings_card: 'kartica nastavitev',
            reservation: 'rezervacija', folio: 'folio', invoice: 'račun', guest: 'gost', group: 'skupina',
            conversation: 'pogovor', guest_conversation: 'pogovor gosta', operation: 'predlog', property: 'objekt',
            user: 'uporabnik', device: 'naprava', display_device: 'zaslon', staff_employment: 'kadrovska kartica',
            shift: 'turnus', absence: 'odsotnost', housekeeping_task: 'naloga sobarice', settings: 'nastavitve',
            company: 'podjetje', proforma: 'predračun', notification: 'sporočilo', playlist: 'zanka',
        },
        nav: 'Revizijska sled',
        title: 'Revizijska sled',
        description: 'Kdo je kaj naredil v tej hiši — po osebi in po dogodku, vključno z vsem, kar je kdorkoli naročil Milu.',
        no_property: 'Najprej izberi objekt.',
        needs_permission: 'Za branje revizijske sledi potrebuješ pravico Revizijska sled (branje).',
        retention: 'Sled se ne briše: zapisi ostanejo, dokler obstaja hiša. Nič je ne more spremeniti ali izbrisati — niti ta zaslon.',
        from: 'Od',
        to: 'Do',
        who: 'Kdo',
        everybody: 'Vsi',
        action: 'Dejanje',
        action_group: 'Vrsta dejanja',
        all_actions: 'Vsa dejanja',
        search: 'Iskanje',
        search_hint: 'Po povzetku ali imenu',
        entity: 'Predmet',
        summary: 'Povzetek',
        when: 'Čas',
        address: 'Naslov IP',
        request: 'Zahtevek',
        detail: 'Podrobnosti',
        detail_title: 'Zapis revizijske sledi',
        open_detail: 'Odpri podrobnosti',
        export: 'Izvozi CSV',
        verify: 'Preveri verigo',
        chain: 'Veriga',
        sequence: 'Zaporedna',
        previous_hash: 'Prejšnji odtis',
        hash: 'Odtis',
        chain_intact: 'Veriga je nedotaknjena',
        chain_intact_hint: 'Preverjenih {checked} zapisov, od zaporedne {from} do {to}.',
        chain_broken: 'Veriga je prekinjena',
        chain_broken_hint: 'Prva prekinitev je pri zaporedni {sequence}: {reason}',
        break_hash: 'vsebina zapisa se ne ujema z njegovim odtisom — zapis je bil spremenjen.',
        break_link: 'zapis se ne veže na prejšnjega — zapis je bil zamenjan ali vrinjen.',
        break_gap: 'zaporedna številka manjka — zapis je bil izbrisan.',
        assistant_text: 'Besedilo',
        assistant_arguments: 'Argumenti orodja {tool}',
        kind_user: 'uporabnik',
        kind_guest: 'gost',
        kind_system: 'sistem',
        kind_assistant: 'pomočnik',
        group_reservation: 'Rezervacije',
        group_folio: 'Kartice',
        group_invoice: 'Računi',
        group_guest: 'Gostje',
        group_group: 'Skupine',
        group_housekeeping: 'Gospodinjstvo',
        group_staff: 'Osebje',
        group_settings: 'Nastavitve',
        group_notification: 'Obveščanje',
        group_auth: 'Prijave',
        group_display: 'Naprave',
        group_assistant: 'Milo (recepcija)',
        group_guest_assistant: 'Milo (gost)',
    },
    ai_usage: {
        nav: 'Poraba AI',
        title: 'Poraba AI',
        description: 'Koliko je hotel porabil za modele — po mesecih in po funkcijah. Brez cen: samo količine.',
        no_property: 'Najprej izberi objekt.',
        needs_permission: 'Za pregled porabe AI potrebuješ pravico Finance (branje) ali Objekt (urejanje).',
        measuring_since: 'Merjenje od {date}. Prvi zabeleženi klic tega hotela: {first}. Za nazaj ni podatkov.',
        measuring_since_empty: 'Merjenje od {date}. Ta hotel od takrat ni porabil nobenega modela. Za nazaj ni podatkov.',
        calls: 'Klici',
        failed: 'Neuspeli',
        failed_hint: 'Izpad ali zavrnitev ponudnika.',
        input_tokens: 'Vhodni žetoni',
        output_tokens: 'Izhodni žetoni',
        tokens_hint: 'Kot jih je sporočil ponudnik.',
        images: 'Slike',
        feature: 'Funkcija',
        by_feature: 'Po funkcijah',
        nothing_this_month: 'Ta mesec ni bilo nobenega klica.',
        no_prices: 'Cen in obračuna tu (še) ni — to so poštene količine, ki so temelj za morebitno doplačilo.',
        feature_chat: 'Milo (pomočnik na recepciji)',
        feature_guest_chat: 'Milo (gostov portal)',
        feature_mail_parse: 'Branje e-pošte',
        feature_rooming_parse: 'Branje rooming liste',
        feature_delivery_parse: 'Branje dobavnice',
        feature_document_scan: 'Branje dokumenta gosta',
        feature_marketing_text: 'Marketinško besedilo',
        feature_marketing_image: 'Marketinška slika',
        feature_reservation_offer: 'Nagovor na ponudbi',
        feature_group_offer: 'Nagovor na skupinski ponudbi',
    },
    yield: {
        moved: 'Dinamične cene so se preselile med Cenike — tam, kjer delaš s cenami.',
        on: 'Vklopljeno',
        off: 'Izklopljeno',
        saved: 'Dinamične cene so shranjene.',
        must_rise: 'Vsaka stopnica mora biti višja od prejšnje.',
        title: 'Dinamične cene',
        hint: 'Ob višji zasedenosti se nočna cena samodejno dvigne — velja najvišja dosežena stopnica. Osnovne cene v ceniku ostanejo nespremenjene.',
        enable: 'Vklopi dinamične cene po zasedenosti',
        occupancy_at_least: 'Zasedenost ≥',
        uplift: 'pribitek',
        add_rule: 'Dodaj stopnico',
    },
    assistant: {
        history:           'Zgodovina pogovorov',
        history_search:    'Išči po naslovih …',
        new_conversation:  'Nov pogovor',
        all_conversations: 'Vsi pogovori (nadzor)',
        read_only:         'Pogovor druge osebe — samo za branje.',
        confirm:   'Potrdi',
        decline:   'Zavrni',
        executed:  'Izvedeno',
        op_failed: 'Ni uspelo',
        declined:  'Zavrnjeno',
        already_decided: 'Že odločeno — poskus je prišel prepozno, predlog je bil medtem že obravnavan.',
        title:        'Milo',
        greeting:     'Sem Milo, pomočnik na tvoji recepciji.',
        intro:        'Vprašaj karkoli o hotelu — rezervacije, zasedenost, sobe, gostje, analitika. Milo bere žive podatke; kar bi spremenil, najprej predlaga in ti potrdiš.',
        placeholder:  'Vprašaj …',
        thinking:     'Milo preverja podatke …',
        still_working: 'Milo dela … (lahko traja do minute)',
        failed:       'Milo ni mogel odgovoriti. Poskusi znova.',
        // Neuspel obrat se odslej izriše v niti in ne samo kot obvestilo (§20).
        // Svoj stavek za primer, ko storitve ni — objava, ponovni zagon, prehod, ki
        // odgovori namesto nje —, ker takrat vprašanja ni treba preubesediti, ampak
        // počakati; vsak drug razlog pove strežnik sam (parseError).
        failed_unreachable: 'Milo ni mogel odgovoriti: strežnik trenutno ni dosegljiv — poskusi čez pol minute.',
        failed_timeout:     'Milo je za to vprašanje potreboval predolgo. Vprašaj ožje ali vprašanje razdeli na dva dela.',
        failed_lost:        'Milo je bil med odgovarjanjem prekinjen (posodobitev storitve). Pošlji vprašanje znova.',
        retry:        'Pošlji znova',
        disclaimer:   'Milo bere žive podatke; kar bi spremenil, najprej predlaga in ti potrdiš. Številke preveri na ustreznem zaslonu, preden ukrepaš.',
        example_arrivals:     'Kdo pride jutri?',
        example_availability: 'Koliko sob je prostih ta vikend?',
        example_revenue:      'Kakšen je prihodek ta mesec?',
        waits_for_step:       'čaka na korak {step}',
        step_prepared_below:  'Milo ga pripravlja spodaj',
        continued:            'Korak izveden — Milo nadaljuje z naslednjim.',
        // Krogla v vrstici, predal in zavedanje strani.
        shortcut:       'Alt+J',
        orb_attention:  'Nekaj čaka nate',
        // Nadomestno besedilo posterja, dokler se 3D glava nalaga (MiloHead.vue).
        head_loading:   'Milo se nalaga …',
        open_full:      'Odpri celozaslonsko',
        on_page:        'Na strani: {subject}',
        on_page_hint:   'Milo ve, kaj imaš odprto. Klikni, če vprašanje ni o tem.',
        on_page_drop:   'Odstrani „{subject}“ iz vprašanja',
        // Povezave v odgovoru in v vrstici o izvedbi (libs/linkify.ts).
        copy_link:        'Kopiraj povezavo',
        link_copied:      'Povezava je kopirana.',
        link_copy_failed: 'Kopiranje ni uspelo — povezavo označi in kopiraj ročno.',
    },
    // Kaj je izvedba naredila. Strežnik pošlje kodo in število (ChatOperationOutcome),
    // stavek sestavi zaslon — ker je stavek strežnika angleški revizijski zapis in ne
    // besedilo za recepcijo. Kode brez štetja imajo samo obliko `other`.
    assistant_result: {
        nights_priced: {
            one:   'posodobljena cena za 1 noč',
            other: 'posodobljene cene za {count} noči',
        },
        rooms_closed: {
            one:   'zaprta 1 soba',
            two:   'zaprti {count} sobi',
            few:   'zaprte {count} sobe',
            other: 'zaprtih {count} sob',
        },
        rooms_reopened: {
            one:   'v prodajo vrnjena 1 soba',
            two:   'v prodajo vrnjeni {count} sobi',
            few:   'v prodajo vrnjene {count} sobe',
            other: 'v prodajo vrnjenih {count} sob',
        },
        guests_retagged: {
            one:   'posodobljene oznake pri 1 gostu',
            other: 'posodobljene oznake pri {count} gostih',
        },
        tasks_assigned: {
            one:   'razporejena 1 naloga',
            two:   'razporejeni {count} nalogi',
            few:   'razporejene {count} naloge',
            other: 'razporejenih {count} nalog',
        },
        round_assigned: {
            one:   'razporejena 1 soba',
            two:   'razporejeni {count} sobi',
            few:   'razporejene {count} sobe',
            other: 'razporejenih {count} sob',
        },
        // Ekipe sobaric (§15). Štiri kode in ne ena „ekipa shranjena“, ker mora vrstica
        // povedati, KAJ se je zgodilo: par je nastal, nekdo je prišel, nekdo je odšel,
        // para ni več. Tri od teh spremenijo tudi to, koliko soba stane — faktor gre za
        // velikostjo.
        team_formed: {
            one:   'ekipa ustvarjena z 1 članico — {detail}',
            two:   'ekipa ustvarjena z {count} članicama — {detail}',
            few:   'ekipa ustvarjena s {count} članicami — {detail}',
            other: 'ekipa ustvarjena s {count} članicami — {detail}',
        },
        team_member_added: {
            one:   'ekipi dodana 1 članica — {detail}',
            two:   'ekipi dodani {count} članici — {detail}',
            few:   'ekipi dodane {count} članice — {detail}',
            other: 'ekipi dodanih {count} članic — {detail}',
        },
        team_member_removed: {
            one:   'iz ekipe umaknjena 1 članica — {detail}',
            two:   'iz ekipe umaknjeni {count} članici — {detail}',
            few:   'iz ekipe umaknjene {count} članice — {detail}',
            other: 'iz ekipe umaknjenih {count} članic — {detail}',
        },
        team_changed: {
            one:   'ekipa spremenjena, ostaja 1 članica — {detail}',
            two:   'ekipa spremenjena, ostajata {count} članici — {detail}',
            few:   'ekipa spremenjena, ostajajo {count} članice — {detail}',
            other: 'ekipa spremenjena, ostaja {count} članic — {detail}',
        },
        team_dissolved: {
            other: 'ekipa razpuščena; sobe, ki jih je naredila, jo še naprej navajajo — {detail}',
        },
        stays_moved: {
            one:   'premaknjeno 1 bivanje',
            two:   'premaknjeni {count} bivanji',
            few:   'premaknjena {count} bivanja',
            other: 'premaknjenih {count} bivanj',
        },
        group_hold_moved: {
            other: 'premaknjena držana soba — {detail}',
        },
        group_hold_restructured: {
            other: 'premaknjena držana soba in prestrukturiran blok skupine — {detail}',
        },
        group_hold_released: {
            other: 'sproščena držana soba, dogovorjeno število ostaja — {detail}',
        },
        group_room_picked_up: {
            other: 'prevzeta soba iz skupine — {detail}',
        },
        group_shifted: {
            one:   'zamaknjena skupina, premaknjena 1 soba — {detail}',
            two:   'zamaknjena skupina, premaknjeni {count} sobi — {detail}',
            few:   'zamaknjena skupina, premaknjene {count} sobe — {detail}',
            other: 'zamaknjena skupina, premaknjenih {count} sob — {detail}',
        },
        group_dates_changed: {
            one:   'spremenjen termin skupine, spremenjena 1 soba — {detail}',
            two:   'spremenjen termin skupine, spremenjeni {count} sobi — {detail}',
            few:   'spremenjen termin skupine, spremenjene {count} sobe — {detail}',
            other: 'spremenjen termin skupine, spremenjenih {count} sob — {detail}',
        },
        group_status_changed: {
            other: 'spremenjeno stanje skupine — {detail}',
        },
        // Rooming lista (docs/SKUPINE.md §5). Štiri kode, ker so to štiri različna
        // dejanja: povezava, ki ne rezervira ničesar; vpisani gostje; prevzeti čakajoči
        // vnosi; in počiščeni čakajoči vnosi, pri katerih ni vpisan nihče.
        // Pozdrav gostu s povezavo do portala. Nič ne šteje — eno sporočilo je —
        // in {detail} je zakrita telefonska številka.
        guest_link_sent: {
            other: 'povezava do portala poslana po WhatsAppu — {detail}',
        },
        rooming_link_issued: {
            other: 'rooming povezava izdana — {detail}',
        },
        rooming_entries_written: {
            one:   'v rooming listo vpisan 1 gost — {detail}',
            two:   'v rooming listo vpisana {count} gosta — {detail}',
            few:   'v rooming listo vpisani {count} gostje — {detail}',
            other: 'v rooming listo vpisanih {count} gostov — {detail}',
        },
        rooming_pending_taken: {
            one:   'čakajoči vnosi prevzeti, vpisan 1 gost — {detail}',
            two:   'čakajoči vnosi prevzeti, vpisana {count} gosta — {detail}',
            few:   'čakajoči vnosi prevzeti, vpisani {count} gostje — {detail}',
            other: 'čakajoči vnosi prevzeti, vpisanih {count} gostov — {detail}',
        },
        rooming_pending_cleared: {
            one:   'počiščen 1 čakajoči vnos, vpisan ni nihče — {detail}',
            two:   'počiščena {count} čakajoča vnosa, vpisan ni nihče — {detail}',
            few:   'počiščeni {count} čakajoči vnosi, vpisan ni nihče — {detail}',
            other: 'počiščenih {count} čakajočih vnosov, vpisan ni nihče — {detail}',
        },
        mappings_saved: {
            one:   'shranjena 1 preslikava',
            two:   'shranjeni {count} preslikavi',
            few:   'shranjene {count} preslikave',
            other: 'shranjenih {count} preslikav',
        },
        program_proposed: {
            one:   'predlagana 1 točka programa za {detail}',
            two:   'predlagani {count} točki programa za {detail}',
            few:   'predlagane {count} točke programa za {detail}',
            other: 'predlaganih {count} točk programa za {detail}',
        },
        display_config_saved: {
            other: 'shranjena nastavitev sobnih zaslonov (revizija {detail})',
        },
        channel_linked: {
            other: 'rezervacija kanala povezana z obstoječo — {detail}',
        },
        channel_placed: {
            other: 'ustvarjena rezervacija {detail}',
        },
        channel_replayed: {
            other: 'rezervacija {detail} je nastala že ob prejšnji potrditvi; nova ni bila ustvarjena',
        },
        full_sync_accepted: {
            other: 'polna sinhronizacija ({detail}) je sprejeta in teče v ozadju',
        },
        comfort_confirmed: {
            other: 'oprema je potrdila — soba {detail}',
        },
        comfort_sent: {
            other: 'ukaz poslan sobi {detail}; oprema ga še ni potrdila',
        },
        comfort_unconfirmed: {
            other: 'ukaz je odšel in NI potrjen — {detail}',
        },
        issue_reported: {
            other: 'ustvarjen nalog za vzdrževanje — {detail}',
        },
        issue_appended: {
            other: 'dopolnjen obstoječi nalog »{detail}«; nov ni bil ustvarjen',
        },
        issue_already_added: {
            other: 'nalog »{detail}« je to dopolnilo že imel; dopisano ni bilo nič',
        },
        message_sent: {
            other: 'poslano na {detail}',
        },
        checked_in: {
            one:   'prijavljena 1 soba',
            two:   'prijavljeni {count} sobi',
            few:   'prijavljene {count} sobe',
            other: 'prijavljenih {count} sob',
        },
        checked_out: {
            one:   'zaključen obračun in odjavljena 1 soba',
            two:   'zaključen obračun in odjavljeni {count} sobi',
            few:   'zaključen obračun in odjavljene {count} sobe',
            other: 'zaključen obračun in odjavljenih {count} sob',
        },
        room_prioritised: {
            other: 'soba {detail} je na vrhu današnjega kroga',
        },
        room_released: {
            other: 'soba {detail} je sproščena za čiščenje',
        },
        reservation_created: {
            other: 'ustvarjena rezervacija — {detail}',
        },
        offer_created: {
            one:   'ustvarjena ponudba za 1 sobo — {detail}',
            two:   'ustvarjena ponudba za {count} sobi — {detail}',
            few:   'ustvarjena ponudba za {count} sobe — {detail}',
            other: 'ustvarjena ponudba za {count} sob — {detail}',
        },
        offer_sent: {
            other: 'ponudba poslana — {detail}',
        },
        // Dve kodi in ne ena: „shranjeno“ nad zapisom, ki je že obstajal, skrije edino
        // stvar, ki je vredna branja — ali ima hiša odslej DRUGI račun za isto pravno
        // osebo ali ne. Popravek šteje polja in ne stvari, zato ima samo obliko other.
        company_created: {
            other: 'odprt poslovni partner — {detail}',
        },
        company_updated: {
            other: 'popravljen poslovni partner — {detail}',
        },
        // Šteje POLJA in ne stvari — „spremenjeni 2 polji“ — ker je popravek kartice
        // gosta lahko en telefon ali pol kartoteke, in tisti, ki bere nit teden
        // pozneje, hoče vedeti, koliko se je premaknilo. Ime gosta je v {detail}.
        guest_updated: {
            one:   'popravljena kartica gosta — spremenjeno 1 polje · {detail}',
            two:   'popravljena kartica gosta — spremenjeni {count} polji · {detail}',
            few:   'popravljena kartica gosta — spremenjena {count} polja · {detail}',
            other: 'popravljena kartica gosta — spremenjenih {count} polj · {detail}',
        },
        // Popust ima DVE kodi in to je vsa vsebina odgovora: znotraj meje je denar že
        // odbit, nad njo ni odbito NIČ in zahtevek čaka. Ena poved za oboje bi bila
        // cena, ki jo recepcija pove gostu, hiša pa se z njo še ni strinjala.
        discount_applied: {
            other: 'popust odbit — {detail}',
        },
        discount_pending: {
            other: 'zahtevek za popust čaka odobritev; z računa ni odbito nič — {detail}',
        },
        line_removed: {
            other: 'postavka umaknjena (storno) — {detail}',
        },
        line_moved: {
            other: 'postavka prenesena v celoti — {detail}',
        },
        line_split: {
            other: 'postavka razdeljena — {detail}',
        },
        overpayment_refunded: {
            other: 'preplačilo vrnjeno — {detail}',
        },
        payment_transferred: {
            other: 'plačilo preneseno med karticama; hiša ni izplačala ničesar — {detail}',
        },
        absence_approved: {
            one:   'odsotnost odobrena — v evidenco zapisan 1 dan · {detail}',
            two:   'odsotnost odobrena — v evidenco zapisana {count} dneva · {detail}',
            few:   'odsotnost odobrena — v evidenco zapisani {count} dnevi · {detail}',
            other: 'odsotnost odobrena — v evidenco zapisanih {count} dni · {detail}',
        },
        absence_rejected: {
            other: 'odsotnost zavrnjena; v evidenco ni bil zapisan noben dan — {detail}',
        },
        correction_approved: {
            other: 'popravek evidence odobren — {detail}; prvotni vpis je označen kot popravljen',
        },
        correction_rejected: {
            other: 'popravek evidence zavrnjen; evidenca ostaja nespremenjena — {detail}',
        },
        notice_queued: {
            other: 'sporočilo uvrščeno v vrsto — {detail}',
        },
        shift_changed: {
            other: 'turnus premaknjen — {detail}',
        },
        // Dogodki (WP-E11). Trinajst kod in ne ena „dogodek shranjen“, ker vrstica pove,
        // KAJ je pritisk naredil — in ker se dve od njih ločita v pogodbi: načrtovano
        // število je navaden popravek, zajamčeno pa nova zamrznjena različica. Kadar
        // ŠTEJEJO, štejejo tisto, kar je vredno brati: različico, glavarino, znesek —
        // ista izbira kot pri `month_closed`, ker „zamrznjeno“ ne pove ničesar, s čimer
        // bi kdo lahko kaj naredil.
        event_created: {
            one:   'ustvarjen dogodek z 1 delom programa — {detail}',
            two:   'ustvarjen dogodek z {count} deloma programa — {detail}',
            few:   'ustvarjen dogodek s {count} deli programa — {detail}',
            other: 'ustvarjen dogodek s {count} deli programa — {detail}',
        },
        event_part_added: {
            other: 'dodan del programa in prevzeti prostori — {detail}',
        },
        event_part_moved: {
            other: 'del programa premaknjen skupaj s prostori — {detail}',
        },
        // Šteje GLAVARINO in ne dejanj: „nastavljeno na 95“ je tisto, kar bralec niti
        // teden pozneje ne rabi iskati. {detail} pove različico, kadar je šlo za
        // zajamčeno število in je zato nastala nova.
        event_headcount_set: {
            other: 'glavarina nastavljena na {count} — {detail}',
        },
        // Šteje ŠTEVILKO RAZLIČICE, iz razloga, iz katerega `month_closed` šteje mesec.
        event_version_frozen: {
            other: 'zamrznjena različica {count} — vsa potrditve oddelkov so ponastavljene · {detail}',
        },
        event_shifted: {
            one:   'dogodek zamaknjen, s prostori premaknjen 1 del programa — {detail}',
            two:   'dogodek zamaknjen, s prostori premaknjena {count} dela programa — {detail}',
            few:   'dogodek zamaknjen, s prostori premaknjeni {count} deli programa — {detail}',
            other: 'dogodek zamaknjen, s prostori premaknjenih {count} delov programa — {detail}',
        },
        event_status_changed: {
            other: 'dogodek prestavljen v stanje {detail}',
        },
        event_lost: {
            other: 'dogodek zabeležen kot izgubljen — razlog: {detail}',
        },
        // Šteje ZNESEK, ki ga je lestvica zaračunala, v centih; {detail} je odstotek.
        // Odpoved brez zneska je edino, česar recepcija ne sme brati kot „urejeno“.
        event_cancelled: {
            other: 'dogodek odpovedan, lestvica je zaračunala {count} (v centih) — {detail}',
        },
        event_task_opened: {
            other: 'odprta naloga na dogodku — {detail}',
        },
        event_catering_set: {
            one:   'zapisana 1 postavka hrane in pijače — {detail}',
            two:   'zapisani {count} postavki hrane in pijače — {detail}',
            few:   'zapisane {count} postavke hrane in pijače — {detail}',
            other: 'zapisanih {count} postavk hrane in pijače — {detail}',
        },
        // Šteje RAZLIČICO, nad katero je bila povezava izdana; {detail} je naslov, ki je
        // ves smisel dejanja — izdaja brez naslova bi poslala nekoga na zaslon po njem.
        event_offer_issued: {
            other: 'izdana povezava do ponudbe nad različico {count}; nič ni bilo poslano — {detail}',
        },
        event_offer_sent: {
            one:   'ponudba poslana 1 naslovniku — {detail}',
            two:   'ponudba poslana {count} naslovnikoma — {detail}',
            few:   'ponudba poslana {count} naslovnikom — {detail}',
            other: 'ponudba poslana {count} naslovnikom — {detail}',
        },
        // Materialno poslovanje (WP-M8, docs/AI.md §34). Šest kod in ne ena „shranjeno“,
        // iz razloga, iz katerega jih ima dogodek trinajst: vrstica pove, KAJ je pritisk
        // naredil. Odobritev in zavrnitev sta dve kodi, ker je „odločeno“ nad zavrnjenim
        // zahtevkom vrstica, po kateri kdo ravna narobe.
        requisition_raised: {
            one:   'zahtevek z 1 postavko — {detail}',
            two:   'zahtevek z {count} postavkama — {detail}',
            few:   'zahtevek s {count} postavkami — {detail}',
            other: 'zahtevek s {count} postavkami — {detail}',
        },
        requisition_approved: {
            other: 'zahtevek odobren — {detail}',
        },
        requisition_rejected: {
            other: 'zahtevek zavrnjen — {detail}',
        },
        // Šteje NAROČILNICE in ne postavk: iz enega zahtevka nastane eno pismo na
        // dobavitelja, {detail} pa nosi njihove številke in artikle brez dobavitelja —
        // torej tiste, ki jih mora zdaj kdo kupiti ročno.
        orders_raised: {
            one:   'nastala 1 naročilnica — {detail}',
            two:   'nastali {count} naročilnici — {detail}',
            few:   'nastale {count} naročilnice — {detail}',
            other: 'nastalo {count} naročilnic — {detail}',
        },
        // ODPRTA in ne „začeta“: posnetek, proti kateremu se meri vsako odstopanje,
        // naredi šele gumb Začni na zaslonu Inventura.
        count_opened: {
            one:   'odprta inventura za 1 skladišče; posnetek še ni narejen — {detail}',
            two:   'odprta inventura za {count} skladišči; posnetek še ni narejen — {detail}',
            few:   'odprta inventura za {count} skladišča; posnetek še ni narejen — {detail}',
            other: 'odprta inventura za {count} skladišč; posnetek še ni narejen — {detail}',
        },
        // Šteje račune, ki so DEJANSKO odšli — ne vseh v obdobju. {detail} nosi osnutke,
        // preskočene in zavrnitve: „poslano 0“ nad petimi zavrnitvami je resničen stavek,
        // ki skrije edino, kar kdo rabi.
        ap_export_sent: {
            one:   'knjigovodji poslan 1 račun kot osnutek — {detail}',
            two:   'knjigovodji poslana {count} računa kot osnutka — {detail}',
            few:   'knjigovodji poslani {count} računi kot osnutki — {detail}',
            other: 'knjigovodji poslanih {count} računov kot osnutkov — {detail}',
        },
    },
    mail_import: {
        button:       'Uvozi iz e-pošte',
        title:        'Uvoz rezervacije iz e-pošte',
        placeholder:  'Prilepi besedilo e-pošte …',
        drop_hint:      'Ali povleci datoteko .eml, .msg oziroma .txt sem.',
        decoding:       'Berem datoteko …',
        decode_failed:  'Datoteke ni bilo mogoče prebrati.',
        mail_from:      'Od',
        mail_to:        'Za',
        mail_subject:   'Zadeva',
        mail_date:      'Datum',
        parse:        'Razčleni',
        parse_failed: 'E-pošte ni bilo mogoče razčleniti.',
        concerns:     'Preveri pred potrditvijo',
        guest:        'Gost',
        contact:      'Kontakt',
        party:        'Zasedba',
        adults:       'odr.',
        children:     'otrok',
        rooms:        'sob',
        room_wish:    'Želena soba',
        company:      'Podjetje',
        notes:        'Opombe',
        known_guest:  'Gost s tem e-naslovom že obstaja v knjigi — rezervacija se bo pripela nanj.',
        confirm_note: 'Nič še ni rezervirano. Odpre se obrazec za novo rezervacijo, predizpolnjen iz e-pošte — preveri, popravi in potrdi.',
        back:         'Nazaj',
        prepare:      'Pripravi rezervacijo',
        guest_failed: 'Gosta ni bilo mogoče ustvariti.',
        wishes:            'Želje poleg sobe',
        wish_daily:        'po dnevih — označi se na obrazcu',
        wish_appointment:  'termin — naroči v Storitvah',
        wish_unknown:      'ni v ponudbi hotela',
        attentions:        'Stalne posebnosti gosta',
        attentions_hint:   'Velja za gosta in ne za to rezervacijo: zapiše se na njegov folio in ga spremlja tudi ob naslednjem bivanju. Kljukico odstrani le, če je bilo prebrano narobe.',
        attentions_failed: 'Posebnosti ni bilo mogoče zapisati na folio gosta — rezervacija je pripravljena, posebnosti vpiši ročno.',
    },
    booking_settings: {
        payment_mode: 'Spletno plačilo',
        payment_mode_hint: 'Ali gost plača s kartico že ob rezervaciji.',
        payment_off: 'Izklopljeno — plačilo ob prihodu',
        payment_optional: 'Neobvezno — gost lahko plača takoj',
        payment_required: 'Obvezno — plačilo pred prihodom',
        prepayment_percent: 'Delež predplačila (%)',
        prepayment_percent_hint: '100 pomeni celoten znesek bivanja. Ostanek gost poravna na recepciji.',
        required_note: 'Rezervacija nastane in drži sobo tudi, če gost ne plača — dobi le oznako »čaka plačilo«. Nič je ne izbriše samodejno; odločitev je vaša.',
        tab: 'Splet',
        title: 'Spletno rezerviranje',
        hint: 'Kaj hotel prodaja na svoji spletni strani. Prodaja se obstoječi šifrant — tipi sob, opisi, fotografije in ceniki, ki jih že vzdržujete; tu se odloči le, kaj je na voljo in pod kakšnimi pogoji.',
        enabled: 'Sprejemaj spletne rezervacije',
        enabled_hint: 'Dokler je izklopljeno, hotel na spletu ni dosegljiv — javna stran ga ne pozna.',
        no_plan_title: 'Ni cenika za prodajo',
        no_plan_hint: 'Izberite vsaj en cenik ali enega označite kot privzetega. Brez tega spletna stran ne bo ponudila nobene sobe.',
        rate_plans: 'Ceniki za splet',
        rate_plans_hint: 'Vsak cenik proda samo tipe sob, ki jih pokriva. Ista soba na dveh cenikih se na strani pokaže dvakrat — z zajtrkom in brez sta dve različni ponudbi.',
        rate_plans_default: 'Privzeti cenik hotela',
        on_sale: 'Na spletu bo na voljo',
        all_types: 'vsi tipi sob',
        uncovered: 'Brez cenika in torej ne na spletu: {types}',
        max_nights: 'Najdaljše bivanje (noči)',
        max_nights_hint: '0 pomeni privzeto (21 noči).',
        terms: 'Pogoji hotela',
        terms_hint: 'Gost jih potrdi pred oddajo rezervacije, prejme pa jih tudi v potrditvenem e-sporočilu.',
        terms_placeholder: 'Npr. plačilo ob prihodu na recepciji. Brezplačna odpoved do 3 dni pred prihodom. Prijava od 14.00, odjava do 10.00. Turistična taksa ni vključena v ceno.',
        terms_default_required: 'Pogoji morajo biti napisani vsaj v osnovnem jeziku hotela ({language}).',
        live_title: 'Hotel sprejema spletne rezervacije',
        live_hint: 'Rezervacije s spleta pridejo v recepcijo kot običajne rezervacije z virom Splet.',
    },
    res_rooming: {
        button: 'Vnos gostov',
        title: 'Vnos gostov (sopotniki)',
        link_title: 'Povezava za gosta',
        link_hint: 'Gost prek te povezave vpiše sopotnike z vsemi podatki za prijavo. Povezava velja do dneva po prihodu; nova povezava razveljavi prejšnjo. Vpis prek nje ničesar ne rezervira.',
        issue: 'Izdaj povezavo',
        reissue: 'Izdaj novo',
        copy: 'Kopiraj',
        copied: 'Povezava je kopirana.',
        expires: 'Velja do {date}',
        pending_title: 'Vpisani, čakajo na potrditev',
        check: 'Preveri nove vnose',
        no_pending: 'Gost še ni vpisal nikogar.',
        pick_stay: 'Izberi bivanje',
        unassigned: 'Nerazporejen',
        commit: 'Potrdi in dodaj ({count})',
        commit_note: 'Potrditev doda osebe na bivanja in ustvari manjkajoče profile gostov. Dokument, ki ga je vpisal gost, ostane nepreverjen — na recepciji ga ob prihodu preverite z izvirnikom.',
        discard: 'Zavrzi seznam',
        added: 'dodanih: {count}',
        overfilled: 'V eno od sob ste razporedili več oseb, kot je bilo rezerviranih. Popravite razporeditev.',
    },
    shift_history: {
        title: 'Zgodovina izmen',
        lead: 'Kdaj je bila blagajna odprta, kdo jo je vodil, kaj je bilo v predalu in za koliko se je razlikovalo od pričakovanega.',
        till: 'Blagajna',
        all_tills: 'Vse blagajne',
        empty: 'V izbranem obdobju ni izmen.',
        open: 'Odprta',
        closed: 'zaključena',
        counted: 'prešteto',
        balanced: 'Se ujema',
        opening_float: 'Začetni polog',
        cash_sales: 'Gotovinska prodaja',
        cash_refunds: 'Vračila v gotovini',
        pay_ins: 'Vplačila',
        pay_outs: 'Izplačila',
        expected: 'Pričakovano v predalu',
        card_sales: 'Kartično',
        room_sales: 'Na sobo',
        movements: 'Vplačila in izplačila',
        pay_in: 'Vplačilo',
        pay_out: 'Izplačilo',
        variance_reason: 'Razlog razlike',
        print: 'Natisni',
    },
    forecast: {
        title: 'Napoved po dnevih',
        lead: 'Prihodi in odhodi, število spečih gostov in predvideni obroki za dneve naprej. Šteje potrjene, prijavljene in odjavljene rezervacije; preklicanih in neprihodov ne.',
        window: 'Obdobje',
        days: 'Naslednjih {count} dni',
        empty: 'V izbranem obdobju ni rezervacij.',
        turnover: 'Prihodi in odhodi',
        arrivals: 'Prihodi',
        departures: 'Odhodi',
        guests: 'Nočitve — osebe na noč',
        guests_series: 'Osebe',
        meals: 'Obroki po tipih',
        breakfast: 'Zajtrk',
        lunch: 'Kosilo',
        dinner: 'Večerja',
        no_board: 'Noben cenik v tem obdobju nima zapisanega penziona, zato obrokov ni mogoče napovedati. Penzion se nastavi na ceniku (Prodaja in gostje → Ceniki).',
        drill_hint: 'Klikni stolpec ali številko pod njim za seznam rezervacij za tisti dan.',
        drill_turnover: 'Prihodi in odhodi tega dne',
        drill_guests: 'Bivanja to noč',
        drill_meals: 'Obroki tega dne po rezervacijah',
        drill_empty: 'Za ta dan ni zapisov.',
        drill_no_guest: 'Gost še ni določen',
        drill_people: '{count} oseb',
    },
    reservation_source: {
        email:   'E-pošta',
        direct:  'Neposredno',
        web:     'Splet',
        phone:   'Telefon',
        walk_in: 'Walk-in',
        ota:     'OTA',
        agency:  'Agencija',
        corporate: 'Podjetje',
        group:   'Skupina',
    },
    check_in: {
        action: 'Prijava',
        action_hint: 'Prijavi gosta — odpre postopek prijave in prijavo v evidenco.',
        several_rooms: 'Rezervacija ima več sob; prijava se opravi po sobah v rezervaciji.',
        title:                        'Prijava gostov',
        deadline:                     'Prijavo je treba oddati najpozneje 12 ur po prihodu gosta.',
        submit:                       'Prijavi in poročaj',
        submit_without_reporting:     'Prijavi brez poročanja',
        submit_partial:               'Prijavi {count} od {total} gostov',
        register_now:                 'Prijavi zdaj',
        arrives_later_hint:           'Pride pozneje — ta gost zdaj ne bo prijavljen in ostane na bivanju kot neprispel.',
        nobody_arriving:              'Nihče ni označen za prijavo. Označi vsaj enega gosta, ki je prišel.',
        register_remaining:           'Prijavi preostale ({count})',
        registered:                   'Prijavljen',
        not_registered_yet:           'Še ni prijavljen',
        result_room_partial:          'Soba je prijavljena. Še ni prijavljenih: {count}.',
        result_guest_later:           'Pride pozneje. Ni prijavljen in ostane na bivanju kot neprispel — prijavi ga, ko pride.',
        check_in_failed:              'Sobe ni bilo mogoče prijaviti. Noben gost ni bil vložen v poročanje.',
        no_guests:                    'Na tem bivanju ni gostov. Dodaj jih pri bivanju, preden sobo prijaviš.',
        reporting_note:               'Prijava sobe je dejstvo na recepciji in se izvede takoj. Poročanje v eTurizem gre v vrsto — oddajo izvede sistem v ozadju in jo po potrebi ponovi.',
        reporting_incomplete:         'Ti gostje ne bodo vloženi v poročanje',
        reporting_not_set_up:         'Poročanje v eTurizem še ni vzpostavljeno',
        reporting_not_set_up_note:    'Soba se prijavi in prijava se shrani, oddaje v eTurizem pa ta strežnik ne izvede — čaka na dostop AJPES. Ko bo urejen, sistem odda shranjene prijave sam.',
        result_room:                  'Soba je prijavljena.',
        result_filed:                 'V poročanje je vloženih {filed} od {total} gostov.',
        result_guest_filed:           'Vloženo v poročanje. Oddajo v eTurizem izvede sistem v ozadju in jo po potrebi ponovi.',
        result_guest_already_filed:   'Za to bivanje je gost že vložen v poročanje; drugič se ne vloži.',
        result_guest_failed:          'Prijava ni bila ustvarjena, zato se poročanje za tega gosta ni začelo. Popravi podatke in poskusi znova — rok je 12 ur po prihodu.',
        result_guest_skipped:         'Ni vloženo v poročanje, ker podatki niso popolni. Gost je prijavljen v sobo.',
        ready:                        'Podatki za poročanje so popolni',
        incomplete:                   'Manjka: {fields}',
        complete:                     'Dopolni',
        hide:                         'Skrij',
        sex:                          'Spol',
        sex_male:                     'Moški',
        sex_female:                   'Ženski',
        sex_unknown:                  'Ni naveden',
        sex_unknown_hint:             'Spola „ni naveden“ eTurizem ne sprejme — dovoljena sta samo M in F. Gost bo prijavljen v sobo, v eTurizem pa ne.',
        mrz:                          'Strojno berljivi zapis (MRZ)',
        mrz_hint:                     'Klikni v polje in potegni dokument skozi čitalnik ali prepiši vrstice z dna dokumenta: potni list ima dve vrstici po 44 znakov, osebna izkaznica tri po 30.',
        mrz_placeholder:              'P<SVNNOVAK<<JANEZ<<<<<<<<<<<<<<<<<<<<<<<<<<<',
        mrz_applied:                  'Podatki so prevzeti z dokumenta ({format}). Kontrolne števke se ujemajo.',
        mrz_applied_unverified:       'Podatki so prevzeti kljub neujemajočim kontrolnim števkam. Preveri jih z dokumentom v roki.',
        printed_applied: 'Izpolnjeno s sprednje strani dokumenta — ni preverjeno s kontrolnimi števkami.',
        chip_applied: 'Izpolnjeno iz čipa dokumenta — podpisano.',
        mrz_apply_anyway:             'Vseeno prevzemi',
        holder_mismatch_title: 'Dokument ni od te osebe',
        holder_mismatch_hint: 'Na dokumentu je {document}, ta kartica pa je za gosta {guest}. V polja ni bilo prepisano nič. Preveri, ali je bil odčitan pravi dokument.',
        holder_mismatch_clear: 'Zavrzi branje',
        holder_mismatch_apply: 'Vseeno uporabi za tega gosta',
        mrz_clear:                    'Počisti zapis',
        mrz_check_failed:             'Kontrolne števke se ne ujemajo: {fields}',
        mrz_check_failed_hint:        'Dokument je bil verjetno napačno prebran, zato podatki niso prevzeti. Prebrano: {read}. Poskusi znova ali vpiši podatke ročno.',
        mrz_check_document_number:    'številka dokumenta',
        mrz_check_date_of_birth:      'datum rojstva',
        mrz_check_expiry:             'datum veljavnosti',
        mrz_check_composite:          'skupna kontrolna števka',
        mrz_error_empty:              'Zapis je prazen. Preberi dokument s čitalnikom ali prepiši vrstice z dna dokumenta.',
        mrz_error_unsupported_format: 'Zapisa ni mogoče prebrati. Podprta sta potni list (2 × 44 znakov) in osebna izkaznica (3 × 30 znakov).',
        mrz_error_invalid_characters: 'Zapis vsebuje znake, ki jih v MRZ ni. Preberi dokument znova.',
        mrz_unknown_country:          'Kode države „{code}“ ni v šifrantu ISO — državljanstvo izberi ročno.',
        document_valid_until:         'Dokument velja do {date}.',
        document_expired:             'Dokument je potekel {date}.',
    },
    check_out: {
        action_hint: 'Odjavi gosta — odpre obračun z zneskom za plačilo.',
        result_owed: 'Odšlo z odprtim saldom {amount}',
        result_owed_hint: 'Znesek ostaja na foliu in je zapisan pri rezervaciji. Račun se lahko poravna tudi po odhodu.',
        open_card_hint:             'Vse postavke in plačila tega folia.',
        back_to_checkout:           'Nazaj na zaključek bivanja',
        step_bill:        'Preveri končni obračun',
        step_pay:         'Prejmi plačilo in izdaj račun',
        add_charge:       'Dodaj postavko',
        take_payment:     'Sprejmi plačilo',
        step_confirm_issue: 'Potrdi obračun in izdaj račun',
        step_confirm_a:   '2a · Potrdi obračun',
        step_confirm_b:   '2b · Kartice: plačilo in račun',
        order_title:      'Vrstni red',
        order_hint:       '1. Potrdi obračun · 2. Sprejmi plačila po karticah · 3. Izdaj račune · 4. Odjavi goste.',
        separate_folio:   'Ločen folio',
        per_folio_hint:   'Vsak folio je ločen račun — zaključi ga s svojim plačilom in izdajo računa.',
        pay_all:          'Sprejmi plačilo za celoten saldo · {amount}',
        pay_all_title:    'Plačilo celotnega salda',
        pay_all_total:    'Za plačilo skupaj',
        pay_all_folios:   'Poplača {count} odprtih folijev, vsakega z njegovim saldom.',
        pay_all_confirm:  'Evidentiraj plačilo za vse',
        pay_all_done:     'Celoten saldo je poravnan.',
        pay_all_failed:   'Nekaterih folijev ni bilo mogoče poravnati — preveri odprte.',
        confirm_and_issue: 'Potrdi obračun in izdaj račun · {amount}',
        confirmed_issued: 'Obračun potrjen in račun izdan.',
        step_depart:      'Odjavi goste',
        finalize:         'Potrdi obračun · {amount}',
        finalized:        'Obračun je potrjen — postavke se ujemajo z obračunom',
        finalize_failed:  'Obračuna ni bilo mogoče potrditi',
        finalize_done_hint:      'Obračun je potrjen. Naslednji korak je izdaja računa na vsaki kartici.',
        finalize_no_permission:  'Za potrditev obračuna je potrebna pravica za knjiženje na folio.',
        issue_needs_finalize:    'Najprej potrdi obračun.',
        bill_accommodation: 'Nastanitev',
        bill_nights_count:  'nočitve: {count}',
        bill_breakdown:     'Razčleni',
        bill_collapse:      'Skrij',
        bill_night:         'noč',
        bill_tax_sub:       'gostje: {guests} · nočitve: {nights}',
        bill_footer_rate:   'DDV {rate} %: osnova {base} · DDV {tax}',
        bill_footer_exempt: 'Turistična taksa ni predmet DDV',
        bill_tourist_tax:   'Turistična taksa',
        bill_tax_nights:    'Noči',
        bill_tax_unnamed:   'Neimenovan gost',
        tax_routing:        'Turistična taksa ob potrditvi',
        tax_routing_hint:   'Turistična taksa se ob potrditvi knjiži na izbrani folio. Izbira velja samo do prve knjižbe — potem se denar prenaša med folii.',
        tax_routing_to:     'Knjiži se na: {folio}',
        tax_routing_posted: 'Že knjiženo na: {folio}',
        tax_routing_group:  'Takso plača skupina — knjiži se na folio skupine po njenih pravilih razporejanja.',
        projected_balance:   'Po knjiženju',
        pending_tourist_tax: 'taksa {amount}',
        pending_nights:      'nočitve {amount}',
        remaining_due:      '{amount} na {folio}',
        remaining_overpaid: 'preplačilo {amount} na {folio}',
        action:                     'Odjava',
        title:                      'Zaključi bivanje',
        departure_on:               'odhod {date}',
        guests_registered:          'Prijavljeni gostje: {count}',
        summary:                    'Povzetek',
        summary_services:           'Druge storitve',
        summary_total:              'Skupaj',
        summary_paid:               'Že plačano',
        aside_note:                 'Obračun najprej potrdiš, nato evidentiraš plačilo in izdaš račun. Odjava je mogoča tudi z odprtim saldom — ta se zabeleži na rezervaciji.',
        ready_title:                'Pripravljeno za odhod',
        ready_owing_title:          'Odprt saldo',
        ready_hint:                 'Saldo je poravnan · gostje bodo odjavljeni.',
        ready_uninvoiced_hint:      'Saldo je poravnan · folijev brez izdanega računa: {count} · gostje bodo odjavljeni.',
        ready_owing_hint:           'Odprti znesek ob odjavi ostane zabeležen na rezervaciji in se lahko poravna tudi kasneje.',
        owed:                       'Še za plačilo',
        balance_all_cards:          'Saldo vseh folijev',
        receivable:                 'Terjatev',
        receivable_hint:            'Folio podjetja s plačilnim rokom {days} dni. To je terjatev in ne neplačan račun, zato odhoda ne zadržuje.',
        invoiced:                   'Račun izdan',
        not_invoiced:               'Brez računa',
        open_card:                  'Odpri folio',
        no_cards:                   'Rezervacija nima folia',
        no_cards_hint:              'Nič ni zaračunano in nič plačano. Preveri, ali je bilo bivanje sploh preneseno na folio, preden gost odide.',
        open_items:                 'Odprto',
        no_open_items:              'Drugega ni odprtega.',
        registrations_hint:         'Njihova odjava se v eTurizem vloži v ozadju kot del te odjave. Na nič se ne čaka.',
        rooms_leaving:              'Sobe, ki odhajajo',
        no_rooms:                   'Nobena soba te rezervacije ni v hotelu',
        already_out:                'Gost je bil odjavljen {at} — bivanje je zaključeno.',
        no_rooms_hint:              'Vse sobe so že odjavljene ali pa nobena ni bila prijavljena. Odjaviti ni česa.',
        blocked_title:              'Odjava je zavrnjena — za plačilo je še {amount}',
        blocked_hint:               'Sprejmi plačilo na foliu ali, če hotel gosta vseeno spusti, uporabi odjavo brez plačila spodaj. Foliji podjetij s plačilnim rokom se sem ne štejejo.',
        blocked_hint_no_override:   'Sprejmi plačilo na foliu. Za odjavo z dolgom je potrebna pravica, ki je ta uporabnik nima — prosi nekoga, ki jo ima. Foliji podjetij s plačilnim rokom se sem ne štejejo.',
        blocked_button:             'Odjava ni mogoča — dolg {amount}',
        submit:                     'Odjavi goste in zaključi bivanje',
        done:                       'Rezervacija je odjavljena',
        refused:                    'Odjava je bila zavrnjena: za plačilo je še {amount}.',
        refused_override:           'Ta uporabnik ne sme odjaviti rezervacije z dolgom ali pa je manjkal razlog. Nič ni bilo odjavljeno.',
        failed:                     'Odjave ni bilo mogoče izvesti',
        override_open:              'Odjavi brez plačila',
        override_title:             'Odjava brez plačila',
        override_hint:              'Hotel spušča to rezervacijo z dolgom {amount}. To se skupaj z zneskom in tvojim imenom zapiše na rezervacijo in tam tudi ostane.',
        override_reason:            'Razlog',
        override_reason_hint:       'Napiši ga za tistega, ki bo čez mesec dni vprašal, zakaj je ta rezervacija odšla brez plačila.',
        override_reason_placeholder: 'Dogovorjeno z vodjo, podjetje plača po povzetju …',
        override_reason_too_long:   'Razlog je predolg — zapiši ga v stavku ali dveh.',
        override_submit:            'Odjavi kljub dolgu {amount}',
        result_title:               'Odjavljenih sob: {done} od {total}',
        result_all:                 'Vse sobe iz te rezervacije so sproščene.',
        result_partial:             'Nekatere sobe niso sproščene. Te so še v hotelu.',
        result_checked_out:         'Odjavljeno',
        result_failed:              'Ni odjavljeno',
        result_failed_hint:         'Soba je še v hotelu. Odpravi vzrok in rezervacijo odjavi znova.',
        result_nights:              'Ob odhodu zaračunanih noči: {count}',
        result_registrations:       'Vloženih odjav v eTurizem: {count}',
        result_housekeeping:        'Sobe so pripravljene za urejanje.',
        result_overridden:          'Rezervacija je odšla z dolgom',
        result_overridden_hint:     'Odjava brez plačila je z zneskom in razlogom zapisana med opombami rezervacije.',

        // Predplačila: kaj je gost že plačal in koliko bo zato račun.
        advance_line:          'Predplačilo {number} — {amount}',
        invoice_after_advance: 'Račun bo znašal {invoice} (storitev {service} − predplačilo {advance}).',
    },
    device: {
        app_version: 'aplikacija {version}',
        outdated: 'zastarela',
        expected: 'Pričakovana različica aplikacije: {version}.',
        ask_update: 'Prosi za nadgradnjo',
        ask_update_hint: 'Na telefon pošlje prošnjo za nadgradnjo na {version}. Namestiti jo mora oseba, ki telefon drži.',
        ask_update_failed: 'Prošnje za nadgradnjo ni bilo mogoče poslati.',
        update_asked: 'Prošnja za nadgradnjo je poslana na {name}.',
        event_update_asked: 'Prošnja za nadgradnjo: {from} → {to}',
        online: 'na zvezi',
        reads: 'prebranih dokumentov: {count}',
        history: 'Zgodovina naprave',
        history_empty: 'Za to napravo še ni zapisanih dogodkov.',
        event_paired: 'Povezana ({desk})',
        event_revoked: 'Preklicana',
        event_restored: 'Obnovljena',
        event_renamed: 'Preimenovana: {from} → {to}',
        event_moved: 'Premaknjena: {from} → {to}',
        desk: 'Recepcija',
        desk_hint: 'Telefon se ponudi ob polju samo na tisti recepciji, kjer leži.',
        desk_this: 'Ta recepcija (ta računalnik)',
        desk_all: 'Vse recepcije',
        desk_other: 'Druga recepcija (pusti, kjer je)',
        this_desk: 'ta recepcija',
        other_desk: 'druga recepcija',
        whole_house: 'vse recepcije',
        name: 'Ime naprave',
        name_hint: 'Kar piše na gumbu na recepciji, ko pošlješ dokument na ta telefon.',
        name_placeholder: 'Glavna recepcija — iPhone 1',
        rename: 'Preimenuj napravo',
        paired: 'Telefon „{name}“ je povezan.',
        tab: 'Naprave',
        title: 'Naprave za skeniranje',
        hint: 'Telefoni, ki berejo dokumente gostov za ta hotel. Povežeš jih enkrat, potem pa recepcija dokument pošlje nanje z enim klikom.',
        pair: 'Poveži telefon',
        pair_steps: 'V aplikaciji izberi „Poveži s PMS" in poslikaj to kodo.',
        pair_expires: 'Koda velja {minutes} minut.',
        empty: 'Ta hotel še nima povezanega telefona.',
        last_seen: 'nazadnje: {when}',
        revoked: 'Preklican',
        revoke: 'Prekliči napravo',
        restore: 'Znova omogoči',
        confirm_revoke: 'Prekličem napravo „{name}"? Telefon takoj izgubi dostop do dokumentov tega hotela.',
        send_to: 'Pošlji na povezan telefon',
        called: 'Poslano na {name} — telefon naj prisloni dokument.',
        call_failed: 'Naprave ni bilo mogoče poklicati.',
    },
    guest_merge: {
        title: 'Zlitje gostov',
        action: 'Zlij z drugim gostom',
        conflict_merge: 'Zlij v obstoječi profil',
        disappears: 'Ta zapis izgine',
        stays_label: 'Ta zapis ostane',
        pick_survivor: 'Poišči glavni zapis',
        swap: 'Zamenjaj smer',
        no_details: 'brez rojstnega datuma in dokumenta',
        moves_title: 'Kaj se prenese na glavni zapis',
        moves_none: 'Ta zapis ne nosi ničesar — prenese se samo ime.',
        taken_title: 'Kaj glavni zapis prevzame (prazna polja)',
        kept_title: 'Kaj na glavnem zapisu ostane nespremenjeno',
        collisions_title: 'Nekaj ostane na starem zapisu',
        collisions_text: 'Zapisov ({count}) ni mogoče prenesti, ker jih ima glavni gost za isto bivanje že sam. Ostanejo na starem zapisu in niso izgubljeni.',
        unchanged_title: 'Česa zlitje ne spremeni',
        unchanged_text: 'Izdanih računov ({invoices}) se ne popravlja, predlogov v klepetu se ne prepisuje, privolitev se ne prenaša navzgor — privolitev je dokaz o dejanju osebe, ne lastnost zapisa.',
        confirm: 'Zlij zapisa',
        done: 'Zapisa sta zlita. Prenesenih vezi: {stays}.',
        merged_title: 'Ta profil je zlit v drugega',
        merged_text: 'Bivanja, foliji in prijave so na zapisu, ki je ta profil prevzel. Ta zapis ostaja zaradi starih sklicev in ni izbrisan.',
        merged_open: 'Odpri glavni zapis',
        blocked_title: 'Zlitje ni mogoče',
        counts: {
            stays: 'Bivanja',
            reservations_as_payer: 'Rezervacije kot plačnik',
            folios: 'Foliji',
            registrations: 'Prijave',
            tourist_tax_records: 'Turistična taksa',
            facility_bookings: 'Rezervacije zmogljivosti',
            lost_items: 'Najdeni predmeti',
            crm_interactions: 'Zapisi v dnevniku',
            crm_tasks: 'Naloge',
            crm_opportunities: 'Priložnosti',
        },
        fields: {
            email: 'E-naslov',
            phone: 'Telefon',
            nationality: 'Državljanstvo',
            language: 'Jezik',
            notes: 'Opombe',
            date_of_birth: 'Rojstni datum',
            document: 'Dokument',
            address: 'Naslov',
            company_id: 'Podjetje',
            tourist_tax_relief_code: 'Status za turistično takso',
        },
        blockers: {
            same_guest: 'Zapisa ne moreš zliti samega vase.',
            duplicate_already_merged: 'Ta zapis je že zlit v drug profil.',
            survivor_already_merged: 'Izbrani glavni zapis je sam že zlit v drugega — izberi zapis, ki je še v uporabi.',
            identity_taken: 'Po zlitju bi glavni zapis dobil isto identiteto kot tretji obstoječi profil.',
        },
    },

    guest: {
        slot: 'Gost {number}',
        slot_empty: 'Ni izbran',
        slots_hint: 'Toliko vnosov, kolikor je odraslih in otrok na tej sobi. Prazne lahko izpolniš pozneje ali jih izpolni gost sam ob spletni prijavi.',
        slots_over_count: 'Na sobi je več gostov, kot jih je napovedanih ({count}). Odvečnih ni odstranila nobena sprememba števila.',
        tourist_tax: 'Turistična taksa',
        tourist_tax_status: 'Status za turistično takso',
        tourist_tax_status_hint: 'Velja za vsa bivanja te osebe. Za posamezno bivanje lahko recepcija izbere drugo oprostitev in ta prevlada.',
        tourist_tax_none: 'Brez oprostitve (polna taksa)',
        conflict_title: 'To osebo hotel že ima',
        conflict_use_existing: 'Uporabi obstoječi profil',
        conflict_open_existing: 'Odpri obstoječi zapis',
        conflict_replaced: 'Soba je zdaj vezana na obstoječi profil. Noben zapis ni bil zlit ali izbrisan.',
        scan_with_phone: 'Poslikaj dokument s telefonom',
        scan_title: 'Zajem dokumenta s telefonom',
        scan_description_device: 'Telefon zajame dokument, podatki se vpišejo sem.',
        scan_description: 'S telefonom poslikaj kodo, nato dokument. Podatki se vpišejo sem.',
        scan_steps: 'Odpri kamero na telefonu, usmeri jo v kodo in odpri povezavo.',
        scan_waiting: 'Čakam na dokument …',
        scan_expires: 'Koda velja {minutes} minut.',
        scan_new_code: 'Nova koda',
        scan_reading: 'Obdelujem dokument …',
        scan_open_app: 'Skeniraj z aplikacijo',
        scan_open_app_hint: 'Odpre aplikacijo za branje dokumentov na tej napravi in prevzame ta zajem. Če aplikacije ni, uporabi kodo spodaj.',
        scan_printed: 'Cone ni bilo mogoče prebrati, sprednja stran pa je razberljiva',
        scan_printed_hint: 'Prebrano s sprednje strani: {name} · št. {number}. Kontrolnih števk ni, zato preveri ob dokumentu.',
        scan_printed_take: 'Prevzemi prebrano',
        printed_applied: 'Izpolnjeno s sprednje strani dokumenta — ni preverjeno s kontrolnimi števkami.',
        chip_applied: 'Izpolnjeno iz čipa dokumenta — podpisano.',
        scan_failed: 'Slike ni bilo mogoče prebrati',
        scan_failed_hint: 'Na telefonu poslikaj še enkrat — koda ostane veljavna.',
        scan_unavailable: 'Branje slik na tem strežniku ni na voljo',
        scan_unavailable_hint: 'Zapis lahko vseeno prepišeš ali skeniraš s čitalnikom.',
        mrz: 'MRZ (strojno berljivi zapis)',
        mrz_hint: 'Neobvezno. Skeniraj ali prepiši dve vrstici pod sliko v potnem listu — polja spodaj se izpolnijo sama.',
        self_entered: 'Podatke je vnesel gost',
        self_entered_hint: 'Preverite jih ob dokumentu — prijava v eTurizem je do potrditve zadržana.',
        verify_document: 'Dokument preverjen',
        mrz_placeholder: 'P<SVNPRIIMEK<<IME<<<<<<<<<<<<<<<<<<<<<<<<<<<\nP12345678SVN8001011M3001012<<<<<<<<<<<<<<06',
        mrz_repaired: 'Zapis je bil popravljen po kontrolnih številkah ({count} znak). Podatki so vpisani \u2014 preveri številko dokumenta.',
        mrz_applied: 'Podatki iz dokumenta so vpisani.',
        mrz_applied_unverified: 'Podatki so vpisani, čeprav kontrolne številke ne ustrezajo. Preveri jih ob dokumentu.',
        mrz_check_failed: 'Kontrolne številke ne ustrezajo: {fields}. Najverjetneje je en znak napačno prebran.',
        mrz_apply_anyway: 'Vseeno uporabi',
        mrz_error_empty: 'Zapisa še ni.',
        mrz_error_invalid_characters: 'Zapis vsebuje znake, ki jih v MRZ ni.',
        mrz_error_unsupported_format: 'Tega zapisa ne poznam — pričakujem 2 × 44 (potni list) ali 3 × 30 (osebna izkaznica).',
        complete: 'Popolno',
        incomplete: 'Ni podatkov',
        details: 'Podatki',
        reportable_hint: 'Podatki so popolni — gosta je mogoče prijaviti. Klikni za urejanje.',
        missing_hint: 'Za prijavo v evidenco manjka: {fields}. Klikni za vnos.',
        add_named: 'Dodaj gosta „{name}“',
        guests:          'Gostje',
        guest:           'Gost',
        add:             'Dodaj gosta',
        edit:            'Uredi gosta',
        first_name:      'Ime',
        last_name:       'Priimek',
        nationality:     'Državljanstvo',
        document_type:   'Vrsta dokumenta',
        document_number: 'Številka dokumenta',
        date_of_birth:   'Datum rojstva',
        address:         'Naslov',
        consents:        'Soglasja',
        marketing_consent: 'Soglasje za obveščanje',
        consent_email: 'E-pošta',
        consent_sms: 'SMS',
        consent_phone: 'Telefonski klic',
        consent_offers: 'Personalizirane ponudbe',
        consent_revoked: 'Preklicano {at}',
        missing_for_check_in: 'Za prijavo manjkajo podatki, ki jih zahteva eVisitor: državljanstvo, dokument in datum rojstva.',
    },
    rate: {
        board_type: 'Penzion',
        board_none: 'Brez obrokov',
        board_breakfast: 'Zajtrk',
        board_half_board: 'Polpenzion',
        board_full_board: 'Polni penzion',
        board_all_inclusive: 'Vse vključeno',
        legacy_included_services: 'Ta cenik je prej navajal',
        legacy_included_services_hint: 'Stari prosti zapis, ohranjen le za branje. Prenesi ga v penzion in doplačila; ko je prenesen, ta blok izgine.',
        rate_plans:    'Ceniki',
        rate_plan:     'Cenik',
        add:           'Dodaj cenik',
        edit:          'Uredi cenik',
        rates:         'Cene',
        restrictions:  'Omejitve',
        parent:        'Nadrejeni cenik',
        offset:        'Odmik',
        offset_percentage: 'Odstotni odmik',
        offset_hint_cheaper: 'Za {reference} pri nadrejenem ceniku ta cenik zaračuna {result} — torej ceneje.',
        offset_hint_dearer:  'Za {reference} pri nadrejenem ceniku ta cenik zaračuna {result} — torej dražje. Za popust vpiši negativno vrednost.',
        offset_amount: 'Zneskovni odmik',
        offset_amount_per_person: 'Znesek na osebo in noč',
        offset_per_person_suffix: '{amount} na osebo in noč',
        offset_hint_per_person_cheaper: 'Za {reference} pri nadrejenem ceniku soba za {occupancy} stane {result} — torej ceneje.',
        offset_hint_per_person_dearer:  'Za {reference} pri nadrejenem ceniku soba za {occupancy} stane {result} — torej dražje. Za znižanje vpiši negativno vrednost.',
        early_booking:             'Zgodnja rezervacija',
        early_booking_hint:        'Kdor rezervira toliko dni vnaprej, dobi na celotno bivanje ta popust. Stopnje so urejene od najdaljšega roka navzdol, velja najboljša, ki jo gost doseže. Shranjenih cen ne spremeni: cenovna mreža in kanali ostanejo pri redni ceni, popust se obračuna ob rezervaciji.',
        early_booking_days:        'Dni vnaprej',
        early_booking_percent:     'Popust (%)',
        early_booking_add:         'Dodaj stopnjo',
        early_booking_remove:      'Odstrani',
        early_booking_none:        'Popusta za zgodnjo rezervacijo ni.',
        early_booking_order:       'Vsaka stopnja mora biti dlje vnaprej od tiste pod njo.',
        early_booking_badge:       'Zgodnja rezervacija −{percent} %',
        early_booking_quote:       'Zgodnja rezervacija −{percent} %, {amount} manj.',
        derived:       'Izveden',
        standard:      'Standarden',
        refundable:    'Vračljiv',
        is_default:    'Privzeti',
        is_default_hint: 'Cenik, ki se izbere sam, kadar ga nihče ne izbere. Privzeti je lahko samo eden — ta ga prevzame prejšnjemu.',
        price:         'Cena',
        price_from_plan: 'Iz cenika, {nights} noči. Ceno lahko popraviš.',
        price_per_night: '{amount} na noč',
        price_per_night_average: '{amount} na noč v povprečju',
        price_partial:   'Iz cenika za {priced} od {nights} noči — za ostale cenik nima cene.',
        no_price_for_dates: 'Ta cenik za izbrani termin nima cen. Vpiši ceno ročno ali jo dodaj v cenik.',
        extra_adult:   'Doplačilo za odraslega',
        weekdays:      'Dnevi v tednu',
        bulk_edit:     'Množično urejanje',
        min_stay:      'Najkrajše bivanje',
        max_stay:      'Najdaljše bivanje',
        stop_sell:     'Ustavi prodajo',
        closed_to_arrival:   'Zaprto za prihod',
        closed_to_departure: 'Zaprto za odhod',
        outside_sales_window: 'Datum je izven prodajnega okna (18 mesecev).',
        type:                'Tip',
        included_services:   'Vključene storitve',
        min_advance_booking: 'Najmanj dni vnaprej',
        child_prices:        'Cene za otroke',
        fields:              'Kaj ta vnos nastavlja',
        fields_hint:         'Omejitve, ki jih ne izbereš, ostanejo na teh datumih nespremenjene.',
        whole_row_hint:      'Cena se zapiše v celoti — vključno z doplačili in cenami za otroke.',
        derived_readonly:    'Izveden cenik nima lastnih cen. Uredi nadrejeni cenik.',
        derived_source:      'Izpeljano iz cenika {plan} ({offset}).',
        restrictions_not_derived: 'Omejitve se ne podedujejo. Prazna mreža pomeni, da ta cenik nima pravil, ne da veljajo nadrejene.',
        clear_prices:        'Počisti cene',
        clear_restrictions:  'Počisti omejitve',
        confirm_clear_prices: 'Res želiš pobrisati cene za izbrano obdobje?',
        confirm_clear_restrictions: 'Res želiš pobrisati omejitve za izbrano obdobje?',
        confirm_delete:      'Res želiš izbrisati ta cenik?',
        no_plan_for_room_type: 'Za ta tip sobe ni nobenega cenika, zato ga ni mogoče prodati. Dodaj cenik ali ta tip sobe dodaj obstoječemu.',
        in_use:              'Cenika ni mogoče izbrisati, ker ima izvedene cenike, cene ali omejitve',
    },
    // O programu: kaj teče, katera izdaja in kaj je prinesla.
    about: {
        update_available: 'Nova različica — osveži',
        update_toast: 'Na voljo je nova različica portala. Klikni »Nova različica — osveži« v meniju, da jo dobiš.',
        title:        'O programu',
        version:      'Različica',
        build:        'Izdaja (commit)',
        vendor:       'Ponudnik',
        vendor_name:  'IT TEAM d.o.o.',
        product_hint: 'Imprion PMS je hotelski sistem za upravljanje nastanitev — rezervacije, recepcija, gospodinjstvo, računi in kanali. Del ponudbe Imprion (POS, KDS).',
        changelog:    'Kaj je novega',
    },
    chessboard: {
        search_placeholder: 'Soba, gost, skupina, podjetje',
        move_refused: 'Premika ni bilo mogoče izvesti. Rezervacija je ostala, kjer je bila.',
        move_done: 'Bivanje je premaknjeno v sobo {room}.',

        // Raztegni bivanje: robova oznake dodajata in odvzemata cele noči.
        resize_arrival:    'Povleci za spremembo prihoda',
        resize_departure:  'Povleci za spremembo odhoda',
        resize_group_hold: 'Skupinski blok: datumi pridejo iz skupine in se spremenijo na njej.',
        resize_nights:     '1 noč | {count} noči',
        resize_added:      '+1 noč | +{count} noči',
        resize_removed:    '−1 noč | −{count} noči',
        resize_refused:    'Bivanja ni bilo mogoče raztegniti. Ostalo je tako, kot je bilo.',
        resize_done:       'Bivanje je zdaj {range} · {nights}.',
        resize_done_plain: 'Bivanje je spremenjeno.',
        group_type_change_confirm: 'Soba {room} je tipa {to}, blok skupine "{group}" pa jo drži pod {from}. Bo blok skupine prilagojen — ena soba manj pod {from}, ena več pod {to}?',

        // Potrditev premika: kaj se bo zgodilo, preden se zgodi.
        board_settings:      'Nastavitve razporeda',
        confirm_moves:       'Potrdi premike',
        confirm_moves_hint:  'Vlečenje rezervacije ali roba bivanja najprej vpraša za potrditev. Sprememba tipa sobe pri skupinskem bloku vpraša vedno.',
        confirm_move_title:  'Premik rezervacije',
        confirm_resize_title: 'Sprememba bivanja',
        confirm_group_title: 'Premik držane sobe',
        confirm_room:        'Soba',
        confirm_arrival:     'Prihod',
        confirm_departure:   'Odhod',
        confirm_nights:      'Noči',
        confirm_type_change: 'Drug tip sobe: {from} → {to}.',
        // Premik sobe cene NE preračuna (Logic.ChangeReservationRoom) — raztegnitev roba pa jo.
        confirm_price_kept:  'Cena bivanja se ne preračuna po ceniku novega tipa — ostane taka, kot je dogovorjena. Po potrebi jo popravi na rezervaciji.',
        confirm_checked_in:  'Gost je že prijavljen — to je fizična selitev v drugo sobo.',
        confirm_room_closed: 'Soba {room} je v tem obdobju zaprta (izven uporabe).',
        confirm_room_taken:  'Sobo {room} v tem terminu že drži nekdo drug — strežnik bo premik zavrnil.',
        confirm_nights_priced: 'Dodane noči se zaračunajo po ceniku rezervacije.',
        confirm_nights_dropped: 'Odvzete noči se odštejejo od cene bivanja.',
        confirm_arrival_locked: 'Gost je že prijavljen — prihoda ni več mogoče premakniti in strežnik bo spremembo zavrnil.',
        action_check_in: 'Prijava',
        action_check_out: 'Odjava',
        action_add_guest: 'Dodaj gosta',
        // Blok ni rezervacija: kartica držane sobe ponudi prevzem in skupino,
        // ne prijave. Ime skupine bere `group.group`.
        action_pickup: 'Prevzem iz bloka',
        // Odjava in sprostitev sobe sta dva dogodka (docs/HOUSEKEEPING.md §16).
        action_release:   'Soba sproščena',
        released:         'Soba {room} je sproščena.',
        released_already: 'Soba {room} je bila že sproščena.',
        release_failed:   'Sobe ni bilo mogoče sprostiti.',
        checked_out_still_occupied: 'Odjavljen, soba še zasedena',
        action_move: 'Premakni sobo',
        action_note: 'Opomba',
        action_folio: 'Folio',
        action_housekeeping: 'Prednostno čiščenje',
        more_actions: 'Več možnosti',
        outstanding: 'Neplačano',
        prioritised: 'Soba {room} je na vrhu današnjega kroga — takoj.',
        column_state: 'Stanje',
        column_work: 'Delo',
        column_live: 'Soba živo',
        collapse_columns: 'Skrči na številke sob',
        expand_columns: 'Razširi stolpce',
        open_room: 'Odpri sobo {room}',
        action_open_room: 'Odpri stran sobe',
        block_window: 'od {from} do {to}',
        block_window_open: 'od {from} do preklica',
        column_cleaning_at: 'V čiščenju ob',
        cleaning_at_now: 'zdaj',
        cleaning_at_unassigned: 'nedodeljeno',
        cleaning_at_after_shift: 'Krog sobo doseže po koncu prijavljene izmene.',
        column_cleaner: 'Čisti',
        column_ready: 'Prosta do',
        column_faults: 'Okvare',
        view_reservations: 'Rezervacije',
        view_availability: 'Zasedenost',
        view_housekeeping: 'Čiščenje',
        view_telemetry: 'Sobe',
        view_occupied: 'zasedena',
        view_empty: 'prazna',
        work_cleaning: 'se čisti',
        work_cleaning_until: 'čisti do {hour}',
        work_repair: 'okvara',
        grouping: 'Razvrščanje',
        group_by_floor: 'Po nadstropjih',
        group_by_type: 'Po tipu sobe',
        group_all_rooms: 'Vse sobe',
        group_by_none: 'Brez skupin',
        filters: 'Filtri',
        filters_n: 'Filtri · {count}',
        filter_remove: 'Odstrani filter: {filter}',
        filter_arrivals_today: 'Današnji prihodi',
        filter_departures_today: 'Današnji odhodi',
        filter_not_checked_in: 'Neprijavljeni',
        filter_room_not_ready: 'Sobe niso pripravljene',
        filter_unpaid: 'Neplačano',
        filter_conflict: 'Konflikt',
        filter_groups: 'Skupine',
        filter_late_checkout: 'Pozni odhodi',
        filter_free_only: 'Samo proste',
        filter_problems_only: 'Samo težave',
        density_comfortable: 'Udobno',
        density_compact: 'Stisnjeno',
        density_ultra: 'Zelo stisnjeno',
    },
    availability: {
        title: 'Razpoložljivost',
        hint: 'Koliko sob je še prostih, po tipu in po dnevu. Pritisni številko in izberi sobo za rezervacijo.',
        room_type: 'Tip sobe',
        days: '{count} dni',
        no_types: 'Hotel nima tipov sob.',
        pick_room: 'Izberi sobo — rezervacija se odpre z že vpisano sobo in nočjo.',
        free_of_total: '{name}: {free} prostih od {total}',
        free_rooms_caption: 'prostih od vseh',
        book_type: '{free} prostih — klikni za rezervacijo {name}',
        full_on: '{name}: zasedeno na {date}',
        expand_all:   'Odpri vse',
        collapse_all: 'Zapri vse',
        availability: 'Razpoložljivost',
        chessboard:   'Razpored sob',
        legend:       'Legenda',
        free:         'Prosto',
        occupied:     'Zasedeno',
        blocked:      'Zaprto',
        room_state_legend: 'Pika ob številki je trenutno stanje sobe. Pri udobni gostoti je zraven izpisano, sicer pelji miško čeznjo.',
        occupancy:    'Zasedenost',
        no_rooms:     'Za izbrani termin ni prostih sob',
        previous_period: 'Prejšnje obdobje',
        next_period:     'Naslednje obdobje',
        window_days:     '{count} dni',
        select_property: 'Najprej izberi objekt',
    },
    folio: {
        folio:               'Folio',
        cards:               'Foliji',
        add:                 'Nov folio',
        label:               'Naziv folia',
        owner:               'Nosilec folia',
        company_owner:       'Podjetje',
        status_open:         'Odprta',
        status_closed:       'Zaprta',
        charges_total:       'Postavke skupaj',
        payments_total:      'Plačila skupaj',
        balance:             'Saldo',
        balance_due:         'Za plačilo',
        balance_overpaid:    'Preplačano',
        balance_pending_posting: 'Taksa čaka knjiženje',
        balance_settled:     'Poravnano',
        split_bill:          'Deljen račun',
        split_bill_hint:     'Drug folio na isti rezervaciji — del bivanja plača nekdo drug. Postavke lahko pozneje prestaviš med foliji.',
        close:               'Zapri folio',
        confirm_close:       'Res želiš zapreti ta folio? Zaprtega folia ni mogoče znova odpreti in nanj ni mogoče dodajati postavk ali plačil.',
        closed:              'Folio je zaprt',
        close_failed:        'Folia ni bilo mogoče zapreti',
        closed_notice:       'Folio je zaprt',
        closed_at:           'Zaprt {date}. Novih postavk ni več mogoče dodajati, spreminjati ali stornirati — popravek je mogoč le z dobropisom k izdanemu računu. Plačilo je še vedno mogoče: račun se lahko poravna tudi po izdaji.',
        closed_hint:         'Zaprt folio ne sprejema novih postavk: z njega je bil izdan račun, ki navaja prav te postavke. Popravek je mogoč le z dobropisom. Plačilo je še vedno mogoče — račun se pogosto poravna šele potem, ko je natisnjen.',
        target_card:         'Ciljni folio',
        // Nosilec folia: sopotniki najprej, širše iskanje za stikalom.
        owner_companion_placeholder: 'Izberi osebo s te rezervacije',
        other_payer:      'Drug plačnik',
        other_payer_hint: 'Vklopi, kadar folio plača nekdo, ki ni na tej rezervaciji - podjetje, agencija, starš.',
        owner_guest:      'Gost',
        owner_company:    'Podjetje',
        no_target_card:      'Ni folia, na katerega bi bilo mogoče prestaviti',
        no_target_card_hint: 'Postavko je mogoče prestaviti le na drug odprt folio iste rezervacije v isti valuti. Takega folia ni — najprej ga dodaj z „Nov folio“.',

        // Predplačila na foliu: kaj je že prišlo pred bivanjem in na katerem papirju je.
        advances:                'Predplačila',
        advances_hint:           'Denar, ki je prišel pred bivanjem in ima svoj račun za predplačilo. Plačilo samo je v tabeli plačil spodaj — tu piše, na katerem papirju je in koliko ga je še mogoče odbiti na končnem računu.',
        advances_total:          'Za odbitek skupaj',
        advance:                 'Predplačilo',
        advance_standing:        'Ostane za odbitek',
        advance_standing_hint:   'Znesek računa za predplačilo, zmanjšan za že izdane dobropise.',
        advance_fully_credited:  'V celoti dobropisano',
        advance_open_document:   'Odpri dokument',
        advance_storno:          'Storniraj del predplačila',
        advance_storno_tooltip:  'Storniraj del — izdaj dobropis k računu za predplačilo.',
        advance_storno_denied:   'Za dobropis je potrebna pravica „Storno računa“ (invoice:credit). Prosi vodjo.',
        advance_storno_amount:   'Znesek dobropisa',
        advance_storno_amount_hint: 'DDV se razdeli po stopnjah sam, v razmerju, v katerem stojijo na računu za predplačilo.',
        advance_storno_whole:    'Celoten preostanek {amount}',
        advance_storno_too_much: 'Znesek presega to, kar od predplačila še ostane.',
        advance_storno_explanation_title: 'Dobropis ne izbriše računa za predplačilo',
        advance_storno_explanation:       'Račun za predplačilo {number} ostane veljaven in nespremenjen. Poleg njega nastane nov dokument — dobropis z nasprotnimi zneski, z lastno številko in z današnjim poslovnim dnem.',
        advance_storno_money_title:       'Denarja to ne vrne',
        advance_storno_money_hint:        'Dobropis je papir. Če gostu vračaš denar, to naredi z vračilom pri plačilu na tem foliu — sicer bo blagajna ob koncu dneva v minusu.',
        advance_confirm_storno:  'Izdam dobropis {amount} k računu za predplačilo {number}? Račun ostane veljaven, dobropis pa je dokončen.',
    },
    transfer_split: {
        button:  'Prenesi / deli',
        title:   'Prenos in delitev',
        hint:    'Del računa gre na drug folio iste rezervacije. Nič se ne izbriše: izvirna postavka se stornira, deleža pa se zapišeta na novo - na vsakem foliu je vidno, kaj se je zgodilo.',
        what:    'Kaj se deli',
        whole_card: 'Ves folio',
        nothing_to_move: 'Na tem foliu ni postavke, ki bi jo bilo mogoče deliti.',
        split:   'Delitev',
        mode_percent: 'Odstotek',
        mode_amount:  'Znesek',
        mode_persons: 'Po osebah',
        // Odprto z gumba na vrstici: ista delitev, samo zožena na eno postavko.
        move_title: 'Prestavi ali deli',
        line_hint:  'Postavka gre na drugo kartico iste rezervacije — cela ali le delež. Cela se prestavi, delež pa se zapiše na novo: izvirna postavka se stornira in oba deleža sta vidna.',
        how:        'Kako',
        mode_whole_line: 'Celo',
        percent: 'Odstotek (%)',
        amount:  'Znesek, ki se prenese',
        numerator:   'Prenese se delov',
        denominator: 'Od skupno delov',
        selected: 'Izbrano skupaj',
        moves_to: 'Prenese se na „{card}“',
        stays:    'Ostane na tem foliu',
        // Zaokroževanje vedno navzdol; ostanek ostane pri tistem, ki je že plačeval.
        remainder: 'Zaradi zaokroževanja navzdol ostane tu {value} več, kot bi ostalo pri zaokroževanju na najbližji cent.',
        confirm:  'Prenesi',
        done:     'Preneseno {moved} na „{card}“.',
        failed:   'Prenosa ni bilo mogoče izvesti.',
        quote_failed: 'Predogleda ni bilo mogoče izračunati.',
    },
    charge: {
        discount: 'Popust',
        edit_failed: 'Postavke ni bilo mogoče spremeniti — folio je morda že zaprt.',
        edit_tooltip: 'Uredi postavko (opis, količina, cena)',
        delete_title: 'Odstrani postavko',
        delete_confirm: 'Postavka »{description}« bo odstranjena brez sledu — pred izdajo računa je folio delovni dokument. Nadaljujem?',
        delete_failed: 'Postavke ni bilo mogoče odstraniti — folio je morda že zaprt.',
        deleted: 'Postavka je odstranjena.',
        delete_tooltip: 'Odstrani postavko',
        discount_hint: 'Vpiši znesek v evrih ali preklopi na % — shrani se vedno znesek, obračunan ob vnosu.',
        discount_percent_preview: 'S postavke gre dol {amount}.',
        charges:                'Postavke',
        add:                    'Dodaj postavko',
        business_date:          'Poslovni dan',
        source:                 'Vir',
        source_room:            'Nastanitev',
        source_pos:             'Blagajna',
        source_service:         'Storitev',
        source_manual:          'Ročni vnos',
        source_tourist_tax:     'Turistična taksa',
        source_facility:        'Ponudba hotela',
        source_dining:          'Obrok pri vratih',
        quantity:               'Količina',
        unit_price:             'Cena na enoto',
        tax_rate:               'Stopnja DDV',
        tax_rate_hint:          'Odstotek, na primer 9,5 ali 22.',
        amount:                 'Znesek',
        external_ref:           'Zunanja oznaka',
        external_ref_hint:      'Oznaka postavke v izvornem sistemu — na primer številka računa iz blagajne.',
        reverse:                'Storniraj',
        storno:                 'Storno',
        reversed:               'Stornirano',
        reverses_line:          'Stornira vrstico {line}',
        reversed_by_line:       'Stornirano z vrstico {line}',
        reverse_line:           'Vrstica {line} · {amount}',
        reverse_hint:           'Storno postavke ne izbriše: postavka ostane na foliu, pod njo pa nastane nasprotna vrstica z istim zneskom v minus. Folio tako še naprej kaže, kaj je bilo zaračunano, kaj vzeto nazaj in zakaj.',
        reason:                 'Razlog',
        confirm_reverse:        'Res želiš stornirati to postavko? Postavka ostane na foliu, poleg nje nastane nasprotna vrstica.',
        reverse_success:        'Postavka je stornirana',
        reverse_failed:         'Postavke ni bilo mogoče stornirati',
        move:                   'Prestavi',
        move_tooltip:           'Prestavi ali deli postavko na drug folio',
        moved:                  'Postavka je prestavljena',
        move_failed:            'Postavke ni bilo mogoče prestaviti',
        room_charge:            'Knjiži nastanitev',
        room_charge_hint:       'Cena bivanja se na folio prenese taka, kot je dogovorjena na rezervaciji, zato je tu ni mogoče spreminjati. Vsako bivanje se prenese samo enkrat.',
        stay:                   'Bivanje',
        transfer:               'Prenesi',
        transferred:            'Nastanitev je prenesena na folio',
        transfer_failed:        'Nastanitve ni bilo mogoče prenesti',
        room_charge_none:       'Ni bivanja za knjiženje',
        room_charge_none_hint:  'Vsa bivanja te rezervacije so že na foliu. Odpovedana bivanja in bivanja gostov, ki niso prišli, se ne prenašajo.',
        room_charge_other_card: 'Nastanitev je pristala na prvem odprtem foliu rezervacije, ne na tem. Preklopi nanj ali postavko prestavi sem.',
    },
    payment: {
        take: 'Sprejmi plačilo',
        payments:                'Plačila',
        add:                     'Dodaj plačilo',
        occurred_at:             'Čas plačila',
        method:                  'Način plačila',
        method_cash:             'Gotovina',
        method_card:             'Kartica',
        method_bank_transfer:    'Nakazilo',
        method_voucher:          'Vrednostni bon',
        method_deposit:          'Predplačilo',
        method_ota_virtual_card: 'Virtualna kartica OTA',
        amount:                  'Znesek',
        reference:               'Sklic',
        reference_hint:          'Oznaka plačila pri ponudniku — številka transakcije, odobritve ali nakazila.',
        no_card_data:            'Podatki o plačilni kartici se nikoli ne shranjujejo. Zabeleži se le način plačila, znesek in sklic ponudnika.',
        terminal_title:          'Ta vnos ne izvede plačila',
        terminal_hint:           'Plačilo najprej izvedi na fizičnem POS terminalu. Tu se evidentira že opravljeno plačilo — vpiši referenco s potrdila terminala.',
        terminal_reference_hint: 'Priporočena: številka potrdila (slipa) s POS terminala, da se zapisa terminala in PMS ujemata.',
        record_terminal:         'Evidentiraj plačilo s terminala',
        stripe_start:            'Ali: plačilna povezava prek Stripe · {amount}',
        stripe_waiting:          'Čakam na plačilo … Gost naj skenira kodo in plača na svojem telefonu.',
        stripe_booked:           'Plačilo je knjiženo na folio.',
        stripe_hint:             'Znesek in knjiženje določi strežnik; plačilo se zapiše šele, ko ga Stripe potrdi. Kartica gosta se nikoli ne dotakne PMS.',
        stripe_copy:             'Kopiraj povezavo',
        stripe_copied:           'Povezava je kopirana.',
        stripe_failed:           'Plačilne povezave ni bilo mogoče ustvariti. Preveri, ali je Stripe nastavljen.',
        refund_stripe_title:     'Denar se vrne na kartico prek Stripe',
        refund_stripe_hint:      'PMS najprej pošlje vračilo Stripe in počaka na potrditev; šele nato zapiše negativno postavko. Če Stripe vračilo zavrne, se tu ne zapiše nič.',
        refund_terminal_title:   'Najprej vračilo na POS terminalu',
        refund_terminal_hint:    'Ta sistem terminala ne doseže. Vračilo najprej izvedi na terminalu, nato ga evidentiraj tukaj z referenco potrdila.',
        refund:                  'Vračilo',
        refund_tooltip:          'Vračilo plačila — del ali celota; nastane negativno plačilo pod tem',
        refund_denied:           'Za vračilo je potrebna pravica „Stornira postavko na foliu“',
        transfer_tooltip:        'Prenos plačila na drug folio iste rezervacije — del ali celota; denar ostane v hiši',
        transfer_denied:         'Za prenos sta potrebni pravici „Stornira postavko na foliu“ in „Knjiži postavke in plačila na folio“',
        refund_tag:              'Vračilo',
        refunded_tag:            'Vrnjeno',
        refunds_line:            'Vrača vrstico {line}',
        refunded_by_line:        'Vrnjeno z vrstico {line}',
        refund_line:             'Vrstica {line} · {amount}',
        refund_hint:             'Plačilo ostane na foliu, pod njim nastane vračilo z negativnim zneskom. Vrniti ni mogoče več, kot je bilo na tem foliu dejansko plačano.',
        refund_too_large:        'Znesek je večji od tistega, kar je še mogoče vrniti.',
        confirm_refund:          'Res želiš vrniti to plačilo? Plačilo ostane na foliu, poleg njega nastane vračilo.',
        refunded:                'Vračilo je zabeleženo',
        refund_failed:           'Vračila ni bilo mogoče zabeležiti',
        refund_overpayment:      'Vrni preplačilo',
        refund_no_payment:       'Na tem foliu ni plačila, ki bi ga bilo mogoče vrniti.',
        transfer_overpayment:    'Prenesi preplačilo na drug folio',
        transfer_title:          'Prenos preplačila na drug folio',
        transfer_hint:           'Denar ostane v hiši — na izvornem foliu nastane negativna postavka, na ciljnem pozitivna. Nič se ne briše in nič ne ureja.',
        transfer_from_payment:   'S katerega plačila',
        transfer_payment_option: 'Vrstica {line} · {method} · {amount}',
        transfer_target:         'Na folio',
        transfer_amount_hint:    'Največ {amount} — toliko je na tem foliu dejansko plačano.',
        transfer_submit:         'Prenesi',
        transfer_too_large:      'Znesek je večji od tistega, kar je na tem foliu dejansko plačano.',
        transfer_not_covered:    'Toliko denarja na tem foliu ni. Zmanjšaj znesek ali izberi drugo plačilo.',
        transferred:             'Preplačilo je preneseno na drug folio.',
        transfer_failed:         'Preplačila ni bilo mogoče prenesti',
        transfer_no_target:      'Ni drugega odprtega folia',
        transfer_no_target_hint: 'Preplačilo je mogoče prenesti samo na drug odprt folio iste rezervacije. Odpri folio in ga dodaj, ali pa preplačilo vrni gostu.',
        transfer_no_payment:     'Na tem foliu ni plačila za prenos',
        transfer_no_payment_hint: 'Prenese se del že evidentiranega plačila. Na tem foliu ni nobenega pozitivnega plačila.',
    },
    payment_method: {
        cash:             'Gotovina',
        card:             'Kartica',
        bank_transfer:    'Nakazilo',
        voucher:          'Vrednostni bon',
        deposit:          'Predplačilo',
        ota_virtual_card: 'Virtualna kartica OTA',
    },
    without_room: {
        title: 'Sprejeto, a še brez sobe',
        hint: 'Ti gostje imajo našo potrditev in sobe še nimajo. Na šahovnici jih ni — nerazporejena rezervacija ne drži nobene sobe, zato zanjo ni vrstice.',
        guest: 'Gost',
        stay: 'Bivanje',
        rooms: 'Sob',
        why: 'Zakaj je brez sobe',
        source: 'Prišlo iz',
        assign: 'Dodeli sobo',
        no_name: '(kanal ni poslal imena)',
        not_placed_yet: 'Še ni razporejeno',
    },
    channel: {
        skip_photos_not_reachable: 'Fotografije niso objavljene ({count}): ta namestitev nima javnega naslova, s katerega bi jih kanal lahko prenesel.',
        skip_room_type_not_mapped: 'Ni preslikano v kanal: {names}',
        skip_photo_failed: 'Fotografij ({count}) ni bilo mogoče objaviti.',
        publish_content: 'Objavi vsebino',
        content_published: 'Objavljeno — tipi sob: {roomTypes}, fotografije: {photos}.',
        channels: 'Upravitelj kanalov',
        description: 'Distribucija na Booking.com, Expedio, Airbnb in ostale prek agregatorja.',
        no_access: 'Ni dostopa do upravitelja kanalov',
        no_access_hint: 'Za pravico do kanalov se obrnite na skrbnika.',
        none_yet: 'Povezave s kanali še ni',
        none_yet_hint: 'Povežite objekt z agregatorjem, da začnete prodajati prek kanalov.',
        add: 'Dodaj povezavo',
        add_hint: 'Povezava se ustvari kot osnutek. Na kanale se ne pošlje nič, dokler je ne povežete.',
        edit: 'Uredi povezavo',
        refresh: 'Osveži',
        provider: 'Agregator',
        provider_channex: 'Channex',
        provider_groups_hint: 'Povežemo se z agregatorjem; kanali so tisto, kar prek njega dosežemo.',
        group_aggregators: 'Agregatorji — z njimi se povežemo',
        group_aggregators_hint: 'Ena pogodba in ena povezava, ki doseže vse kanale.',
        group_channels: 'Kanali — do njih pridemo prek agregatorja',
        group_channels_hint: 'Tu gost dejansko rezervira. Iz tega zaslona se nanje ne povezujemo neposredno.',
        provider_channex_hint: '60 kanalov, REST/JSON. Edini z odprtim peskovnikom — priporočen.',
        provider_siteminder_hint: 'Velika mreža, SOAP in OTA XML. Pogodba pred začetkom razvoja.',
        provider_staah_hint: '250+ PMS. Zahteva, da končni točki izpostavimo mi.',
        provider_dedge_hint: '300+ distribucijskih strani. Brez javne razvijalske poti.',
        provider_rategain_hint: '450+ kanalov. Brez javne razvijalske poti.',
        provider_hotelrunner_hint: 'XML. Nazivi partnerstev iz posrednih virov, nepreverjeno.',
        provider_webbookingpro_hint: 'Hrvaška. 50+ OTA in GDS, beli izdelek, cena na povpraševanje.',
        channel_booking_com_hint: 'Najpomembnejši pri nas. Neposredno ne gre: sprejemanje novih ponudnikov povezljivosti je ustavljeno.',
        channel_expedia_hint: 'Neposredno zahteva pogodbo in PCI skladnost.',
        channel_airbnb_hint: 'Brez javnega razvijalskega portala; dostop samo prek odobrenega partnerstva.',
        channel_agoda_hint: 'Dosegljiv prek agregatorja.',
        channel_hostelworld_hint: 'Hostli in mladinski turizem. Prek agregatorja.',
        channel_hrs_hint: 'Nemški poslovni gost. Prek agregatorja.',
        channel_hotelbeds_hint: 'Touroperaterski in bedbank promet. Prek agregatorja.',
        channel_trip_com_hint: 'Dosegljiv prek agregatorja.',
        channel_feratel_hint: 'Destinacijski sistem, močan v alpskem prostoru. Prek agregatorja.',
        channel_google_hotel_hint: 'Brezplačne rezervacijske povezave. Podpora pri agregatorju ni potrjena.',
        external_property_id: 'ID objekta pri agregatorju',
        external_property_id_hint: 'Oznaka, s katero agregator označuje ta hotel.',
        connection: 'Povezava',
        connection_hint: 'Stanje povezave z agregatorjem, obe smeri in zadnja napaka.',
        state_draft: 'Osnutek',
        state_connected: 'Povezan',
        state_suspended: 'Zaustavljen',
        state_error: 'Napaka',
        last_synced_at: 'Zadnja oddaja',
        last_polled_at: 'Zadnji prevzem',
        full_sync: 'Pošlji vse',
        full_sync_success: 'Polna sinhronizacija je naročena',
        confirm_full_sync: 'Vsem kanalom povem razpoložljivost, cene in omejitve za celotno prodajno obdobje. Nadaljujem?',
        last_full_sync_at: 'Zadnja polna sinhronizacija',
        last_error: 'Zadnja napaka',
        last_error_at: 'Zabeleženo',
        last_error_past:      'Zadnja napaka (odpravljena)',
        last_error_recovered: 'Od takrat je povezava uspešno oddala ali prevzela — napaka je zapis, ne trenutno stanje.',
        never: 'Nikoli',
        just_now: 'pravkar',
        minutes_ago: 'pred {count} min',
        hours_ago: 'pred {count} h',
        days_ago: 'pred {count} d',
        pending_ari: 'Čaka na oddajo',
        pending_ari_hint: 'Cene in razpoložljivost, spremenjene tu in še neposlane na kanale.',
        pending_ari_open: 'Klikni za seznam datumov.',
        waiting_title: 'Čaka na oddajo',
        waiting_description: 'Datumi, ki jih agregator še ne pozna, in zakaj vsak od njih še čaka.',
        waiting_none: 'Vse je oddano',
        waiting_none_hint: 'Kanali imajo trenutne cene in razpoložljivost.',
        waiting_date: 'Datum',
        waiting_room_type: 'Tip sobe',
        waiting_rate_plan: 'Cenik',
        waiting_reason: 'Zakaj čaka',
        waiting_attempts: 'Poskusov',
        waiting_unknown: 'Neznano',
        waiting_availability_only: 'samo razpoložljivost',
        waiting_reason_unmapped: 'Ni preslikave',
        waiting_reason_retrying: 'Ponovni poskus',
        waiting_reason_sending: 'Se pošilja',
        waiting_reason_waiting: 'Na vrsti',
        waiting_unmapped_hint: 'Za {count} datumov ni preslikave tipa sobe ali cenika na kanal. Ti ne bodo oddani nikoli — dokler preslikave ne dokončaš v zavihku Preslikave.',
        waiting_truncated: 'Prikazanih je prvih {count} datumov.',
        needs_attention: 'Potrebuje pozornost',
        needs_attention_hint: 'Rezervacije s kanalov, ki se niso mogle vnesti same.',
        connect: 'Poveži',
        resume: 'Ponovno zaženi',
        retry: 'Poskusi znova',
        suspend: 'Zaustavi',
        disconnect: 'Prekini povezavo',
        confirm_suspend: 'Zaustavim kanal? Do ponovnega zagona se nič ne pošilja in ne prevzema.',
        confirm_disconnect: 'Prekinem povezavo? Hotel preneha prodajati prek vseh kanalov, preslikave se izgubijo.',
        connect_success: 'Kanal je povezan',
        suspend_success: 'Kanal je zaustavljen',
        disconnect_success: 'Povezava s kanalom je prekinjena',
        mapping: 'Preslikave',
        mapping_hint: 'Kar prodajamo, ob oznakah agregatorja. Kar ni preslikano, se ne prodaja prek nobenega kanala.',
        kind_room_type: 'Tipi sob',
        kind_room_type_hint: 'ena vrstica na tip sobe',
        kind_rate_plan: 'Ceniki po vrstah sob',
        kind_rate_plan_hint: 'ena vrstica na par tip sobe + cenik',
        local_room_type: 'Naš tip sobe',
        local_rate_plan: 'Naš cenik',
        external_id: 'ID pri agregatorju',
        external_id_placeholder: 'ID pri agregatorju',
        propose: 'Predlagaj preslikave',
        proposed: 'Izpolnjenih {filled} oznak. Brez para: {ours} naših, {theirs} njihovih. Nič ni shranjeno, dokler ne pritisneš Shrani.',
        sell: 'V prodaji',
        mapped: 'Preslikano',
        unmapped: 'Ni preslikano',
        switched_off: 'Izklopljeno',
        mapped_count: '{mapped} od {total} v prodaji',
        no_local_items: 'Za preslikavo še ni ničesar.',
        no_rate_plans_here: 'noben cenik',
        no_rate_plans_here_hint: 'Za ta tip sobe ni nobenega cenika, zato ga ni mogoče prodajati prek nobenega kanala. Cenik dodajte pri Cenikih.',
        expand_all: 'Razpri vse',
        collapse_all: 'Skrči vse',
        pairs_none_mapped: 'Nobeden od parov še nima ID-ja pri agregatorju (skupaj: {count})',
        pairs_none_mapped_hint: 'To ni napaka. Preslikava cenika je zdaj par tip sobe + cenik, prejšnji zapisi pa so bili vezani samo na cenik in niso mogli povedati, za kateri tip sobe veljajo — zato so bili odstranjeni namesto uganjeni. Vsak par zdaj potrebuje svoj ID pri agregatorju. Pri agregatorju ni bilo izbrisano nič.',
        nothing_unmapped_here: 'Tu je vse v prodaji.',
        only_unmapped: 'Prikaži samo tisto, kar ni v prodaji ({count})',
        plans_without_room_type: 'Cenikov brez tipa sobe: {count}',
        plans_without_room_type_hint: 'Ti ceniki ne pokrivajo nobenega tipa sobe, zato jih ni mogoče preslikati in se ne prodajajo nikjer. Tipe sob jim določite pri Cenikih. Zadeva: {plans}',
        cannot_clear: 'Izbrisanih ID-jev: {count}',
        cannot_clear_hint: 'ID-ja pri agregatorju ni mogoče odstraniti — vmesnik pozna samo zapis in izklop. Vrstico izklopite s stikalom „V prodaji“; ob shranjevanju se izbrisano polje povrne na shranjeno vrednost.',
        unmapped_warning: '{count} od {total} se ne prodaja prek kanalov',
        unmapped_warning_hint: 'Nepreslikan tip sobe ali par tip sobe + cenik se ne ponuja na nobenem kanalu.',
        all_mapped: 'Vse je preslikano',
        all_mapped_hint: 'Vsi tipi sob in vsi pari tip sobe + cenik se prodajajo prek kanalov.',
        save_mapping: 'Shrani preslikave',
        mapping_saved_count: 'Shranjenih preslikav: {count}',
        bookings: 'Rezervacije s kanalov',
        bookings_hint: 'Kaj je prišlo prek kanalov in kaj je s tem še treba narediti.',
        booking: 'Rezervacija s kanala',
        booking_details: 'Podrobnosti rezervacije s kanala',
        booking_status_received: 'Prejeta',
        booking_status_applied: 'Vnesena',
        booking_status_needs_attention: 'Potrebuje pozornost',
        booking_status_cancelled: 'Odpovedana',
        booking_status_ignored: 'Odložena',
        ota_reference: 'Sklic OTA',
        channel_code: 'Kanal',
        received_at: 'Prejeto',
        revision: 'Različica',
        revision_n: 'različica {revision}',
        reason: 'Razlog',
        attention_count: 'Pozornost potrebuje: {count}',
        linked_reservation: 'Povezana rezervacija',
        open_reservation: 'Odpri rezervacijo',
        payload: 'Kar je poslal kanal',
        payload_empty: 'Kanal ni poslal ničesar.',
        resolve: 'Razreši',
        resolve_title: 'Poveži z rezervacijo',
        resolve_hint: 'Poveži jo z rezervacijo, ki ji pripada. Iskanje se začne pri sklicu, ki ga ima gost.',
        resolve_note: 'Opomba (neobvezno)',
        search_reservation: 'Številka rezervacije ali priimek gosta',
        no_reservation_found: 'Ni najdene rezervacije. Poskusite s priimkom gosta ali številko rezervacije.',
        resolve_success: 'Rezervacija s kanala je povezana z rezervacijo',
        place: 'Ustvari rezervacijo',
        place_title: 'Ustvari rezervacijo iz te',
        place_hint: 'Gost, termin, število oseb in cena so prepisani s kanala. Izberite le tip sobe in sobo; rezervacija s kanala se poveže sama.',
        place_pick_room: 'Izberite prosto sobo',
        place_no_free_room: 'Za izbrani termin in tip sobe ni proste sobe.',
        place_channel_quote: 'Kanal je gostu zaračunal',
        place_exchange_rate: 'Tečaj ({from} → {to})',
        place_house_amount: 'Znesek v {currency}',
        place_exchange_hint: 'Predlog je referenčni tečaj ECB (uradna tečajnica); tečaj lahko popravite. Na bivanju se shranita izvorni znesek in vpisani tečaj, račun pa gre v valuti hotela.',
        place_rate_suggest: 'Predlagaj tečaj (ECB)',
        place_rate_suggested: 'Referenčni tečaj ECB z dne {date}: 1 {from} = {rate} {to}',
        place_rate_suggest_failed: 'Tečaja ECB ni bilo mogoče pridobiti.',
        place_rate_required: 'Vpišite tečaj.',
        place_success: 'Rezervacija {number} je ustvarjena in povezana s kanalom',
        place_replayed: 'Gumb je bil pritisnjen dvakrat — velja prva rezervacija {number}. Druge ni.',
        ignore: 'Odloži',
        ignore_title: 'Odloži',
        ignore_reason: 'Razlog',
        ignore_reason_duplicate: 'Podvojena',
        ignore_reason_test: 'Testna rezervacija',
        ignore_reason_entered_by_hand: 'Že ročno vnesena',
        ignore_reason_cancelled_by_ota: 'Odpovedana na kanalu',
        ignore_reason_other: 'Drugo',
        ignore_success: 'Rezervacija je odložena',
        reason_unmapped_room_type: 'Tip sobe s te rezervacije ni preslikan v našega.',
        reason_unmapped_rate_plan: 'Cenik s te rezervacije ni preslikan v naš.',
        reason_no_rooms: 'Rezervacija ne navaja nobene sobe.',
        reason_invalid_dates: 'Prihod in odhod ne zajemata nobene nočitve.',
        reason_no_room_free: 'Za te nočitve ni proste sobe te vrste.',
        reason_overbooking: 'Sobe so bile medtem prodane — ta rezervacija bi presegla zasedenost hotela.',
        reason_reservation_refused: 'Rezervacije ni bilo mogoče ustvariti — preveri datume, zasedenost in ceno.',
        reason_missing_guest_name: 'Rezervacija nima popolnega imena gosta.',
        reason_guest_refused: 'Podatkov o gostu ni bilo mogoče shraniti — vnesi gosta ročno.',
        reason_changed_after_placement: 'Kanal je spremenil rezervacijo, ki je že v hotelu.',
        reason_cancellation_failed: 'Kanal je odpovedal rezervacijo, naše rezervacije pa ni bilo mogoče odpovedati.',
        reason_system_error: 'Te rezervacije ni bilo mogoče samodejno umestiti.',
    },
    content: {
        room_type_hint: 'Opis tega tipa sobe, njegova oprema in fotografije, v jezikih, v katerih hotel prodaja. Shrani se ločeno od nastavitev sobe.',
        content: 'Vsebina',
        room_type_action: 'Opis in oprema',
        room_type_action_hint: 'Opis, oprema in fotografije tega tipa sobe.',
        property_hint: 'Opis hotela in pomembne informacije, v jezikih, v katerih hotel prodaja.',
        description: 'Opis',
        description_hint: 'Kar gost prebere o hotelu oziroma o sobi, preden rezervira.',
        description_placeholder: 'Kratek opis …',
        important_information: 'Pomembne informacije',
        important_information_hint: 'Kar mora gost vedeti pred prihodom — parkiranje, prevzem ključa, hišni red.',
        important_information_placeholder: 'Kar mora gost vedeti pred prihodom …',
        add_language: 'Dodaj jezik',
        remove_language: 'Odstrani jezik',
        remove_language_confirm: 'Odstranim ta jezik? Besedilo v njem se izbriše.',
        default_language_tab: 'Jezik hotela',
        default_language_required: 'Jezik hotela mora biti izpolnjen, dokler je izpolnjen katerikoli drug — prevod brez izvirnika je prazna stran za vsakega, ki tega jezika ne bere.',
        characters: '{count} znakov',
        discard: 'Zavrzi spremembe',
    },
    photo: {
        photos: 'Fotografije',
        photos_hint: 'Kar kanal pokaže gostu. Prva slika je naslovna.',
        count: '{count} od {max}',
        upload: 'Naloži',
        upload_failed: 'Slike „{name}“ ni bilo mogoče naložiti.',
        too_large: 'Slika „{name}“ je prevelika (največ 10 MB).',
        full_title: 'Zbirka je polna',
        full_hint: 'Največ {max} fotografij na objekt oziroma tip sobe. Izbriši katero, če hočeš dodati novo.',
        none: 'Fotografij še ni',
        none_hint: 'Brez slik kanali sobe skoraj ne prodajo. Naloži jih toliko, kolikor jih hotel ima.',
        cover: 'Naslovna',
        make_cover: 'Naslovna',
        cover_set: 'Naslovna slika je nastavljena',
        move_earlier: 'Premakni naprej',
        move_later: 'Premakni nazaj',
        confirm_delete: 'Izbrišem to fotografijo?',
        deleted: 'Fotografija je izbrisana',
        details: 'Podrobnosti fotografije',
        caption: 'Podnapis',
        caption_hint: 'Kar piše pod sliko na kanalu; po jezikih.',
        caption_placeholder: 'Npr. Pogled s terase',
        author: 'Avtor',
        author_hint: 'Ime fotografa, če je dogovorjeno, da mora biti naveden.',
    },
    policy: {
        policies: 'Politike odpovedi',
        add: 'Dodaj politiko',
        edit: 'Uredi politiko',
        what_it_is: 'Politika odpovedi',
        what_it_is_hint: 'Do kdaj sme gost brezplačno odpovedati in kaj se zaračuna potem.',
        name_hint: 'Ime, po katerem jo recepcija prepozna — npr. „Brezplačno do 18:00 na dan prihoda“.',
        description_hint: 'Neobvezno pojasnilo za recepcijo.',
        free_cancellation: 'Brezplačna odpoved',
        free_cancellation_hint: 'Izklopljeno pomeni nevračljivo: zaračuna se od trenutka rezervacije.',
        free_window: 'Brezplačno do',
        deadline: 'Rok',
        deadline_hint: 'Ura po lokalnem času hotela.',
        days_before_arrival: 'Dni pred prihodom',
        days_before_arrival_hint: '0 pomeni dan prihoda.',
        penalty: 'Zaračuna se',
        penalty_hint: 'Kaj hotel zaračuna, če gost odpove po roku.',
        penalty_none: 'Nič',
        penalty_first_night: 'Prva noč',
        penalty_percentage: 'Odstotek bivanja',
        penalty_full_stay: 'Celotno bivanje',
        penalty_percent: 'Odstotek',
        penalty_percent_hint: 'Delež celotnega bivanja.',
        free_needs_penalty: 'Politika z brezplačnim rokom mora povedati, kaj se zaračuna po njem.',
        is_default: 'Privzeta politika hotela',
        is_default_hint: 'Velja za cenike, ki ne imenujejo svoje.',
        default_short: 'Privzeta',
        in_use: 'V uporabi',
        confirm_delete: 'Izbrišem to politiko?',
        summary: 'Povzetek',
        summary_never_free: 'Nevračljivo',
        summary_arrival_day: 'Brezplačno do {time} na dan prihoda',
        summary_days_before: 'Brezplačno do {time}, {days} dni pred prihodom',
    },
    extra: {
        extras: 'Doplačila',
        hint: 'Kar hotel zaračuna poleg sobe — zaključno čiščenje, prijavnina, ljubljenčki. Cenik lahko katero od njih vključi v ceno.',
        add: 'Dodaj doplačilo',
        edit: 'Uredi doplačilo',
        code_hint: 'Trajna oznaka za postavke, poročila in kanale.',
        charging: 'Obračun',
        charging_hint: 'Kolikokrat se enota šteje v enem bivanju.',
        price: 'Cena (z DDV)',
        price_hint: 'Bruto cena ene enote — znesek, ki ga gost sliši.',
        tax_rate: 'DDV (%)',
        included: 'Vključeno',
        included_in_room_price: 'Vključeno v ceni sobe',
        included_in_room_price_hint: 'Vključeno doplačilo se ne zaračuna posebej.',
        in_use: 'Tega doplačila ni mogoče izbrisati — vključuje ga vsaj en cenik. Raje ga upokoji.',
        confirm_delete: 'Izbrišem „{name}“?',
        none: 'Doplačil še ni',
        none_hint: 'Vpiši, kar hotel zaračuna poleg sobe, da bo obračun povsod enak.',
        charging_per_stay: 'Enkrat na bivanje',
        charging_per_night: 'Na noč',
        charging_per_person: 'Na osebo',
        charging_per_person_per_night: 'Na osebo na noč',
        vat_of: 'DDV {rate}',
    },
    tax: {
        tax_sets: 'Davčni nabori',
        hint: 'Kako je cena sestavljena: DDV in dajatve, vsaka vključena v ceno ali prišteta. Cenik lahko imenuje svoj nabor, sicer velja privzeti.',
        add: 'Dodaj nabor',
        edit: 'Uredi nabor',
        levies: 'Dajatve',
        levies_hint: 'Odstotek se vpiše v odstotkih, znesek v evrih. Davek se nikoli ne obračuna na drug davek.',
        add_levy: 'Dodaj dajatev',
        remove_levy: 'Odstrani',
        kind: 'Vrsta',
        percent: 'Odstotek',
        amount: 'Znesek',
        included: 'Vključeno v ceni',
        is_default: 'Privzeti nabor hotela',
        is_default_hint: 'Velja za cenike, ki ne imenujejo svojega.',
        default_short: 'Privzeti',
        in_use: 'Tega nabora ni mogoče izbrisati — uporablja ga vsaj en cenik. Raje ga upokoji.',
        confirm_delete: 'Izbrišem nabor „{name}“?',
        empty_set: 'Brez dajatev',
        none: 'Davčnih naborov še ni',
        none_hint: 'Vpiši DDV in dajatve, ki jih hotel zaračuna, da bodo cene sestavljene enako povsod.',
        tourist_tax_title: 'Turistična taksa se vodi drugje',
        tourist_tax_hint: 'Zakonski stopnji in olajšave so v Nastavitvah pod Turistična taksa (od tam gredo v eTurizem), prikaz na ponudbi pa v davčnem naboru. Tretjega mesta ne ustvarjaj.',
        tourist_tax_open: 'Odpri Turistično takso',
        kind_percentage: 'Odstotek',
        kind_per_night: 'Na noč',
        kind_per_person_per_night: 'Na osebo na noč',
    },
    /**
     * The municipality's rate card and the grounds on which a guest does not pay it
     * (docs/ETURIZEM.md §6). The relief DESCRIPTIONS are not here: the statutory list
     * comes from the service, which is also what seeds it into a house's settings, and
     * a relief's description has never been a translated string — it is one line of the
     * hotel's own text, stored in its settings and printed on a bill.
     */
    tourist_tax: {
        nav: 'Turistična taksa',
        intro: 'Koliko takse hotel pobere za občino in kdo je ne plača. Stopnjo določi občinski odlok, olajšave pa ZSRT-1; preveri jih pred prvim obračunom.',
        no_property: 'Najprej izberi objekt',
        no_property_hint: 'Taksa je nastavitev posameznega objekta. Odpri objekt v Objektih in se vrni sem.',
        no_permission: 'Nimaš pravice za skladnost',
        no_permission_hint: 'Za ogled takse potrebuješ pravico compliance:read, za urejanje compliance:write.',
        rates: 'Stopnji',
        rates_hint: 'Zneska na osebo na noč, kot ju določa občinski odlok.',
        rate: 'Turistična taksa',
        per_person_per_night: 'Na osebo na noč',
        promotion_rate: 'Promocijska taksa',
        promotion_rate_hint: 'Na osebo na noč. Po zakonu 25 % turistične takse.',
        promotion_suggestion: 'Promocijska taksa odstopa od 25 %',
        promotion_suggestion_hint: 'Po 17. členu ZSRT-1 znaša promocijska taksa 25 % turistične — pri tej stopnji {amount}. Če občina določa drugače, pusti svoj znesek.',
        promotion_apply: 'Nastavi na 25 %',
        rate_too_high: 'Znesek je previsok — vpiši ga v evrih, ne v centih.',
        reliefs: 'Olajšave',
        reliefs_hint: 'Podlage, po katerih gost plača manj ali nič. Šifra je hišna in ostane zapisana pri obračunanih bivanjih, zato je pozneje ne preimenuj.',
        add_relief: 'Dodaj olajšavo',
        add_statutory: 'Dodaj zakonske olajšave (ZSRT)',
        remove_relief: 'Odstrani',
        confirm_remove: 'Odstranim olajšavo „{name}“? Že obračunana bivanja se ne spremenijo.',
        no_reliefs: 'Olajšav še ni',
        no_reliefs_hint: 'Dokler jih ni, vsak gost plača polno takso, na kartici gosta pa ni polja za oprostitev. Začni z zakonskim naborom in ga uskladi z občinskim odlokom.',
        code: 'Šifra',
        description: 'Naziv',
        relief_percent: 'Olajšava (%)',
        relief_percent_hint: '100 je popolna oprostitev.',
        reporting_code: 'Šifra AJPES',
        reporting_code_hint: 'Podlaga, pod katero se oprostitev vloži v eTurizem.',
        age_from: 'Starost od',
        age_to: 'Starost do',
        age_hint: 'Dopolnjena leta ob prihodu, obe meji vključeni.',
        age_needed: 'Samodejna olajšava potrebuje starostno mejo.',
        age_order: 'Zgornja meja ne sme biti nižja od spodnje.',
        automatic: 'Samodejno po starosti',
        automatic_hint: 'Sistem jo prizna sam iz rojstnega datuma. Vklopi jo samo tam, kjer ni potrebnega potrdila.',
        duplicate_code: 'Ta šifra je že uporabljena.',
        percent_range: 'Vpiši med 1 in 100.',
        saved: 'Turistična taksa je shranjena',
        statutory_unavailable: 'Zakonskega nabora ni bilo mogoče prebrati. Poskusi znova ali vpiši olajšave ročno.',
        reporting_0: 'Polna turistična taksa',
        reporting_1: 'Oprostitev – otrok do 7. leta starosti',
        reporting_2: 'Oprostitev – zdravniška napotnica',
        reporting_3: 'Oprostitev – invalidnost, telesna okvara',
        reporting_4: 'Oprostitev – otrok s posebnimi potrebami',
        reporting_5: 'Oprostitev – vzgojno-izobraževalni program',
        reporting_6: 'Oprostitev – dijaki, študenti v domovih',
        reporting_7: 'Delno plačilo – osebe na začasnem delu',
        reporting_8: 'Oprostitev – mednarodna pogodba',
        reporting_9: 'Oprostitev – planinski dom (člani PZS)',
        reporting_10: 'Oprostitev – predpis občine',
        reporting_11: 'Polovično plačilo – oseba od 7. do 18. leta starosti',
        reporting_12: 'Polovično plačilo – mladinska prenočišča IYHF',
        reporting_13: 'Polovično plačilo – turisti v kampih',
        reporting_14: 'Polovično plačilo – predpis občine',
        reporting_15: 'Delno plačilo – predpis občine',
        reporting_16: 'Ni plačila – ni storitve prenočevanja',
        reporting_17: 'Oprostitev – udeleženci letovanj prek društev v javnem interesu',
        reporting_18: 'Oprostitev – prostovoljci za odpravo elementarnih nesreč',
        reporting_19: 'Oprostitev – policisti v obdobju opravljanja nalog',
    },
    amenity_category: {
        general: 'Splošno',
        in_room: 'V sobi',
        bathroom: 'Kopalnica',
        kitchen: 'Kuhinja',
        view: 'Razgled',
        outside: 'Zunaj',
        security: 'Varnost',
        accessibility: 'Dostopnost',
    },
    amenity: {
        scope: 'Kje velja',
        scope_hint: 'Oprema sobe, ponudba objekta ali oboje. Objektna ponudba gre na kanale kot lastnost hotela.',
        scope_room: 'Oprema sobe',
        scope_property: 'Ponudba objekta',
        scope_both: 'Oboje',
        property_offers: 'Kaj ponuja objekt',
        property_offers_hint: 'Bazen, savna, restavracija, bar, izposoja koles … Označeno gre na kanale kot lastnost hotela in se pokaže gostu.',
        property_offers_empty: 'Ni še nobene postavke z oznako »Ponudba objekta«. Dodaj jo v seznamu spodaj.',
        property_offers_saved: 'Ponudba objekta je shranjena.',
        more: '+{count}',
        none_on_room_type: 'Oprema ni določena',
        amenities: 'Oprema',
        hint: 'Kaj soba ima. Katalog je hotelski: oznake agregatorjev so njihove, tvoj seznam pa preživi menjavo ponudnika.',
        add: 'Dodaj opremo',
        edit: 'Uredi opremo',
        code: 'Šifra',
        code_hint: 'Trajna oznaka, ki jo nosijo izvozi in preslikave na kanale. Preimenovanje je ne premakne.',
        code_invalid: 'Šifra sme imeti male črke, številke in podčrtaje, začne pa se s črko.',
        code_taken: 'Ta šifra je v tem objektu že uporabljena.',
        category: 'Kategorija',
        install_starter: 'Namesti običajni seznam',
        installed: 'Dodanih: {count}',
        in_use: 'Te opreme ni mogoče izbrisati — uporablja jo vsaj en tip sobe. Najprej jo odkljukaj tam.',
        confirm_delete: 'Izbrišem „{name}“?',
        none: 'Opreme še ni',
        none_hint: 'Namesti običajni seznam devetnajstih postavk in ga popravi po svoje, ali dodaj svoje.',
        room_type_hint: 'Odkljukaj, kar ta tip sobe ima. Shrani se ločeno od nastavitev sobe.',
    },
    company: {
        company: 'Podjetje',
        companies: 'Podjetja',
        hint: 'Podjetja, ki plačujejo rezervacije. Vodijo se za celotnega najemnika, ne za posamezen objekt — pogodba je ena.',
        add: 'Dodaj podjetje',
        edit: 'Uredi podjetje',
        legal_name: 'Naziv',
        tax_number: 'Davčna številka',
        tax_number_hint: 'Davčna številka podjetja.',
        tax_number_taken: 'Podjetje s to davčno številko že obstaja.',
        vat_number: 'ID za DDV',
        vat_number_hint: 'Izpolni le pri zavezancu — na račun gre ta številka.',
        lookup:             'Poišči po ID za DDV',
        lookup_done:        'Podatki iz registra so vpisani v prazna polja.',
        lookup_not_found:   'Te številke v evropskem registru DDV ni. Podjetje morda ni zavezanec — vpiši podatke ročno.',
        lookup_unavailable: 'Register ni odgovoril. Vpiši podatke ročno.',
        lookup_invalid:     'To ni številka za DDV. Vpiši 8-mestno davčno številko (npr. 40978273) ali ID za DDV s predpono države (SI40978273, DE…).',
        register:                'Poišči v registru',
        register_hint:           'Slovenski register davčnih zavezancev (FURS). Vpiši ime podjetja — davčna številka, ID za DDV in naslov se prepišejo iz registra.',
        register_search:         'Ime podjetja',
        register_placeholder:    'npr. Mercator',
        register_town:           'Kraj (neobvezno)',
        register_min:            'Vpiši vsaj tri črke imena.',
        register_none:           'V registru ni podjetja s tem imenom. V registru je zapisan uradni naziv, ki pogosto ni tisti z dopisa — poskusi z drugo besedo ali vpiši podatke ročno.',
        register_failed:         'Registra ni bilo mogoče prebrati. Vpiši podatke ročno.',
        register_taken:          'Prevzeto iz registra. Naziv je uradni — če hiša podjetje kliče drugače, ga popravi.',
        register_empty:          'Register še ni prenesen na tej namestitvi, zato iskanje ne najde ničesar. Osveži se sam vsako noč.',
        register_vat_payer:      'zavezanec za DDV',
        register_not_vat_payer:  'ni zavezanec za DDV',
        register_sole_trader:    's.p.',
        register_state:          'Register FURS: osvežen {when}, {count} zavezancev',
        register_state_never:    'Register FURS: še ni prenesen',
        register_state_problem:  'Register FURS: zadnji prenos ni uspel — {note}',
        contact: 'Kontaktna oseba',
        payment_terms: 'Plačilni rok',
        payment_terms_hint: 'Koliko dni po računu podjetje plača. Nič pomeni takoj — in samo z rokom odjava ni ustavljena zaradi odprtega salda.',
        days: '{count} dni',
        pos_buyer_id: 'Oznaka kupca v blagajni',
        pos_buyer_id_hint: 'Neobvezno. Kupca v Imprion POS je treba ustvariti tam; tu se le poveže.',
        active_hint: 'Izklopljeno podjetje se ne ponuja več, obstoječi računi pa ostanejo nedotaknjeni.',
    },
    // Kaj se je z računom dogajalo. Račun se nikoli ne popravlja, zato to ni seznam
    // različic, ampak seznam trenutkov, v katerih je dokument sodeloval.
    invoice_history: {
        title:     'Zgodovina',
        hint:      'Kdaj je bil račun izdan, potrjen na FURS, plačan in morebiti storniran.',
        issued:    'Izdan',
        fiscal:    'Zaščitna oznaka (ZOI)',
        confirmed: 'Potrdil FURS (EOR)',
        payment:   'Plačilo',
        storno:    'Storniran z dobropisom',
        storno_of: 'Stornira račun',
    },
    // Natisnjeni račun. Besedilo je namenjeno gostu in računovodstvu, ne zaslonu.
    invoice_print: {
        reservation: 'Rezervacija',
        room:        'Soba',
        not_subject_to_vat: 'Ni predmet DDV',
        total_without_vat:  'Skupaj brez DDV',
        discount:            'popust',
        paper_a4: 'A4',
        paper_receipt: 'Trak 80 mm',
        invoice:             'RAČUN',
        credit_note:         'DOBROPIS',
        issued_at:           'Datum in čas izdaje',
        service_period:      'Obdobje storitve',
        payment_method:      'Način plačila',
        due_date:            'Rok plačila',
        buyer:               'Kupec',
        buyer_tax_number:    'Davčna številka',
        tax_number:          'Davčna številka',
        vat_number:          'ID za DDV',
        registration_number: 'Matična številka',
        description:         'Opis',
        quantity:            'Kol.',
        unit_price:          'Cena',
        tax_rate:            'DDV',
        amount:              'Vrednost',
        tax_base:            'Osnova',
        tax_amount:          'DDV',
        total:               'Skupaj',
        total_due:           'SKUPAJ ZA PLAČILO',
        remaining:           'Preostanek',
        operator:            'Operater',
        eor_pending:         'EOR še ni prejet — račun je bil izdan ob nedosegljivosti FURS in bo potrjen naknadno.',
        storno_of:           'Dobropis k računu {number}',
        tourist_tax:         'Turistična in promocijska taksa',
        tourist_tax_note:    'Pobrano v imenu in za račun občine. Ni vključeno v davčno osnovo DDV.',
        reference:           'Sklic',

        // Predplačila: naslov dokumenta, sklic na predračun in blok odbitka.
        advance_invoice:     'RAČUN ZA PREDPLAČILO',
        by_proforma:         'Po predračunu: {number}',
        advance_deductions:  'Odbitek predplačil',
        advance_deducted:    'Predplačilo po računu {number} z dne {date}',
    },
    // Glava računa: kdo ga izda in pod katerimi številkami.
    identity: {
        vat_payer: 'Zavezanec za DDV',
        vat_payer_label: 'Hotel je zavezanec za DDV',
        vat_payer_help: 'Davčna številka in ID za DDV sta ista številka — ID se izpelje sam (SI + davčna).',
        vat_payer_derived: 'ID za DDV: {vat}',
        title:                    'Podatki izdajatelja',
        hint:                     'Natisne se na vsak račun. Podatki so podjetja, ne dokumenta — ponatis starega računa pokaže današnji naslov in račun.',
        legal_name:               'Naziv pravne osebe',
        legal_name_help:          'Pusti prazno, če je enak imenu objekta.',
        tax_number:               'Davčna številka',
        vat_number:               'ID za DDV',
        vat_number_help:          'Npr. SI12345678. Pusti prazno, če hotel ni zavezanec za DDV.',
        registration_number:      'Matična številka',
        iban:                     'IBAN',
        bic:                      'BIC / SWIFT',
        email:                    'E-pošta',
        phone:                    'Telefon',
        payment_terms: 'Rok plačila (dni)',
        payment_terms_help: 'Koliko dni od izdaje ima kupec za plačilo računa, ki ob izdaji ni poravnan. 0 pomeni plačljivo ob izdaji.',
        vat_exemption_note:       'Klavzula o oprostitvi DDV',
        vat_exemption_note_help:  'Stavek, ki se natisne namesto stopnje, kadar hotel DDV ne obračunava.',
    },
    integration: {
        connection: 'Nastavitve za blagajno',
        copy_connection: 'Kopiraj vse',
        title: 'Blagajne in povezave',
        hint: 'Ključi, s katerimi hotelske naprave knjižijo porabo na sobo — blagajna v baru, v restavraciji, v velnesu. Ključ ni uporabniški račun: sme samo knjižiti račun na folio gosta v hotelu.',
        issue: 'Izdaj ključ',
        name_hint: 'Kako tej napravi rečete v hotelu — „Bar terasa“, „Restavracija“. Ime se izpiše ob vsaki postavki, ki jo blagajna knjiži.',
        issued_title: 'Ključ je izdan',
        issued_hint: 'Prepiši ga zdaj v blagajno — shranjena je samo zgoščena vrednost, zato ga ni več mogoče pokazati. Če se izgubi, izdaj novega in tega prekliči.',
        copy: 'Kopiraj',
        copied: 'Kopirano',
        copy_failed: 'Ključa ni bilo mogoče kopirati — označi ga in kopiraj ročno.',
        prefix: 'Začetek ključa',
        last_used: 'Nazadnje uporabljen',
        never_used: 'še nikoli',
        revoked: 'Preklican',
        revoke: 'Prekliči',
        revoke_confirm: 'Prekličem ključ „{name}“? Ta blagajna od tega trenutka ne bo mogla več knjižiti na sobo.',
        restore: 'Povrni',
        empty: 'Ta objekt še nima izdanega nobenega ključa.',
    },
    invoice: {
        issued_for:     '{buyer} · {amount}',
        show_and_print: 'Prikaži in natisni',
        storno_fiscal_title: 'Dobropis se pošlje na FURS',
        storno_fiscal_hint: 'Hotel račune davčno potrjuje sam, zato bo dobropis dobil svojo številko na isti napravi, svojo zaščitno oznako in potrditev FURS. Ročno ni treba ničesar vnašati.',
        paid:                     'Plačano',
        language: 'Jezik računa',
        language_hint: 'Dokument se natisne v tem jeziku, ne glede na jezik vmesnika bralca.',
        to_company: 'Račun na podjetje',
        to_company_hint: 'Podjetje izberi iz registra — naziv, naslov in davčna se prepišejo z zapisa.',
        pdf:                      'PDF / natisni',
        invoices:                 'Računi',
        invoice:                  'Račun',
        document:                 'Dokument',
        number:                   'Številka',
        issued_from_folio_hint:   'Račun se izda s folia gosta. Izdanega računa ni mogoče spreminjati ali brisati — edini popravek je storno z dobropisom.',
        business_date:            'Poslovni dan',
        business_date_from:       'Poslovni dan od',
        business_date_to:         'Poslovni dan do',
        issued_at:                'Izdan',
        buyer:                    'Kupec',
        buyer_name:               'Naziv kupca',
        tax_number:               'Davčna številka',
        tax_number_hint:          'Obvezna le, kadar kupec želi račun na podjetje.',
        buyer_snapshot_hint:      'Podatki kupca so prepis stanja ob izdaji. Poznejša sprememba profila gosta izdanega računa ne spremeni.',
        note:                     'Opomba',
        lines:                    'Postavke',
        source_ref:               'račun',
        not_subject_to_vat:       'Ni predmet DDV',
        description:              'Opis',
        quantity:                 'Količina',
        unit_price:               'Cena na enoto',
        tax_rate:                 'Stopnja DDV',
        amount:                   'Znesek',
        tax_recap:                'Rekapitulacija DDV',
        net:                      'Osnova',
        tax:                      'DDV',
        gross:                    'Skupaj z DDV',
        total_net:                'Osnova skupaj',
        total_tax:                'DDV skupaj',
        total_gross:              'Za plačilo',
        payments:                 'Plačila',
        payments_hint:            'Plačila pripadajo foliu gosta, s katerega je bil račun izdan, ne računu samemu.',
        payments_total:           'Plačano skupaj',
        issue:                    'Izdaj račun',
        issue_irreversible_title: 'Izdaja je dokončna',
        issue_irreversible_hint:  'Izdanega računa ni mogoče spremeniti ali izbrisati. Popravek pomeni storno z dobropisom in nov račun, zato zdaj preveri podatke kupca in postavke.',
        issue_preview:            'Predogled računa',
        issue_preview_hint:       'Tako bo račun videti. Postavke so prevzete s folia gosta in jih tu ni mogoče spreminjati.',
        confirm_issue:            'Izdam račun za kupca {buyer} v znesku {amount}? Izdaje ni mogoče preklicati.',
        issued:                   'Račun je izdan',
        issue_failed:             'Računa ni bilo mogoče izdati. Nič ni bilo izdano in nič fiskalizirano — odpravi vzrok in poskusi znova.',
        folio_not_open:           'Folio ni odprt, zato z njega ni mogoče izdati računa.',
        folio_nothing_to_invoice: 'Na foliu ni postavk za račun. Prazna kartica ali kartica, na kateri je vsaka postavka v celoti stornirana — stornirani pari se na račun ne izpišejo.',
        folio_not_positive:       'Skupni znesek folia ni večji od nič.',
        omitted_reversed_pairs:   'Izpuščeni stornirani pari: {count}',
        storno:                   'Storno',
        storno_create:            'Izdaj dobropis',
        storno_explanation_title: 'Storno ne izbriše računa',
        storno_explanation:       'Račun {number} ostane veljaven in nespremenjen. Poleg njega nastane nov dokument — dobropis z nasprotnimi zneski, z lastno številko iz iste serije in z današnjim poslovnim dnem.',
        storno_pos_title:         'Dobropis se ne pošlje v blagajno',
        storno_pos_warning:       'Imprion POS nima klica za storno, zato dobropis ni fiskaliziran. Popravek mora nekdo ročno vnesti v zaledje blagajne, sicer ostane nenarejen.',
        original_invoice:         'Prvotni račun',
        stays_valid:              'Ostane veljaven',
        credit_note_amount:       'Znesek dobropisa',
        credit_note_date_hint:    'Z današnjim poslovnim dnem, ne z dnem prvotnega računa.',
        storno_full: 'Cel dokument',
        storno_partial: 'Del dokumenta',
        partial_amount: 'Dobropis za izbrano: {amount}.',
        partial_needs_lines: 'Izberi vsaj eno postavko.',
        archive_pdf: 'Arhiviran PDF',
        archive_missing: 'Ta dokument še nima arhiva — izdan je bil, preden je arhiv obstajal.',
        storno_reason:            'Razlog storna',
        storno_reason_hint:       'Razlog se zapiše na dobropis in je prvo, kar prebere revizija. Napiši, kaj se je zgodilo.',
        confirm_storno:           'Izdam dobropis k računu {number}? Račun ostane veljaven, dobropis pa je dokončen.',
        storno_created:           'Dobropis je izdan',
        storno_failed:            'Dobropisa ni bilo mogoče izdati',
        storno_of_link:           'Odpri prvotni račun',
        cancelled_by_title:       'Stornirano z dobropisom {number}',
        cancelled_by_hint:        'Račun ostane veljaven dokument in se ne spremeni — dobropis je samostojen dokument, ki ga izniči.',
        credit_note_title:        'Dobropis k računu {number}',
        credit_note_hint:         'Ta dokument je dobropis: zneski so nasprotni in izničijo prvotni račun. Dobropisa samega ni mogoče stornirati — popravek dobropisa je nov račun.',
        open_credit_note:         'Odpri dobropis',
        open_original:            'Odpri prvotni račun',
        fiscal:                   'Fiskalizacija',
        fiscal_confirmed:         'Potrjeno na FURS',
        fiscal_pending:           'Čaka potrditev FURS',
        fiscal_pending_hint:      'Račun je izdan in fiskaliziran — ZOI je izračunan — FURS pa še ni odgovoril. To je zakonito stanje, saj sme potrditev prispeti v 48 urah, in ni napaka. Ukrepati ni treba.',
        fiscal_none:              'Ni fiskalizirano',
        provider_imprion_pos:     'Imprion POS',
        provider_furs:            'FURS (neposredno)',
        zoi:                      'ZOI',
        eor:                      'EOR',
        confirmed_at:             'Potrjeno',
        bill_number:              'Številka računa v blagajni',
        business_unit:            'Poslovni prostor',
        cash_register:            'Elektronska naprava',

        // Predplačila: vrsta dokumenta, sklic na predračun, odbitek in dve zavrnitvi.
        kind:                     'Vrsta',
        kind_final:               'Račun',
        kind_advance:             'Račun za predplačilo',
        kind_all:                 'Vse vrste',
        by_proforma:              'Po predračunu {number}',
        advance_deduction_tag:    'Odbitek predplačila',
        advance_deductions_hint:  'Postavke z negativnim zneskom odbijejo že prejeto predplačilo — skupaj z DDV po stopnjah. Znesek za plačilo je zato že zmanjšan zanje.',
        advance_already_consumed: 'To predplačilo je že odbito na računu {number}. Najprej storniraj tisti račun, šele nato je predplačilo spet na voljo.',
        advance_already_consumed_unknown: 'To predplačilo je že odbito na izdanem računu. Najprej storniraj tisti račun, šele nato je predplačilo spet na voljo.',
        advance_exceeds_total:    'Prejeta predplačila presegajo vrednost bivanja. Gost je preplačal — izdaj delni dobropis k računu za predplačilo in razliko vrni, računa z negativnim zneskom ni mogoče izdati.',
    },
    invoice_status: {
        issued:    'Izdan',
        cancelled: 'Dobropis',
    },
    // Ko hotel fiskalizira sam: kar mora davčni organ vedeti o poslovnem prostoru in
    // napravi, preden sme ta hotel izdati račun.
    certificate: {
        title: 'Digitalna potrdila',
        hint: 'S čim ta sistem podpisuje v imenu podjetja. Potrdilo je podjetja in ne posameznega hotela — davčni organ ga izda enega na zavezanca in isto podpisuje za vse objekte.',
        none: 'Ni naloženega potrdila.',
        no_permission: 'Za potrdila nimaš pravice.',
        upload: 'Naloži potrdilo',
        upload_failed: 'Potrdila ni bilo mogoče naložiti.',
        uploaded: 'Potrdilo je naloženo.',
        deactivate: 'Upokoji',
        deactivated: 'Potrdilo je upokojeno.',
        retired: 'Upokojeno',
        purpose: 'Namen',
        purpose_hint: 'Fiskalizacijsko izda davčni organ sam. Poročevalsko je kvalificirano potrdilo komercialnega izdajatelja, vpisano v profil podjetja na AJPES.',
        purpose_fiscalisation: 'Fiskalizacija (FURS)',
        purpose_reporting: 'Poročanje (AJPES)',
        label: 'Ime',
        label_hint: 'Vaše lastno ime zanj — „FURS blagajna“, „Halcom, direktorica“ — da ob zamenjavi veste, katero je katero.',
        file: 'Datoteka',
        file_hint: 'PKCS#12 (.p12 ali .pfx), kakršnega je izdal izdajatelj.',
        file_password: 'Geslo datoteke',
        file_password_hint: 'Odklene datoteko in se ne shrani — varovalo je samo prenos.',
        portal_username: 'Uporabniško ime na portalu',
        portal_hint: 'Račun, s katerim to potrdilo podpisuje. Fiskalizacijsko potrdilo računa nima.',
        portal_password: 'Geslo na portalu',
        sealed: 'Potrdilo se zapečati',
        sealed_hint: 'Gradivo in gesla so zapečateni in jih noben zaslon ne vrne nazaj. Vidno je samo, kar piše na potrdilu: komu pripada, kdo ga je izdal in do kdaj velja.',
        valid_until: 'Velja do {date}',
    },
    fiscal: {
        moved_hint: 'Fiskalizacija se ureja v Nastavitve (zobnik) → Finance in skladnost → Blagajne, skupaj z blagajnami, ki izdajajo račune, in potrdili, ki jih podpisujejo.',
        moved_open: 'Odpri Blagajne',
        title:                            'Fiskalizacija',
        hint:                             'Ko hotel davčno potrjuje račune sam, jih PMS podpiše in pošlje na FURS. Digitalno potrdilo je podjetjevo in se naloži enkrat, v nastavitvah potrdil.',
        settings_hint:                    'Pusti prazno, če hotel računov ne potrjuje sam — takrat jih potrdi blagajna.',
        settings:                         'Nastavitve objekta',
        certificate:                      'Digitalno potrdilo',
        premises:                         'Poslovni prostor',
        tax_number:                       'Davčna številka zavezanca',
        tax_number_help:                  'Osem številk. Mora biti ista kot na digitalnem potrdilu, sicer FURS sporočilo zavrne.',
        business_premise_id:              'Oznaka poslovnega prostora',
        business_premise_id_help:         'Vpiše se enkrat in se ne spreminja — je del vsake zaščitne oznake (ZOI), ki jo je ta hotel kdaj izračunal.',
        electronic_device_id:             'Oznaka elektronske naprave',
        electronic_device_id_help:        'Blagajna tega hotela. Tudi ta je del vsake zaščitne oznake.',
        cadastral_number:                 'Katastrska občina',
        building_number:                  'Številka stavbe',
        building_section_number:          'Številka dela stavbe',
        software_supplier_tax_number:     'Davčna številka dobavitelja programske opreme',
        software_supplier_tax_number_help: 'Naša, ne hotelova. FURS jo zahteva pri prijavi poslovnega prostora.',
        register_premises:                'Prijavi poslovni prostor',
        premises_registered:              'Poslovni prostor je prijavljen na FURS.',
        premises_failed:                  'Poslovnega prostora ni bilo mogoče prijaviti.',
        premises_missing_hint:            'Dokler poslovni prostor ni prijavljen, FURS zavrne vsak račun iz tega hotela. Prijava je enkratno dejanje.',
        certificate_missing_hint:         'Naloži digitalno potrdilo podjetja (namen: fiskalizacija) v nastavitvah potrdil.',
        unconfirmed:                      'Nepotrjeni računi',
        unconfirmed_hint:                 'Računi so izdani in veljavni — zaščitna oznaka je izračunana — FURS pa jih še ni potrdil. Sistem jih pošilja naprej sam; zakon daje 48 ur. Če številka ne pada, preveri povezavo.',
    },

    registration: {
        stay_title: 'Prijave gostov',
        stay_hint: 'Kar je bilo o tem bivanju sporočeno v eTurizem. Če je prijava zavrnjena, popravi podatek pri gostu in sproži ponovno prijavo.',
        retry: 'Ponovna prijava',
        retry_queued: 'Prijava je uvrščena v vrsto.',
        retry_failed: 'Ponovne prijave ni bilo mogoče sprožiti.',
        retry_rebuilds: 'Ta prijava eTurizma še ni dosegla — ponovni poskus bo vzel gostove trenutne podatke.',
        retry_keeps_snapshot: 'Ta prijava je bila že oddana — ponovni poskus pošlje enak posnetek. Za spremembo podatkov oddaj novo prijavo.',
        filed_at: 'Oddano {at}',
        serial: 'Zap. št.',
        package: 'paket',
        reporting:      'Poročanje AJPES/eTurizem',
        reporting_settings_hint: 'Brez teh dveh podatkov hotel ne more prijaviti gosta. Dobiš ju pri vpisu obrata v register nastanitvenih obratov.',
        facility_id:    'Številka nastanitvenega obrata (idNO)',
        facility_id_help: 'Iz registra nastanitvenih obratov. 0 pomeni, da hotel še ni vpisan in ne poroča.',
        serial_start:   'Zadnja uporabljena zaporedna številka letos',
        serial_start_help: 'Če je knjigo gostov letos vodil kdo drug (spletna aplikacija AJPES, papir, drug sistem), vpiši zadnjo številko — naša prva prijava dobi naslednjo. Sprememba pozneje ne prešteva že oddanih.',
        status:         'Stanje',
        reported_at:    'Prijavljen',
        registered_by:  'Prijavil',
        note:           'Opomba',
        attempts:       'Poskusov oddaje: {count}',
        report_hint:    'Kar je hotel sporočil državi. Zavrnjeno vrstico lahko popraviš kar tu — odpri gosta, popravi podatek in pošlji znova; isto je še naprej mogoče tudi pri bivanju gosta.',
        edit_guest:     'Uredi gosta',
        resend:         'Pošlji znova',
        guest_load_failed: 'Gosta ni bilo mogoče odpreti.',
        window:             'Obdobje se nanaša na',
        window_arrivals:    'Prijave v obdobju',
        window_departures:  'Odjave v obdobju',
        window_arrivals_help:   'Gostje, katerih prijava v eTurizem je bila vložena v izbranem obdobju.',
        window_departures_help: 'Gostje, katerih odjava je bila vložena v izbranem obdobju — najnovejša najprej.',
        departure_reported: 'Odjavljen',
        still_registered:   'še prijavljen',
        sent_hint:      'Sistem je sprejel',
        pending_hint:   'Čaka v vrsti',
        failed_hint:    'Za pregled',
        // Pas „danes“ na vrhu zaslona: kaj država še čaka na današnji hotelski dan.
        outstanding_failed:         'Zavrnjene danes',
        outstanding_pending:        'V vrsti danes',
        outstanding_unregistered:   'Neprijavljeni v hiši',
        outstanding_departures_due: 'Nesporočene odjave',
        // Plošči, ki poimenujeta tisto, česar register nima v nobeni vrstici.
        unregistered_panel_hint:  'Te osebe so v hiši in država o njih še ni obveščena. Prijavi jih tu — gumb preveri podatke in odda prijavo v eTurizem. Rok je 12 ur po prihodu.',
        unregistered_panel_empty: 'Nihče ni neprijavljen — vsi, ki so prišli, so oddani v eTurizem.',
        unregistered_nameless:    'Gost brez imena',
        unregistered_stay:        '{arrival} – {departure} · {nights} noči',
        unregistered_arrived:     'prihod {at}',
        file_guest:               'Prijavi',
        open_reservation:         'Odpri rezervacijo',
        // Prijava iz plošče „Neprijavljeni v hiši“: gumb, ki odda, in gumb, ki pošlje
        // po manjkajoči podatek — kateri od njiju se izriše, odloči `missing`.
        file_ajpes:               'Prijavi v AJPES',
        filed_ok:                 'Prijava oddana v eTurizem — {name}',
        complete_data:            'Dopolni podatke',
        missing_prefix:           'Manjka',
        file_incomplete:          'Prijave ni mogoče oddati — gostu manjka: {fields}. Dopolni podatke o gostu in poskusi znova.',
        // Imena polj, kot jih zahteva eTurizem. Ključe pošlje strežnik
        // (DataStructures.RegisteredGuest.Missing), besede so tu.
        missing: {
            first_name:      'ime',
            last_name:       'priimek',
            nationality:     'državljanstvo',
            document_type:   'vrsta dokumenta',
            document_number: 'številka dokumenta',
            date_of_birth:   'datum rojstva',
            sex:             'spol',
        },
        departures_due_panel_hint:  'Za te goste pri državi še vedno piše, da so pri nas. Odjava je ista prijava, oddana še enkrat z datumom odhoda; sproži jo pri rezervaciji. Rok je 12 ur po odhodu.',
        departures_due_panel_empty: 'Vse odjave so sporočene.',
        departures_due_capped:      'Prikazanih {shown} od {total} — najprej tiste z najnovejšim odhodom.',
        departures_due_left:        'odšel {on}',
    },
    /**
     * Poročanje — dostop objekta do AJPES eTurizem (docs/ETURIZEM.md § 4.3).
     *
     * Svoj imenski prostor in ne del `registration`, ker to niso podatki o prijavi gosta,
     * ampak poverilnice hiše: kdo poroča, s katerim potrdilom in ali povezava deluje.
     * `eturizem_error` spodaj pa razlaga zavrnitve posamezne prijave.
     */
    eturizem: {
        title: 'Poročanje',
        hint: 'Uporabniško ime, geslo in digitalno potrdilo, s katerimi ta objekt poroča v AJPES eTurizem. AJPES pravico za poročanje dodeli za posamezen nastanitveni obrat, zato jih vpišeš po objektu.',
        no_permission: 'Za te nastavitve potrebuješ pravico za upravljanje digitalnih potrdil.',

        environment_title: 'Ta objekt poroča s poverilnicami namestitve',
        environment_hint: 'Uporabniško ime in potrdilo sta nastavljena ob namestitvi (okoljske spremenljivke) in prijave gredo skozi. Vpiši spodnje podatke le, če naj ta objekt poroča s svojim računom AJPES — na primer, ker je pravica za njegov obrat dodeljena drugemu uporabniku.',

        nowhere_title: 'Prijave nikamor ne gredo',
        nowhere_hint: 'Ta objekt nima svojih poverilnic, namestitev pa jih tudi ne. Prijave gostov se nabirajo v vrsti in bodo oddane, ko bosta vpisana uporabniško ime in potrdilo.',

        username: 'Uporabniško ime AJPES',
        username_description: 'Račun na portalu AJPES, s katerim ta objekt poroča (uName v klicu servisa).',
        username_help: 'Prazno pomeni, da objekt poroča s poverilnicami namestitve. Naj bo namenski račun, ne osebni račun recepcije. Uporabnik mora imeti v aplikaciji eTurizem dodeljeno pravico za poročanje za številko obrata tega objekta, sicer AJPES zavrne z napako 41397.',

        password: 'Geslo AJPES',
        password_description: 'Geslo istega računa (pwd v klicu servisa). Shrani se šifrirano in se nikoli ne prikaže nazaj.',
        password_help: 'Prazno polje pomeni „ne spreminjaj“ — ne izbriši. Za odvzem gesla uporabi gumb „Odstrani geslo“.',
        password_set: 'nastavljeno',
        set: 'nastavljeno',
        clear_password: 'Odstrani geslo',
        clear_password_confirm: 'Ali res odstranim shranjeno geslo AJPES? Dokler ne vpišeš novega, ta objekt ne bo mogel poročati s svojim računom.',

        base_url: 'Naslov servisa (neobvezno)',
        base_url_description: 'Prazno pomeni naslov, ki je nastavljen za celo namestitev — običajno pravi (produkcijski) servis AJPES.',
        base_url_help: 'Vpiši le, če naj ta objekt poroča na drug naslov, na primer na testni servis AJPES, medtem ko je preostanek namestitve že v živo.',
        base_url_placeholder: 'kot je nastavljeno za namestitev',

        certificate: 'Kvalificirano digitalno potrdilo (KDP)',
        certificate_description: 'Spletni servis eTurizem zahteva potrdilo pri vsakem klicu, ne le ob nastavitvi. Potrdilo mora biti vpisano v profil uporabnika na portalu AJPES (Evidenca digitalnih potrdil).',
        certificate_none: 'Potrdilo za ta objekt še ni naloženo.',
        certificate_file: 'Datoteka potrdila',
        certificate_file_description: 'Sprejmemo .p12 ali .pfx, kot ga izda overitelj, in .pem, če je bilo potrdilo že pretvorjeno.',
        certificate_file_help: 'Če datoteke ni mogoče prebrati takšne, kot je, jo pretvori z: openssl pkcs12 -legacy -in kdp.p12 -out kdp.pem -nodes in naloži .pem.',
        certificate_password: 'Geslo datoteke',
        certificate_password_description: 'Geslo, s katerim se odpre .p12. Ne shranimo ga — varuje le datoteko na poti do nas.',
        certificate_password_help: 'Pretvorjena datoteka .pem gesla običajno ne potrebuje.',
        certificate_upload: 'Naloži potrdilo',
        certificate_uploaded: 'Potrdilo je shranjeno.',
        certificate_upload_failed: 'Potrdila ni bilo mogoče shraniti.',
        certificate_delete: 'Odstrani potrdilo',
        certificate_delete_confirm: 'Ali res odstranim potrdilo tega objekta? Dokler ne naložiš novega, prijave s svojim računom ne bodo šle skozi.',
        certificate_deleted: 'Potrdilo je odstranjeno.',
        valid_until: 'Velja do {date}',

        sealed: 'Geslo in potrdilo sta šifrirana',
        sealed_hint: 'Oboje se shrani šifrirano s ključem namestitve in ga nobena pot v portalu ne vrne nazaj. Na zaslonu ostane le, kaj piše na potrdilu — komu je izdano, kdo ga je izdal in do kdaj velja.',

        check: 'Preveri povezavo',
        check_hint: 'Preverjanje prebere šifrant držav — ničesar ne prijavi in ničesar ne spremeni. Dokaže uporabniško ime, geslo in potrdilo; pravice za posamezno številko obrata (napaka 41397) ne more dokazati, to pokaže šele prva prava prijava.',
        check_ok: 'Povezava deluje',
        check_failed: 'Povezava ne deluje',
        last_check: 'Zadnje preverjanje',
        never_checked: 'Povezava še ni bila preverjena.',
    },
    eturizem_error: {
        why:               'Zakaj je oddaja spodletela',
        answer:            'Odgovor sistema',
        generic:           'Sistem eTurizem je prijavo zavrnil.',
        generic_hint:      'Preveri spodnji odgovor sistema, popravi podatek, na katerega opozarja, in sproži ponovno prijavo.',
        birth:             'Datum rojstva gosta je za eTurizem nemogoč — pred letom 1800, v prihodnosti ali starejši od 120 let.',
        birth_hint:        'Popravi datum rojstva pri gostu na bivanju in sproži ponovno prijavo. Najpogosteje gre za tipkarsko napako v letnici.',
        birth_missing:     'Gost nima vpisanega datuma rojstva, eTurizem pa ga zahteva.',
        birth_missing_hint: 'Vpiši datum rojstva pri gostu na bivanju in sproži ponovno prijavo.',
        sex:               'Spol gosta ni zapisan tako, kot ga eTurizem pozna — sprejme samo moški ali ženski.',
        sex_hint:          'Popravi spol pri gostu na bivanju in sproži ponovno prijavo.',
        country:           'Državljanstvo gosta ni veljavna koda države iz šifranta eTurizem.',
        country_hint:      'Popravi državljanstvo pri gostu na bivanju (dvočrkovna koda, npr. SI, DE) in sproži ponovno prijavo.',
        document_type:     'Vrsta dokumenta ni ena od tistih, ki jih eTurizem pozna.',
        document_type_hint: 'Popravi vrsto dokumenta pri gostu (osebna izkaznica = I, potni list = P) in pošlji znova.',
        document_number:   'Številka dokumenta je prekratka — eTurizem zahteva vsaj dva znaka.',
        document_number_hint: 'Vpiši celotno številko dokumenta pri gostu na bivanju in sproži ponovno prijavo.',
        name:              'Ime ali priimek gosta je za eTurizem prekratek ali predolg.',
        name_hint:         'Popravi ime in priimek pri gostu na bivanju in sproži ponovno prijavo.',
        arrival_missing:   'Prijava nima časa prihoda, eTurizem pa ga zahteva.',
        arrival_missing_hint: 'Preveri prihod na rezervaciji in sproži ponovno prijavo.',
        dates:             'Datuma prihoda in odhoda si nasprotujeta ali sta zunaj obdobja, ki ga eTurizem sprejme.',
        dates_hint:        'Popravi prihod in odhod na rezervaciji in sproži ponovno prijavo.',
        date_window:       'Datum prihoda ali odhoda je zunaj obdobja, v katerem eTurizem še sprejema prijave.',
        date_window_hint:  'Prijava je prepozna ali predčasna. Preveri datuma na rezervaciji; če sta pravilna, se glede vnosa za nazaj obrni na AJPES.',
        tourist_tax:       'Podatek o turistični taksi ni sprejemljiv — razlog oprostitve ali višina takse.',
        tourist_tax_hint:  'Preveri turistično takso pri gostu in nastavitve takse objekta, nato sproži ponovno prijavo.',
        credentials:       'eTurizem ni sprejel uporabniškega imena ali gesla objekta.',
        credentials_hint:  'Uporabniško ime in geslo popravi v Nastavitve (zobnik) → Objekt in sobe → Objekti → odpri objekt → zavihek Podatki objekta → Poročanje in pritisni „Preveri povezavo“. Če je kartica prazna, objekt poroča s poverilnicami namestitve — te nastavi skrbnik sistema. Dokler poverilnice niso pravilne, ne bo šla skozi nobena prijava.',
        authorisation:     'Uporabnik nima pooblastila za ta nastanitveni obrat.',
        authorisation_hint: 'Pooblastilo za obrat se uredi pri AJPES. Preveri tudi, ali je v nastavitvah objekta vpisana prava številka obrata.',
        establishment:     'Nastanitveni obrat v registru ne obstaja, ni aktiven ali je izbrisan.',
        establishment_hint: 'Preveri številko obrata v Nastavitve (zobnik) → Objekt in sobe → Objekti → odpri objekt → zavihek Podatki objekta → Poročanje in stanje obrata v registru RNO.',
        certificate:       'Digitalno potrdilo objekta ni registrirano, še ne velja ali je poteklo.',
        certificate_hint:  'Veljavno potrdilo naloži v Nastavitve (zobnik) → Objekt in sobe → Objekti → odpri objekt → zavihek Podatki objekta → Poročanje; kartica pokaže, komu je izdano in do kdaj velja. Potrdilo mora biti vpisano tudi v profil uporabnika na portalu AJPES. Če kartica nima svojega potrdila, objekt uporablja potrdilo namestitve. Prijave do takrat ne bodo šle skozi.',
        serial_conflict:   'Zapis s to zaporedno številko je v tem letu vpisal drug uporabnik.',
        serial_conflict_hint: 'Zaporedna številka je bila pri AJPES že uporabljena. Pošlji znova — prijava dobi naslednjo številko. Če se ponavlja, dvigni „Zadnja uporabljena zaporedna številka“ v nastavitvah objekta (Poročanje).',
        already_filed:     'Ta zapis je bil oddan že prej; eTurizem ga ne bo sprejel dvakrat.',
        already_filed_hint: 'Gost je najverjetneje že prijavljen. Preveri v knjigi gostov na eTurizem; če je res prijavljen, prijave ni treba ponavljati.',
        monthly_window:    'Mesečno poročilo je mogoče oddati le v določenem obdobju.',
        monthly_window_hint: 'Počakaj na obdobje za oddajo in poskusi znova.',
        too_many:          'Paket je vseboval preveč zapisov.',
        too_many_hint:     'Sproži ponovno prijavo; sistem bo poslal manjši paket.',
        transient:         'eTurizem je imel začasno napako v obdelavi.',
        transient_hint:    'To gre običajno skozi samo od sebe — prijava je v vrsti za ponovni poskus. Če vztraja, sproži ponovno prijavo.',
        not_configured:    'Poročanje gostov za ta objekt ni nastavljeno.',
        not_configured_hint: 'Vpiši poverilnice in številko obrata v Nastavitve (zobnik) → Objekt in sobe → Objekti → odpri objekt → zavihek Podatki objekta → Poročanje.',
        our_fault:         'Prijava je bila zavrnjena zaradi napake v našem sistemu, ne zaradi podatkov gosta.',
        our_fault_hint:    'Sporoči nam to napako — na strani hotela ni kaj popraviti.',
    },
    registration_status: {
        pending:   'V vrsti',
        sent:      'Oddano',
        confirmed: 'Potrjeno',
        failed:    'Ni uspelo',
        cancelled: 'Preklicano',
    },
    partner: {
        partner_marker: 'partner',
        overview_count: 'naših: {count}',
        overview_no_free: 'Ta dan pri partnerju ni prostih terminov.',
        overview_unavailable: 'Partner se ne odziva — prosti termini niso znani.',
        overview_free: 'Prosto {from}–{to}',
        legend_free: 'prosto pri partnerju (v živo)',
        legend: 'zmogljivost partnerja (le naši gostje)',
        other_area: 'Drugo',
        partners: 'Partnerji',
        partner: 'Partner',
        add: 'Poveži partnerja',
        edit: 'Uredi partnerja',
        connection_hint: 'Zmogljivost, ki jo vodi drugo podjetje v sistemu Rezervacije. Ključ vam izda partner.',
        name: 'Ime partnerja',
        key: 'Ključ partnerja',
        key_hint: 'Ključ „rk_…“, ki ga je partner izdal temu hotelu. Pred shranjevanjem se preveri pri partnerju.',
        key_keep_hint: 'Hranjen je ključ {prefix}… — pustite prazno, da ostane, ali vpišite novega.',
        active: 'Povezava je vklopljena',
        saved: 'Partner je shranjen.',
        book: 'Rezerviraj pri partnerju',
        book_hint: 'Prosti termini se preberejo pri partnerju v tem trenutku.',
        service: 'Storitev',
        day: 'Dan',
        day_hint: 'Dan po koledarju partnerja.',
        slot: 'Prost termin',
        reading_slots: 'Berem proste termine pri partnerju …',
        no_slots: 'Ta dan partner nima prostega termina za to storitev.',
        slots_failed: 'Prostih terminov ni bilo mogoče prebrati.',
        pick_slot: 'Izberite termin',
        guest: 'Gost',
        guest_hint: 'Soba gosta, ki je v hotelu.',
        guest_placeholder: 'Soba ali priimek',
        price_line: 'Cena partnerja {price} · {minutes} min',
        booked: 'Rezervirano pri partnerju, koda {code}.',
        none: 'Ni povezanih partnerjev',
        none_hint: 'Wellness, terme ali golf, ki jih vodi drugo podjetje v sistemu Rezervacije, lahko recepcija rezervira neposredno od tu — s ključem, ki ga izda partner.',
        refresh: 'Osveži ponudbo',
        refreshed: 'Ponudba partnerja je osvežena.',
        refresh_failed: 'Ponudbe ni bilo mogoče osvežiti.',
        inactive: 'Povezava s tem partnerjem je izklopljena.',
        connection_trouble: 'Povezava s partnerjem trenutno ne deluje',
        our_guests: 'Naši gostje pri partnerju',
        no_bookings: 'Ta dan naši gostje pri tem partnerju nimajo rezervacij.',
        booked_by_partner: 'vpisal partner',
        cancelled_from_room_screen: 'odpovedano s sobnega zaslona',
        on_room: 'Na sobi',
        cancel: 'Odpovej pri partnerju',
        cancel_confirm: 'Odpovem „{service}“ ob {time} pri partnerju?',
        cancel_failed: 'Odpoved ni uspela.',
        cancelled: 'Rezervacija pri partnerju je odpovedana.',
        offer: 'Ponudba partnerja',
        minutes: '{minutes} min',
        synced_at: 'Ponudba prebrana {at}',
        at_partners: 'Pri partnerjih',
        none_for_guest: 'Gostje te rezervacije pri partnerjih nimajo ničesar rezerviranega.',
    },
    facility: {
        spots_total: '{count} parkirnih mest',
        duration: 'Trajanje (od – do)',
        pay_now: 'Takojšnje plačilo',
        pay_now_hint: 'Po shranjevanju se odpre blagajna: gotovina, kartica ali na sobo.',
        full: 'Polno',
        price_unit: 'Cena za',
        price_unit_hint: 'Za kaj velja cena — parkirno mesto na dan, dvorana na uro, masaža na obravnavo.',
        price_unit_hour: 'na uro',
        price_unit_day: 'na dan',
        price_unit_night: 'na noč',
        price_unit_person: 'na osebo',
        price_unit_use: 'na uporabo',
        price_unit_item: 'na kos',
        price_unit_treatment: 'na obravnavo',
        type_choose: 'Izberi …',
        type_search: 'Poišči tip — savna, dvorana, polnilnica …',
        type_no_match: 'Nič se ne ujema.',
        type_unknown: 'Neznan tip',
        setup_tab: 'Zmogljivosti',
        setup_title: 'Zmogljivosti hotela',
        setup_hint: 'Kaj hotel ima — bazen, terasa, dvorana, polnilnica — in kaj želimo s tem početi: prodajati po terminih, oglaševati, objaviti na spletni strani. Tu se postavi; delo s tem (koledar, cene, rezervacije) je pod Zmogljivosti.',
        setup_empty: 'Zmogljivosti še niso vpisane.',
        setup_empty_hint: 'Dodaj prvo — izbereš jo iz kataloga, vse ostalo se prilagodi izbranemu tipu.',
        setup_hours_hint: 'Kdaj je odprto. Neoznačen dan je zaprt dan; pri prostorih, ki se rezervirajo, je to hkrati čas, ko se sploh da rezervirati.',
        other_group: 'Drugo',
        type: 'Kaj je to',
        type_hint: 'Iz kataloga — savna, sejna soba, polnilnica … Izbira določi, katera polja ima ta zmogljivost.',
        class: 'Vrsta prodaje',
        class_hint: 'Kaj ta zmogljivost je: prostor po terminih, sredstvo, ki se vzame in vrne, storitev, ali območje, ki je gostom preprosto odprto.',
        class_unit: 'Nastanitvena enota',
        class_venue: 'Rezervabilni prostor',
        class_resource: 'Rezervabilno sredstvo',
        class_service: 'Storitev',
        class_area: 'Dostopno območje',
        class_operational: 'Operativni prostor',
        class_equipment: 'Oprema',
        status_open: 'Odprto',
        status_seasonal: 'Sezonsko',
        status_maintenance: 'V vzdrževanju',
        status_closed: 'Zaprto',
        status_planned: 'Načrtovano',
        uses: 'Kaj želimo s tem početi',
        uses_hint: 'Izbrano odpre ustrezno delo drugod: rezervacije v koledarju, cene v ceniku, opis in slike za splet in objave.',
        use_booking: 'Rezervacije',
        use_pricing: 'Cene',
        use_website: 'Spletna stran',
        use_social: 'Družbena omrežja',
        use_channels: 'Kanali (OTA)',
        accessibility: 'Dostopnost',
        access_step_free: 'Brez stopnic',
        access_lift: 'Dvigalo',
        access_accessible_wc: 'Prilagojeno stranišče',
        access_pool_lift: 'Dvigalo v bazen',
        access_hearing_loop: 'Indukcijska zanka',
        access_braille: 'Braillove oznake',
        access_assistance_dog: 'Vstop s psom vodnikom',
        location: 'Lokacija',
        floor: 'Nadstropje',
        capacity_people: 'Kapaciteta (oseb)',
        capacity_short: '{count} oseb',
        bookable: 'Rezervabilno',
        bookable_hint: 'Gost vzame termin.',
        chargeable: 'Obračunljivo',
        chargeable_hint: 'Za uporabo se zaračuna.',
        min_minutes: 'Najkrajše trajanje (min)',
        max_minutes: 'Najdaljše trajanje (min)',
        duration_hint: 'Nič pomeni brez omejitve.',
        preparation_minutes: 'Priprava (min)',
        preparation_hint: 'Čas pred in po terminu, ko je prostor zaseden, a ne prodan.',
        teardown_minutes: 'Pospravljanje (min)',
        min_age: 'Starost od',
        max_age: 'Starost do',
        age_hint: 'Nič pomeni brez omejitve.',
        access_rules: 'Pravila dostopa',
        access_rules_hint: 'Kar gostu povemo: kopalna kapa obvezna, brez stekla ob bazenu, samo za hotelske goste.',
        maintenance_interval: 'Vzdrževanje na (dni)',
        maintenance_hint: 'Nič pomeni, da ni rednega termina.',
        maintenance_notes: 'Kaj je treba narediti',
        description_hint: 'Za spletno stran in objave. Piši v jeziku, ki je izbran zgoraj.',
        no_fields: 'Za ta tip ni dodatnih polj.',
        photos_count: 'Slik: {count}',
        photos_after_save: 'Slike lahko dodaš, ko je zmogljivost shranjena.',
        tab_place: 'Kje in koliko',
        tab_selling: 'Prodaja',
        tab_details: 'Podrobnosti',
        tab_content: 'Opis in slike',
        description: 'Kar hotel prodaja poleg sobe — velnes, izposoja koles, parkirišče. Restavracija sem ne sodi: hotel jo ima in z njo oglašuje, račun za hrano pa je od blagajne.',
        add: 'Dodaj objekt ponudbe',
        edit: 'Uredi objekt ponudbe',
        facility: 'Objekt ponudbe',
        code_hint: 'Stalna oznaka za izvoze in podporo — wellness, kolesa, parkirisce. Male črke, števke in podčrtaj.',
        kind: 'Vrsta',
        kind_hint: 'Vrsta določa samo videz zaslonov; mehanizem pod njimi je en sam.',
        kind_wellness: 'Velnes',
        kind_hire: 'Izposoja',
        kind_rental: 'Najem',
        kind_other: 'Drugo',
        active_hint: 'Neaktivna zmogljivost ostane v evidenci, a se iz nje ne prodaja nič novega.',
        inactive: 'neaktivno',
        empty: 'Ponudba še ni postavljena.',
        empty_hint: 'Dodaj zmogljivost (velnes, kolesa), pod njo storitve s ceno in sredstva s koledarjem.',

        services: 'Storitve',
        service: 'Storitev',
        service_add: 'Dodaj storitev',
        service_edit: 'Uredi storitev',
        service_active_hint: 'Neaktivne storitve se ne dajo več prodati, obstoječe rezervacije ostanejo.',
        no_services: 'Brez storitev.',
        price: 'Cena',
        price_hint: 'Bruto cena storitve. Cenik sobe je ločen in se z njo ne meša.',
        tax_rate: 'Stopnja DDV',
        guest_cancel: 'Spletna odpoved (ur pred začetkom)',
        guest_cancel_hint: '0 pomeni do samega začetka; -1 pomeni, da gost prek portala ne more odpovedati in odloča samo recepcija.',
        cells: 'Število celic',
        cells_hint: 'Koliko celic vira zasede. Petdesetminutna masaža na četrturnem koledarju je 4 celice — ura z obračanjem vmes.',

        resources: 'Sredstva',
        resource: 'Sredstvo',
        resource_add: 'Dodaj sredstvo',
        resource_edit: 'Uredi sredstvo',
        resource_name_hint: 'Tisto, kar ima koledar: terapevtka, savna, kolo 07, parkirno mesto 3.',
        resource_active_hint: 'Neaktivno sredstvo se ne prikaže v koledarju.',
        no_resources: 'Ta hotel še nima nobenega sredstva s koledarjem.',
        no_resources_yet: 'Brez sredstev.',
        grid: 'Enota koledarja',
        grid_hint: 'Dolžina ene celice. Po objavi koledarja je ni več mogoče spremeniti.',
        grid_locked: 'Enote obstoječega sredstva ni mogoče spremeniti — za drugo enoto naredi novo sredstvo.',
        grid_daily: 'cel dan',
        grid_minutes: '{minutes} min',
        capacity: 'Zasedljivost celice',
        capacity_hint: 'Koliko rezervacij gre v eno celico: 1 za terapevtko, več za skupinsko vadbo.',
        hours: 'Odpiralni čas',
        hours_hint: 'Koledar nastane samo tam, kjer je sredstvo odprto. Neoznačen dan je zaprt dan in tega dne ni mogoče nič prodati.',
        whole_day: 'cel dan',
        whole_week: 'Vse dni, cel dan',
        closed: 'zaprto',
        no_hours: 'brez odpiralnega časa',
        publish_after_save: 'Koledar se objavi sam ob shranjevanju sredstva.',

        diary: 'Koledar',
        time: 'Ura',
        matrix_show: 'Prikaži:',
        matrix_show_all: 'Vse',
        resource_kind: 'Vrsta sredstva',
        service_resources: 'Kdo ali kaj to izvede',
        service_resources_hint: 'Rezervacija bo ponudila samo označene.',
        service_resources_all: 'Nič označeno pomeni: vsa sredstva te zmogljivosti.',
        service_resources_none: 'Ta center še nima sredstev.',
        additional_resources: 'Sredstva, ki jih termin zasede',
        additional_resources_hint: 'Poleg glavnega sredstva zgoraj — masaža za pare potrebuje še eno terapevtko za isti termin, ne dveh zaporednih terminov.',
        additional_resources_group: 'Skupina {n}',
        additional_resources_count: 'Koliko',
        additional_resources_pool_all: 'Katerokoli sredstvo te zmogljivosti.',
        additional_resources_add_group: 'Dodaj skupino sredstev',
        resource_kind_hint: 'Oseba ima svoj zaslon in svoje termine; oprema in prostor ne.',
        resource_kind_person: 'Oseba',
        resource_kind_equipment: 'Oprema',
        resource_kind_space: 'Prostor',
        resource_account: 'Uporabniški račun',
        resource_account_hint: 'Termin na tem koledarju se prikaže v „Moje storitve“ tega računa.',
        resource_account_no_access: 'Za povezavo z računom rabiš pravico za branje uporabnikov.',
        resource_account_none: 'Brez računa',
        resource_account_bound: 'že vezan: {name}',
        resource_account_conflict: 'Ta uporabniški račun je že vezan na sredstvo »{name}«.',
        matrix_no_resources: 'Ta center še nima nobenega sredstva (osebe, prostora ali opreme).',
        from: 'Od',
        to: 'Do',
        occupancy: 'Zasedenost',
        occupancy_empty: 'Za to obdobje ni podatkov.',
        occupancy_rate: 'Zasedenost',
        occupancy_cells: 'Termini',
        occupancy_bookings: 'Rezervacije',
        occupancy_revenue: 'Promet',
        occupancy_where: 'Način plačila',
        occupancy_no_diary: 'koledar ni objavljen',
        occupancy_blocked: 'zaprtih {count}',
        occupancy_completed: 'končanih {count}',
        occupancy_no_show: 'ni prišel: {count}',
        occupancy_cancelled: 'odpovedanih {count}',
        occupancy_free: 'brezplačnih: {count}',
        occupancy_today: 'Danes',
        occupancy_week: 'Teden',
        occupancy_month: 'Mesec',
        occupancy_all: 'Vse',
        occupancy_open_diary: 'Odpri koledar',
        occupancy_badge_unsettled: 'neobračunano',
        occupancy_badge_full: 'skoraj polno',
        occupancy_badge_quiet: 'brez rezervacij',
        occupancy_badge_ok: 'v redu',
        date: 'Datum',
        previous_day: 'Nazaj',
        next_day: 'Naprej',
        free: 'prosto',
        view_day: 'Dan',
        view_week: 'Teden',
        day_column: 'Dan',
        week_total: 'Skupaj',
        week_cell: '{count} · {hours} h',
        today: 'danes',
        workflow: 'Način dela',
        workflow_hint: 'Kaj s tem počne osebje: izvaja termine, izdaja in prevzema nazaj, ali samo drži za gosta.',
        workflow_default: 'Kot pravi katalog za ta tip',
        workflow_appointment: 'Termin — izvajalec začne in zaključi',
        workflow_handover: 'Izdaja in vračilo — odkljuka se predaja in vrnitev',
        workflow_held: 'Samo držano — nihče ne izvaja (parkirišče)',
        publish: 'Objavi koledar',
        publish_hint: 'Koledar se piše sam — ob nastavitvi vira, ob spremembi ur in vsak dan za dan naprej. To je popravilo, če kaj manjka.',
        published: 'Objavljenih celic: {cells}.',
        diary_empty: 'Za ta dan ni celic.',
        diary_empty_hint: 'Sredstvo ta dan ni odprto ali koledar še ni objavljen.',

        bookings: 'Rezervacije',
        catalogue: 'Ponudba',
        book: 'Rezerviraj',
        booked_label: 'Rezervirano',
        no_bookings: 'V izbranem obdobju ni rezervacij.',
        when: 'Kdaj',
        ends_at: 'Konec',
        status: 'Status',
        status_booked: 'Rezervirano',
        status_completed: 'Opravljeno',
        status_cancelled: 'Preklicano',
        status_no_show: 'Ni prišel',
        status_in_progress: 'V teku',
        reopen: 'Razveljavi',
        reopen_taken: 'Tega termina ni več — uro je medtem vzel nekdo drug. Naredi novo rezervacijo.',
        start: 'Začni',
        completed: 'Storitev je zaključena',
        complete_title: 'Zaključi storitev',
        complete_description: 'Kako se ta storitev obračuna?',
        complete_free_hint: 'Ta storitev nima cene — zaključi se brez obračuna.',
        complete_already_charged: 'Ta termin je že na foliu gosta. Znesek se ne bo zaračunal dvakrat.',
        settlement: 'Obračun',
        settlement_hint: 'Kam gre denar za to storitev.',
        settle_folio: 'Na sobo',
        settle_folio_room: 'Na sobo {rooms}',
        settle_folio_hint: 'Postavka gre na folio gosta in se plača ob odjavi.',
        settle_folio_no_stay: 'Ni mogoče — ta termin ni vezan na bivanje.',
        settle_paid: 'Takojšnje plačilo',
        settle_paid_hint: 'Gost je plačal na blagajni; na folio ne gre nič.',
        settle_free: 'Brez plačila',
        settle_free_hint: 'Vključeno v paket ali brezplačno.',
        settled_folio: 'Na sobo',
        settled_paid: 'Plačano',
        settled_free: 'Brezplačno',
        settled_pending: 'Ni obračunano',
        complete: 'Opravljeno',
        no_show: 'Ni prišel',
        taken: 'Ta termin je medtem zasedel nekdo drug. Izberi drugega.',
        additional_resource_pick: 'Drugo sredstvo {n}',
        additional_resource_auto: 'Samodejno (prva prosta)',
        additional_resource_busy: 'zasedeno',
        additional_resource_none_free: 'Za ta termin ni prostega sredstva iz te skupine.',
        reservation: 'Rezervacija sobe',
        reservation_hint: 'Če je gost v hotelu, gre poraba na njegov folio. Brez njega je to gost brez rezervacije, ki plača na recepciji.',
        room: 'Soba',
        room_hint: 'Soba gosta, ki je v hotelu — poraba gre na folio te rezervacije. Prazno pomeni gost brez rezervacije, ki plača na recepciji.',
        room_guest: 'Gost v sobi',
        room_payer: 'plačnik',
        lane_n: 'Pas {number}',
        walk_in: 'Gost brez rezervacije',
        guest_name: 'Ime gosta',
        guest_name_hint: 'Kar se izpiše v koledarju. Ime ostane tako, kot je bilo dano ob rezervaciji.',
        amount: 'Znesek',
        amount_hint: 'Privzeto cena storitve. Če je dogovorjena druga, jo vpiši tu in ne v opombo.',
        charge: 'Na sobo',
        charged: 'na foliu',
        not_charged: 'še ni zaračunano',
        post_to_folio: 'Takoj zaračunaj na folio',
        post_to_folio_hint: 'Kolo, ki ga gost vzame zdaj, se zaračuna zdaj; termin za prihodnji teden takrat, ko je opravljen.',
        post_needs_reservation: 'Za knjiženje na folio je potrebna rezervacija sobe.',
        source: 'Vir rezervacije',
        source_hint: 'Kje je bila rezervacija sprejeta. Za statistiko hotela — koliko prinese telefon in koliko recepcija.',
        source_desk: 'Recepcija',
        source_phone: 'Telefonski klic',
        source_walk_in: 'Gost brez rezervacije',
        source_services: 'Portal za izvajalce',
        source_hospitality: 'Imprion Hospitality',
        issue_invoice: 'Izdaj fiskaliziran račun',
        issue_invoice_hint: 'Gost plača zdaj in dobi račun. Odkljukaj, če račun izdaš v svoji blagajni.',
        payment_method: 'Način plačila',
        buyer_name: 'Kupec na računu',
        buyer_name_hint: 'Neobvezno. Prazno pomeni račun brez imena kupca.',
        invoiced: 'Zaključeno, račun izdan.',
        fiscal: 'Fiskalizacija',
        fiscal_hint: 'Zmogljivost s svojo blagajno je svoj poslovni prostor. Prazno pomeni, da prodaja prek blagajne hotela.',
        fiscal_premise_id: 'Oznaka poslovnega prostora',
        fiscal_device_id: 'Oznaka elektronske naprave',
        fiscal_cadastral: 'Katastrska občina',
        fiscal_building: 'Stavba',
        fiscal_building_section: 'Del stavbe',
        fiscal_pos_unit: 'Poslovna enota v blagajni',
        fiscal_pos_register: 'Blagajna (POS)',
        fiscal_pos_hint: 'Za hotel, ki fiskalizira prek Imprion POS: enota in blagajna te zmogljivosti.',
        fiscal_registered: 'Prijavljen na FURS {date}',
        fiscal_not_registered: 'Ni prijavljen na FURS — računi iz te zmogljivosti bi bili zavrnjeni.',
        fiscal_register: 'Prijavi poslovni prostor',
        fiscal_registered_now: 'Poslovni prostor je prijavljen.',
        fiscal_needs_premise: 'Najprej vpiši oznako poslovnega prostora in naprave ter katastrske podatke.',
        room_service: 'Postrežba v sobo',
        room_service_hint: 'Gost naroči s sobnega zaslona iz jedilnika restavracije. Jedilnik se bere sproti iz blagajne — tu povej samo, iz katere, koliko hotel doda in kaj sme v sobo.',
        room_service_no_pos: 'Hotel nima povezane blagajne, zato ni kaj izbrati. Ko bo blagajna povezana, se restavracije pokažejo tukaj.',
        room_service_unit: 'Blagajna (restavracija)',
        room_service_unit_hint: 'Blagajna, iz katere se bere jedilnik in v katero gre naročilo.',
        room_service_unit_none: 'Ni povezave z blagajno',
        room_service_table: 'Miza na blagajni',
        room_service_table_hint: 'Miza, pod katero se naročilo iz sobe pokaže na blagajni, npr. SOBE1. Listki za kuhinjo in šank se natisnejo v vsakem primeru.',
        room_service_table_none: 'Ne prikaži na blagajni',
        room_service_markup: 'Pribitek',
        room_service_markup_hint: 'Odstotek, ki ga hotel doda cenam iz jedilnika blagajne za postrežbo v sobi.',
        room_service_categories: 'Kategorije menija',
        room_service_categories_hint: 'Kaj iz jedilnika sme v sobo. Prazno pomeni cel jedilnik.',
        overview_search: 'Išči zmogljivost, sredstvo ali gosta',
        overview_groups: 'Skupine',
        overview_new: 'Nova rezervacija',
        overview_bookings: '1 termin | {count} terminov',
        overview_no_resources: '{count} brez virov',
        overview_unsettled: '{count} neobračunanih',
        overview_open: 'Odprto {from}–{to}',
        overview_none: 'Brez virov',
        overview_none_hint: 'koledar ni objavljen',
        overview_setup: 'Nastavi',
        overview_taken: 'Zasedenih {taken} od {total}',
        overview_meta_none: 'brez virov',
        overview_meta_closed: 'brez koledarja',
        overview_meta_open: 'odprto',
        overview_no_cell: 'Danes ni več prostega termina — izberi drug dan ali uro na koledarju.',
        overview_closed_then: 'Ob tej uri je zmogljivost zaprta.',
        overview_group_other: 'Drugo',
        legend_free: 'prosto',
        legend_busy: 'zasedeno',
        legend_none: 'brez virov',
        legend_closed: 'brez koledarja',
        now_at: 'zdaj {time}',
        desk_all: 'Vse zmogljivosti',
        desk_groups: 'Skupine',
        desk_facilities_count: '{count} zmogljivosti',
        desk_setup: 'Nastavi zmogljivosti',
        desk_meta: '{count} sredstev · {from}–{to} · enota {grid}',
        desk_free_slots: '{count} prostih terminov',
        desk_today: 'Danes',
        desk_in_progress: 'V teku',
        desk_upcoming: 'Prihajajoči termini',
        desk_unsettled: 'Neobračunano',
        desk_empty: 'Za ta dan ni terminov.',
        desk_quick: 'Hitra rezervacija',
    },
    maintenance: {
        stat_cancelled:            'Preklicanih',
        in_repair:                 'V popravilu ({count})',
        assign_not_live:           'Okvara ni več v delu — dodeliti je ni mogoče. Osveži seznam.',
        description:        'Kaj je pokvarjeno in kdo to popravlja.',
        report:             'Prijavi okvaro',
        edit:               'Uredi okvaro',
        fault:              'Okvara',
        area:               'Kje v sobi',
        area_hint:          'Kopalnica, balkon, TV — neobvezno.',
        room_hint:          'Prazno pusti, če okvara ni v sobi (dvigalo, hodnik, recepcija).',
        title_hint:         'Ena vrstica, po kateri se okvara prepozna: „Tušu kaplja mešalna baterija".',
        severity:           'Resnost',
        severity_hint:      'Blokirna soba ne gre v prodajo, dokler okvara stoji.',
        severity_blocking:  'Blokira sobo',
        severity_normal:    'Navadna',
        severity_cosmetic:  'Kozmetična',
        status:             'Stanje',
        status_open:        'Prijavljena',
        status_assigned:    'Dodeljena',
        status_in_progress: 'V delu',
        status_resolved:    'Odpravljena',
        status_closed:      'Zaprta',
        status_cancelled:   'Preklicana',
        status_duplicate:   'Podvojena',
        reported_at:        'Prijavljeno',
        resolved_at:        'Odpravljeno {at}',
        expected_resolved_by:      'Predvidoma rešeno',
        expected_resolved_by_hint: 'Do kdaj je predvideno, da bo okvara odpravljena — neobvezno.',
        room_blocked: 'Sobe {room} ni mogoče zapreti: rezervirana je {dates}{who}.',
        room_blocked_open_reservation: 'Odpri rezervacijo',
        room_blocked_open_group: 'Odpri seznam skupin ({name})',
        save_without_block: 'Shrani brez blokade',
        expected_by:               'predvidoma do {date}',
        overdue_by:                'zamuja, predvidoma do {date}',
        start:              'Začni',
        resolve:            'Odpravljeno',
        close:              'Potrdi',
        resolution:         'Kaj je bilo narejeno',
        resolution_hint:    'To bere naslednji, ko ista pipa spet kaplja — „zamenjana tesnila, drugič letos" pove več kot „popravljeno".',
        blocks_sale_short:  'Soba ni v prodaji',
        room_block_failed:  'Blokada NI uspela',
        room_block_failed_hint: 'Soba je bila že rezervirana v tem obdobju, zato zapisa ni bilo mogoče zapreti — soba ostaja v prodaji. Sistem poskus samodejno ponavlja.',
        awaiting_move_short: 'Čaka premik gosta',
        no_room:            'Ni vezano na sobo',
        count_open:         'Odprtih',
        count_blocking:     'Blokira sobe',
        count_resolved:     'Za potrditev',
        assigned_to: 'Dodeljeno',
        assign: 'Dodeli',
        assign_to: 'Dodeli osebi',
        assign_hint: 'Izberi »Nihče«, da napako vrneš na odprti seznam.',
        nobody: 'Nihče',
        reported_by: 'Prijavil: {name}',
        statistics: 'Statistika',
        statistics_hint: 'Kaj se je pokvarilo v izbranem obdobju, kaj je popravljeno in kje se ponavlja.',
        stat_reported: 'Prijavljenih',
        stat_resolved: 'Popravljenih',
        stat_open: 'Odprtih',
        stat_blocking: 'Blokira sobe',
        stat_average_hours: 'Povprečno ur do popravila',
        by_severity: 'Po resnosti',
        by_status: 'Po stanju',
        by_area: 'Po lokaciji',
        by_person: 'Po osebah',
        by_room: 'Sobe, ki se ponavljajo',
        stat_hours: 'ur',
        stat_empty: 'V tem obdobju ni prijavljenih okvar.',
        period_from: 'Od',
        period_to: 'Do',

        // Stanje sob — več sob hkrati izven uporabe ali nazaj v prodajo.
        rooms_tab:               'Stanje sob',
        rooms_hint:              'Katere sobe so v prodaji in katere ne. Več sob hkrati gre lahko izven uporabe ali nazaj v prodajo.',
        rooms_search:            'Iskanje po številki',
        rooms_pick_floor:        'Celo nadstropje:',
        rooms_whole_floor:       'Celo {floor}',
        rooms_selected:          'Nobena soba ni izbrana | Izbrana je 1 soba | Izbranih sob: {count}',
        rooms_clear_selection:   'Počisti izbiro',
        rooms_select_all:        'Izberi vse prikazane sobe',
        rooms_select_room:       'Izberi sobo {number}',
        rooms_block:             'Daj izven uporabe',
        rooms_release:           'Vrni v prodajo',
        rooms_block_for:         'Za 1 izbrano sobo | Za izbrane sobe: {count}',
        rooms_block_booked_hint: 'Sobe, v katerih je v tem obdobju rezervacija ali skupinski blok, bodo zavrnjene in spodaj izpisane po številkah.',
        rooms_reason_hint:       'Razlog velja za vse izbrane sobe: »puščanje na tretjem nadstropju«, »prenova kopalnic«.',
        rooms_until_revoked:     'Prazno pomeni do preklica.',
        rooms_release_confirm:   '1 sobo vrniti v prodajo? Stanje bo »Za urediti«, zapora pa odstranjena. | V prodajo vrniti toliko sob: {count}? Stanje bo »Za urediti«, zapore pa odstranjene.',
        rooms_result_blocked:    'Nobena soba ni bila zaprta | Zaprta je 1 soba | Zaprtih sob: {count}',
        rooms_result_released:   'Nobena soba ni bila vrnjena v prodajo | V prodajo je vrnjena 1 soba | V prodajo vrnjenih sob: {count}',
        rooms_result_refused:    'Zavrnjena je 1 soba — v njej je rezervacija ali skupinski blok | Zavrnjenih sob: {count} — v njih je rezervacija ali skupinski blok',
    },
    till: {
        title: 'Moja blagajna',
        opening_float: 'Začetno stanje',
        opening_float_hint: 'Gotovina, prešteta v predal ob začetku izmene.',
        open: 'Odpri blagajno',
        opened_message: 'Blagajna je odprta.',
        open_failed: 'Blagajne ni bilo mogoče odpreti — morda je ena že odprta.',
        running: 'Odprta od {opened} · začetno stanje {float} · pričakovano zdaj {expected}.',
        counted: 'Prešteto stanje',
        counted_hint: 'Gotovina, fizično prešteta ob zaključku.',
        close: 'Zaključi blagajno',
        closed_message: 'Blagajna je zaključena. Zapis je zaklenjen.',
        close_failed: 'Zaključka ni bilo mogoče zapisati.',
        difference_reason: 'Razlog razlike',
        needs_reason: 'Razlika zahteva razlog.',
        difference_line: 'Razlika med preštetim in pričakovanim: {amount}.',
        sessions: 'Zaključki blagajn',
        opened: 'Odprta',
        closed: 'Zaključena',
        expected: 'Pričakovano',
        difference: 'Razlika',
        still_open: 'še odprta',
    },
    finance: {
        title: 'Finance',
        tab_overview: 'Pregled',
        tab_receivables: 'Odprti računi',
        vat_exempt_row: 'Ni predmet DDV',
        tab_sales: 'Prodaja',
        tab_vat: 'DDV',
        vat_hint: 'DDV obdobja iz izdanih računov.',
        vat_hint_detail: 'Vrstice so seštete iz rekapitulacij samih dokumentov, zato se tabela lahko samo ujema s papirji, ki jih povzema. Dobropisi odštevajo sami.',
        sales_hint: 'Knjižen promet obdobja, razrezan na dva načina.',
        sales_hint_detail: 'Po viru postavke in po skupini prihodka — iste postavke obakrat, zato se skupka morata ujemati.',
        sales_by_source: 'Po viru',
        sales_by_group: 'Po skupini prihodka',
        sales_group_desk: 'Recepcija',
        sales_empty: 'V obdobju ni prometa.',
        export_invoices: 'Izvoz računov (CSV)',
        export_hint: 'Vsi dokumenti obdobja: številka, datumi, kupec, osnova, DDV, bruto, plačano. Podpičja, decimalna vejica.',
        tab_forecast: 'Napoved',
        tab_comparison: 'Primerjava',
        charged: 'Knjiženo',
        charged_hint: 'Postavke na folijih v obdobju — tudi še ne izdane na računu',
        settled: 'Poravnano',
        settled_hint: 'Plačila v obdobju, vračila odšteta',
        receivables_open: 'Odprte terjatve',
        receivables_open_hint: 'Vse odprto do danes, ne samo v obdobju',
        forecast_30: 'Napoved 30 dni',
        forecast_30_hint: 'Vrednost rezerviranih nočitev v naslednjih 30 dneh',
        needs_review_title: 'Kartična plačila za ročni pregled: {count}',
        needs_review_hint: 'Prejeta plačila v napačni valuti (evidentirana, ne knjižena) ali vračila, ki jih je Stripe zavrnil po knjiženju (denar je vrnjen na folio gosta v PMS, a ni odšel). Preveri v Stripe nadzorni plošči in uskladi.',
        needs_review_open: 'Poglej zapise',
        review_title: 'Kartična plačila za ročni pregled',
        review_lead: 'Zapisi, pri katerih se je samodejno knjiženje namerno ustavilo. Uskladitev je zapis odločitve — denarja ne premakne.',
        review_empty: 'Ni zapisov za pregled.',
        review_kind_currency_mismatch: 'Napačna valuta',
        review_kind_refund_failed: 'Vračilo zavrnjeno po knjiženju',
        review_why_currency_mismatch: 'Plačilo je prišlo v valuti, ki je hotel ne vodi. Evidentirano je, knjiženo ni — tečaja, po katerem bo hotel dejansko prejel denar, sistem ne more poznati.',
        review_why_refund_failed: 'Stripe je vračilo zavrnil šele potem, ko so ga knjige že zabeležile. Kompenzacijska vrstica je knjige popravila, gost pa denarja še ni dobil.',
        review_reference: 'Referenca',
        review_raw_status: 'Surovi status',
        review_reservation: 'Rezervacija',
        review_guest: 'Gost',
        review_reconcile: 'Označi kot usklajeno',
        review_reconcile_confirm: 'Shrani in označi',
        review_reconcile_failed: 'Uskladitve ni bilo mogoče shraniti.',
        review_reconciled: 'Zapis je označen kot usklajen.',
        review_reconciled_by: 'Uskladil {name} · {at}',
        review_note: 'Zapisek (obvezno)',
        review_note_hint: 'Kaj se je dejansko zgodilo z denarjem. To bo čez pol leta edini zapis o tem.',
        review_note_placeholder: 'Npr. vrnjeno z bančnim nakazilom 3. 5., sklic 1234, gost obveščen po e-pošti.',
        invoiced: 'Izdani računi',
        invoiced_hint: 'Vsota izdanih računov v obdobju, dobropisi odšteti',
        gap_uninvoiced: 'Knjiženo in še brez računa: {amount}.',
        gap_unpaid: 'Na računih in še neplačano: {amount}.',
        gap_prepaid: 'Plačil je za {amount} več kot izdanih računov — predujmi in plačila pred izdajo.',
        by_drawer: 'Po blagajnah',
        drawer: 'Blagajna',
        drawer_unknown: '(izbrisan račun)',
        events: 'Dogodkov',
        receivables_hint: 'Odhodi z odprtim saldom — kdo jih je odobril in zakaj.',
        receivables_hint_detail: 'Zapis nastane ob odjavi z odprtim saldom. »Še odprto« se šteje iz foliev v živo: plačilo, ki prispe pozneje, terjatev samo poravna.',
        open_invoices: 'Neplačani računi',
        open_invoices_empty: 'Vsi izdani računi so plačani.',
        departures_register: 'Odhodi z odprtim saldom',
        due: 'Zapade',
        paid_column: 'Plačano',
        overdue_days: 'Dni čez',
        aging_count: '{count} računov',
        show_settled: 'Pokaži tudi poravnane',
        receivables_empty: 'Ni odprtih terjatev.',
        debtor: 'Dolžnik',
        owed_at_departure: 'Ob odhodu',
        remaining: 'Še odprto',
        approved_by: 'Odobril',
        reason: 'Razlog',
        departed: 'Odhod',
        settled_label: 'poravnano',
        forecast_hint: 'Vrednost rezerviranih bivanj po mesecih, za leto naprej.',
        forecast_hint_detail: 'Bivanja so razdeljena po nočeh, zato bivanje čez mejo meseca pripada obema — stolpci se seštejejo nazaj v rezervacije. Odpovedi in neprihodi ne štejejo.',
        forecast_empty: 'Ni prihodnjih rezervacij.',
        forecast_total: 'Skupaj',
        month: 'Mesec',
        booked_revenue: 'Rezervirano',
        years_back: 'Število let',
        year_total: 'Skupaj',
    },
    report: {
        registrations_empty_title: 'Ta objekt še nima nobene prijave v eTurizem',
        registrations_empty_hint: 'Prijava nastane ob prijavi gosta (check-in) z gumbom »Prijavi in poročaj«. Preveri tudi, ali je zgoraj izbran pravi objekt.',
        registrations_window_empty_title: 'V obdobju {from} – {to} ni prijav',
        registrations_window_empty_hint: 'Objekt ima sicer {count} prijav v eTurizem — razširi obdobje (npr. »Ta mesec«), da jih vidiš.',
        settlement: 'Zaključek blagajne',
        settlement_hint: 'Denar po načinu plačila — kar je bilo dejansko poravnano.',
        settlement_hint_detail: 'Šteje plačila po poslovnem dnevu: gotovina v blagajni, kartice, nakazila na TRR, boni, predplačila in agencijske virtualne kartice. Kaj je bilo prodano, pove poročilo Prodaja; tu je, s čim je bilo plačano.',
        settlement_net: 'Skupaj',
        settlement_empty: 'V izbranem obdobju ni bilo nobenega plačila.',
        settlement_method_hint: '{count} plačil',
        settlement_method_hint_refunds: 'prejeto {received} · vrnjeno {refunded} · {count} dogodkov',
        reports:               'Poročila',
        daily:                 'Dnevno',
        occupancy:             'Zasedenost',
        performance:           'Uspešnost',
        business_date:         'Poslovni dan',
        business_date_hint:    'Poročilo velja za poslovni dan, ne za koledarskega. Po polnoči in pred nočnim zaključkom je to še vedno včerajšnji dan.',
        current_business_date: 'Danes',
        rooms_guests:          'Sob: {rooms} · Gostov: {guests}',
        stay:                  'Bivanje',
        stay_amount:           'Znesek bivanja',
        night_count:           '1 noč | {count} noči',
        period_from:           'Obdobje od',
        period_to:             'Obdobje do',
        period_hint:           'Oba datuma sta všteta v obdobje.',
        day_count:             'Št. dni: {count}',
        period_invalid:        'Obdobje ni veljavno — datum „do“ mora biti enak datumu „od“ ali poznejši.',
        period_too_long:       'Obdobje je predolgo. Največ je {max} dni.',
        this_month:            'Ta mesec',
        last_month:            'Prejšnji mesec',
        last_7_days:           'Zadnjih 7 dni',
        last_30_days:          'Zadnjih 30 dni',
        rooms_sold:            'Prodane sobe',
        room_nights:           'Sobne noči',
        rooms_available:       'Razpoložljive sobe',
        rooms_available_hint:  'Sobne noči, ki so bile na voljo za prodajo.',
        days:                  'Dnevi',
        business_days:         'Poslovni dnevi v obdobju',
        weekday:               'Dan v tednu',
        weekend:               'Konec tedna',
        no_inventory:          'Ni sob za prodajo',
        period_average:        'Povprečje obdobja',
        chart_summary:         'Zasedenost po dnevih za obdobje {period}. Povprečje obdobja je {occupancy}.',
        room_revenue:          'Prihodek od nastanitve',
        revenue_hint:          'Šteje se le prihodek od nastanitve',
        revenue_hint_detail:   'V znesek je vključena le cena bivanja. Storitve, blagajna in turistična taksa niso zajete ne tu ne v ADR ne v RevPAR.',
        adr:                   'ADR',
        adr_hint:              'Povprečna cena prodane sobe — prihodek, deljen s prodanimi sobnimi nočmi.',
        revpar:                'RevPAR',
        revpar_hint:           'Prihodek na razpoložljivo sobo — prihodek, deljen z razpoložljivimi sobnimi nočmi.',
        occupancy_hint:        'Prodane sobne noči glede na razpoložljive.',
        by_room_type:          'Po tipu sobe',
        by_source:             'Po viru rezervacije',
        revenue_share:         'Delež prihodka',
    },
    settings: {
        appearance_hint: 'Tema in jezik veljata samo za ta brskalnik in za tvoj račun — ne za hotel.',
        hub_hint:  'Vse, kar hiša nastavi enkrat. Prikazane so samo skupine, do katerih imaš pravice.',
        hub_empty: 'Za zdaj nimaš pravic za nobeno od nastavitev hiše. Videz in jezik tega brskalnika lahko spremeniš v Videzu.',
        tills_hint: 'Kje se prodaja čez pult in kaj sme vsaka blagajna prodajati. Nastavi se enkrat — prodajalec tega med prodajo ne potrebuje.',
        tills_no_property: 'Najprej izberi objekt zgoraj.',
        categories: 'Kategorije artiklov',
        categories_hint: 'Kategorija je prosto besedilo na artiklu, zato se ista stvar čez leto natipka na tri načine in blagajna pokaže tri čipe za eno polico. Tu se to popravi na vseh artiklih hkrati.',
        categories_empty: 'Noben artikel še nima kategorije.',
        categories_count: '{count} artiklov',
        categories_uncategorised: 'Brez kategorije: {count} artiklov. Na blagajni so pod „Vse“.',
        category_rename: 'Preimenuj kategorijo',
        category_rename_hint: 'Novo ime se zapiše na vse artikle, ki nosijo staro. Ničesar drugega na artiklu se ne dotakne.',
        category_current: 'Trenutno ime',
        category_new: 'Novo ime',
        category_new_hint: 'Največ 60 znakov. Prazno pomeni, da se kategorija z artiklov odstrani.',
        category_merge: 'To bo združilo dve kategoriji',
        category_merge_hint: 'Kategorija „{name}“ že obstaja — artikli obeh imen bodo po tem pod njo.',
        category_clear: 'To bo odvzelo kategorijo',
        category_clear_hint: 'Artikli ostanejo, samo brez kategorije — na blagajni bodo pod „Vse“.',
        category_renamed: 'Preimenovano na {count} artiklih.',
    },
    user: {
        users:                 'Uporabniki',
        access_hint:           'Računi, ki se lahko prijavijo v recepcijo. Kaj kdo sme, določajo vloge, ki jih ima dodeljene. Računa ni mogoče izbrisati, le deaktivirati — njegovo ime je na delu, ki ga je opravil.',
        add:                   'Dodaj uporabnika',
        edit:                  'Uredi uporabnika',
        name:                  'Ime in priimek',
        username:              'Uporabniško ime',
        username_hint:         'S tem se uporabnik prijavi v recepcijo.',
        password:              'Geslo',
        new_password:          'Novo geslo',
        personnel_card:        'Kadrovska kartica',
        new_personnel_card:    'Nova kadrovska kartica',
        password_confirmation: 'Ponovi geslo',
        password_hint:         'Najmanj {count} znakov.',
        password_too_short:    'Geslo mora imeti vsaj {count} znakov',
        password_mismatch:     'Gesli se ne ujemata',
        till_pin: 'PIN za blagajno',
        // Krajše od naslova pogovornega okna: v meniju vrstice stoji poleg „Spremeni
        // geslo“ in ne sme prelomiti vrstice.
        till_pin_action: 'PIN blagajne',
        till_pin_new: 'Nov PIN',
        till_pin_confirmation: 'Ponovi PIN',
        till_pin_hint: 'Od {min} do {max} števk. Vpiše se na blagajni in pove, kdo je prodal.',
        till_pin_invalid: 'PIN mora imeti od {min} do {max} števk.',
        till_pin_mismatch: 'PIN-a se ne ujemata.',
        till_pin_clear: 'Odvzemi PIN',
        till_pin_cleared: 'PIN je odvzet.',
        tills: 'Blagajne',
        tills_hint: 'Katere blagajne sme ta oseba uporabljati. Prazno = nobene.',
        tills_none: 'Nobena blagajna',
        tax_number: 'Osebna davčna številka',
        tax_number_hint: 'Osem števk. Davčna številka te osebe gre na vsak fiskalni račun, ki ga izda — tako zahteva ZDavPR. Davčna hotela NI nadomestek: brez te številke ali oznake tujega operaterja spodaj ta oseba računa ne more izdati.',
        tax_number_invalid: 'To ni davčna številka: osem števk, prva ni nič, zadnja je kontrolna.',
        tax_number_placeholder: '12345678',
        foreign_operator: 'Tuji operater (nima slovenske davčne številke)',
        foreign_operator_hint: 'Označi samo, če ta oseba res nima slovenske davčne številke. Na račun gre oznaka ForeignOperator namesto davčne — tako zahteva ZDavPR. Napačna označitev je napačna izjava davčnemu organu.',
        operator_missing: 'Ta oseba ne more izdajati računov',
        operator_missing_hint: 'ZDavPR zahteva davčno številko fizične osebe, ki izda račun, ali oznako tujega operaterja. Brez enega od obojega izdaja računa prek lastne fiskalizacije ne bo mogoča.',
        change_password:       'Spremeni geslo',
        password_changed:      'Geslo je spremenjeno',
        last_password_change:  'Zadnja sprememba gesla',
        never:                 'Nikoli',
        language_default:      'Kot v brskalniku',
        facilities: 'Zmogljivosti, ki jih pokriva',
        facilities_hint: 'Kaj vidi v portalu za storitve. Prazno pomeni vse zmogljivosti.',
        facilities_all: 'Vse zmogljivosti',
        search: 'Poišči po imenu, uporabniškem imenu ali vlogi',
        language_hint:         'Jezik vmesnika, ki ga dobi ta uporabnik ob prijavi. Brez izbire odloči brskalnik.',
        you:                   'Ti',
        activate:              'Aktiviraj',
        deactivate:            'Deaktiviraj',
        confirm_activate:      'Naj se račun „{name}“ znova aktivira? Spet se bo lahko prijavil.',
        confirm_deactivate:    'Naj se račun „{name}“ deaktivira? Prijava ne bo več mogoča — zavrnjena bo enako kot napačno geslo. Dosedanje delo ostane zapisano na tem računu.',
        activated:             'Račun je aktiviran',
        deactivated:           'Račun je deaktiviran',
        cannot_deactivate:     'Tega računa ni mogoče deaktivirati — zadnji aktiven račun in svoj lastni morata ostati vklopljena',
        username_taken:        'To uporabniško ime je že zasedeno',
        email_hint: 'Kam gre obvestilo o urniku. Prazno je v redu — večina osebja hiši naslova ni dala.',
        phone_hint: 'V mednarodni obliki, npr. +38641123456. Uporabi se za SMS in WhatsApp.',
        channels_hint: 'Po katerih poteh naj ta oseba prejema obvestila. Nič izbranega pomeni po vseh, ki jih hiša ima in za katere ima ta oseba naslov.',
        channels_all: 'Vse poti, ki jih hiša ima',
        telegram_unpair: 'Odveži',
        telegram_will_unpair: 'Ob shranjevanju bo povezava odvezana.',
        viber_will_unpair: 'Ob shranjevanju bo povezava z Viberjem odvezana.',
    },
    // Kako hiša obvesti svoje ljudi (docs/OBVESCANJE.md). Pošta je bila tu že prej in
    // ostaja pod /mail; ta stran jo samo nariše zraven, ker je vprašanje eno — kako
    // hiša sploh koga doseže — in polovica odgovora na drugem zaslonu je natanko tako,
    // da ima hiša urejeno pošto in nima pojma, da SMS ne gre nikamor.
    notifications: {
        nav: 'Obveščanje',
        no_property: 'Najprej izberi objekt.',

        state_title: 'Kaj hiša zmore',
        state_hint: 'Zeleno je pot, po kateri sporočilo res odide. Siva pomeni, da manjka nastavitev spodaj.',

        channel_email: 'E-pošta',
        channel_sms: 'SMS',
        channel_messaging: 'Sporočilne aplikacije',
        channel_push: 'Aplikacija na telefonu',
        channel_email_hint: 'Potrebuje tvoj e-naslov.',
        channel_sms_hint: 'Potrebuje tvojo telefonsko številko.',
        channel_messaging_hint: 'Potrebuje WhatsApp številko ali povezan Viber na profilu osebe.',
        channel_push_hint: 'Potrebuje seznanjen telefon ali uro Imprion Sobe.',

        mail_title: 'E-pošta',
        mail_hint: 'Strežnik SMTP hiše. Iste nastavitve uporabljajo računi, potrditve rezervacij in obvestila o urniku — ena pošta na hišo, ne dve.',
        mail_host: 'Strežnik',
        mail_port: 'Vrata',
        mail_security: 'Zaščita',
        mail_security_none: 'Brez (samo v lokalnem omrežju)',
        mail_username: 'Uporabniško ime',
        mail_password: 'Geslo',
        mail_from: 'Pošiljatelj (naslov)',
        mail_from_name: 'Pošiljatelj (ime)',
        mail_test: 'Pošlji poskusno sporočilo',

        sms_title: 'SMS',
        sms_hint: 'Prehod, prek katerega hiša pošlje sporočilo na telefon. Ponudnik je pogodba hiše, ne izdelka.',
        sms_provider: 'Ponudnik',
        sms_provider_hint: 'Generični HTTP pokrije vse slovenske prehode: gre za en klic s predlogo naslova.',
        provider_off: 'Izklopljeno',
        provider_generic: 'Generični HTTP',
        sms_generic_title: 'Dve oznaki v predlogi',
        sms_generic_hint: '{to} je prejemnik, {text} je besedilo. V naslovu se zakodirata za URL, v telesu JSON pa kot JSON — tega ni treba nastavljati.',
        sms_endpoint: 'Naslov',
        sms_endpoint_hint: 'Npr. https://api.ponudnik.si/send?to={to}&text={text}',
        sms_method: 'Metoda',
        sms_body: 'Telo zahteve',
        sms_body_hint: 'Če je veljaven JSON, se pošlje kot JSON; sicer kot obrazec.',
        sms_from: 'Pošiljatelj',
        sms_from_hint: 'Ime ali številka, ki jo vidi prejemnik. Marsikateri prehod ima svojo in to polje prezre.',
        sms_token: 'Žeton',
        twilio_sid: 'Account SID',
        twilio_token: 'Auth Token',
        twilio_shared: 'Ta par pošlje tudi WhatsApp',
        twilio_shared_hint: 'SMS je izklopljen, WhatsApp pa ta hiša pošilja prek Twilia — Account SID in Auth Token torej potrebuje tudi kartica sporočilnih aplikacij. En račun, en par polj.',
        twilio_from_hint: 'Številka ali ime, ki ga je Twilio potrdil. Obvezno.',
        test_number: 'Poskusna številka',
        test_number_hint: 'Prazno pošlje na tvojo lastno številko.',

        messaging_title: 'Sporočilne aplikacije',
        messaging_hint: 'Ena pot obveščanja. Nosita jo WhatsApp in Viber: sporočilo gre po prvi aplikaciji, ki jo ima hiša nastavljeno in za katero ima oseba naslov.',
        telegram_soon: 'Telegram: kmalu.',
        messaging_order: 'Ena pot, prva ustrezna aplikacija',
        messaging_order_hint: 'Sporočilo gre po vrsti Telegram → WhatsApp → Viber: prva, ki jo ima hiša nastavljeno in za katero ima oseba naslov. Preizkus zato pošlje eno sporočilo, ne treh.',
        telegram: 'Telegram',
        telegram_hint: 'Bot hiše. Vsak zaposleni se z njim poveže sam, s kodo s svojega profila — ID pogovora je številka, ki je nihče ne pozna na pamet.',
        telegram_name: 'Ime bota',
        telegram_name_hint: 'Npr. @hotel_test_bot. Prikaže se osebi, ki se povezuje.',
        telegram_token: 'Žeton bota',
        whatsapp: 'WhatsApp',
        whatsapp_provider: 'Ponudnik',
        whatsapp_provider_hint: 'Ista platforma, dvoje vrat. Meta je neposredna pot in zahteva preverjeno podjetje; Twilio je preprodajalec pred istim WhatsAppom in ima peskovnik, ki dela isto popoldne. Prehod med njima je ta izbirnik in nič drugega.',
        whatsapp_provider_meta: 'Meta Cloud API',
        whatsapp_provider_twilio: 'Twilio',
        whatsapp_twilio_credentials: 'Poverilnici sta Twilijevi iz kartice SMS',
        whatsapp_twilio_credentials_hint: 'Hotel ima en račun pri Twiliu: Account SID in Auth Token iz kartice SMS zgoraj pošljeta tudi WhatsApp. Dve polji za isti račun bi bili dve polji, od katerih je eno vedno zastarelo. Če je SMS izklopljen, poverilnici vseeno vpiši tam.',
        whatsapp_twilio_credentials_missing: 'Twilijevih poverilnic še ni. Vpiši Account SID in Auth Token v kartico SMS zgoraj.',
        whatsapp_twilio_from: 'Pošiljatelj (WhatsApp številka)',
        whatsapp_twilio_from_hint: 'Peskovnikova številka (+14155238886) ali številka, ki jo je hotel registriral pri Twiliu. Predpona „whatsapp:“ ni obvezna — doda se sama.',
        whatsapp_twilio_service: 'Messaging Service SID (neobvezno)',
        whatsapp_twilio_service_hint: 'Če hiša pošilja prek Twilijeve storitve sporočanja (MG…). Vpisana prevlada nad številko zgoraj.',
        whatsapp_twilio_sandbox: 'Peskovnik: vsak prejemnik se mora najprej javiti',
        whatsapp_twilio_sandbox_hint: 'Twilijev peskovnik ne dostavi ničesar osebi, ki mu ni prva pisala. To je Twilijevo pravilo in ne nastavitev — na registrirani številki odpade.',
        whatsapp_twilio_sandbox_word: 'Beseda peskovnika',
        whatsapp_twilio_sandbox_word_hint: 'Iz Twilio → Messaging → Try it out → WhatsApp sandbox, npr. „tiger-market“. Prazno pomeni, da hiša peskovnika ne uporablja.',
        whatsapp_twilio_join: 'Povej osebju natanko tole',
        whatsapp_twilio_join_sentence: 'Pošlji „join {word}“ na {number} in šele nato boš prejemal obvestila hotela.',
        whatsapp_twilio_content: 'Potrjena predloga (Content API)',
        whatsapp_twilio_content_hint: 'Twilio predlogo naslovi z ID-jem in ne z imenom. Ustvari jo v Twilio → Content Template Builder, počakaj na potrditev WhatsAppa in prilepi ID sem.',
        whatsapp_twilio_content_sid: 'Content SID',
        whatsapp_twilio_content_sid_hint: 'Npr. HXxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx. Prazno pomeni, da se predloga ne uporabi nikoli — v peskovniku je to običajno stanje.',
        whatsapp_twilio_content_sid_shift: 'Content SID za spremembo turnusa',
        whatsapp_twilio_content_sid_shift_hint: 'Predloga z gumboma Potrjujem / Ne morem. Neobvezno: prazno pomeni, da gre tudi sprememba turnusa po predlogi zgoraj in brez gumbov.',
        whatsapp_twilio_buttons: 'Kaj mora ta predloga imeti',
        whatsapp_twilio_buttons_hint: 'Telo z eno spremenljivko {{1}}, kot zgoraj, in dva gumba hitrega odgovora: „Potrjujem“ z vrednostjo ack in „Ne morem“ z vrednostjo decline. Vrednosti se vpišeta ob izdelavi predloge in ju pozneje ni mogoče spremeniti.',
        whatsapp_twilio_content_docs: 'Twilijeva navodila za predloge →',
        whatsapp_twilio_content_variable: 'Predloga mora imeti eno spremenljivko, {{1}}: vanjo gre celoten stavek hiše, v eni vrstici in do 1024 znakov. Enako telo kot pri Meti, tako da prehod ne zahteva nove potrditve.',
        whatsapp_twilio_always_needs_content: '„Vedno predloga“ brez Content SID-a ni mogoče shraniti — brez predloge ne bi odšlo nič.',
        whatsapp_twilio_status: 'Poročila o dostavi',
        whatsapp_twilio_status_hint: 'Naslov potuje na vsakem sporočilu, zato ga v Twiliu ni treba nastaviti. Prilepi ga le, če želiš isti naslov nastaviti tudi na ravni storitve sporočanja.',
        whatsapp_twilio_status_callback: 'Naslov za poročila o dostavi',
        whatsapp_twilio_status_none: 'Ta namestitev nima javnega naslova, zato poročil o dostavi ne bo. Obveščanje deluje naprej.',
        whatsapp_twilio_inbound: 'Odgovori osebja',
        whatsapp_twilio_inbound_hint: 'Ta naslov moraš prilepiti sam. Twilio ga sam od sebe ne pozna: poročilo o dostavi potuje na sporočilu, prihajajoče sporočilo pa gre tja, kamor pokaže pošiljatelj — brez tega gumba na telefonu ne dosežeta ničesar.',
        whatsapp_twilio_inbound_url: 'Naslov za prejeta sporočila',
        whatsapp_twilio_inbound_where: 'Prilepi ga v Twilio → Messaging → Senders → WhatsApp senders → izberi številko → „When a message comes in“ (metoda POST).',
        whatsapp_twilio_inbound_none: 'Ta namestitev nima javnega naslova, zato odgovorov osebja ni mogoče prejemati. Obveščanje deluje naprej.',

        // Pozdrav gostu in povezava do portala (docs/OBVESCANJE.md §10.9). Predlogi
        // odobri WhatsApp prek Twilia; hiša ju samo poimenuje tukaj.
        guest_welcome: 'Gostje',
        guest_welcome_hint: 'Pozdrav gostu s povezavo do njegovega portala gre kot POTRJENA Twilijeva vsebinska predloga tipa „Call to action“ z dinamičnim gumbom. Spremenljivke po vrsti: {1} ime plačnika, {2} ime hiše, {3} datum prihoda, {4} žeton povezave (le del za /r/).',
        guest_welcome_button_url: 'Naslov gumba v predlogi',
        guest_welcome_button_url_hint: 'V Twilio Content Template Builderju gumbu „Odpri portal gosta“ nastavi točno ta naslov. Predloga z drugačno osnovo odpre prazno stran.',
        guest_welcome_no_portal: 'Ta namestitev nima naslova portala za goste (GUEST_PORTAL_URL), zato povezave ni mogoče sestaviti. Pozdrava ne pošiljaj, dokler naslov ni nastavljen.',
        guest_welcome_sid_sl: 'Content SID — slovenska predloga',
        guest_welcome_sid_sl_hint: 'Predloga pms_gost_pozdrav. Gost, ki govori slovensko, dobi to.',
        guest_welcome_sid_en: 'Content SID — angleška predloga',
        guest_welcome_sid_en_hint: 'Predloga pms_guest_welcome. Vsak gost, ki ne govori slovensko, dobi to.',
        guest_welcome_auto: 'Ob potrditvi pošlji najprej po WhatsAppu',
        guest_welcome_auto_hint: 'Povezava do portala gre gostu samodejno vedno, ko rezervacija postane potrjena — enkrat na rezervacijo. Vklopljeno: najprej po WhatsAppu. Sicer (ali kadar WhatsApp ne gre) po e-pošti, če jo ima plačnik, nato po SMS. Če gosta ni mogoče doseči, jo recepcija pošlje z gumbom na rezervaciji.',
        guest_welcome_not_ready: 'Samodejno pošiljanje je vklopljeno, hiša pa pozdrava še ne more poslati: potrebuje Twilio kot ponudnika WhatsAppa, shranjeni poverilnici na kartici SMS in vsaj en Content SID zgoraj.',

        // Predloge, ki jih zgradi PMS sam (docs/OBVESCANJE.md §10.10).
        templates: 'Predloge WhatsApp',
        templates_hint: 'PMS lahko štiri hišine predloge ustvari na tvojem Twilijevem računu sam in jih odda WhatsAppu v potrditev — z besedili, gumbi in naslovom te namestitve. Obstoječe predloge z istim imenom ohrani in Content SID-a, ki si ga vpisal sam, nikoli ne prepiše.',
        templates_build: 'Ustvari predloge v Twiliu',
        templates_refresh: 'Osveži stanje',
        templates_built: 'Predloge so ustvarjene in oddane v potrditev.',
        templates_no_credentials: 'Predloge se gradijo na hišinem Twilijevem računu — Account SID in Auth Token vpiši v kartico SMS zgoraj.',
        templates_approval_hint: 'Predloge potrjuje Meta, običajno v 48 urah. Kategorija je Utility (transakcijska sporočila). Dokler predloga ni odobrena, po njej ni mogoče poslati ničesar.',
        template_name: 'Predloga',
        template_kind: 'Vrsta',
        template_sid: 'Content SID',
        template_status: 'Stanje',
        template_missing: 'Ni ustvarjena',
        template_unsubmitted: 'Ustvarjena, ni oddana',
        template_received: 'Oddana',
        template_pending: 'V pregledu',
        template_approved: 'Odobrena',
        template_rejected: 'Zavrnjena',
        template_kind_text: 'Besedilo',
        template_kind_quick_reply: 'Hitri odgovor (gumba)',
        template_kind_call_to_action: 'Poziv k dejanju (povezava)',
        whatsapp_window: 'Prosto besedilo samo 24 ur',
        whatsapp_window_hint: 'WhatsApp dostavi prosto besedilo le osebi, ki je v zadnjih 24 urah pisala hiši. Zunaj tega okna dostavi samo potrjeno predlogo — nastavi jo spodaj.',
        whatsapp_number_id: 'ID telefonske številke',
        whatsapp_number_id_hint: 'Metin ID pošiljajoče številke, ne številka sama.',
        whatsapp_token: 'Žeton (Cloud API)',
        whatsapp_template: 'Potrjena predloga',
        whatsapp_template_hint: 'Kar doseže osebje, ki hiši ni pisalo v zadnjih 24 urah. Predlogo potrdi Meta, ne ta zaslon — tu se vpiše samo, kako se imenuje.',
        whatsapp_template_approval: 'Potrdi jo v Meta Business Manager',
        whatsapp_template_approval_hint: 'Kategorija Utility (ne Marketing — ta zahteva privolitev za oglaševanje), jezik enak spodnjemu, telo z eno spremenljivko. Predlogo, katere celotno telo je samo „{{1}}“, Meta praviloma zavrne.',
        whatsapp_template_body: 'Priporočeno telo predloge',
        whatsapp_template_body_hint: 'Prilepi ga v Meta Business Manager. Spremenljivka {{1}} nosi celotno sporočilo hiše, v eni vrstici in do 1024 znakov.',
        whatsapp_template_body_example: 'Sporočilo hotela: {{1}}',
        whatsapp_template_docs: 'Metina navodila za predloge →',
        whatsapp_template_name: 'Ime predloge',
        whatsapp_template_name_hint: 'Natanko tako, kot je zapisana v Meta Business Manager, npr. rota_obvestilo.',
        whatsapp_template_language: 'Jezik predloge',
        whatsapp_template_language_hint: 'Koda jezika, v katerem je predloga potrjena — npr. sl ali en_US. Prazno pomeni sl.',
        whatsapp_template_mode: 'Kdaj uporabi predlogo',
        whatsapp_template_mode_hint: 'Prazna predloga zgoraj pomeni, da se predloga ne uporabi nikoli, karkoli piše tu.',
        whatsapp_mode_auto: 'Samodejno — najprej prosto besedilo, predloga ob Metini zavrnitvi',
        whatsapp_mode_always: 'Vedno predloga',
        whatsapp_mode_never: 'Nikoli — samo prosto besedilo',
        whatsapp_webhook: 'Povratni klic (neobvezno)',
        whatsapp_webhook_hint: 'Meta sem sporoči, ali je sporočilo prispelo, bilo prebrano ali zavrnjeno. Brez tega obveščanje deluje naprej — le zapisa o dostavi ni.',
        whatsapp_webhook_url: 'Naslov povratnega klica',
        whatsapp_webhook_url_hint: 'Prilepi ga v Meta → WhatsApp → Configuration → Webhook in naroči dogodek „messages“.',
        whatsapp_verify_token: 'Žeton za preverjanje',
        whatsapp_verify_token_hint: 'Poljuben niz, ki ga vpišeš tu in v Metin obrazec. Ni skrivnost, ampak dokaz, da je oba konca nastavil isti človek.',
        whatsapp_app_secret: 'Skrivnost aplikacije (App secret)',
        viber: 'Viber',
        viber_hint: 'Bot hiše. Vsak zaposleni se z njim poveže sam, s kodo s svojega profila — ID pogovora izda Viber prek webhooka in ga nihče ne pozna na pamet.',
        viber_sender: 'Ime pošiljatelja',
        viber_sender_hint: 'Viber ga zahteva na vsakem sporočilu; največ 28 znakov.',
        viber_uri: 'Naslov bota (URI)',
        viber_uri_hint: 'Javni URI računa iz Viberjeve skrbniške konzole — npr. hotel_test. Iz njega se sestavi povezava, ki jo osebje odpre.',
        viber_token: 'Žeton bota',
        viber_webhook: 'Webhook',
        viber_webhook_none: 'Webhook: ni nastavljen',
        viber_webhook_set: 'Webhook: nastavljen',
        viber_webhook_failed: 'Webhook: napaka',

        events_title: 'Dogodki',
        events_hint: 'Kaj hiša sploh pošlje. Privzeto nič: sporočilo na telefon je nekaj, kar hotel vklopi namenoma.',
        event_rota_published: 'Objava urnika',
        event_rota_published_hint: 'Eno sporočilo na osebo in teden, ko vodja objavi urnik.',
        event_rota_changed: 'Sprememba turnusa',
        event_rota_changed_hint: 'Ko se že objavljen turnus premakne — s prejšnjim in novim časom.',
        event_rota_cancelled: 'Odpoved turnusa',
        event_rota_cancelled_hint: 'Ko se že objavljen turnus umakne.',
        event_channels: 'Privzete poti',
        event_channels_hint: 'Nič izbranega pomeni vse poti, ki jih hiša ima. Izbira posameznika to zoži, nikoli ne razširi.',
        event_channels_all: 'Vse poti hiše',

        test: 'Preizkusi',
        test_sent: 'Poskusno sporočilo je poslano.',
        test_sent_template: 'Poslano prek potrjene predloge — predloga deluje.',
        test_sent_text: 'Poslano kot prosto besedilo — torej znotraj 24-urnega okna te številke. Osebje, ki hiši ne piše, doseže samo predloga.',
        // Kaj se je zgodilo s sporočilom, ki ga je hiša oddala Twiliu
        // (docs/OBVESCANJE.md §10.2). Stanja so Twilijeva lastna beseda in ne prevod
        // našega izmišljenega stanja — tako se to, kar piše tu, ujema s konzolo, ki jo
        // hotelir gleda.
        delivery_following: 'Spremljam dostavo …',
        delivery_accepted: 'Sprejeto',
        delivery_queued: 'V vrsti',
        delivery_sent: 'Poslano',
        delivery_delivered: 'Dostavljeno',
        delivery_read: 'Prebrano',
        delivery_failed: 'Ni poslano',
        delivery_undelivered: 'Ni dostavljeno',
        delivery_console: 'Podrobnosti v Twilio konzoli: Monitor → Logs → Messaging',
        delivery_at: 'Čas',
        delivery_to: 'Komu',
        delivery_purpose: 'Namen',
        delivery_status: 'Stanje',
        delivery_purpose_test: 'Preizkus',
        delivery_purpose_notice: 'Obvestilo',
        delivery_purpose_shift_change: 'Sprememba turnusa',
        delivery_purpose_unknown: 'Neznano',
        // Ena slovenska vrstica k Twilijevim besedam: kaj naj hiša naredi. Angleški
        // stavek ostane zraven, dobesedno — on je merodajen.
        delivery_error_21612: 'Ta cilj ne sprejme črkovnega pošiljatelja (npr. „ImprionPMS“). Vpiši Twilijevo številko kot pošiljatelja.',
        delivery_error_30003: 'Telefon je izklopljen ali zunaj dosega. Poskusi pozneje.',
        delivery_error_30005: 'Te številke ni — preveri obliko (+386…) in operaterja.',
        delivery_error_30006: 'Številka je stacionarna ali ne sprejema SMS.',
        delivery_error_30007: 'Operater je sporočilo filtriral (praviloma vsebina ali neregistriran pošiljatelj).',
        delivery_error_30008: 'Operater ni povedal, zakaj. Če se ponavlja, poglej v Twilio konzolo.',
        delivery_error_63016: 'Zunaj 24-urnega okna WhatsAppa — prosto besedilo ne gre skozi, potrebna je potrjena predloga.',
        deliveries_title: 'Zadnja sporočila',
        deliveries_hint: 'Zadnjih deset sporočil te hiše prek Twilia, SMS in WhatsApp skupaj. Številke so zakrite na zadnje tri števke; zapisi se hranijo 30 dni.',

        // Odgovori na spremembo turnusa po SMS-u (docs/OBVESCANJE.md §11).
        sms_inbound: 'Odgovori osebja (SMS)',
        sms_inbound_hint: 'Ta naslov moraš prilepiti sam. Poročilo o dostavi potuje na sporočilu samem, prihajajoče sporočilo pa gre tja, kamor pokaže številka — brez tega „DA“ odide s telefona in ne pride nikamor.',
        sms_inbound_url: 'Naslov za prejeta sporočila',
        sms_inbound_where: 'Prilepi ga v Twilio → Phone Numbers → izberi številko → Messaging → „A message comes in“ (metoda POST). Sporočilo o spremembi turnusa se takrat konča z „Odgovorite DA ali NE.“',
        sms_inbound_none: 'Ta namestitev nima javnega naslova, zato odgovorov po SMS-u ni mogoče prejemati. Pošiljanje deluje naprej.',
        sms_inbound_alphanumeric: 'Pošiljatelj ni telefonska številka, zato nanj ni mogoče odgovoriti. Vpiši Twilijevo številko namesto črkovnega imena, če želiš prejemati odgovore.',
        secret_set: 'Shranjeno',
        secret_hint: 'Ne vrne se nazaj. Prazno polje pomeni „pusti, kar je shranjeno“.',
        secret_stored: 'Shranjeno. Prazno polje pusti obstoječega; za odvzem uporabi gumb.',
        clear_secret: 'Odstrani',
        secret_cleared: 'Odstranjeno.',
        saved: 'Nastavitve so shranjene.',
    },
    // Lastni profil: kje me hiša doseže in po katerih poteh. Brez pravice — po
    // docs/OSEBJE.md §13 je samopostrežba druga stran tega, da si v evidenci, in ne
    // pravica, ki ti jo nekdo podeli.
    profile: {
        nav: 'Moj profil',
        contact_title: 'Moji podatki za obveščanje',
        contact_hint: 'Kam naj hiša pošlje obvestilo o urniku. Ti podatki so tvoji in jih urejaš sam.',
        email: 'E-naslov',
        email_hint: 'Sem pride obvestilo o objavi urnika in o spremembi turnusa.',
        phone: 'Telefon',
        phone_hint: 'V mednarodni obliki: +38641123456.',
        phone_invalid: 'Telefon mora biti v obliki +386… (od 8 do 15 števk).',
        channels: 'Poti obveščanja',
        channels_hint: 'Nič izbranega pomeni vse poti, ki jih hiša ima. Siva pot pomeni, da je hiša ni nastavila.',
        channel_unavailable: 'Hiša te poti (še) nima nastavljene.',

        messaging_title: 'Sporočilne aplikacije',
        messaging_hint: 'WhatsApp potrebuje številko — vpiši jo le, če ni ista kot telefon zgoraj. Viber se poveže s kodo.',
        telegram_state_paired: 'Povezano',
        telegram_state_unpaired: 'Ni povezano',
        telegram_no_bot: 'Hiša nima bota',
        telegram_no_bot_hint: 'Ko ga bo nastavila, se boš lahko povezal tukaj.',
        telegram_paired_hint: 'Obvestila prejemaš prek bota {bot}.',
        telegram_unpair: 'Odveži',
        telegram_unpaired: 'Povezava je odvezana.',
        telegram_get_code: 'Pridobi kodo',
        telegram_new_code: 'Nova koda',
        telegram_step_code: 'Pridobi kodo spodaj.',
        telegram_step_open: 'V Telegramu odpri bota {bot}.',
        telegram_step_send: 'Pošlji mu spodnjo vrstico. Povezava bo urejena v minuti.',
        telegram_code_expires: 'Koda velja do {at}.',

        whatsapp_number: 'WhatsApp številka',
        whatsapp_number_hint: 'Samo če se razlikuje od telefona zgoraj. Prazno pomeni isto številko.',
        viber_no_bot: 'Hiša Viberja (še) nima nastavljenega. Ko ga bo, se boš lahko povezal tukaj.',
        viber_paired_hint: 'Obvestila prejemaš prek Viber bota hiše.',
        viber_state_stale: 'Povezava ne deluje',
        viber_stale: 'Viber povezava ne deluje več',
        viber_stale_hint: 'Viber sporočil na ta račun ne dostavlja več — najverjetneje si bota odstranil. Pridobi novo kodo in se poveži znova.',
        viber_get_code: 'Pridobi kodo',
        viber_unpair: 'Odveži',
        viber_unpaired: 'Povezava z Viberjem je odvezana.',
        viber_open: 'Odpri bota v Viberju',
        viber_step_code: 'Pridobi kodo spodaj.',
        viber_step_open: 'Odpri bota hiše v Viberju — s spodnjim gumbom ali tako, da ga poiščeš.',
        viber_step_send: 'Če se pogovor ne poveže sam, mu pošlji spodnjo kodo. Povezava bo urejena takoj.',
        pairing_new_code: 'Nova koda',
        pairing_code_expires: 'Koda velja do {at}.',

        account_title: 'Račun',
        account_hint: 'Kdo si v sistemu.',
        account_managed_elsewhere: 'Ime, uporabniško ime in pravice ureja skrbnik pod Nastavitve (zobnik) → Uporabniki, vloge in varnost → Uporabniki.',
        saved: 'Shranjeno.',
    },
    // Zvonec v zgornji vrstici. Ne meša se z „Opomniki" v stranskem meniju: opomnik je
    // zapisek z datumom, ki si ga nekdo napiše sam, tukaj pa je samo tisto, kar hiša
    // čaka od tega računa, in odgovor, ki mu ga je hiša vrnila.
    notification: {
        vacation_decision_issued: 'Izdan je odlok o dopustu — potrdi prejem',
        title: 'Obvestila',
        empty: 'Nič ne čaka.',
        waiting: 'Obvestila: čaka jih {count}',
        action_failed: 'Dejanja ni bilo mogoče izvesti. Poskusi znova.',

        bill_change_pending: 'Zahtevek za popust čaka tvojo odobritev',
        bill_change_approved: 'Tvoj zahtevek za popust je odobren',
        bill_change_rejected: 'Tvoj zahtevek za popust je zavrnjen',
        decided_by: 'Odločitev: {name}, {when}',

        rota_change_mine: 'Spremenjen je tvoj objavljen turnus',
        rota_change_undelivered: 'Spremembe turnusa še ni potrdil',
        rota_change_declined:    'Spremembo turnusa je zavrnil(a)',

        absence_request_pending: 'Zahtevek za odsotnost čaka tvojo odločitev',
        absence_approved: 'Tvoja odsotnost je odobrena',
        absence_rejected: 'Tvoja odsotnost je zavrnjena',
    },
    bill_change: {
        // Vodilo za izrazje: „popust" in „umik" sta besedi, ki ju recepcija reče na
        // glas, in tako sta poimenovana tudi zapisa v dnevniku. „Sprememba računa" je
        // skupno ime za oboje in stoji samo tam, kjer sta obe vrsti skupaj.
        panel: 'Spremembe računa',
        report: 'Popusti in umiki',

        kind: 'Vrsta',
        kind_discount: 'Popust',
        kind_removal: 'Umik',

        discount: 'Popust',
        remove: 'Umakni',
        discount_tooltip: 'Popust na postavko (z razlogom)',
        remove_tooltip: 'Umakni postavko z računa (z razlogom)',
        give: 'Odobri popust',
        ask: 'Pošlji v odobritev',

        mode: 'Kako',
        mode_percent: 'Odstotek',
        mode_amount: 'Znesek',
        percent: 'Popust (%)',
        amount: 'Popust (znesek)',

        original: 'Postavka',
        comes_off: 'Odbito',
        resulting: 'Za plačilo',
        total_column: 'Skupaj',

        reason: 'Razlog',
        reason_hint: 'Obvezno. To je prvo, kar mesec dni pozneje prebere vodja — „gost nezadovoljen s sobo" pove nekaj, „popust" ne.',

        discount_line: 'Postavka #{line}, {amount}',
        remove_line: 'Postavka #{line}, {amount}',
        remove_hint: 'Postavka ostane na kartici, pod njo pa se zapiše storno. Račun mora pokazati, da je bila postavka tam in da je bila umaknjena — račun, ki parkirišča sploh ne omenja, ni preverljiv.',
        room_line_hint: 'Nočitve so bile prespane in jih ni mogoče umakniti. Če se soba ne sme zaračunati, se skrajša ali odpove bivanje.',

        your_limit: 'Tvoja meja: {limit}',
        no_limit: 'Popusta ne moreš odobriti sam — vsak gre v odobritev vodji.',
        needs_approval: 'Presega tvojo mejo',
        needs_approval_hint: 'Popust znaša {share}, tvoja meja je {limit}. Zahtevek se shrani in ga odobri nekdo, čigar meja ga pokriva. Z računa se ne odbije nič, dokler tega ne stori.',

        given: 'Popust je odbit.',
        asked: 'Zahtevek je poslan v odobritev.',
        removed: 'Postavka je umaknjena.',
        discount_failed: 'Popusta ni bilo mogoče odbiti.',
        remove_failed: 'Postavke ni bilo mogoče umakniti.',

        pending_title: 'Čaka odobritev',
        asked_by: 'Zahteval {name}, {when}',
        asked_by_short: 'zahtevala {name}',
        approve: 'Odobri',
        reject: 'Zavrni',
        approved: 'Popust je odobren in odbit.',
        rejected: 'Zahtevek je zavrnjen.',
        decision_failed: 'Odločitve ni bilo mogoče zapisati.',
        decision_note: 'Zakaj ne?',
        reject_hint: 'Razlog je obvezen: zavrnitev brez razloga je zavrnitev, na katero tisti, ki je vprašal, ne more odgovoriti.',
        over_your_limit: 'Zahtevek presega tvojo mejo — odobri ga lahko nekdo z višjo.',

        approved_by: 'Odobril',
        person_unknown: 'Neznano',
        empty: 'Na tem računu ni popustov ne umikov.',

        status_pending: 'Čaka odobritev',
        status_applied: 'Izvedeno',
        status_rejected: 'Zavrnjeno',

        discounts_line: 'popust na postavko {line}',
        discounted_by_line: 'popust: {line}',

        by_person: 'Po osebi',
        by_reason: 'Po razlogu',
        report_total: 'Skupaj odbito',
        report_count: '{count} sprememb',
        report_changes: 'Sprememb',
        report_rows: 'Posamezne spremembe',
        report_empty: 'V tem obdobju z računov ni bilo odbito nič.',
        report_empty_hint: 'Šteje se samo izvedeno: zahtevek, ki še čaka odobritev, z računa ni odbil ničesar.',
        open_folio: 'Odpri kartico',

        alert_title: 'Čaka odobritev: {count} zahtevkov za popust',
        alert_hint: 'Z računa se ne odbije nič, dokler zahtevka ne odobri nekdo, čigar meja ga pokriva.',
        alert_can_decide: 'Tvoja meja pokriva zahtevek — odobriš ali zavrneš ga lahko kar tukaj.',
    },
    role: {
        max_discount: 'Največji popust (%)',
        max_discount_hint: 'Koliko sme nosilec te vloge odbiti s postavke odprtega računa. 0 pomeni, da gre vsak popust v odobritev.',
        max_discount_inactive: 'Vloga nima pravice „Popust na postavko", zato meja zaenkrat ne velja. Obkljukaj jo spodaj (folio:discount).',
        max_discount_note: 'Popust nad mejo ni zavrnjen — shrani se kot zahtevek in ga odobri nekdo z višjo mejo. Kdor ima več vlog, dobi najvišjo od njih.',
        assignments_title: 'Vloge in pravice',
        assignments_hint_short: 'Kaj bo ta račun smel. Brez vloge se lahko prijavi in ne more ničesar.',
            assignments_failed_new_user: 'Vlog ni bilo mogoče shraniti. Račun obstaja — vlogo mu dodeli iz seznama uporabnikov.',
        roles:                 'Vloge',
        hint:                  'Vloga je poimenovan snop pravic. Koda nikoli ne vpraša, ali je nekdo receptor — vpraša, ali sme izdati račun. Privzete vloge niso posebne: preimenuj, spremeni ali izbriši jih tako kot vsako drugo.',
        add:                   'Dodaj vlogo',
        edit:                  'Uredi vlogo',
        name:                  'Naziv vloge',
        name_hint:             'Ime, po katerem jo bo hotel klical — „Receptor“, „Nočni receptor“.',
        description:           'Opis',
        description_hint:      'Za koga je ta vloga in česa namenoma ne zajema.',
        permissions:           'Pravice',
        permissions_count:     'Pravic',
        permissions_required:  'Vloga brez ene same pravice ne dovoli ničesar — izberi vsaj eno',
        holders:              'Uporabnikov',
        holders_title:        'Vlogo {role} imajo',
        holders_description:  'Računi s to vlogo in objekt, v katerem jo imajo.',
        open_user: 'Odpri uporabnika',
        holders_empty:        'To vlogo nima nihče.',
        holders_none:          'Nihče',
        no_permissions:        'Brez pravic',
        confirm_delete:        'Naj se vloga „{name}“ izbriše? Računi, ki jo imajo, izgubijo pravice iz nje.',
        in_use:                'Te vloge ni mogoče izbrisati — ima jo še {count} uporabnikov. Najprej jim dodeli drugo vlogo.',
        in_use_unknown:        'Te vloge ni mogoče izbrisati, ker jo nekdo še ima. Najprej mu dodeli drugo vlogo.',
        locked:                'Te spremembe ni mogoče shraniti — s tem bi upravljanje uporabnikov ostalo brez lastnika ali bi ga vzela sebi',
        selected:              'Izbrano {selected} od {total}',
        select_all:            'Vse v tem sklopu',
        legend:                'Branje in pisanje sta povsod ločena. Nevarna dejanja imajo svojo pravico tudi takrat, ko so „samo“ pisanje.',
        roles_held:            'Dostop',
        no_roles:              'Brez dostopa',
        no_roles_assign:       'Brez vlog — dodeli',
        unknown_role:          'Neznana vloga',
        unknown_property:      'Neznan objekt',
        assignments:           'Dostop uporabnika {name}',
        // Napis dejanja v vrstici — na tablici se prebere kot besedilo v meniju, zato
        // pove obe stvari, ki ju nekdo išče: vloge in dostop.
        manage_assignments:    'Vloge in dostop',
        assignments_hint:      'Vsaka vrstica je ena vloga v enem objektu. Sobarica dela v enem hotelu, ne v vseh — zato objekt ni samoumeven.',
        assignments_empty:     'Ta uporabnik nima nobene vloge. Prijaviti se še vedno lahko, videl pa ne bo ničesar.',
        role_column:           'Vloga',
        property_column:       'Objekt',
        all_properties:        'Vsi objekti',
        select_role:           'Izberi vlogo',
        select_property:       'Izberi objekt',
        add_assignment:        'Dodaj vlogo',
        remove_assignment:     'Odstrani vrstico',
        duplicate_assignment:  'Ta vloga je v tem objektu že navedena',
        assignments_saved:     'Dostop je shranjen',
        assignments_failed:    'Dostopa ni bilo mogoče shraniti',
        assignments_locked:    'Tega ni mogoče shraniti — nekdo mora ostati z upravljanjem uporabnikov, in sebi ga ne moreš vzeti',
        effective:             'Kaj s tem sme',
        effective_hint:        'Seštevek pravic vseh izbranih vlog — to je tisto, kar strežnik dejansko preveri.',
        effective_none:        'Nič. S takim naborom se lahko prijavi, ne more pa odpreti nobenega zaslona.',
        no_properties:         'Ta najemnik nima nobenega objekta. Vloge lahko dodeliš samo v vseh objektih.',
        read_only:             'Za spreminjanje vlog in dostopa je potrebna pravica „Upravlja uporabnike, vloge in dostop“. Tu jih lahko samo pregleduješ.',
        editor_title:       'Vloge in pravice',
        editor_hint:        'Vloga je poimenovan snop pravic. Tu se ureja, kaj vloga dovoli; kdo jo ima, se ureja med uporabniki.',
        pick_role:          'Izberi vlogo',
        pick_hint:          'Izberi vlogo na seznamu in njene pravice se odprejo tukaj.',
        search_permissions: 'Išči pravico po imenu, opisu ali kodi',
        search_none:        'Nobena pravica ne ustreza iskanju.',
        only_granted:       'Samo dodeljene',
        sensitive_held:     'Nevarnih: {count}',
        save_permissions:   'Shrani pravice',
        unsaved:            'Neshranjene spremembe',
        discard:            'Razveljavi spremembe',
        expand_all:         'Razpri vse sklope',
        collapse_all:       'Zapri vse sklope',
        managed_on_users:   'Vloge se dodajajo in brišejo na zaslonu Uporabniki — tukaj se jim ureja samo nabor pravic.',
        open_permissions:   'Uredi pravice te vloge',
        granted_by:         'Prinašajo jo vloge:',
        granted_by_none:    'Nobena od izbranih vlog te pravice ne prinaša.',
        role_missing:       'Te vloge ni več — morda je bila izbrisana.',
        count_permissions:  'Pravic: {count}',
        confirm_switch:     'Spremembe pravic te vloge še niso shranjene. Naj se zavržejo?',
    },
    permission: {
        sensitive:                              'Nevarno',
        sensitive_hint:                         'Storno, dobropis, odpoved, nočni zaključek in upravljanje uporabnikov — to je tisto, kar hotel navadno dovoli ožjemu krogu.',
        untranslated:                           'Nova pravica, ki je ta zaslon še ne zna poimenovati.',
        code:                                   'Koda pravice',
        no_description:                         'Opisa še ni.',
        module_off:                             'Modul ni vključen',
        module_off_hint:                        'Modul „{module}“ za ta hotel ni vključen. Pravico vloga vseeno lahko drži — strežnik jo do vklopa modula samo maskira, vloge pa ne spremeni.',
        module_distribution:                    'Distribucija',
        module_guest:                           'Gost',
        module_operations:                      'Obratovanje',
        module_pos_link:                        'Gostinstvo (POS)',
        module_staff:                           'Zaposleni in čas',
        module_reports:                         'Poročila',
        module_groups_events:                   'Skupine, dogodki in storitve',
        module_marketing:                       'Marketing in spletna stran',
        module_materials:                       'Materialno poslovanje in nabava',
        module_revenue:                         'Revenue',
        module_chains:                          'Veriga',
        domain_property:                        'Objekti in sobe',
        domain_guest:                           'Gostje',
        domain_crm:                             'CRM — odnosi',
        domain_sales:                           'Prodaja',
        domain_reservation:                     'Rezervacije',
        domain_rate:                            'Ceniki',
        domain_folio:                           'Foliji gostov',
        domain_invoice:                         'Računi',
        domain_housekeeping:                    'Gospodinjstvo',
        domain_retail:                          'Prodaja na blagajni',
        domain_stock:                           'Skladišče',
        domain_materials:                       'Materialno: računi',
        domain_facility:                        'Zmogljivosti hotela',
        domain_dining:                          'Obroki in vstopi',
        domain_telemetry:                       'Sobna telemetrija',
        domain_maintenance:                     'Vzdrževanje',
        domain_compliance:                      'Prijava gostov',
        domain_channel:                         'Kanali',
        domain_report:                          'Poročila',
        domain_finance:                         'Finance',
        domain_night_audit:                     'Nočni zaključek',
        domain_chat:                            'Milo',
        domain_marketing:                       'Marketing',
        domain_staff:                           'Zaposleni in čas',
        domain_user:                            'Uporabniki in dostop',
        domain_certificate:                     'Digitalna potrdila',
        property_read:                          'Vidi objekte, tipe sob in sobe',
        property_read_desc:                     'Register objektov, tipov sob, sob in opreme — brez možnosti spreminjanja.',
        property_write:                         'Ureja objekte, tipe sob in sobe',
        property_write_desc:                    'Postavljanje in urejanje objektov, tipov sob, sob in njihove opreme.',
        guest_read:                             'Vidi kartoteko gostov',
        guest_read_desc:                        'Kartoteka gostov in podjetij, ki plačujejo zanje.',
        guest_write:                            'Vnaša in ureja goste',
        guest_write_desc:                       'Vnos in popravek gosta — najširši krog v hotelu, ker to počne vsak, ki sprejme gosta za pultom.',
        guest_merge:                            'Združi dvojnika gosta',
        guest_merge_desc:                       'Združitve ni mogoče razveljaviti: bivanja, foliji, prijave in turistična taksa se preselijo z ene osebe na drugo.',
        guest_message:                          'Piše gostu v imenu hotela',
        guest_message_desc:                     'Sporočilo, podpisano z imenom hotela, zapusti stavbo in ga ni mogoče vzeti nazaj — vsako je hotel, ki govori.',
        reservation_read:                       'Vidi rezervacije in razpored sob',
        reservation_read_desc:                  'Rezervacije, šahovnica, razpoložljivost, ponudbe in skupine.',
        reservation_write:                      'Sprejema rezervacije, prijavlja in odjavlja goste',
        reservation_write_desc:                 'Sprejem rezervacije, prijava in odjava, razporejanje po sobah.',
        reservation_cancel:                     'Odpove rezervacijo',
        reservation_cancel_desc:                'Odpoved rezervacije ali skupine in označitev neprihoda.',
        reservation_checkout_unpaid:            'Odjava brez plačila',
        reservation_checkout_unpaid_desc:       'Edina odločitev ob odhodu, ki hotel stane pravi denar — hotel jo sme dovoliti, ne sme pa je spregledati, zato se zabeleži.',
        reservation_override_restrictions:      'Rezervira mimo omejitev cenika',
        reservation_override_restrictions_desc: 'Zaprt datum, minimalno bivanje, ustavljena prodaja: omejitev je poslovna odločitev o nekem vikendu in kdor jo razveljavi, pove zakaj.',
        rate_read:                              'Vidi cenike in cene',
        rate_read_desc:                         'Ceniki, dnevne cene, doplačila in odpovedni pogoji.',
        rate_write:                             'Določa cenike, cene in omejitve',
        rate_write_desc:                        'Določanje cen, doplačil, odpovednih pogojev in omejitev prodaje.',
        folio_read:                             'Vidi folio gosta',
        folio_read_desc:                        'Postavke in plačila na foliu gosta ter zaključni obračun bivanja.',
        folio_post:                             'Knjiži postavke in plačila na folio',
        folio_post_desc:                        'Knjiženje postavke ali plačila in prenos postavke na drug folio.',
        folio_reverse:                          'Stornira postavko na foliu',
        folio_reverse_desc:                     'Storno postavke in vračilo plačila — denar gre nazaj s folia.',
        folio_discount:                         'Da popust na postavko folia',
        folio_discount_desc:                    'Znižanje postavke z razlogom. Kako daleč sega, pove najvišji popust vloge — nad njim gre zahtevek v odobritev.',
        folio_remove_line:                      'Umakne postavko s folia',
        folio_remove_line_desc:                 'Umik postavke z računa z razlogom — parkirišče, zajtrk. Izvede se kot storno in šteje v managerski pregled.',
        invoice_read:                           'Vidi izdane račune',
        invoice_read_desc:                      'Izdani računi, njihova zgodovina, dokument in kopije.',
        invoice_issue:                          'Izda račun',
        invoice_issue_desc:                     'Izdaja računa, ki je davčni dokument in ga ni mogoče popraviti, ampak samo stornirati.',
        invoice_credit:                         'Izda dobropis',
        invoice_credit_desc:                    'Storno izdanega računa z dobropisom.',
        housekeeping_read:                      'Vidi razpored čiščenja',
        housekeeping_read_desc:                 'Razpored čiščenja, stanje sob in najdene stvari.',
        housekeeping_work:                      'Označi sobo kot počiščeno',
        housekeeping_work_desc:                 'Sobarica pove, da je s sobo končala.',
        housekeeping_inspect:                   'Potrdi pregled sobe',
        housekeeping_inspect_desc:              'Nadzornica potrdi, da je počiščena soba pregledana.',
        retail_read:                            'Vidi blagajne in promet',
        retail_read_desc:                       'Branje pulta ni isto kot delo na njem: blagajne, prodaje in vračila, brez prijave na blagajno.',
        retail_sell:                            'Prodaja na blagajni',
        retail_sell_desc:                       'Prijava na blagajno, odprtje izmene in izdaja prodaje na pultu.',
        retail_refund:                          'Vrne blago in denar',
        retail_refund_desc:                     'Vračilo blaga in denarja — dejanje nadzornika, ne prodajalca.',
        retail_manage:                          'Postavi blagajne in bere izmene',
        retail_manage_desc:                     'Postavitev blagajn in vpogled v vse izmene, tudi tuje.',
        retail_price_override:                  'Proda po drugačni ceni',
        retail_price_override_desc:             'Cena s police je poslovna odločitev; odstop se zabeleži z obveznim razlogom, ker je razlika resničen denar.',
        stock_read:                             'Vidi zalogo in skladišča',
        stock_read_desc:                        'Artikli, skladišča, dobavitelji, stanja, primanjkljaji in bližnji roki uporabe.',
        stock_move:                             'Prenaša blago',
        stock_move_desc:                        'Odpis s police ali prenos med skladišči — sobarica vzame steklenico iz minibara.',
        stock_post:                             'Knjiži dobavnice in prejete račune',
        stock_post_desc:                        'Papir za blagom: dobavnica, prejeti račun in njuno knjiženje. Delo knjigovodje, ne skladiščnika.',
        stock_inventory:                        'Knjiži inventuro',
        stock_inventory_desc:                   'Edino knjiženje, ki na novo zapiše, kaj hotel misli, da ima: druga povedo, kaj se je premaknilo, to pove, kaj dejansko je.',
        stock_manage:                           'Ureja artikle, skladišča in dobavitelje',
        stock_manage_desc:                      'Registri sami — kaj hotel sploh vodi, ne premikanje česarkoli od tega.',
        materials_invoice:                      'Prejeti računi, ujemba in dobropisi',
        materials_invoice_desc:                 'Knjigovodska stran nabave: dobaviteljev račun kot svoj dokument, trismerna ujemba z naročilnico in prevzemom, knjiženje na police in dobropis. Ni isto kot stock:post — ta pravica ustvari obveznost, uveljavi vstopni DDV in SPREJME dobaviteljevo ceno, tudi kadar odstopa znotraj toleranc.',
        materials_procure:                      'Katalog, pogodbe in naročilnice',
        materials_procure_desc:                 'Nabavna stran: kaj kateri dobavitelj zaračuna, po kateri šifri in do kdaj cena velja, ter dogovori za obdobje. Ni isto kot stock:manage — ta pravica ureja, kaj hiša SME PLAČATI: aktivacija pogodbe zapiše cene, po katerih se potem naročajo vse naslednje pošiljke, in dovoli sprejeti pretečeno ceno na naročilnici.',
        materials_rules:                        'Pravila odobritev zahtevkov',
        materials_rules_desc:                   'Kdo mora potrditi zahtevek, od katerega zneska naprej, v koliko stopnjah in do kdaj. Ni isto kot materials:approve — ta pravica ne odgovarja na vprašanje, ampak ga postavlja: kdor bi smel obenem odobravati in pisati lestvico, bi lahko potrdil karkoli tako, da si prej zniža stopnjo.',
        facility_read:                          'Vidi zmogljivosti, razpored in cene',
        facility_read_desc:                     'Wellness, kolesarnica, parkirišče: kaj hotel prodaja poleg sobe.',
        facility_book:                          'Rezervira termin gostu',
        facility_book_desc:                     'Ena prodaja: receptor vpiše gosta na termin, cene pa ne določa.',
        facility_work:                          'Izvaja storitve: začne in zaključi svoje termine',
        facility_work_desc:                     'Terapevt ali izposojevalec vidi dan, začne termin in ga zaključi — ne sprejema rezervacij in ne določa cene.',
        facility_manage:                        'Ureja zmogljivosti, cene in odpiralni čas',
        facility_manage_desc:                   'Katalog in cenik tega, kar hotel ponuja poleg sobe.',
        dining_read:                            'Vidi jutranji pregled obrokov',
        dining_read_desc:                       'Jutro pri vratih jedilnice, kot ga bere recepcija.',
        dining_work:                            'Preverja upravičenost pri vratih',
        dining_work_desc:                       'Delo pri vratih: upravičenost, dietne opombe in evidentiranje obroka — ne pa postavljanje jedilnice.',
        dining_override:                        'Spusti neupravičenega ali zavrne',
        dining_override_desc:                   'Brezplačen zajtrk je denar, ki ga hotel podari, zato oba akta zahtevata razlog.',
        dining_manage:                          'Ureja restavracije, obroke in urnike',
        dining_manage_desc:                     'Restavracije, obroki, termini, cena dodatnega obroka in PIN nad dietnimi opombami.',
        telemetry_read:                         'Vpogled v dogajanje v sobah',
        telemetry_read_desc:                    'Sobarica mora videti odprto okno in znak „ne moti“, ne pa nastavljati temperature v sobi, kjer gost spi.',
        telemetry_comfort:                      'Nastavljanje ogrevanja sobe',
        telemetry_comfort_desc:                 'Način, ciljna temperatura in „pripravi za prihod“.',
        telemetry_automation:                   'Nastavljanje urnikov in mej hotela',
        telemetry_automation_desc:              'Urniki, meje in povezava sama — vključno s tem, ali hotel sploh vidi simulirano opremo.',
        maintenance_read:                       'Vidi prijave okvar',
        maintenance_read_desc:                  'Prijave okvar in kako daleč so.',
        maintenance_report:                     'Prijavi okvaro',
        maintenance_report_desc:                'Prijava okvare — pravica tistega, ki jo opazi.',
        maintenance_work:                       'Odpravlja okvare',
        maintenance_work_desc:                  'Prevzem prijave in delo na njej.',
        maintenance_close:                      'Zaključi prijavo okvare',
        maintenance_close_desc:                 'Potrditev, da je okvara odpravljena.',
        compliance_read:                        'Vidi prijave gostov in turistično takso',
        compliance_read_desc:                   'Kaj je bilo prijavljeno organu in koliko takse je obračunane.',
        compliance_write:                       'Prijavlja goste in obračuna turistično takso',
        compliance_write_desc:                  'Oddaja prijave in obračun takse — zakonska obveznost hotela.',
        channel_read:                           'Branje kanalov',
        channel_read_desc:                      'Stanje povezav s portali in kaj je z njih prišlo.',
        channel_manage:                         'Upravljanje povezav in preslikav',
        channel_manage_desc:                    'Povezava hotela s portalom in preslikava sob in cenikov: enkratno, natančno delo.',
        channel_resolve:                        'Reševanje rezervacij s kanalov',
        channel_resolve_desc:                   'Rezervacija, ki je prišla s portala in je ni bilo mogoče umestiti; delo za pultom pod časovnim pritiskom, ker gost drži potrditev v roki.',
        report_read:                            'Vidi poročila in promet',
        report_read_desc:                       'Poročila o zasedenosti in prometu hotela.',
        night_audit_run:                        'Zažene nočni zaključek',
        night_audit_run_desc:                   'Zapre poslovni dan hotela in ga premakne naprej.',
        finance_read:                           'Vidi finance in blagajniške zaključke',
        finance_read_desc:                      'Denarna poročila hotela: to bere računovodkinja, ne tisti, ki gleda zasedenost.',
        finance_reconcile:                      'Označi kartična plačila kot usklajena',
        finance_reconcile_desc:                 'Pisanje, ne branje: postavko vzame z opozorilne luči za vse, in vrednost dejanja je zapis, kdo je tako odločil.',
        crm_read:                               'Pregled odnosov (CRM)',
        crm_read_desc:                          'Odnos z gostom in podjetjem: zgodovina, segmenti in lijak.',
        crm_write:                              'Urejanje CRM (opombe, oznake, opravila, segmenti)',
        crm_write_desc:                         'Odnosna kartoteka hotela — vse ostane znotraj hotela.',
        sales_manage:                           'Vodenje prodaje (priložnosti, pogodbe, kontakti)',
        sales_manage_desc:                      'Prodajni lijak in pogodbeni papir s podjetji.',
        user_read:                              'Vidi uporabnike in vloge',
        user_read_desc:                         'Seznam računov, vloge in kdo katero ima.',
        user_manage:                            'Upravlja uporabnike, vloge in dostop',
        user_manage_desc:                       'Ključ, ki deli vse druge: ustvarjanje računov, urejanje vlog in dodeljevanje dostopa.',
        certificate_manage:                     'Vidi in zamenja digitalna potrdila',
        certificate_manage_desc:                'Seznam potrdil pove, kdo podpisuje v imenu podjetja in kdaj to preneha veljati.',
        chat_use:                               'Uporablja Mila',
        chat_use_desc:                          'Odpre vrata; kaj skozi njih vidi, še vedno odloča njegov lastni nabor pravic, orodje za orodjem.',
        chat_write:                             'Pusti Milu pripraviti množične spremembe',
        chat_write_desc:                        'Ključ do predala s predlogi, ne do podatkov: vsaka pripravljena sprememba ob potrditvi znova preveri svojo pravico.',
        chat_admin:                             'Vidi pogovore vseh uporabnikov',
        chat_admin_desc:                        'Nadzor, ne stranska vrata: pogovor vsebuje le tisto, kar je smel prebrati njegov lastnik.',
        marketing_read:                         'Vidi marketinški modul',
        marketing_read_desc:                    'Ponudbe, kampanje in kaj čaka na odločitev.',
        marketing_write:                        'Ureja ponudbe in vsebino',
        marketing_write_desc:                   'Urejanje ponudbe in njenega besedila — osnutek, nikoli objava.',
        marketing_ai:                           'Pusti modelu pisati osnutke',
        marketing_ai_desc:                      'Vsaka uporaba stane, osnutek pa nosi glas hotela.',
        marketing_approve:                      'Potrdi osnutek',
        marketing_approve_desc:                 'Človeška polovica pravila „model predlaga, človek potrdi“ — pisec besedila ni samodejno tudi njegov podpisnik.',
        marketing_publish:                      'Objavi navzven',
        marketing_publish_desc:                 'Trenutek, ko nekaj postane vidno zunaj hotela; edina od petih, ki je urejanje ne more razveljaviti.',
        staff_read:                             'Vidi, kdo je danes na delu',
        staff_read_desc:                        'Operativni pogled na hotel, brez evidence delovnega časa.',
        staff_schedule:                         'Sestavlja urnik svojega oddelka',
        staff_schedule_desc:                    'Obseg ni ločena pravica: izhaja iz kadrovske kartice sestavljalca, zato kdor zamenja oddelek, s seboj odnese tudi obseg.',
        staff_time:                             'Vidi evidenco delovnega časa vseh',
        staff_time_desc:                        'Branja lastne evidence ta pravica ne odpira in se sploh ne dodeljuje — je samopostrežna, strežnik odgovor zoži na prijavljeno osebo.',
        staff_clock:                            'Registrira prihod in odhod',
        staff_clock_desc:                       'Pravica NAPRAVE, nikoli osebe: ta terminal sme zabeležiti čas tistemu, ki se je pravkar identificiral s PIN. Za svoj prihod nihče ne potrebuje pravice.',
        staff_correct:                          'Vnese popravek delovnega časa',
        staff_correct_desc:                     'Branje evidence in njeno spreminjanje nista ista pravica; popravek pusti sled v pravnem dokumentu.',
        staff_approve:                          'Potrdi popravke, odsotnosti in nadure',
        staff_approve_desc:                     'Predlagati spremembo in jo potrditi sta dve roki — prav to daje evidenci vrednost v sporu.',
        staff_manage:                           'Ureja kadrovske kartice in organizacijo',
        staff_manage_desc:                      'Najobčutljivejša od devetih: kartica so osebni podatki, ki jih recepcija nima razloga videti, zato namenoma ne stoji pod „Vidi uporabnike“.',
        staff_report:                           'Vidi statistiko svojega oddelka',
        staff_report_desc:                      'Statistika lastnega oddelka, z istim obsegom kot urnik.',
        staff_oversee:                          'Vidi urnike in statistiko vseh oddelkov',
        staff_oversee_desc:                     'Direktorjeva pravica: pregled nad celim hotelom in nič zapisljivega.',
    },
    // Zaposleni in čas (docs/OSEBJE.md). Modul `staff`, prodajno Imprion Workforce.
    // Evidenca delovnega časa (docs/OSEBJE.md §8, §9). Ločeno od `staff`, ker je urnik
    // obljuba hiše, evidenca pa uradni zapis — in ker se ta sklop preseli v `staff-web`
    // v celoti, ko bo tisti portal obstajal.
    staff_time: {
        scoped_to_person: 'Prikazano samo za osebo: {name}',
        show_whole_house: 'Pokaži vso hišo',
        // Moja ura
        my_time:            'Moja ura',
        today_total:        'Danes',
        of_which_break:     'od tega odmor {minutes}',
        break_counts_hint:  'Odmor šteje v delovni čas in se ne odšteva.',
        first_in:           'prihod {at}',
        last_out:           'odhod {at}',
        day_open:           'Dan ni zaključen — odhod ni zabeležen.',
        stamped:            'Zabeleženo: {kind}',
        my_record:          'Moja evidenca',
        period_week:        'Teden',
        period_month:       'Mesec',
        no_days:            'V tem obdobju ni zabeleženih dni.',
        break_short:        'odmor {minutes}',
        open:               'Nedokončan',
        excess_pending:     'Presežek — čaka razvrstitev',
        my_corrections:     'Moji zahtevki za popravek',

        // Žigi
        kind_clock_in:      'Prihod',
        kind_clock_out:     'Odhod',
        kind_break_start:   'Odmor',
        kind_break_end:     'Konec odmora',
        stamp:              'Žig',
        occurred_at:        'Čas dogodka',
        received_at:        'Prejeto na strežniku',
        source:             'Vir',
        device:             'Naprava',
        zone:               'Časovni pas',
        corrected:          'Popravljen',
        no_stamps:          'Ta dan nima nobenega žiga.',
        source_personal_device: 'Osebna naprava',
        source_kiosk:       'Kiosk',
        source_manual:      'Ročni vnos',

        // Evidenca časa (vodja)
        record:             'Evidenca časa',
        person:             'Oseba',
        no_record:          'V tem obdobju ni zabeleženih ur.',
        open_days:          'Nedokončani dnevi',
        open_days_hint:     'Dan brez odhoda se ne zapre sam. Popravek zahteva zaposleni ali vodja, odloči pa nekdo drug.',
        previous_month:     'Prejšnji mesec',
        this_month:         'Ta mesec',
        next_month:         'Naslednji mesec',
        total_worked:       'Delo',
        total_break:        'Odmor',
        total_expected:     'Obveznost',
        total_balance:      'Saldo',
        excess:             'Presežek',
        no_rounding_hint:   'Brez zaokroževanja: v celicah so ure na eno decimalko, seštevki in izvoz nosijo minute.',

        // Popravki
        corrections:        'Popravki',
        corrections_hint:   'Popravek je nov zapis, nikoli urejanje žiga. Izvorni žig ostane viden.',
        no_corrections:     'Ni zahtevkov v tem stanju.',
        correction_requested: 'Zahtevan',
        correction_approved:  'Potrjen',
        correction_rejected:  'Zavrnjen',
        all_states:         'Vsa stanja',
        from_to:            'iz {from} v {to}',
        missing_stamp_at:   'manjkajoči žig ob {at}',
        requested_by:       'Zahteval: {who}, {at}',
        decided_by:         'Odločil: {who}, {at}',
        decision_reason:    'Razlog: {reason}',
        not_your_own:       'O svojem zahtevku ne odločaš. Odloči imetnik pravice staff:approve v drugem oddelku ali direktor.',
        approve:            'Odobri',
        reject:             'Zavrni',
        reject_hint:        'Zavrnitev ostane vidna vlagatelju in v dnevniku.',
        reject_reason:      'Razlog zavrnitve',
        approved:           'Popravek je potrjen.',
        rejected:           'Popravek je zavrnjen.',

        // Zahtevek za popravek
        request_correction: 'Zahtevaj popravek',
        correction_hint:    'Zahtevaš lahko sam; odloči nekdo drug.',
        correction_what:    'Kaj popravljaš',
        correction_mode_existing: 'Popravek obstoječega žiga',
        correction_mode_missing:  'Manjkajoči žig',
        correction_which_stamp:   'Kateri žig',
        correction_no_stamps:     'Ta dan nima žiga, ki bi ga bilo mogoče popraviti.',
        correction_kind:    'Vrsta žiga',
        correction_date:    'Datum',
        correction_time:    'Ura',
        correction_reason:  'Razlog',
        correction_send:    'Pošlji zahtevek',
        correction_sent:    'Zahtevek je poslan v odločitev.',
        correction_decided_by_other: 'O zahtevku odloči nekdo drug — svojega ne moreš potrditi sam.',

        // Nastavitve
        settings:           'Evidenca delovnega časa',
        settings_hint:      'Kaj hiša odloči o evidenci. Zaokroževanja ni in ne bo — za vsebinsko zaokroževanje delovnega časa ni zakonske varne cone.',
        break_recording:    'Beleženje odmora',
        break_recording_hint: 'Naša prostovoljna funkcija, ne zakonska zahteva (ZEPDSV-B, 23. 4. 2025). Predpostavljen odmor je fikcija, ki jo evidenca trdi — zato jo ponujamo, in zato jo je mogoče izklopiti.',
        excess_threshold:   'Prag presežka (minute)',
        excess_threshold_hint: 'Od koliko minut čez turnus nastane naloga za razvrstitev. 0 pomeni nikoli. Minute se štejejo v saldo tako ali tako — prag odloča le, ali gre kdo to pogledat.',

        // PIN za kiosk
        kiosk_pin:          'PIN za kiosk',
        kiosk_pin_action:   'PIN za kiosk',
        kiosk_pin_mine:     'Moj PIN',
        kiosk_pin_hint:     'Samo številke, od {min} do {max} mest. PIN se shrani zaklenjen in se nikoli ne prikaže nazaj.',
        kiosk_pin_shared_warning: 'Deljen terminal ostane deljiv: ena oseba lahko žigosa drugo. Žig zato zapiše napravo, s katere je prišel — osebna naprava je močnejši dokaz od kioska.',
        kiosk_pin_new:      'Nov PIN',
        kiosk_pin_confirmation: 'Ponovi PIN',
        kiosk_pin_invalid:  'PIN mora imeti od {min} do {max} številk.',
        kiosk_pin_mismatch: 'PIN-a se ne ujemata.',
        kiosk_pin_clear:    'Odvzemi PIN',
        kiosk_pin_cleared:  'PIN je odvzet.',

        // Kioski (naprave)
        kiosks:             'Kioski',
        kiosks_hint:        'Tablice na hodniku, na katerih se osebje žigosa s svojim PIN. Koda za registracijo velja pet minut in en poskus.',
        kiosks_empty:       'Ta hiša še nima kioska.',
        kiosk_add:          'Dodaj kiosk',
        kiosk_rename:       'Preimenuj kiosk',
        kiosk_shared:       'Skupni terminal',

        // Mesečna evidenca in izvoz
        not_payroll:        'Evidenca delovnega časa — ni obračun plač.',
        not_payroll_hint:   'Ta zaslon nosi količine: kdaj, koliko in katera vrsta odsotnosti. Kaj je dan vreden, kdo krije nadomestilo in katero šifro nosi v plači, odloči računovodstvo v svojem programu. Mesec tudi ni zamrznjen — popravek ga spremeni.',
        month_record:       'Mesečna evidenca',
        month_record_hint:  'Po osebah, v isti obliki kot izvoz — zaslon in datoteka sta isti dokument, prebran dvakrat.',
        month_not_final:    'Mesec se izračuna ob vsakem branju in ni zaključen: popravek spremeni tudi mesec, ki je bil že prebran.',
        export_csv:         'Izvozi CSV',
    },

    /*
     * Zaključevanje meseca (docs/EVIDENCA-CASA.md § „Zaključevanje meseca“).
     *
     * Ločen razdelek od `staff_time`, ker gre za drugo vprašanje: `staff_time` pove, KAJ
     * evidenca pravi, ta pa, ali je to kdo podpisal. Števila so izpisana kot „Nedokončani
     * popravki evidence: 3“ in ne s slovnično množino — slovenščina ima dvojino, i18n v
     * tem portalu pa privzeto pozna dve obliki, in „2 popravki“ bi bilo narobe.
     */
    staff_month: {
        close:                'Zaključi mesec',
        close_hint:           'Zaključujete {month}.',
        close_means:          'Kaj pomeni zaključitev:',
        close_means_snapshot: 'Mesec se zamrzne: zaslon in izvoz od tedaj odgovarjata shranjen posnetek s kontrolno vsoto (hash).',
        close_means_refused:  'Popravki evidence, vnos in odobritev odsotnosti ter žigi znotraj tega meseca so zavrnjeni, dokler ga kdo ponovno ne odpre.',
        close_means_rota:     'Urnik ostane urejljiv: turnus je načrt, evidenca so žigi.',
        close_means_reopen:   'Ponovno odprtje zahteva pravico staff:manage in zapisan razlog; posnetek se pri tem ne izbriše.',
        close_writes_version: 'Ta zaključitev zapiše verzijo {version}. Prejšnje ostanejo shranjene.',
        closed:               'Mesec je zaključen.',

        pending_title:       'Najprej odločite, kar čaka v tem mesecu',
        pending_corrections: 'Nedokončani popravki evidence: {count}',
        pending_absences:    'Nedokončani zahtevki za odsotnost: {count}',

        reopen:                 'Ponovno odpri',
        reopen_hint:            'Ponovno odpirate {month}.',
        reopen_keeps_snapshot:  'Posnetek se ne izbriše. Trenutna verzija se označi kot ponovno odprta, naslednja zaključitev pa zapiše verzijo več.',
        reopened:               'Mesec je ponovno odprt.',
        reason:                 'Razlog',
        reason_hint:            'Zakaj se zaključen mesec ponovno odpira. Zapiše se v revizijsko sled in ga bo nekdo prebral.',
        closed_version:         'Zaključena verzija',

        version_line:  'Verzija {version} · zaključil {name}, {date}',
        reopened_line: 'Ponovno odprl {name}, {date} · razlog: {reason}',
        history:       'Zgodovina ({count})',

        strip_open:         'Mesec ni zaključen',
        strip_open_hint:    'Izračuna se ob vsakem branju; popravek ga spremeni.',
        strip_closed:       'Zaključeno {date} · verzija {version} · {name}',
        strip_closed_hint:  'Zaslon in izvoz odgovarjata shranjen posnetek. Kontrolna vsota: {hash}',
        strip_reopened:     'Ponovno odprto {date} · {name} (verzija {version})',

        month_is_final: 'Mesec je zaključen: prikazane so shranjene številke iz posnetka, ne sprotni izračun.',
        badge_closed:   'Zaključeno',
    },

    staff_absence: {
        // Vrste — NAŠ seznam in začasen (docs/OSEBJE.md §10)
        kind_vacation:      'Dopust',
        kind_sick_leave:    'Bolniška',
        kind_holiday:       'Praznik',
        kind_training:      'Izobraževanje',
        kind_business_trip: 'Službena pot',
        kind_unexcused:     'Neopravičena odsotnost',
        kind_other:         'Drugo',
        provisional_kinds:  'Seznam vrst odsotnosti je začasen.',
        provisional_kinds_hint: 'Imena so naša, ne zakonska: zakon predpisuje finančne skupine in ne kataloga imen. Dokončno preslikavo v računovodske šifre potrdi računovodstvo.',

        // Stanja zahtevka
        state_requested:    'Zahtevano',
        state_approved:     'Odobreno',
        state_rejected:     'Zavrnjeno',
        state_withdrawn:    'Umaknjeno',

        // Vir zapisa
        source_request:     'Zahtevek',
        source_manager:     'Vnos vodje',
        source_calendar:    'Koledar praznikov',

        // Moja ura → Moje odsotnosti
        my_absences:        'Moje odsotnosti',
        my_absences_hint:   'Tvoji zahtevki in odločitve o njih. Zavrnjeni ostanejo vidni — zavrnitev, ki izgine, je zavrnitev, ki se ni zgodila.',
        no_my_requests:     'Nimaš zahtevkov za odsotnost.',
        request_leave:      'Zahtevaj dopust',
        request_hint:       'Zase lahko zahtevaš dopust. Bolniška se prijavi in evidentira, praznik izhaja iz koledarja, izobraževanje in službeno pot vpiše vodja.',
        request_sent:       'Zahtevek je poslan v odločitev.',
        send_request:       'Pošlji zahtevek',
        decided_by_other:   'O zahtevku odloči nekdo drug — svojega ne moreš potrditi sam.',
        withdraw:           'Umakni',
        withdrawn:          'Zahtevek je umaknjen.',
        range_backwards:    'Konec ne more biti pred začetkom.',
        range_too_long:     'Zahtevek lahko obsega največ {days} dni. Za daljšo odsotnost vpiše dneve vodja.',

        // Vodja
        requests:           'Zahtevki za odsotnost',
        requests_hint:      'Dopust zahteva zaposleni, odloči vodja. O svojem zahtevku ne odloča nihče.',
        no_requests:        'V tem stanju ni zahtevkov.',
        requested_at:       'Zahtevano {at}',
        days_recorded:      'Evidentiranih dni: {count}',
        not_your_own:       'O svojem zahtevku ne odločaš. Odloči imetnik pravice staff:approve v drugem oddelku ali direktor.',
        approved:           'Odsotnost je odobrena in evidentirana.',
        rejected:           'Odsotnost je zavrnjena.',
        reject_hint:        'Zavrnitev mora povedati razlog. Ostane vidna vlagatelju.',

        // Zapisi
        recorded:           'Evidentirane odsotnosti',
        no_records:         'V tem mesecu ni evidentiranih odsotnosti.',
        enter:              'Vnesi odsotnost',
        enter_hint:         'Bolniška, izobraževanje, službena pot, neopravičena odsotnost — vse, česar se ne zahteva, vpiše vodja.',
        person:             'Oseba',
        kind:               'Vrsta',
        from:               'Od',
        to:                 'Do',
        note:               'Opomba',
        absent:             'Odsotnost',
        total_absence:      'Odsotnost',
        employee_no:        'Šifra',
        working_days_only:  'Zapis nastane samo za dneve, ko je oseba imela delovno obveznost. Prosti dan po razporedu ni odsotnost.',
        never_deleted_hint: 'Evidentirane odsotnosti se ne brišejo in ne prepisujejo. Popravek je nov zapis, ki se sklicuje na prejšnjega; prejšnji ostane viden.',
        supersede:          'Popravi',
        supersede_hint:     'Popravek je nov zapis. Prejšnji ostane viden in označen — ne prečrtan in ne izbrisan.',
        supersede_keeps_day: 'Dan, oseba in minute ostanejo. Napačne DNEVE se popravi tako, da se vpiše prave in preseže napačne.',
        current_record:     'Zapis zdaj',
        new_kind:           'Nova vrsta',
        superseded:         'Zapis je popravljen z novim.',

        // Koledar praznikov
        calendars:          'Koledar praznikov',
        calendars_hint:     'Dnevi, ko je hiša zaprta. Kadrovska kartica se sklicuje nanj, dan v evidenci pa ga prebere sproti — popravek tukaj doseže vse dneve.',
        no_calendars:       'Ta hiša še nima koledarja praznikov.',
        add_calendar:       'Dodaj koledar',
        edit_calendar:      'Uredi koledar',
        calendar_name:      'Ime koledarja',
        holidays:           'Prazniki',
        holiday_name:       'Ime praznika',
        add_holiday:        'Dodaj praznik',
        holiday_count:      'Praznikov: {count}',
        seed_official:      'Dodaj uradne praznike',
        seeded_country:     'Uradni prazniki za {country} so dodani od leta {year} naprej. Kar hiša že ima, ostane nespremenjeno.',
        seed_is_a_starting_point: 'Uradni seznam je izhodišče — koledar ureja hiša sama',
        source:             'Vir',
        source_url:         'Povezava do vira',
        confirm_delete_calendar: 'Izbrišem koledar „{name}“?',
        calendar_only_working_days: 'Praznik postane odsotnost samo tam, kjer bi oseba po vzorcu ali urniku delala. Praznik na prostem dnevu ni dopust.',
    },

    /**
     * Pravila pokritosti (docs/OSEBJE.md §11 „Pravila pokritosti“).
     *
     * Zaradi tega bloka obstaja ta izdaja. Recepcija je imela razporejenih 16 ur in
     * potrebo 0 — ker housekeeping ima normo, pult pa ni imel ničesar. Norme za prijavo
     * gosta ni in je ne bomo izmislili: koliko stane pult, ve hiša, in tu to zapiše.
     */
    staff_coverage: {
        title:      'Pokritost',
        title_hint: 'Koliko dela ima posamezen oddelek na dan. Housekeeping to izpelje iz norm in odhodov; recepcija in podobni pulti ne — njihov dan je obratovalni čas plus prihodi in odhodi gostov.',

        department:      'Oddelek',
        rule:            'Pravilo',
        kind:            'Način izračuna',
        no_rule:         'Ni pravila',
        no_rule_line:    'Potreba tega oddelka je 0 in primanjkljaj ni meritev.',
        add_rule:        'Nastavi pravilo',
        edit_rule:       'Uredi pravilo',
        remove_rule:     'Odstrani pravilo',
        no_departments:  'Ta objekt še nima oddelkov. Dodaj jih v Zaposleni → Kadri → zavihek Oddelki in delovna mesta.',

        kind_desk:       'Pult (obratovalni čas + prihodi/odhodi)',
        kind_desk_hint:  'Za recepcijo, konsjerža, wellness pult. Dan stane toliko, kolikor je pult odprt, plus delo, ki ga prinesejo prihodi in odhodi tistega dne.',
        kind_none:       'Iz modula (npr. housekeeping)',
        kind_none_hint:  'Potrebo pove modul sam',
        kind_fixed:      'Fiksno po dnevih v tednu',
        kind_fixed_hint: 'Za oddelek, ki stane enako vsak teden, ne glede na zasedenost.',

        open_hours:     'Obratovalni čas',
        open_from:      'Odprto od',
        open_to:        'Odprto do',
        span_from:      'Od',
        span_to:        'Do',
        add_span:       'Dodaj termin',
        remove_span:    'Odstrani termin',
        spans_hint:     'Deljen delovni čas se zapiše kot več terminov (npr. 06:00–10:00, 11:30–14:30, 18:00–22:00) in se seštejejo. Termini se ne smejo prekrivati.',
        clock_hint:     'Ura v obliki HH:MM. „00:00–24:00“ je cel dan; „00:00–00:00“ je zaprto. Konec pred začetkom pomeni čez polnoč (22:00–06:00 je 8 ur).',
        min_staff_open: 'Oseb na pultu',

        night:           'Nočna pokritost',
        night_from:      'Noč od',
        night_to:        'Noč do',
        min_staff_night: 'Oseb ponoči',
        night_hint:      'Nočna se PRIŠTEJE k obratovalnemu času. Če je pult odprt 24 ur in ponoči zadošča ena oseba, pusti „Oseb ponoči“ na 0 — 1 pomeni nočnega receptorja POLEG pulta.',

        minutes_per_arrival:       'Minut na prihod',
        minutes_per_departure:     'Minut na odhod',
        minutes_per_in_house_room: 'Minut na zasedeno sobo',
        minutes_hint:              'Prihodi in odhodi se štejejo iz rezervacij tega dne — potrjenih tudi za naprej. To je edina številka, ki je ura na zidu ne zna.',
        in_house_hint:             'Stalna obremenitev gosta, ki je že v hiši (telefon, rezervacije, taksi). Privzeto 0 — večina hiš tega ne šteje za delo pulta.',

        fixed_week:      'Minute po dnevih v tednu',
        fixed_week_hint: 'Kar ni vpisano, je 0 — tisti dan oddelek ne potrebuje nikogar.',

        desk_summary:     'obratovanje {spans}, {people} oseb(a)',
        night_summary:    'noč {from}–{to}, {people} oseb(a)',
        movement_summary: 'prihod {arrival} min · odhod {departure} min',
        in_house_summary: 'sobe v hiši {minutes} min',
        fixed_summary:    'fiksno, {total} na teden',

        term_desk:       'obratovanje {span} × {people}',
        term_desk_spans: 'obratovanje {spans} = {span} × {people}',
        term_fixed:      'fiksno {minutes}',
        term_night:      'noč {span} × {people}',
        term_arrivals:   '{count} prihodov × {minutes} min',
        term_departures: '{count} odhodov × {minutes} min',
        term_in_house:   '{count} sob v hiši × {minutes} min',
        term_nothing:    'Za ta dan pravilo ne zahteva nikogar.',

        // Trije viri iz §11, zaprti 8. 9. 2026: jedilnica, dogodki in vzdrževanje.
        kind_dining:           'Jedilnica (obroki in pokriti)',
        kind_dining_hint:      'Za kuhinjo in strežbo. Dan stane toliko, kolikor stane odpreti posamezen obrok, plus delo, ki ga prinesejo pokriti tistega dne. Število pokritih pove modul obrokov — iz pansionov in rezervacij — in je natanko tisto, po katerem sodi tudi tablica pred jedilnico.',
        kind_events:           'Dogodki (dvorane in udeleženci)',
        kind_events_hint:      'Za bankete in konference. Dogodek je rezervacija dvorane (sejna soba, konferenčna ali banketna dvorana); skupina sama ni dogodek, ker so njene noči že preštete pri housekeepingu in na pultu.',
        kind_maintenance:      'Vzdrževanje (obhodi in naloge)',
        kind_maintenance_hint: 'Za vzdrževalno službo. Dan so obhodi plus odprte naloge, ki danes zapadejo ali so že zamujene — s stropom, ker zaostanek ni delo enega dne.',

        meal_breakfast: 'Zajtrk',
        meal_lunch:     'Kosilo',
        meal_dinner:    'Večerja',

        minutes_per_service: 'Minut na obrok',
        minutes_per_cover:   'Minut na pokritega',
        dining_hint:         'Minute na obrok so cena tega, da obrok sploh odpreš — brigada je tam, ne glede na to, ali pride pet ljudi ali devetdeset. Obrok, ki ga ta oddelek ne dela, pusti na 0; takrat ne stane nič.',
        dining_covers_hint:  'Pokriti se štejejo iz pansionov gostov v hiši in iz rezervacij tistega dne, po istem pravilu kot na tablici pred jedilnico. Zajtrk pripada jutru PO noči, večerja pa noči sami.',

        dining_summary:       '{meal} {service} min + {cover} min/os.',
        dining_summary_empty: 'ta oddelek ne dela nobenega obroka',

        minutes_per_event:         'Minut na dogodek',
        minutes_per_participant:   'Minut na udeleženca',
        default_participants:      'Privzeto oseb',
        events_hint:               'Minute na dogodek so postavitev, strežba in pospravljanje skupaj — ena številka, ker se vir šteje po dogodkih in ne po njihovih fazah.',
        default_participants_hint: 'Uporabi se za dogodek, ki števila oseb NE nosi, in večina jih ne: dvorana za seminar nosi podjetje in termin, število ljudi pa je v elektronski pošti. Prešteti se dajo samo dogodki, rezervirani na gostovo rezervacijo. 0 je poštena izbira — tak dogodek stane samo svoje minute — razčlenitev pa vedno pove, koliko dogodkov je bilo tako ocenjenih.',

        events_summary:               '{minutes} min na dogodek',
        participant_summary:          '{minutes} min na udeleženca',
        default_participants_summary: 'privzeto {count} oseb',

        minutes_per_day:   'Minut obhodov na dan',
        max_issue_minutes: 'Strop nalog na dan (min)',
        minutes_blocking:  'Minut na blokirajočo',
        minutes_normal:    'Minut na običajno',
        minutes_cosmetic:  'Minut na kozmetično',
        severity_blocking: 'blokirajočih',
        severity_normal:   'običajnih',
        severity_cosmetic: 'kozmetičnih',
        maintenance_hint:  'Naloga ne nosi ocene trajanja — kdor prijavi počeno cev, je sobarica s telefonom na hodniku — zato ceno pove hiša, po resnosti. Štejejo se odprte naloge, ki tisti dan zapadejo ali so že zamujene; naloge brez roka se pokažejo posebej in ne štejejo, ker naloga brez roka danes ne zapade.',
        cap_hint:          'Strop velja SAMO za naloge, obhodi so zunaj njega. 0 pomeni privzetek strežnika (4 h) in nikoli „brez stropa“: brez njega bi hiša s 300 odprtimi nalogami vsak dan brala, da rabi 150 ur vzdrževanja — aritmetično pravilno in neuporabno.',

        rounds_summary: 'obhodi {minutes} min',
        cap_summary:    'strop {minutes}',

        term_meal:         '{meal} {services} × {service} min + {covers} pokritih × {cover} min',
        term_events:       '{count} dogodkov × {minutes} min',
        term_participants: '{count} udeležencev × {minutes} min',
        term_assumed:      'od tega {count} brez štetja oseb (privzeto {participants})',
        term_no_events:    'Ta dan ni dogodkov.',
        term_rounds:       'obhodi {minutes}',
        term_issues:       '{count} {severity} × {minutes} min',
        term_capped:       'naloge bi bile {uncapped}, strop dneva je {cap}',
        term_undated:      '{count} nalog brez roka ni šteto',

        example:      'Primer',
        example_hint: 'Pri {arrivals} prihodih in {departures} odhodih: {sentence}',
        saved_hint:   'Pravilo velja takoj — pokritost se izračuna ob vsakem branju in nič ni shranjeno vnaprej.',
    },
    staff_vacation: {
        // Odmera letnega dopusta (docs/OSEBJE-UI.md §5)
        title:            'Dopusti',
        title_hint:       'Odmera letnega dopusta po osebah. Saldo je branje evidence; odlok je kadrovsko dejanje in zahteva pravico za kadrovske kartice.',
        days_count:       '{count} dni',

        my_vacation:      'Moj dopust',
        my_balance:       'Moj dopust',
        tab_vacation:     'Dopust',
        balance:          'Saldo dopusta',
        balance_line:     'Odmerjeno {entitled} \u00b7 izrabljeno {used} \u00b7 v odlo\u010danju {pending} \u00b7 ostane {remaining}',

        entitled:         'Odmerjeno',
        carried_over:     'Preneseno',
        used:             'Izrabljeno',
        pending:          'V odlo\u010danju',
        remaining:        'Ostane',
        of_which_pending: 'Od tega \u010daka odlo\u010ditev: {days}',

        // Star (prenesen) in nov (letošnji) dopust — 162. člen ZDR-1
        available:        'Na voljo',
        old_leave:        'Star dopust ({year})',
        current_leave:    'Letni dopust {year}',
        still_days:       '\u0161e {days}',
        still_of:         '\u0161e {left} od {total}',
        use_by:           'Izrabi do {date}.',
        expired_days:     'Zapadlo {days} \u2014 rok je bil {date}.',
        of_which_used:    'Od tega izrabljeno: {days}',
        not_issued_hint:  'Odlok za to leto \u0161e ni izdan.',
        bucket_old:       'Star',
        bucket_current:   'Nov',
        usage_history:    'Zgodovina uporabe',
        no_usage:         'V tem letu ni zabele\u017eene izrabe dopusta.',
        requested_days:   'Zahtevanih delovnih dni: {days}',
        over_remaining:   'Zahtevek presega razpolo\u017eljivih {days}. Odlo\u010ditev je vseeno na hi\u0161i.',
        remaining_total:  'Skupaj ostane',
        people:           'Oseb',
        with_decision:    'Z odlokom',
        acknowledged_count: 'Potrjeno',

        this_year:        'Letos',
        previous_year:    'Prej\u0161nje leto',
        next_year:        'Naslednje leto',

        no_balance:       'Za to leto ni podatka o dopustu.',
        no_balance_hint:  'Saldo nastane, ko je izdan odlok in ko ima oseba veljavno obdobje dela.',
        no_balance_person: 'Za to leto ta oseba nima izra\u010dunanega salda.',
        no_balances:      'Za to leto ni nobene osebe s saldom dopusta.',

        decision:         'Odlok',
        decisions:        'Odloki',
        decisions_hint:   'Vsak odlok nosi razčlenitev, s katero je bil izdan. Sprememba pravil velja za naprej in izdanega odloka ne premakne.',
        decision_for_year: 'Odlok za leto {year}',
        decision_total:   'Odmerjeno: {days}',
        decision_line:    'Leto {year}: {days}',
        no_decisions:     'Za to osebo \u0161e ni izdanega nobenega odloka.',
        my_decisions:     'Moji odloki',
        my_decisions_hint: 'Odlo\u010dbe o odmeri letnega dopusta, ki jih je hi\u0161a izdala tebi.',
        no_my_decisions:  'Zate \u0161e ni izdan noben odlok.',

        issue:            'Izdaj odlok',
        issue_for:        'Izdaj odlok za {year}',
        issue_all:        'Izdaj odloke za leto {year}',
        issued:           'Odlok je izdan.',
        issued_count:     'Izdanih odlokov: {count}',
        issue_failed:     'Neizdanih odlokov: {count}',
        confirm_issue_all: 'Izdam odloke za leto {year} vsem, ki ga \u0161e nimajo? To je {count} oseb.',
        confirm_reissue:  'Za osebo {name} odlok za leto {year} \u017ee obstaja. Izdam novega?',
        overridden:       'Ro\u010dna odmera',
        version:          'Razli\u010dica {version}',
        prorated_months:  'Sorazmerni del: {months} polnih mesecev zaposlitve \u2192 {days}.',
        override_line:    'Ro\u010dna odmera: {days}. Pravila hi\u0161e so dala skupaj celoletno vsoto zgoraj.',

        not_issued:       '\u010caka odlok',
        acknowledged:     'Potrjeno',
        not_acknowledged: 'Ni potrjeno',
        acknowledge:      'Potrjujem',
        acknowledge_hint: 'Potrjuje\u0161 PREJEM odloka, ne strinjanja s \u0161tevilom dni.',
        acknowledged_toast: 'Prejem odloka je zabele\u017een.',
        acknowledged_at:  'Potrjeno: {at}',
        issued_at:        'Izdal: {who}, {at}',
        pdf:              'PDF',

        part_base:           'Osnova',
        part_tenure:         'Delovna doba',
        part_education:      'Izobrazba',
        part_responsibility: 'Odgovorno delovno mesto',
        part_special:        'Posebna kategorija',
        part_children:       'Otroci',
        part_full_year:      'Skupaj (celo leto)',

        // Kadrovska kartica → Dopust
        card_fields:      'Podlaga za odmero',
        card_fields_hint: 'Polja so na OBDOBJU dela. Kon\u010dan \u0161tudij je novo obdobje, lanski odlok pa ostane, kakr\u0161en je bil.',
        education_level:  'Izobrazba',
        education_unset:  'Ni dolo\u010dena',
        prior_service_days: 'Predhodna delovna doba (dni)',
        prior_service_days_hint: 'Doba, prislu\u017eena pred to hi\u0161o. \u0160teje v lestvico po dobi.',
        prior_service_entered_on: 'Stanje na dan',
        prior_service_entered_on_hint: 'Dan, na katerega je bila doba pre\u0161teta iz dokumentov. Brez njega je \u0161tevilka \u010dez leto neberljiva.',
        prior_service_entered_on_required: 'Vpiši dan, na katerega je bila doba prešteta.',
        responsible_position: 'Odgovorno delovno mesto',
        special_category: 'Posebna kategorija (invalidnost, nega, no\u010dno delo)',
        special_category_hint: 'Kaj \u0161teje kot posebna kategorija, dolo\u010da kolektivna pogodba. Tu se samo zabele\u017ei, da velja.',
        children:         'Otroci',
        add_child:        'Dodaj otroka',
        no_children:      'Ni vpisanih otrok.',
        child_birth_date: 'Datum rojstva',
        children_hint:    'Samo datum rojstva. Imena otrok hi\u0161i ne pripadajo, starost pa se vsako leto izra\u010duna sama.',

        // Nastavitve → Pravila dopusta
        rules:            'Pravila dopusta',
        rules_hint:       'Iz \u010desa je sestavljena letna odmera. Sprememba velja za naprej in izdanega odloka ne premakne.',
        base_days:        'Osnova (dni)',
        base_days_hint:   'Zakonski minimum so \u0161tirje tedni \u2014 pri petdnevnem tednu 20 dni.',
        responsibility_days: 'Dodatek za odgovorno delovno mesto',
        responsibility_days_hint: 'Kdo ima odgovorno delovno mesto, pove kartica.',
        special_days:     'Dodatek za posebno kategorijo',
        special_days_hint: 'Invalidnost, nega, no\u010dno delo \u2014 po kolektivni pogodbi.',
        child_days:       'Dni na otroka',
        child_age_limit:  'Otrok \u0161teje do starosti',
        child_age_limit_hint: 'Leta. Otrok, ki jih je prekora\u010dil, se ne \u0161teje ve\u010d.',
        proration:        'Sorazmernost',
        proration_hint:   'Kako se meri leto, ki ni celo.',
        proration_full_months: 'Po dopolnjenih mesecih',
        tenure_tiers:     'Lestvica po delovni dobi',
        education_tiers:  'Lestvica po izobrazbi',
        add_tier:         'Dodaj stopnjo',
        no_tiers:         'Ni stopenj.',
        from_years:       'Od let',
        extra_days:       'Dodatnih dni',
        level_prefix:     'Stopnja',
        level_prefix_hint: 'Ujema se po za\u010detku: „VII“ pokrije VII/1 in VII/2.',
        tiers_are_highest: 'Velja NAJVI\u0160JA dose\u017eena stopnja, stopnje se ne se\u0161tevajo.',
        carry_over_month: 'Prenos velja do (mesec)',
        carry_over_day:   'Prenos velja do (dan)',
        carry_over_hint:  'Do tega dne se sme izrabiti lanski ostanek.',

        example:          'Primer',
        example_tenure:   'Let delovne dobe',
        example_children: '\u0160tevilo otrok',
        example_line:     'Primer: {years} let dobe, {level}, {children} otrok \u2192 {days}',
        example_hint:     'Primer ni\u010desar ne izda in ni\u010desar ne zapi\u0161e \u2014 pove le, kaj bi te nastavitve pomenile.',

        over_balance:     'Zahtevek presega ostanek dopusta. Odlo\u010ditev je vseeno tvoja.',
    },
    staff_document: {
        expires_at:       'Velja do',
        expires_at_hint:  'Neobvezno: dan, ko dokument preneha veljati (dovoljenje, zdravniško). Zaslon Danes opozori 30 dni prej.',
        // Dokumenti iz predlog (docs/OSEBJE-UI.md §5)
        documents:        'Dokumenti',
        documents_hint:   'Kar je hi\u0161a vlo\u017eila k tej osebi. Umaknjen dokument ostane na seznamu, prečrtan in z razlogom.',
        no_documents:     'Za to obdobje \u0161e ni nobenega dokumenta.',
        tab_documents:    'Dokumenti',
        document:         'Dokument',
        kind:             'Vrsta',
        kind_hint:        'Pod kaj se dokument vlo\u017ei. Seznam se kon\u010da z \u201edrugo\u201c \u2014 papirjev, ki jih hi\u0161a hrani, ni mogo\u010de na\u0161teti do konca.',
        kind_pogodba:     'Pogodba o zaposlitvi',
        kind_aneks:       'Aneks',
        kind_m1:          'Obrazec M-1',
        kind_nda:         'Izjava o zaupnosti',
        kind_odlok:       'Odlok',
        kind_drugo:       'Drugo',
        from_template:    'Iz predloge',
        title_field:      'Naslov',
        file:             'Datoteka',
        file_hint:        'Nalo\u017ei datoteko, kakr\u0161na je \u2014 skenirano pogodbo, potrdilo.',
        upload:           'Nalo\u017ei',
        uploaded:         'Dokument je nalo\u017een.',
        download:         'Prenesi',

        generate:         'Ustvari iz predloge',
        generate_hint:    'Predloga se izpolni s podatki kartice in ra\u010duna. Vpra\u0161amo samo za tisto, \u010desar kartica ne ve.',
        create:           'Ustvari',
        created:          'Dokument je ustvarjen.',
        template:         'Predloga',
        filled_automatically: 'To izpolnimo sami',
        extra_values:     'Dodatna polja predloge',
        no_extra_values:  'Ta predloga ne potrebuje ni\u010desar dodatnega.',
        no_templates_hint: 'Ta hi\u0161a \u0161e nima nobene predloge. Dodaj jo v Nastavitve \u2192 Zaposleni.',

        withdraw:         'Umakni',
        withdraw_hint:    'Dokument ostane v registru, ozna\u010den kot umaknjen.',
        withdraw_keeps_file: 'Datoteka se ne izbri\u0161e. Umik je zapis o tem, da dokument ne velja ve\u010d.',
        withdrawn:        'Dokument je umaknjen.',
        withdrawn_tag:    'Umaknjen',
        withdrawn_because: 'Umaknjen {at}: {reason}',
        reason:           'Razlog umika',
        reason_hint:      '„Umaknjeno“ brez razloga je dejstvo brez avtorja.',

        // Osebno
        my_documents:     'Moji dokumenti',
        my_documents_hint: 'Kar je hi\u0161a vlo\u017eila k tebi. Bere\u0161 in prenese\u0161; vlaga hi\u0161a.',
        no_my_documents:  'Zate \u0161e ni vlo\u017eenega nobenega dokumenta.',

        // Nastavitve → Predloge dokumentov
        templates:        'Predloge dokumentov',
        templates_hint:   'Datoteke .docx, iz katerih hi\u0161a izdeluje dokumente za svoje ljudi.',
        add_template:     'Dodaj predlogo',
        template_name:    'Ime predloge',
        template_name_hint: 'Kar bo pisalo v izbirniku. Prazno vzame ime datoteke.',
        template_added:   'Predloga je dodana.',
        docx_only:        'Samo .docx.',
        no_templates:     'Ta hi\u0161a \u0161e nima nobene predloge.',
        no_placeholders:  'V tej predlogi ni najdenega nobenega polja {…}.',
        placeholder_legend: 'Sivo izpolnimo sami; modro vpra\u0161amo ob izdelavi dokumenta.',
        upload_failed:    'Predloge ni bilo mogo\u010de nalo\u017eiti.',
        confirm_delete_template: 'Izbri\u0161em predlogo „{name}“? \u017De izdelani dokumenti ostanejo.',
    },
    staff: {
        // Kadrovski modul, urejen (docs/OSEBJE-UI.md)
        open_person:      'Odpri kadrovsko kartico',
        back_to_people:   'Kadrovske kartice',
        person_periods_hint: 'Vsa obdobja te osebe, tudi pretekla. Sezonski povratek sta dve obdobji in ne eno.',
        no_periods:       'Ta oseba še nima nobenega obdobja dela.',
        no_current_period: 'Danes ni veljavnega obdobja',
        no_current_period_hint: 'Danes za to osebo ne velja nobeno obdobje dela. Dopust in dokumenti visijo na obdobju, zato jih ni mogoče voditi, dokler ga ni.',
        tab_details:      'Podatki',
        tab_employment:   'Zaposlitev',
        tab_record:       'Evidenca',
        contact:          'Kontakt',
        contact_hint:     'Z računa osebe. Ureja se na Uporabnikih in na njenem lastnem profilu — drugo polje za isto številko bi bila druga številka.',
        no_account:       'Za to osebo ni najdenega računa.',
        account_state:    'Račun',
        card_fields:      'Kadrovska kartica',
        time_record:      'Evidenca delovnega časa',
        open_time_record: 'Odpri evidenco časa',
        // Splošno
        rota:            'Urnik',
        employments:     'Kadrovske kartice',
        employments_hint: 'Datirana obdobja dela. Sprememba oddelka ali obveznosti je NOVO obdobje, ne popravek starega — januarski saldo se meri po januarski obveznosti.',
        coverage:        'Pokritost',
        coverage_hint:   'Potrebne ure proti razporejenim, po dnevih in oddelkih. Potrebo pozna samo PMS — ura na zidu ne ve, koliko dela je jutri v hotelu.',
        no_property:     'Izberi objekt, da se prikaže urnik.',
        whole_house:     'Cel hotel',
        all_departments: 'Vsi oddelki',
        all_people:      'Vsi zaposleni',
        unknown_person:     'Neznana oseba',
        unknown_department: 'Neznan oddelek',
        unknown_position:   'Neznano delovno mesto',
        unknown_property:   'Neznan objekt',

        // Branje, ki ni uspelo — StaffLoadError.vue pove, da odgovora NI, namesto da bi
        // zaslon narisal prazno stanje, ki se bere kot »ni bilo nič«.
        // Kolega, ki je pri nas na posoji iz druge hiše (docs/UPRAVA.md §39, WP-G17).
        // Brez tega je v izbirniku samo neznano ime, in na neznano ime v izbirniku se
        // vodja odzove tako, da ga ne izbere.
        loan_person: '{name} (posojen iz {house})',
        load_failed: 'Podatkov ni bilo mogoče prebrati.',
        try_again:   'Poskusi znova',
        unit_hours:   'h',
        unit_minutes: 'min',

        // Urnik
        previous_week:      'Prejšnji teden',
        next_week:          'Naslednji teden',
        this_week:          'Ta teden',
        copy_previous_week: 'Podvoji prejšnji teden',
        add_shift:          'Dodaj turnus',
        edit_shift:         'Uredi turnus',
        publish_week:       'Objavi teden',
        amend_week: 'Popravi teden',
        change_live: 'Sprememba velja takoj. Zaposleni jo na svojem urniku še potrdi — do potrditve računaj, da pride ob stari uri.',
        nothing_to_publish: 'Ni neobjavljenih turnusov. Popravek objavljenega turnusa velja takoj, ko ga shraniš — zaposleni ga mora le še potrditi.',
        state_draft:     'Osnutek',
        state_published: 'Objavljeno',
        state_cancelled: 'Odpovedano',
        state_none:      'Brez turnusov',
        draft_week_title: 'Osnutek: {count} turnusov še ni objavljenih',
        draft_week_hint:  'Ta teden zaposlenim še ni viden. Objava ga pokaže na njihovem urniku; obvešča se šele SPREMEMBA že objavljenega turnusa.',
        rota_empty:      'Ta teden ni razporejen nihče.',
        rota_empty_hint: 'Turnus dodaš z gumbom zgoraj ali s podvojitvijo prejšnjega tedna.',
        person_line:           'obveznost {weekly} · razporejeno {scheduled}',
        person_line_scheduled: 'razporejeno {scheduled}',
        scheduled:       'Razporejeno',
        required:        'Potrebno po normi',
        required_hint:   'Iz odhodov, obrokov in drugih virov',
        scheduled_split: 'objavljeno {published} · osnutek {draft}',

        // Noga urnika (docs/OSEBJE.md §7, §11). Pokritost šteje SAMO objavljene
        // turnuse — osnutek ni obljuba — zato sta vrstici dve in ne ena: brez tega je
        // teden, ki je ves v osnutku, pisal »Razporejeno 0 min« nad polno mrežo.
        published_row: 'Objavljeno',
        draft_row:     'Osnutek',
        coverage_draft_hint: 'Pokritost šteje samo objavljene turnuse; osnutek jo pokrije šele z objavo.',
        publish_now:         'Objavi',

        // Norma po oddelkih, v glavi vsake skupine v mreži (docs/OSEBJE.md §11). Noga
        // sešteje hišo, hiša pa skrije prekratek housekeeping za pokrito kuhinjo — in
        // popravi se vedno EN oddelek, ne hiša. Barva je ista kot v nogi.
        department_day:         '{published} / {required}',
        department_day_title:   'Potrebno {required} · objavljeno {published} · osnutek {draft}',
        department_day_no_rule: 'ni norme za ta oddelek',

        // Bilanca (docs/OSEBJE-UI.md §5). Par „24 h / 17 h 15 min“ pri treh ljudeh
        // odšteješ na pamet, pri petindvajsetih pa je to sedem odštevanj na oddelek —
        // in kdor bere zid parov, jih ne odšteje nobenega. Zato je razlika prva vrstica
        // in par druga.
        //
        // Beseda in ne predznak: „−3 h“ v mreži, polni ur, je minus, ki ga oko preskoči,
        // pomen pa je ves v njem. Nič ima svojo besedo — „pokrito“ je odgovor,
        // „0 min“ je meritev ničesar.
        balance_short:   'manjka {missing}',
        balance_over:    'preveč {over}',
        balance_covered: 'pokrito',
        balance_row:     'Bilanca',
        balance_column:  'bilanca',
        week_column:     'Teden',
        week_balance_title: 'Teden: potrebno {required} · objavljeno {published} · osnutek {draft}',
        balance_hint: 'Manjka = potrebno − razporejeno (objavljeno + osnutki); preveč = več razporejenega kot potrebnega.',

        not_covered:      '{day}: {department} ni pokrit',
        not_covered_hint: 'Potrebno je {required}, objavljeno {scheduled} — manjka {missing}.',
        not_covered_draft_line: 'V osnutku je {draft}; tudi po objavi bo manjkalo {missing}.',
        covered_by_draft:      '{day}: {department} je pokrit šele z objavo',
        covered_by_draft_hint: 'Potrebno je {required}, objavljeno {published}, v osnutku {draft}. Ure so razporejene, a jih nihče še ni prejel — objavi teden, da veljajo.',

        // Nepokriti dnevi so ena plošča in ne škatla na dan: teden, ki je prekratek v
        // dveh oddelkih, je prej odrinil mrežo pod rob zaslona. Štirje stavki zgoraj so
        // to, kar vrstica plošče pove ob prehodu z miško.
        //
        // Plošča je DVA bloka in ne en seznam. Naslov je prej pisal „Nepokriti dnevi“,
        // kar je pomenilo »potrebno > objavljeno« — pravilo pokritosti (§11) in pošteno
        // ime za to, kar meri noga. Le da gostinec načrtuje v osnutkih: teden, ki ga je
        // pravkar razporedila, je zanjo rešen teden, plošča pa ga je naštela kot sedem
        // nepokritih dni. Vprašanje, ki ga v resnici postavlja, je »kaj je prekratko
        // tudi s tem, kar sem načrtovala« — zato štejeta dva različna DEJANJA:
        // rdeče pomeni, da ur še ni in mora nekdo razporediti človeka; jantarno pomeni,
        // da ure so in jih nihče še ni prejel — en pritisk na Objavi teden.
        uncovered_even_with_drafts: 'Nepokrito tudi z osnutki: {count}',
        covered_pending_publish:    'Pokrito z osnutki — čaka objavo: {count}',
        uncovered_missing:          'manjka {missing}',
        uncovered_awaiting:         'čaka objavo {missing}',
        all_covered:                'Vsi dnevi so pokriti',
        all_covered_with_drafts:    'Vsi dnevi so pokriti (z osnutki)',
        uncovered_expand:           'Pokaži',
        uncovered_collapse:         'Skrij',
        recurring_shortfall: '{department}: razpored je prekratek {days} dni',
        recurring_weekday:   'Vedno isti dan v tednu ({weekday}), skupaj {minutes} primanjkljaja. To je vprašanje kadrovskega načrta, ne vrsta nadur.',
        recurring_spread:    'Primanjkljaj je razpršen čez teden, skupaj {minutes}. To je vprašanje kadrovskega načrta, ne vrsta nadur.',
        confirm_publish: 'Objavim ta teden? Teden se bo prikazal zaposlenim na njihovem urniku ({count} turnusov).',
        published:       'Objavljenih turnusov: {count}',
        confirm_copy_week: 'Podvojim prejšnji teden v ta teden? Nastanejo OSNUTKI — objava je svoj korak.',
        copied:            'Kopiranih turnusov: {count}',
        // Preskočene je treba povedati na glas: „Kopiranih turnusov: 0“ brez pojasnila
        // je za razporejevalko pokvarjen gumb in ne teden, ki je že razporejen.
        copied_with_skipped: 'Kopiranih turnusov: {count} · {skipped} jih je ta teden že imel.',
        see_coverage:      'Odpri pokritost',
        sources_incomplete: 'Pozor: nekateri viri potrebe ne prispevajo — {sources}.',

        // Odsotnosti v urniku (docs/OSEBJE.md §10, §11). Evidentiran dan je dejstvo in
        // se odšteje od pokritosti; zahtevek je vprašanje in ne odšteje ničesar.
        absence_on_day:       'Odobrena odsotnost: {kind}',
        absence_pending_chip: '{kind} · čaka',
        absence_pending_hint: 'Zahtevek čaka odločitev. Odpri Odsotnosti.',
        open_absences:        'Odsotnosti',
        legend_published:      'Objavljen turnus',
        legend_draft:          'Osnutek',
        legend_absence:        'Odobrena odsotnost',
        legend_absence_pending: 'Zahtevek čaka odločitev',
        // Barvi plošče na vrhu, v svoji vrstici: zgornja legenda govori o CELICAH.
        legend_uncovered:       'Nepokrito tudi z osnutki',
        legend_pending_publish: 'Pokrito z osnutki, čaka objavo',
        legend_rule_warning:    'Turnus z opozorilom o počitku ali obremenitvi',

        // Pravila urnika (docs/OSEBJE.md §7). Vsi stavki opozoril prihajajo s strežnika
        // in se izpišejo dobesedno — tukaj so samo naslovi okoli njih.
        rule_warnings_title:  'Ta teden ima opozoril: {count}',
        rule_warnings_hint:   'Počitek in obremenitev. Nič od tega ni prepovedano — turnusi so označeni na mreži, opis pa je na celici.',
        shift_warning_hint:   'Opozorilo, ne prepoved. Če veš, da je tako dogovorjeno, shrani še enkrat — v sledi se zabeleži, da si vedela.',
        save_despite_warning: 'Shrani kljub opozorilu',
        pending_absences_title: '{department}: zahtevki za odsotnost čakajo odločitev',
        pending_absences_hint:  'Oseb: {count} · dni v tem oknu: {days}. Zahtevek se v pokritost NE šteje — dokler ni odločen, so ure še vedno razporejene.',
        absent:              'Odsotni',
        absent_pending_line: 'čaka: {names}',

        // Obvestila o spremembi objavljenega turnusa (§7). Prva objava se NE obvešča —
        // teden sam je objava; obvešča se le sprememba tistega, kar je nekdo že prebral.
        my_rota:           'Moj urnik',
        my_rota_empty:      'Ta teden nimaš razporejenega turnusa.',
        my_rota_empty_hint: 'Kar vidiš tukaj, je samo objavljeno. Osnutkov razporejevalca ne kaže — dokler teden ni objavljen, ni obljuba.',
        today:    'Danes',
        free_day: 'Prosto',
        break_of: 'odmor {minutes}',
        my_changes_title: 'Spremembe, ki jih še nisi potrdil: {count}',
        my_pending_title: 'Zahtevki, ki čakajo odločitev: {count}',
        change_moved:     'Iz {previous} v {current}',
        change_withdrawn: 'Turnus je odpovedan (bil je {previous})',
        change_reason_line: 'Razlog: {reason}',
        change_changed_at:  'Spremenjeno {at}',
        change_for_person:  '{name}: {change}',
        acknowledge:      'Razumem',
        acknowledged:     'Prejem potrjen',
        acknowledge_hint: 'S potrditvijo se v evidenco zapiše, da si spremembo videl, in kdaj. Dokler ne potrdiš, razporejevalec vidi, da še ne veš.',
        decline:        'Ne morem',
        decline_note:   'Zakaj ne moreš? (neobvezno)',
        decline_hint:   'Razporejevalec bo videl, da ne moreš, in poiskal nadomestilo. Sprememba ostane na seznamu, dokler tega ne uredi.',
        decline_send:   'Pošlji',
        declined:       'Zabeleženo: ne moreš.',
        decline_failed: 'Odgovora ni bilo mogoče zapisati.',
        not_told_title: 'Še ne ve za spremembo: {count}',
        not_told_hint:  'Dostava se zabeleži, ko oseba spremembo na svojem urniku potrdi — ne ko jo objavimo. Dokler ni potrjena, računaj, da človek pride ob stari uri.',
        told_in_person:        'Sporočeno osebno',
        told_in_person_done:   'Zabeleženo: osebi {name} je bilo sporočeno osebno.',
        told_in_person_failed: 'Zaznamka o osebnem obvestilu ni bilo mogoče shraniti.',
        notice_pending:   'Še ne ve',
        notice_sent:      'Poslano, nepotrjeno',
        notice_delivered: 'Potrjeno',
        notice_failed:    'Obvestilo ni uspelo',
        notice_declined:  'Zavrnjeno',
        declined_by:       '{name} je zavrnil(a) spremembo turnusa',
        declined_by_noted: '{name} je zavrnil(a) spremembo turnusa: {note}',
        declined_line:       'Spremembo turnusa je zavrnil(a)',
        declined_line_noted: 'Spremembo turnusa je zavrnil(a): {note}',

        // Turnus
        person:             'Oseba',
        person_placeholder: 'Izberi osebo',
        department:         'Oddelek',
        position:           'Delovno mesto',
        date:               'Datum',
        starts:             'Začetek',
        ends:               'Konec',
        break_minutes:      'Odmor (min)',
        break_hint:         'Odmor šteje v delovni čas in se ne odšteva.',
        overnight_hint:     'Turnus se konča naslednji dan. Ure se štejejo v koledarski dan, v katerem so bile oddelane.',
        shift_length_hint:  'Dolžina izmene: {length}',
        shift_published_notice: 'Ta turnus je objavljen. Oseba si je teden že razporedila okoli njega — sprememba jo mora doseči z razlogom.',
        shift_on_absence:      '{name} ima ta dan odobreno odsotnost: {kind}.',
        shift_on_absence_hint: 'Turnus lahko vseeno vpišeš — razpored je namera, prisotnost je dejstvo. Vedi le, da pokritost to osebo ta dan šteje kot odsotno, zato te ure v pokritost ne prispevajo.',
        shift_on_pending:      '{name} je za ta dan zaprosila za {kind} in odločitve še ni.',
        shift_on_pending_hint: 'Zahtevek v pokritost ne šteje — ure so razporejene, dokler nekdo ne odloči. Če ga odobriš potem, ostane ta turnus nepokrit.',
        change_reason:      'Razlog spremembe',
        change_reason_hint: 'Zapiše se skupaj s prejšnjim in novim časom ter stanjem dostave obvestila.',
        shift_added:        'Turnus dodan',
        confirm_delete_shift: 'Izbrišem ta osnutek turnusa?',
        cancel_shift:         'Odpovej turnus',
        cancel_needs_reason:  'Odpoved objavljenega turnusa potrebuje razlog.',
        confirm_cancel_shift: 'Odpovem ta objavljeni turnus? Interval se ohrani, oseba je obveščena, delovno mesto pa se pokaže kot nepokrito.',
        shift_cancelled:      'Turnus odpovedan',

        // Kadrovska kartica
        add_employment:  'Nova kadrovska kartica',
        edit_employment: 'Uredi obdobje',
        edit_period_notice: 'To je popravek obdobja, ne sprememba razmerja.',
        edit_period_hint:   'Selitev v drug oddelek ali sprememba obveznosti je NOVO obdobje — uporabi »Zaključi in odpri novo«.',
        section_person:       'Oseba',
        section_organisation: 'Organizacija',
        section_basis:        'Pravna podlaga',
        section_obligation:   'Obveznost',
        section_validity:     'Veljavnost',
        employee_no:        'Interna številka',
        employee_no_hint:   'Po njej računovodstvo ujame izvoz s svojo evidenco.',

        // Računovodski oznaki s kartice (docs/EVIDENCA-CASA.md § „Payroll Connect“).
        // Nista druga interna številka: interna je naša, ti dve sta njihovi.
        payroll_code:      'Plačna šifra',
        payroll_code_hint: 'Šifra te osebe v programu za obračun plač. Ni druga interna številka — interna pove, kdo je to pri nas, ta pa, katero postavko posodobi obračun. V eni hiši jo hkrati lahko nosi samo ena oseba.',

        cost_centre:             'Stroškovno mesto',
        cost_centre_hint:        'Samo za izjeme. Prazno pomeni stroškovno mesto oddelka, kar je običajna kartica.',
        cost_centre_placeholder: 'po oddelku',
        cost_centre_from_department: 'Po oddelku',

        legal_entity:      'Družba',
        legal_entity_hint: 'Družba, pri kateri je sklenjena ta pogodba. Izpelje se iz dodelitve hiše na dan začetka obdobja; popravi se v konzoli uprave verige, ker odloča, kdo oddaja obračun.',

        department_cost_centre_hint: 'Privzeto stroškovno mesto za vse v tem oddelku. Prosto besedilo, ker je šifrant računovodski in ne naš. Posameznik ga na svoji kartici lahko povozi.',
        employee_no_search: 'Išči po imenu, številki ali oddelku',
        search:             'Iskanje',
        organisation:       'Organizacija',
        home_property:      'Matični objekt',
        home_property_hint: 'Po njem se oseba pojavi na urniku tega hotela.',
        work_properties:      'Objekti dela',
        work_properties_hint: 'Kje oseba DELA. To niso dostopne pravice — te določa vloga na računu.',
        works_in:             'dela v {count} objektih',
        department_hint:        'Matični oddelek — tisti, pod katerim oseba nastopa na urniku.',
        work_departments:       'Dela tudi v',
        work_departments_hint:  'Drugi oddelki, kjer oseba DELA in je lahko razporejena. Ni isto kot vodenje oddelka.',
        works_also_in:          'dela tudi v: {departments}',
        managed_departments:      'Razporeja oddelke',
        managed_departments_hint: 'Vodja več oddelkov je pravilo, ne izjema. Obseg razporejanja pride od tod.',
        rosters:                  'razporeja: {departments}',
        manager:      'Vodja',
        manager_hint: 'Prazno pomeni: potrditve gredo vsem imetnikom staff:approve v tem hotelu.',
        manager_heads_hint:     'Predlagani so vodje izbranega oddelka.',
        manager_approvers_hint: 'Tega oddelka ne vodi nihče, zato so predlagani imetniki staff:approve.',
        manager_approver:       '{name} (staff:approve)',
        manager_none: 'Brez vodje',
        engagement_basis: 'Pravna podlaga',
        basis_employment_contract:  'Pogodba o zaposlitvi',
        basis_agency_worker:        'Agencijski delavec',
        basis_student_work:         'Študentsko delo',
        basis_pensioner_temporary:  'Začasno delo upokojenca',
        basis_traineeship:          'Praktično usposabljanje ali vajeništvo',
        basis_service_contract:     'Podjemna pogodba',
        basis_copyright_contract:   'Avtorska pogodba',
        basis_short_term_family_work: 'Kratkotrajno družinsko delo',
        basis_self_employed:        'Samostojni izvajalec',
        basis_other:                'Druga pravna podlaga',
        contract_duration:   'Trajanje pogodbe',
        duration_indefinite: 'Nedoločen čas',
        duration_fixed_term: 'Določen čas',
        fixed_term_reason:   'Razlog za določen čas',
        working_time_type:   'Delovni čas',
        time_full:           'Polni delovni čas',
        time_part:           'Krajši delovni čas',
        insurance_basis_code:      'Šifra podlage zavarovanja',
        insurance_basis_code_hint: 'Uradna šifra M-1, npr. 001.',
        time_record_required:      'Za to osebo se vodi evidenca delovnega časa',
        time_record_required_hint: 'Odkljukaj samo, kadar zakon evidence ne zahteva — in povej, zakaj.',
        time_record_basis: 'Evidenca se vodi iz',
        record_clock:      'Žigov',
        record_schedule:   'Urnika',
        record_pattern:    'Delovnega vzorca',
        record_manual:     'Ročnega vnosa',
        record_kept:       'evidenca iz: {basis}',
        time_record_exemption:      'Razlog izvzetja',
        time_record_exemption_hint: 'Poslovodna oseba je IZJEMA od evidence, ne vrsta zaposlitve.',
        exempt_managing_person:     'Poslovodna oseba',
        exempt_other:               'Drug razlog',
        record_exempt:              'brez evidence: {reason}',
        weekly_minutes:        'Tedenska obveznost (min)',
        weekly_hours:          'Tedenska obveznost (h)',
        obligation:            'Obveznost',
        per_week:              '{minutes} / teden',
        reference_period:      'Referenčno obdobje (mesecev)',
        reference_period_hint: 'Pri neenakomerno razporejenem delovnem času. Pripada osebi, ne hotelu.',
        reference_months:      'referenčno obdobje: {months} mes.',
        work_pattern:  'Delovni vzorec (min po dnevih)',
        work_pattern_hours:  'Delovni vzorec (h po dnevih)',
        no_pattern:    'brez delovnega vzorca',
        pattern_total: 'Vzorec skupaj {pattern} · tedenska obveznost {weekly}',
        day_monday:    'pon',
        day_tuesday:   'tor',
        day_wednesday: 'sre',
        day_thursday:  'čet',
        day_friday:    'pet',
        day_saturday:  'sob',
        day_sunday:    'ned',
        valid_from:    'Veljavno od',
        valid_to:      'Veljavno do',
        valid_to_hint: 'Prazno pomeni odprto obdobje.',
        validity:      'Veljavnost',
        open_ended:    'odprto',
        in_force:      'velja danes',
        current_only:      'Samo veljavna danes',
        current_only_hint: 'Odkljukano prikaže tudi pretekla obdobja — zgodovino, ne podvojitev.',
        confirm_delete_employment: 'Izbrišem to obdobje osebe {name}? Za odhod uporabi »Zaključi in odpri novo« — evidenca opravljenega dela ostane.',

        // Zaključek obdobja
        end_period:        'Zaključi in odpri novo',
        end_period_action: 'Zaključi obdobje',
        end_period_title:  'Zaključek in naslednik sta ena poteza.',
        end_period_hint:   'Strežnik najprej zapre staro obdobje in šele nato odpre novo — dve ločeni potezi bi ob napaki pustili osebo brez obdobja od jutri.',
        last_day:      'Zadnji dan obdobja',
        last_day_hint: 'Vključno. Naslednje obdobje se privzeto začne naslednji dan.',
        open_successor:      'Odpri novo obdobje',
        open_successor_hint: 'Selitev v drug oddelek, sprememba obveznosti, nova sezona.',
        successor_section:   'Novo obdobje',
        departure_title:     'Brez naslednika je to odhod.',
        departure_hint:      'Obdobje se zaključi in nič ga ne nasledi. Pretekla evidenca ostane nespremenjena.',
        period_ended:     'Obdobje zaključeno',
        period_succeeded: 'Obdobje zaključeno, novo odprto',

        // Šifranta
        departments:      'Oddelki',
        departments_hint: 'Šifrant. Prosto besedilo bi v pol leta dalo »Recepcija«, »recepcija« in »Front desk« kot tri oddelke — pokritost bi štela tri ekipe tam, kjer je ena.',
        positions:        'Delovna mesta',
        positions_hint:   'Kaj kdo DELA. Ni vloga: kaj sme račun odpreti, določa vloga in nič drugega.',
        add_department:   'Dodaj oddelek',
        edit_department:  'Uredi oddelek',
        add_position:     'Dodaj delovno mesto',
        edit_position:    'Uredi delovno mesto',
        no_departments:   'Oddelkov še ni.',
        no_positions:     'Delovnih mest še ni.',
        position_cost:        'Strošek na uro (povprečje)',
        position_cost_failed: 'Stroška delovnega mesta ni bilo mogoče shraniti',
        position_cost_hint:   'POVPREČJE za to delovno mesto v tej hiši, ne plača posameznika. Plač ta sistem ne vodi in evidenca delovnega časa ostaja brez denarja — ta znesek uporabi uprava verige za strošek dela na prodano sobo-noč. Prazno pomeni „ni znano“ in tabla to pove.',
        position_cost_none:   'ni določeno',
        name:         'Naziv',
        code:         'Šifra',
        code_hint:    'Stabilna oznaka za izvoz in podporo: male črke, številke in podčrtaji, začne se s črko.',
        code_invalid: 'Šifra sme vsebovati male črke, številke in podčrtaje ter se začeti s črko.',
        default_department:      'Privzeti oddelek',
        default_department_hint: 'Privzetek, ne omejitev — obdobje dela nosi svoj oddelek.',
        no_default_department:   'Brez privzetega oddelka',
        offered:       'Se še ponuja',
        offered_hint:  'Upokojeno šifro urnik in poročila še vedno preberejo; nova obdobja je ne dobijo več.',
        offered_short: 'V uporabi',
        retired:       'Upokojeno',
        confirm_delete_department: 'Izbrišem oddelek {name}?',
        confirm_delete_position:   'Izbrišem delovno mesto {name}?',

        // Organigram
        parent_department:      'Nadrejeni oddelek',
        parent_department_hint: 'Kje oddelek stoji v hiši. Brez nadrejenega pomeni: neposredno pod hišo.',
        no_parent_department:   '— brez —',

        department_head:      'Vodja oddelka',
        department_head_hint: 'Kdo vodi oddelek. Ime se izpiše na organigramu; pravic ne podeljuje.',
        no_department_head:   '— brez —',

        org_chart:          'Organigram',
        org_chart_hint:     'Organizacijska struktura: drevo oddelkov z zaposlenimi in linije poročanja po nadrejenih.',
        org_chart_back:     'Zaposleni',
        org_chart_on:       'Na dan',
        org_chart_horizontal: 'Vodoravno',
        org_chart_vertical:   'Vertikalno',

        org_chart_by_departments:   'Po oddelkih',
        org_chart_edit_departments: 'Uredi oddelke',
        org_chart_reporting_lines:  'Linije poročanja (nadrejeni)',

        org_chart_people:               'oseb: {count}',
        org_chart_head_label:           'Vodja: {name}',
        org_chart_head_title:           'Vodja oddelka',
        org_chart_set_head:             'Nastavi za vodjo',
        org_chart_no_employees:         'Ni zaposlenih',
        org_chart_also_here:            'tudi:',
        org_chart_cycle:                '(cikel)',
        org_chart_unassigned_group:     'Nerazporejeni ({count})',
        org_chart_unassigned_hint:      'Računi brez kadrovske kartice na ta dan. Povleci osebo na oddelek: odpre se nova kartica z izpolnjenim oddelkom.',
        org_chart_no_department_group:  'Brez oddelka ({count})',
        org_chart_no_people_on_record:  'Ni zaposlenih v evidenci.',
        org_chart_footnote:             'Nadrejeni je najprej polje „Nadrejeni\" v kadrovski kartici. Kjer je prazno, vodja oddelka poroča vodji nadrejenega oddelka, ostali pa vodji svojega oddelka; taka vrstica je označena „po oddelku“. Kdor nima nikogar nad seboj, je na vrhu.',
        org_chart_via_department:       'po oddelku {department}',
        org_chart_reports_to:           'Poroča: {name}',

        org_chart_drag_hint:      'Oddelek povleci na drug oddelek ali na hišo. Vodjo nastaviš z zvezdico ob imenu.',
        org_chart_drag_hint_more: 'Ljudi organigram ne premika — matični oddelek nosi kadrovska kartica. Isto hierarhijo in vodjo lahko nastaviš tudi v dialogu na zaslonu Oddelki in delovna mesta.',

        // Pokritost
        window_hint:  'Najdlje 31 dni.',
        by_day:       'Po dnevih',
        people:       'Oseb',
        shortfall:    'Primanjkljaj',
        shortfall_hint: 'Negativno pomeni presežek',
        short_days:      'Nepokritih dni',
        short_days_hint: 'Dnevi, kjer razpored ne pokrije potrebe',
        required_total:  'Potrebno v obdobju',
        sources:      'Viri potrebe',
        sources_hint:  'Vsak vir pove, ali sploh prispeva. Tiha nula izgleda enako kot miren torek — in to je najslabše, kar bi ta zaslon lahko pokazal.',
        source:       'Vir',
        contribution: 'Prispevek',
        source_core:         'Jedro (prihodi in odhodi gostov)',
        source_housekeeping: 'Housekeeping',
        source_dining:       'Obroki',
        source_events:       'Dogodki',
        source_maintenance:  'Vzdrževanje',
        reason_contributing:  'Prispeva',
        reason_not_licensed:  'Modul ni licenciran',
        reason_not_built:     'Še ni zgrajeno',
        reason_no_department: 'Ni oddelka za to delo',
        reason_no_rule:       'Ni pravila pokritosti',
        no_sources:            'Virov potrebe ni.',
        no_coverage_days:      'V tem obdobju ni podatkov o pokritosti.',
        no_coverage_days_hint: 'Pokritost potrebuje oddelke, razporejene turnuse in vir potrebe — npr. odhode za housekeeping.',
        // Oddelek brez pravila pokritosti (§11). To je napaka, ki jo je javil hotelir:
        // recepcija ima razporejenih 16 ur, potreba pa 0 — ker hiši nihče ni povedal,
        // koliko stane recepcijski pult.
        no_rule_title: '{department}: ni pravila pokritosti',
        no_rule_hint:  'Za ta oddelek ni pravila pokritosti — nastavi ga v Nastavitve (zobnik) → Uporabniki, vloge in varnost → Evidenca delovnega časa → zavihek Pokritost. Do takrat je potreba 0 in primanjkljaj ni meritev.',
        open_coverage_rules: 'Nastavi pravilo',
    },
    /**
     * Zaslon „modul ni vključen“ (docs/MODULI.md §3.3). Eden za vse module: pove isto
     * poved vsakič, ime modula pa pride iz naslova. Brez sivih gumbov „nadgradi“ —
     * hotel, ki modul želi, se pogovori s tistim, ki podpisuje pogodbe.
     */
    module_off: {
        title:               'Modul ni vključen',
        description:         'Modul „{module}“ ni del naročnine tega hotela, zato ta zaslon zanj ni na voljo.',
        planned_title:       'Modul je v pripravi',
        planned_description: 'Modul „{module}“ je v pripravi in še ni na voljo za nakup.',
        contact:             'Kontaktirajte skrbnika sistema.',
        back:                'Nazaj na šahovnico',
    },
    errors: {
        partner_not_configured: 'Ta namestitev ni nastavljena za povezavo s partnerji. Obrnite se na podporo.',
        partner_unavailable: 'Partner se trenutno ne odziva. Poskusite znova čez trenutek.',
        partner_refused: 'Partner je zavrnil: {reason}',
        partner_refused_plain: 'Partner je zahtevo zavrnil.',
        on_save: 'Sprememb ni bilo mogoče shraniti.',
        operation_in_progress: 'Ta prodaja se že zaključuje. Ne pritiskaj znova — preveri med današnjimi prodajami, ali je bila izdana. Če je ni, obvesti nadrejenega.',
        operation_mismatch: 'Ta blagajna je izgubila sled: isti poskus prodaje je bil začet z drugačno vsebino. Osveži zaslon in prodajo začni znova.',
        operator_not_identified: 'Računa ni mogoče izdati: oseba, ki ga izdaja, nima vpisane osebne davčne številke niti oznake tujega operaterja. Zakon (ZDavPR) zahteva eno od obojega. Uredi v Nastavitve (zobnik) → Uporabniki, vloge in varnost → Uporabniki. Nič ni bilo zapisano — ne račun, ne zaloga, ne plačilo.',
        fields: {
            name:                     'ime objekta',
            address:                  'naslov',
            night_audit_hour:         'ura nočnega obračuna',
            currency:                 'valuta (tri črke, npr. EUR)',
            language:                 'privzeti jezik',
            housekeeping_norm:        'norme čiščenja',
            reporting:                'podatki za poročanje (AJPES)',
            fiscal_tax_number:        'davčna številka za fiskalizacijo (8 števk)',
            fiscal_business_premise:  'oznaka poslovnega prostora',
            fiscal_electronic_device: 'oznaka elektronske naprave',
            fiscal_supplier_tax_number: 'davčna številka dobavitelja programa (8 števk)',
            fiscal_premises_numbers:  'katastrski podatki prostora',
            payment_terms:            'rok plačila (0–365 dni)',
            legal_name:               'pravni naziv',
            identity_tax_number:      'davčna številka',
            identity_vat_number:      'ID za DDV',
            registration_number:      'matična številka',
            iban:                     'IBAN',
            bic:                      'BIC',
            email:                    'e-naslov',
            phone:                    'telefon',
            vat_exemption_note:       'klavzula o oprostitvi DDV',
            legal_address:            'naslov pravne osebe',
            vat_rates:                'stopnje DDV',
            accommodation_tax_rate:   'stopnja DDV za nastanitev',
            amenities:                'oprema',
            document_scan:            'nastavitve branja dokumentov',
            local_events_url:         'vir lokalnih dogodkov (URL mora biti http/https)',
            yield:                    'stopnice dinamičnih cen',
            timezone:                 'časovni pas',
        },
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Nimaš pravic za to dejanje',
        staff_not_employed: 'Ta oseba na ta dan v tej hiši nima veljavnega obdobja zaposlitve. Uredi kadrovski karton.',
        conflict:      'Zapis je že zaseden ali obstaja',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri urejanju',
        on_delete:     'Napaka pri brisanju',
        on_load:       'Napaka pri nalaganju',
        // Kar zaslon nariše NAMESTO praznega stanja, ko odgovora ni (AppLoadError.vue).
        // Prazna tabela in ničla pod njo se bereta kot „ni bilo nič“; to pove, da
        // podatkov ni bilo mogoče prebrati.
        load_failed:   'Podatkov ni bilo mogoče prebrati.',
        session_expired: 'Seja je potekla. Prijavi se znova — narejeno ni bilo nič.',
        guest_already_exists: 'Tega gosta hotel že ima — enak priimek, ime in datum rojstva. Nič ni bilo spremenjeno.',
        charge_reference_in_use: 'Ta dokument je na tem objektu že knjižen na neki kartici. Nič ni bilo spremenjeno — poišči obstoječo postavko.',
        room_charge_already_posted: 'Nočitev za to sobo je za ta dan že knjižena. Nič ni bilo spremenjeno — poišči obstoječo postavko.',
        module_not_licensed: 'Modul ni vključen za ta hotel',
    },
    success: {
        add:    'Uspešno dodano',
        edit:   'Uspešno posodobljeno',
        delete: 'Uspešno izbrisano',
    },
    validation: {
        required:      'To polje je obvezno',
        email:         'Neveljaven e-naslov',
        min:           'Vrednost je premajhna',
        max:           'Vrednost je prevelika',
        positive:      'Vrednost mora biti večja od nič',
        date_order:    'Odhod mora biti po prihodu',
        invalid_date:  'Neveljaven datum',
    },
    /**
     * Kaj sobni televizorji kažejo (docs/DISPLAY.md §9).
     *
     * Svoj imenski prostor in ne del `display`, ker je to drug del izdelka: `display`
     * je oprema — zasloni, ki jih hotel obesi in spusti noter — to pa je VSEBINA, ki
     * je na njih. Ločena tudi zato, ker se ta obrazec izpolni enkrat, tisti zaslon pa
     * se odpira vsak dan.
     */
    display_config: {
        theme: 'Tema zaslonov',
        theme_hint: 'Podlaga, na katero je narisano vse ostalo.',
        theme_help: 'Svetla tema sveti tudi ob treh zjutraj, v sobi, kjer nekdo spi. Za hotel, ki hoče svetlo podobo, je zato mišljena možnost Samodejno.',
        theme_dark: 'Temna',
        theme_light: 'Svetla',
        theme_auto: 'Samodejno (svetla podnevi, temna ponoči)',
        maps_url: 'Povezava Google Maps — na TV postane QR koda, v portalu za gosta povezava',
        discount: 'Popust za goste hotela (npr. 10 % na kosilo)',
        tab: 'Vsebina zaslonov',
        intro: 'Kar je tu vpisano, hotel pove sam o sebi. Kar ni vpisano, zaslon tiho izpusti — nič ni obvezno.',
        read_only: 'Za urejanje vsebine zaslonov potrebuješ pravico property:write.',
        stale: 'Nastavitve je vmes shranil še nekdo drug',
        stale_hint: 'En hotel ima en zapis, zato zadnje shranjevanje prepiše prejšnje. Osveži, preden shraniš znova.',
        reload: 'Osveži nastavitve',
        saved: 'Nastavitve zaslonov so shranjene',

        welcome: 'Pozdravni zaslon',
        welcome_hint: 'Prvo, kar gost vidi, ko stopi v sobo.',
        greeting: 'Pozdrav',
        greeting_hint: 'Napiši {name} tam, kjer naj se izpiše gostovo ime. Prazno pusti izdelkovo besedilo.',
        empty_greeting: 'Pozdrav v prazni sobi',
        empty_greeting_hint: 'Kaj piše, kadar v sobi ni nikogar in na panelu v avli. Imena ne more vsebovati — ni ga koga poimenovati.',
        subtitle: 'Vrstica pod pozdravom',
        show_departure: 'Pokaži datum odhoda',
        show_room_number: 'Pokaži številko sobe',
        show_weather: 'Pokaži vreme',
        weather_off_hint: 'Vreme je izklopljeno spodaj, zato se panel ne bo izrisal.',

        house: 'Hotel',
        house_hint: 'Kar gost v prvi uri vpraša na recepciji.',
        address: 'Naslov pod imenom hotela',
        wifi_network: 'Wi-fi omrežje',
        wifi_password: 'Wi-fi geslo',
        wifi_password_hint: 'Geslo gostovskega omrežja se izpiše na zaslonu — to je namen. Sem ne vpisuj internih gesel.',
        reception_key: 'Tipka za recepcijo',
        reception_key_hint: 'Številka, ki je zapisana v nogi več zaslonov.',
        emergency: 'Obvestilo za sili',
        house_photo: 'Fotografija hotela',
        hours: 'Odpiralni časi',
        hours_label: 'Zajtrk',
        hours_value: '07.00 – 10.30',
        phone_keys: 'Tipke sobnega telefona',

        letter: 'Pozdravno pismo',
        letter_hint: 'Kje v tej stavbi je kaj. Gost ga prebere enkrat, ob prihodu.',
        letter_intro: 'Uvodni odstavek',
        letter_lines: 'Vrstice',
        letter_signature: 'Podpis',
        no_icon: 'Brez znaka',

        local: 'Okolica',
        local_hint: 'Kaj se dogaja v mestu in kaj je tam vedno. Vpiši samo tisto, kar res drži — zaslon gosta pošlje tja.',
        local_qr:      'QR koda za pot',
        local_qr_hint: 'Kartica s povezavo Google Maps pokaže še QR kodo z napisom »skeniranje za pot«. Če jo izklopiš, povezava v portalu za gosta ostane.',
        events: 'Dogodki',
        event_time: '21.00',
        event_name: 'Ime dogodka',
        event_venue: 'Prizorišče',
        event_price: 'Cena',
        event_past: 'Datum je mimo — ta dogodek na zaslone ne gre.',
        distance: '8 minut peš',
        places: 'Kraji',
        place_name: 'Ime',
        place_hours: 'Odpiralni čas',
        place_note: 'Opomba',

        services: 'Storitve na zaslonu',
        services_hint: 'Cenik ostane v modulu Zmogljivosti. Tu se vpiše samo, v čem se zaslon od njega razlikuje.',
        no_catalogue: 'Za urejanje storitev potrebuješ pravico facility:read.',
        no_services: 'Hotel v ceniku še nima storitev.',
        only_selected: 'Na zaslonu samo izbrane storitve',
        only_selected_hint: 'Izklopljeno (privzeto) pomeni obratno: na zaslonu je vse razen tistega, kar je tu skrito.',
        service_title: 'Krajše ime',
        group_photo: 'Slika sklopa',

        booking: 'Naročanje z zaslona',
        booking_hint: 'Kaj sme gost naročiti kar iz postelje.',
        booking_enabled: 'Vklopi naročanje',
        booking_facilities: 'Zmogljivosti',
        booking_facilities_hint: 'Prazno pomeni vse, kar je mogoče rezervirati.',
        booking_lead: 'Najmanj ur vnaprej',
        booking_note: 'Kaj piše ob potrditvi',
        booking_seam: 'Ta obrazec določa PONUDBO. Sam zapis rezervacije s televizorja še ni zgrajen — gost pokliče recepcijo.',

        weather: 'Vreme',
        weather_hint: 'Napoved nad hotelom, iz javnega servisa Open-Meteo.',
        weather_enabled: 'Pokaži vreme',
        weather_place: 'Kraj',
        weather_place_hint: 'Prazno pomeni kraj hotela.',
        weather_days: 'Število dni',
        weather_hourly: 'Ponudi tudi diapozitiv »Vreme po urah (danes)«',
        weather_hourly_hint: 'Vklopljeno doda med vrste diapozitivov v zankah digital signage vreme za današnji dan po urah, od trenutne ure naprej. Sobnih zaslonov ne spremeni.',
        weather_quiet: 'Če napovedi ni mogoče dobiti, se panel preprosto ne izriše — nikoli črtice.',

        screens: 'Zasloni',
        screens_hint: 'Kateri zasloni so na voljo, v kakšnem vrstnem redu, pod kakšnim imenom in nad katero sliko.',
        screens_home_note: 'Pozdravnega zaslona ni mogoče izklopiti — televizor brez njega ne kaže ničesar.',
        background: 'Ozadje',

        screen_home: 'Pozdrav',
        screen_letter: 'Pismo',
        screen_program: 'Program dneva',
        screen_services: 'Storitve hotela',
        screen_nearby: 'Storitve v bližini',
        screen_local: 'V okolici',
        screen_house: 'Hotel',
        screen_bill: 'Račun',
        screen_booking: 'Naročilo',
        screen_tv: 'TV kanali',
        screen_music: 'Glasba',
        screen_alarm: 'Budilka',
        screen_room_service: 'Postrežba v sobo',

        kind_sight: 'Znamenitost',
        kind_restaurant: 'Restavracija',
        kind_activity: 'Dejavnost',
        kind_shop: 'Trgovina',
        kind_other: 'Drugo',

        preview: 'Kako bo izgledalo',
        preview_note: 'Približek: postavitev, besedilo in slike so prave, pisava zaslona pa ni. Pravi zaslon je pms-display.',
        preview_room: 'Soba 205',
        preview_departure: 'Odhod 13. 9. do 10.00',
        preview_wifi: 'Wi-fi',
        preview_hours: 'Odpiralni časi',
        preview_empty_hours: 'Ni vpisanih odpiralnih časov.',
        preview_phone: 'Sobni telefon',
        preview_empty_phone: 'Ni vpisanih tipk.',
        preview_empty_letter: 'Pismo še ni napisano.',
        preview_this_week: 'Ta teden',
        preview_always_open: 'Vedno odprto',
        preview_free: 'Brezplačno',
        preview_ask_desk: 'Za več vprašajte na recepciji — tipka {key}.',
        preview_empty_local: 'O okolici še ni nič vpisanega. Zaslon v tem stanju napoti gosta na recepcijo.',
        preview_empty_services: 'V ceniku ni storitev za zaslon.',
        preview_not_configurable: 'Ta zaslon se riše iz podatkov, ki jih ta obrazec ne ureja — program dneva, račun, glasba.',

        picture_choose: 'Izberi sliko',
        picture_change: 'Zamenjaj',
        picture_clear: 'Odstrani',

        image_title: 'Slika za zaslon',
        image_hint: 'Nariši novo, naloži svojo ali izberi eno iz knjižnice hotela.',
        image_no_provider: 'Ta namestitev slik ne riše',
        image_no_provider_hint: 'Ponudnik slik ni nastavljen. Svoje fotografije lahko kljub temu naložiš.',
        image_generate: 'Nariši sliko',
        image_note: 'Kaj naj bo na sliki',
        image_note_hint: 'Kratko navodilo, na primer „terasa, pozno popoldne“. Ostalo se sestavi iz podatkov o hotelu.',
        image_draw: 'Nariši',
        image_drawing: 'Risanje traja skoraj minuto in hotel nekaj stane. Ne pritiskaj znova.',
        image_provider: 'Riše {provider} · {model}',
        image_failed: 'Slike ni bilo mogoče narisati.',
        image_upload: 'Naloži svojo fotografijo',
        image_upload_hint: 'Najbolje ležeča, temna in mirna — čez njo se izpisuje belo besedilo.',
        image_upload_failed: 'Nalaganje ni uspelo.',
        image_uploaded: 'Fotografija je naložena',
        image_library: 'Knjižnica hotela',
        image_library_empty: 'Ta hotel še nima nobene slike za zaslone.',
        image_clear: 'Brez slike',
        image_no_note: 'Brez opisa',
        image_confirm_delete: 'Res odstranim to sliko iz knjižnice?',

        /*
         * Video v knjižnici (docs/DISPLAY.md §10.9). Svoje ključe in ne razširitev
         * `image_*`, ker gre za drugo stvar: slika se nariše ali naloži, film se samo
         * naloži — in edino, kar je pri filmu treba povedati VNAPREJ, je kodek.
         */
        video_title: 'Video za diapozitiv',
        video_hint: 'Naloži film in ga izberi. Predvaja se na panelu, ko diapozitiv pride na vrsto.',
        video_codec: 'MP4 (H.264/AAC)',
        video_codec_hint: 'Do {size} MB. Samsung in Safari predvajata samo H.264 — HEVC/H.265 na steni ostane črn, čeprav se tu naloži.',
        video_upload: 'Naloži film',
        video_making_poster: 'Rišem prvo sličico …',
        video_sending: 'Pošiljam … {percent} %',
        video_library: 'Knjižnica hotela',
        video_library_empty: 'Ta hotel še nima nobenega filma.',
        video_clear: 'Brez filma',
        video_no_name: 'Brez imena',
        video_meta: '{length} · {size} MB',
        video_meta_no_length: 'dolžina ni znana · {size} MB',
        video_too_large: 'Film je prevelik — največ {size} MB.',
        video_upload_failed: 'Nalaganje filma ni uspelo.',
        video_uploaded: 'Film je naložen',
        video_confirm_delete: 'Res odstranim ta film iz knjižnice? Diapozitivi, ki ga imenujejo, se nehajo prikazovati.',
    },
    /**
     * Nastavitve → Zasloni: en meni za sobne televizorje in za digital signage
     * (Screens.vue). Oba imenska prostora spodaj (`display`, `signage`) ostaneta.
     */
    screens: {
        nav: 'Zasloni',
        intro: 'Televizorji v sobah in paneli v javnih prostorih — vsak s svojimi zavihki.',
        rooms_tab: 'TV v sobah',
        signage_tab: 'Digital signage',
    },
    /**
     * Digital signage — paneli v javnih površinah (docs/DISPLAY.md §10).
     *
     * Svoj imenski prostor in ne del `display` ali `display_config`, ker je to tretja
     * stvar: `display` je oprema, `display_config` je vsebina SOBNIH zaslonov, to pa je
     * zanka, ki se sama vrti na steni v avli — z osnovno enoto »diapozitiv«, ki je nikjer
     * drugje v izdelku ni.
     */
    signage: {
        nav: 'Digital signage',
        intro: 'Kaj se vrti na zaslonih v avli, pred restavracijo, ob dvigalu. Sobnih televizorjev to ne zadeva.',
        no_property: 'Najprej izberi objekt.',
        read_only: 'Za urejanje zank potrebuješ pravico property:write.',

        loops_tab: 'Zanke',
        devices_tab: 'Zasloni',

        loop: 'Zanka',
        loop_hint: 'Ime, opomba in privzeti čas diapozitiva.',
        loop_name: 'Ime zanke',
        loop_name_hint: 'Kako jo boš našel v seznamu — ne piše na steni.',
        loop_name_example: 'npr. Avla',
        loop_note: 'Opomba',
        loop_note_hint: 'Zate in za sodelavce. Na zaslon ne pride.',
        new_loop: 'Nova zanka',
        delete_loop: 'Izbriši zanko',
        no_loops: 'Ni zank',
        no_loops_hint: 'Ta hotel še nima nobene zanke. Naredi prvo in ji dodeli zaslon brez sobe.',
        name_off: '{name} (izklopljena)',
        active: 'Vklopljena',
        active_hint: 'Izklopljena zanka se ne vrti — zaslon kaže običajne zaslone avle. Dodelitve ostanejo.',
        default_seconds: 'Privzeti čas (s)',
        default_seconds_hint: '0 pomeni {seconds} s.',
        running_on: 'Vrti se na {count} zaslonih.',
        running_on_none: 'Ta zanka se zaenkrat ne vrti na nobenem zaslonu.',
        stale: 'Zanko je vmes shranil še nekdo drug',
        stale_hint: 'Tvoje shranjevanje je prepisalo njegovo. Osveži in preveri, kaj je zdaj notri.',
        reload: 'Osveži',
        saved: 'Zanka shranjena',
        confirm_delete: 'Res izbrišem zanko {name}?',
        confirm_delete_running: 'Zanko {name} trenutno vrti {count} zaslonov. Res jo izbrišem?',

        slides: 'Diapozitivi',
        slides_hint: 'Vrstni red je vrstni red na steni. Kar je izklopljeno ali izven datumskega okna, na zaslon ne pride.',
        add_slide: 'Dodaj diapozitiv',
        no_slides: 'Ta zanka še nima diapozitivov.',
        full: 'Zanka je polna — največ {count} diapozitivov.',
        slide_kind: 'Vrsta',
        slide_title: 'Naslov',
        slide_body: 'Besedilo',
        slide_picture: 'Slika v ozadju',
        slide_seconds: 'Čas (s)',
        slide_seconds_hint: '0 = privzeti',
        slide_seconds_film: '0 = dolžina videa ({seconds} s)',
        slide_enabled: 'Vklopljen',
        slide_from: 'Velja od',
        slide_to: 'Velja do',
        move_up: 'Premakni gor',
        move_down: 'Premakni dol',
        duplicate: 'Podvoji',
        remove_slide: 'Odstrani diapozitiv',

        slide_no_film: 'Film še ni izbran',
        choose_film: 'Izberi film',
        change_film: 'Zamenjaj film',
        slide_muted: 'Brez zvoka',
        slide_loop_within: 'Ponavljaj do konca časa',
        slide_sound_warning: 'Zvok v avli sliši vsak, ki gre mimo — in brskalnik lahko samodejno predvajanje z zvokom zavrne, takrat panel utiša film sam.',

        kind_poster: 'Plakat',
        kind_welcome: 'Pozdrav hotela',
        kind_program: 'Program dneva',
        kind_weather: 'Vreme',
        kind_weather_hourly: 'Vreme po urah (danes)',
        kind_services: 'Storitve',
        kind_local: 'V okolici',
        kind_hours: 'Odpiralni časi',
        kind_video: 'Video',

        derived_welcome: 'Ime in podoba hotela. Besedila tu ne vpisuješ.',
        derived_program: 'Objavljeni program dneva. Ureja se pod Nastavitve (zobnik) → Izkušnja gosta, Milo in zasloni → Zasloni → TV v sobah → zavihek Program dneva.',
        derived_weather: 'Napoved za kraj hotela. Vklopi se pod Nastavitve (zobnik) → Izkušnja gosta, Milo in zasloni → Zasloni → TV v sobah → zavihek Vsebina zaslonov.',
        derived_weather_hourly: 'Današnji dan po urah, od trenutne ure naprej. Isti kraj kot napoved; izklopi se pod Nastavitve (zobnik) → Izkušnja gosta, Milo in zasloni → Zasloni → TV v sobah → zavihek Vsebina zaslonov. Pozno zvečer, ko od dneva ne ostane nič, diapozitiv odpade.',
        derived_services: 'Cenik iz modula Zmogljivosti.',
        derived_local: 'Dogodki in znamenitosti iz Vsebine zaslonov.',
        derived_hours: 'Urniki in naslov iz Vsebine zaslonov. Wi-Fi in tipke telefona na javno steno ne gredo.',

        previous_slide: 'Prejšnji diapozitiv',
        next_slide: 'Naslednji diapozitiv',
        preview_at: 'Diapozitiv {at} od {of}',
        // Oblika panela, za katerega hotelir sestavlja zanko. Ista zanka teče na obeh —
        // kateri zasloni v hiši so obrnjeni, je lastnost NAPRAV (docs/DISPLAY.md §10.10).
        preview_landscape: 'Ležeči panel',
        preview_portrait: 'Pokončni panel',
        preview_note: 'Predogled je približek: postavitev in vsebina sta pravi, pisava zaslona pa ne.',
        preview_empty: 'Ta zanka nima diapozitivov.',
        preview_welcome: 'Dobrodošli',
        preview_blank: 'Ta plakat nima ne naslova, ne besedila, ne slike.',
        preview_dropped: 'Za to zdaj ni vsebine — zaslon tega diapozitiva ne bo pokazal.',
        preview_no_film: 'Ta diapozitiv še nima filma — zaslon ga ne bo pokazal.',
        wall_shows: 'Na zaslonih se zdaj vrti {count} diapozitivov.',
        wall_unknown: 'Kaj se zdaj vrti na zaslonih, trenutno ni znano.',

        place_sight: 'Znamenitost',
        place_restaurant: 'Kje jesti',
        place_activity: 'Aktivnost',
        place_shop: 'Nakupi',
        place_other: 'Drugo',

        devices: 'Zasloni in zanke',
        devices_hint: 'Zanko lahko dobi samo zaslon BREZ sobe. Sobni televizor se ne vrti — glej docs/DISPLAY.md §10.4.',
        no_devices: 'Ta hotel še nima vpisanih zaslonov.',
        device_public: 'Javna površina (brez sobe)',
        device_in_room: 'Soba {room}',
        device_seen: 'nazadnje {when}',
        device_never_seen: 'še nikoli javljen',
        unassigned: 'Brez zanke',
        assigned: 'Zaslon je dobil zanko',
        cleared: 'Zaslon je brez zanke',
    },
    /**
     * Opomniki — datirani zapiski recepcije na rezervaciji. „Zamujeni / danes /
     * prihodnji“ so skupine, v katerih jih recepcija bere; „zamuja“ je oznaka ob
     * posameznem opomniku na rezervaciji.
     */
    reminder: {
        reminders: 'Opomniki',
        add: 'Dodaj opomnik',
        edit: 'Uredi opomnik',
        delete: 'Izbriši opomnik',
        empty: 'Za to rezervacijo ni opomnikov.',
        open_empty: 'Ni odprtih opomnikov.',
        group_empty: 'V tej skupini ni opomnikov.',
        text: 'Opomnik',
        text_placeholder: 'Pokliči gosta glede poznega prihoda',
        due: 'Rok',
        due_time: 'Ura',
        time_optional: 'neobvezno',
        mark_done: 'Označi kot opravljeno',
        reopen: 'Ponovno odpri',
        confirm_delete: 'Izbrišem opomnik? Opravljene raje označi kot opravljene — ostanejo zapisani.',
        saved: 'Opomnik je shranjen',
        done_at: 'Opravljeno {when}',
        overdue_one: 'zamuja',
        overdue: 'Zamujeni',
        today: 'Danes',
        upcoming: 'Prihodnji',
        all: 'Vsi',
        refresh: 'Osveži',
        unknown_reservation: 'Neznana rezervacija',
    },

    /*
     * Prevozi — vožnje, ki jih hotel uredi za gosta.
     *
     * "Zabeleženo" je izraz, ki ga je treba prebrati dvakrat: pomeni, da hotel nima
     * priklopljenega prevoznika, da je vožnja zapisana in da NI bila nikomur poslana.
     * To je običajno stanje običajnega hotela in ne napaka — narobe bi bilo le, če bi
     * receptorka mislila, da je avto naročen.
     */
    transfer: {
        title: 'Prevozi',
        hint: 'Prevozi gostov: prevzem na letališču, vožnja na postajo, taksi pred vrati.',
        add: 'Nov prevoz',
        arrange: 'Uredi prevoz',
        record: 'Zabeleži',
        send: 'Pošlji prevozniku',
        cancel: 'Prekliči prevoz',
        confirm_cancel: 'Res prekličeš ta prevoz? Preklic velja samo za naš zapis — prevoznika je treba obvestiti posebej.',
        cancelled_notice: 'Prevoz je preklican v našem zapisu. Prevoznika obvesti sam.',
        optional: 'neobvezno',

        when: 'Kdaj',
        route: 'Relacija',
        contact: 'Kontakt',
        day: 'Datum',
        time: 'Ura',
        passengers: 'Potnikov',
        pickup_place: 'Prevzem',
        dropoff_place: 'Dostava',
        place_hint: 'Zapiši po domače: „Terminal 2, prihodi“, „hotel“, „železniška postaja“.',
        flight_number: 'Let ali vlak',
        contact_name: 'Ime kontakta',
        contact_phone: 'Telefon kontakta',
        notes: 'Opombe',
        needs_time: 'Vpiši datum in uro prevoza.',

        kind: 'Vrsta',
        kind_all: 'Vse vrste',
        kind_airport: 'Letališče',
        kind_station: 'Postaja',
        kind_taxi: 'Taksi',
        kind_other: 'Drugo',

        status_all: 'Vsi statusi',
        status_recorded: 'Zabeleženo',
        origin_guest: 'Zaprosil gost prek Mila — potrdi uro in ceno',
        status_requested: 'Poslano',
        status_confirmed: 'Potrjeno',
        status_failed: 'Ni uspelo',
        status_cancelled: 'Preklicano',

        internal_only_title: 'Prevozi se nikamor ne pošiljajo',
        internal_only_hint: 'Ta hotel nima priklopljenega prevoznika. Prevoz se samo zabeleži — avto je treba naročiti po telefonu.',
        internal_only_hint_manager: 'Ta hotel nima priklopljenega ali vklopljenega prevoznika. Prevoz se samo zabeleži. Povezavo urediš pod „Prevoznik“.',

        recorded_only: 'Prevoz je zabeležen. Poslan ni bil nikomur.',
        sent: 'Prevoz je poslan prevozniku.',
        sent_with_reference: 'Prevoz je potrjen, sklic {reference}.',
        dispatch_failed: 'Prevoz je zabeležen, prevoznik pa ga ni sprejel: {reason}',

        provider_button: 'Prevoznik',
        provider_title: 'Povezava s prevoznikom',
        provider_hint: 'Kam ta hotel pošilja prevoze. Ključ se shrani zaklenjen in se nikoli ne prikaže nazaj.',
        provider_kind: 'Vrsta povezave',
        provider_webhook: 'Splošni odhodni webhook (HTTP POST)',
        provider_active: 'Povezava je vklopljena',
        provider_active_hint: 'Izklopljena povezava pomeni, da se prevozi samo beležijo.',
        base_url: 'Naslov (URL)',
        base_url_hint: 'Naslov, ki ti ga je dal prevoznik. Prevoz gre nanj kot POST z JSON telesom spodaj.',
        base_url_invalid: 'Vpiši veljaven naslov, ki se začne s http:// ali https://',
        api_key: 'Ključ',
        api_key_hint: 'Če ga endpoint zahteva. Poslan bo v glavi Authorization: Bearer.',
        api_key_set: 'Ključ je shranjen. Pusti prazno, če ga ne menjaš.',
        envelope: 'Kaj prejme nasprotna stran',
    },

    /* Mobilno materialno poslovanje (docs/MATERIALNO-MOBILNO.md, WP-M7). */
    mobile_stock: {
        title: 'Mobilno skladišče',
        lead: 'Trije postopki, ki jih opraviš stoje ob blagu: prevzem, inventura in izdaja.',
        nothing_allowed: 'Za te postopke nimaš pravic. Oglasi se pri vodji skladišča.',
        back_to_hub: 'Nazaj na izbiro',

        receive: 'Prevzem',
        receive_lead: 'Blago od dobavitelja, s skeniranjem in odstopanji.',
        count: 'Inventura',
        count_lead: 'Preštej police, ki so ti dodeljene.',
        issue: 'Izdaja',
        issue_lead: 'Blago, ki gre iz skladišča na oddelek ali v porabo.',

        supplier: 'Dobavitelj',
        supplier_help: 'Od koga je blago prišlo. Izbira odpre njegove odprte naročilnice.',
        to_place: 'Prostor prejema',
        to_place_help: 'Kam blago fizično gre. Privzeto je hišni glavni prostor.',
        open_orders: 'Odprte naročilnice',
        no_open_orders: 'Za tega dobavitelja ni odprtih naročilnic.',
        order_lines: '{count} vrstic',
        without_order: 'Prevzem brez naročilnice',

        scan_to_start: 'Skeniraj prvo kodo — vrstica se doda sama.',
        start_scanning: 'Začni skeniranje',
        edit_quantity: 'Popravi količino',
        received_of_ordered: 'Prejeto {received} od {ordered} {unit}',
        not_ordered: 'ni na naročilnici',
        ordered_n: 'Naročeno: {count} {unit}',
        nothing_counted: 'Nobena vrstica nima količine.',

        unit_cost: 'Cena na enoto (€)',
        unit_cost_help: 'Neto nabavna cena brez DDV. Pri prevzemu po naročilnici se prepiše iz nje.',
        lot: 'Serija (lot)',
        lot_help: 'Oznaka serije s pakiranja. Pri artiklih s sledenjem je obvezna.',
        lot_required: 'Artikel „{item}“ zahteva serijo.',
        expires_on: 'Rok uporabe',
        expires_on_help: 'Datum s pakiranja. Prazno, če ga blago nima.',

        /* Prevzem po dobavnici (docs/MATERIALNO-PREVZEM.md §11): na telefonu ni koraka
           za dobaviteljev račun in to je povedano, preden kdo kaj pritisne. */
        delivery_note_only: 'Prevzem po dobavnici; račun dobavitelja se vnese pozneje v Prejeti računi.',

        /* Zavrnitev ostane na zaslonu, ne le v obvestilu: osnutek je zapisan in
           naslednji pritisk knjiži TISTEGA. */
        post_refused: 'Papirja {number} ni bilo mogoče knjižiti.',

        finish_receipt: 'Zaključi prevzem',
        receipt_posted: 'Prevzem {number} je knjižen.',
        receipt_posted_help: 'Blago je na zalogi. Če je kaj šlo v karanteno, piše spodaj.',
        receive_again: 'Nov prevzem',

        from_place: 'Iz prostora',
        from_place_help: 'Polica, s katere blago odhaja.',
        reason: 'Razlog',
        reason_help: 'Zakaj blago odhaja. Zapiše se na dokument.',
        reason_department: 'Oddelek',
        reason_consumption: 'Poraba',
        cost_centre: 'Stroškovno mesto',
        cost_centre_help: 'Kam gre strošek v knjigah. Telefon si zapomni zadnjega, ker se ista kuhinja zalaga dvajsetkrat na jutro.',
        no_cost_centre: 'Brez stroškovnega mesta',
        issue_note: 'Opomba',
        issue_note_help: 'Karkoli, kar bo čez mesec dni povedalo, zakaj je bila ta izdaja drugačna. Oddelek in razlog sta zdaj polji in ju ni treba pisati sem.',
        on_hand: 'na zalogi: {quantity}',

        /* Neuspelo branje zaloge se ne sme narisati kot „na zalogi 0“: to je ista slika
           kot prazno skladišče, izdaja pa bi šla proti številkam, ki jih ni nihče
           prebral. */
        balances_failed: 'Zaloge ni bilo mogoče prebrati.',
        balances_failed_help: 'Brez nje ne vemo, kaj prostor drži, zato izdaja ni mogoča. Poskusi znova.',
        balances_retry: 'Poskusi znova',

        /* Šifranti — prostori, dobavitelji, register artiklov — se niso prebrali. Pove
           se pred vsem ostalim, ker vsak korak stoji na enem od teh treh seznamov:
           prazen register bi skener spustil v delo in vsak karton bi bil „neznana
           črtna koda“. */
        codebooks_failed: 'Šifrantov ni bilo mogoče prebrati.',

        post_issue: 'Knjiži izdajo',
        issue_posted: 'Izdaja {number} je knjižena.',
        issue_posted_help: 'Zaloga v prostoru je zmanjšana.',
        issue_again: 'Nova izdaja',

        backspace: 'Zbriši zadnjo števko',
    },

    /* Inventure — telefon v skladišču in nadzornikov zaslon. */
    counts: {
        title: 'Inventure',
        lead: 'Popis zaloge: kdo šteje kaj, primerjava z zalogo in knjiženje razlik.',
        empty: 'Ni inventur.',
        add: 'Nova inventura',
        edit: 'Uredi inventuro',
        open_desk: 'Odpri pregled inventur',

        filter_status: 'Stanje',
        filter_status_help: 'Privzeto so prikazane vse. Za tekoče štetje izberi „V štetju“.',
        filter_all: 'Vse',

        status_draft: 'Osnutek',
        status_counting: 'V štetju',
        status_review: 'V pregledu',
        status_posted: 'Knjižena',
        status_cancelled: 'Preklicana',

        name: 'Naziv',
        name_help: 'Kako se bo popis imenoval na seznamu — „Kuhinja, september“.',
        places: 'Prostori',
        places_help: 'Katere police popis zajame. Po začetku se ne spreminjajo.',
        places_n: '{count} prostorov',
        category: 'Kategorija',
        category_help: 'Popis lahko zajame samo eno kategorijo artiklov. Prazno pomeni vse.',
        every_category: 'Vse kategorije',
        blind: 'Slepo štetje',
        blind_help: 'Štetju se ne pokaže knjižna zaloga. Polica se prešteje, ne potrdi.',
        blind_short: 'Slepo',

        counters: 'Števci',
        counters_help: 'Kdo šteje in katere prostore. Prostor brez števca ostane nepopisan.',
        counters_n: '{count} števcev',
        counter: 'Oseba',
        counter_places: 'Njeni prostori',
        counter_places_help: 'Samo prostori, ki jih zajema ta popis.',
        add_counter: 'Dodaj števca',
        no_counters: 'Nihče še ni dodeljen.',

        start: 'Začni štetje',
        started: 'Štetje se je začelo. Zaloga je zamrznjena.',
        to_review: 'Pošlji v pregled',
        in_review: 'Popis je v pregledu.',
        post: 'Knjiži razlike',
        posted: 'Razlike so knjižene.',
        cancel: 'Prekliči popis',
        cancelled: 'Popis je preklican.',
        cancelled_by_desk: 'Preklicano na recepciji.',
        confirm_post: 'Knjižene razlike premaknejo zalogo in jih ni mogoče preklicati — samo popraviti z novim dokumentom. Nadaljujem?',
        confirm_cancel: 'Preklican popis se ne da nadaljevati. Nadaljujem?',
        snapshot_at: 'Zaloga zamrznjena {at}',
        posted_documents: 'Nastalo je {count} inventurnih dokumentov.',
        movements_after_review_title: 'Po pregledu se je zaloga premaknila na {count} vrsticah',
        movements_after_review_lead: 'Med pregledom in knjiženjem je blago prišlo v popisane prostore ali odšlo iz njih. '
            + 'Knjiženje je to upoštevalo: knjižena je razlika proti zamrznjeni knjigi, natanko takšna, kot jo je '
            + 'pokazal pregled — stolpec premikov na vrsticah zgoraj pa ob podpisu ni bil več točen.',

        article: 'Artikel',
        place: 'Prostor',
        expected: 'Knjižno',
        counted: 'Prešteto',
        second: 'Drugo štetje',
        diff: 'Razlika',
        value: 'Vrednost',
        moved_since_snapshot: 'Blago se je po zamrznitvi premikalo — del razlike je resnično gibanje.',
        save_second: 'Shrani',
        second_saved: 'Drugo štetje je shranjeno.',
        second_needed_title: 'Čaka drugo štetje: {count} vrstic',
        second_needed_lead: 'Dokler te vrstice niso preštete drugič, popisa ni mogoče knjižiti.',

        /* Prostori, kategorije in števci za pogovorno okno novega popisa. Svoje
           sporočilo in ne splošno, ker pove, KAJ manjka: seznam popisov spodaj je
           lahko čisto v redu. */
        reference_failed: 'Šifrantov za nov popis ni bilo mogoče prebrati.',

        mine_lead: 'Popisi, pri katerih si vpisan kot števec.',
        none_counting: 'Trenutno ni popisa v štetju.',
        no_places_for_me: 'V tem popisu ti ni dodeljen noben prostor.',
        counted_of: 'Prešteto {counted} od {total}',
        not_counted: 'še ni prešteto',
        expected_n: 'knjižno {quantity} {unit}',
        item_added: '„{item}“ ni bil na seznamu — dodan je.',
        entry_refused: 'Štetja ni bilo mogoče zabeležiti.',
        queue_pending: 'pošiljam: {count}',
        queue_offline: 'čaka na povezavo: {count}',
        offline_title: 'Ni povezave',
        offline_lead: 'Preštete količine čakajo in bodo poslane, ko se povezava vrne. Shranjene so na tej napravi, '
            + 'zato preživijo tudi osvežitev strani.',
        retry_now: 'Poskusi zdaj',
        submit: 'Oddaj štetje',
        submitted: 'Štetje prostora je oddano.',
        still_sending: 'Še {count} količin ni poslanih. Počakaj trenutek.',
        confirm_incomplete: 'V tem prostoru {count} artiklov še ni preštetih. Vseeno zaključim?',
        leave_pending: '{count} vnosov še ni poslanih — ostani in počakaj?',

        /* Vnosi, ki so ostali na napravi (docs/MATERIALNO-MOBILNO.md §5.2). Naslov pove
           sejo, ker gre vsak vnos v svojo sejo in ne v tisto, ki je odprta. */
        held_title: 'Neposlani vnosi ({count}) — seja {session}',
        held_lead: 'Vtipkane količine, ki niso prišle do strežnika. Poslane bodo v svojo sejo.',
        held_other: 'Vnose je vtipkal drug števec na tej napravi. Pošlje jih lahko samo on; tu jih lahko le zavržeš.',
        held_send: 'Pošlji',
        held_discard: 'Zavrzi',
        held_confirm_discard: 'Zavržem {count} neposlanih vnosov za sejo {session}? Preštetih količin ni več mogoče dobiti nazaj.',
        refused_title: 'Zavrnjeni vnosi: {count}',
        refused_discard: 'Zavrzi',
        /* Vnos, ki ga je zavrnil čuvaj merila: količina ostane v vrsti, a je ni mogoče
           poslati, dokler je nekdo ne vtipka znova v novem merilu artikla. */
        refused_reenter: 'vpiši znova',
    },

    /* Branje črtnih kod (docs/MATERIALNO-MOBILNO.md §3). */
    scanner: {
        mode_camera: 'Kamera',
        mode_keyboard: 'Čitalnik',
        mode_manual: 'Ročno',
        camera_hint: 'Kodo drži v okvirju. Zajame se sama.',
        camera_denied: 'Dostop do kamere je zavrnjen',
        camera_denied_help: 'V nastavitvah brskalnika dovoli kamero za to stran, ali pa uporabi čitalnik oziroma ročni vnos.',
        camera_unsupported: 'Ta brskalnik ne zna brati kod',
        camera_unsupported_help: 'Kamera deluje v Chromu in na napravah z Androidom. Drugje uporabi čitalnik ali ročni vnos.',
        camera_failed: 'Kamere ni bilo mogoče odpreti',
        camera_failed_help: 'Naprava morda nima kamere ali jo uporablja druga aplikacija. Uporabi čitalnik ali ročni vnos.',
        keyboard_hint: 'Skeniraj s pištolo — koda se prebere tudi, če ni nobeno polje izbrano.',
        manual_placeholder: 'Vpiši kodo',
        manual_submit: 'Potrdi kodo',
        unknown_code: 'Neznana koda',
        find_item: 'Poišči artikel',
        pick_item: 'Artikel',
        pick_item_help: 'Izberi, kaj imaš v rokah. Koda se lahko pripne temu artiklu.',
        attach_code: 'Pripni kodo temu artiklu',
        attach_code_help: 'Odslej bo ta koda vedno pomenila ta artikel. Pripni jo samo, če si prepričan.',
        code_attached: 'Koda je pripeta.',
        use_item: 'Uporabi artikel',
    },
}
